"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2395],{

/***/ 35290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ useAccessibleNameWarning; },
/* harmony export */   "t": function() { return /* binding */ hasAccessibleName; }
/* harmony export */ });
/* unused harmony export n */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
"use client";

//#region src/utils/accessible-name.ts
/**
* Runtime mirror of the {@link AccessibleNameProps} constraint: any of
* `aria-label`, `aria-labelledby`, or an `id` (assumed to be referenced by an
* external `<label htmlFor>`) names the control. Components with an additional
* name source (e.g. Checkbox's `caption`) pass it as `extraNameSource`. An
* empty string is not a name.
*/ function hasAccessibleName(props) {
    var extraNameSource = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return Boolean(props["aria-label"] || props["aria-labelledby"] || props.id) || extraNameSource;
}
/**
* Dev-only backstop for the {@link AccessibleNameProps} type constraint: logs a
* `console.warn` (development builds only) when a control that requires an
* accessible name was rendered without one. The type system enforces this for
* TypeScript callers; this catches JS consumers and `as any` escapes that slip
* past it. Compute the flag with {@link hasAccessibleName} so every component
* shares one definition of "named".
*
* Always called so hook order stays stable; the effect no-ops in production.
*/ function useAccessibleNameWarning(componentName, hasName) {
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (true) return;
        if (hasName) return;
        console.warn("[Atoms] <".concat(componentName, "> was rendered without an accessible name. Provide `aria-label`, `aria-labelledby`, or an `id` referenced by a `<label htmlFor>` (for example via `Field`/`Form`). Without one, assistive technology cannot announce the control."));
    }, [
        componentName,
        hasName
    ]);
}
/**
* Dev-only counterpart to {@link useAccessibleNameWarning}: warns (development
* builds only) when a control is given *more than one* accessible name — e.g.
* Checkbox's visible `caption` alongside an `aria-label`/`aria-labelledby`. The
* `aria-*` value wins and silently suppresses the visible label from the
* accessible name, so assistive technology announces something other than what's
* shown. Pass `true` for `hasConflict` when competing sources are present.
*
* Always called so hook order stays stable; the effect no-ops in production.
*/ function useAccessibleNameConflictWarning(componentName, hasConflict) {
    useEffect(function() {
        if (true) return;
        if (!hasConflict) return;
        console.warn("[Atoms] <".concat(componentName, "> was given more than one accessible name (for example a visible `caption` together with `aria-label`/`aria-labelledby`). The `aria-*` value overrides the visible label for assistive technology — provide exactly one."));
    }, [
        componentName,
        hasConflict
    ]);
}
//#endregion



/***/ }),

/***/ 47380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ ComboboxList; },
  "D": function() { return /* binding */ NumberFieldInput; },
  "F": function() { return /* binding */ ComboboxEmpty; },
  "H": function() { return /* binding */ ComboboxInput; },
  "I": function() { return /* binding */ ComboboxItem; },
  "K": function() { return /* binding */ useRender; },
  "L": function() { return /* binding */ ComboboxPopup; },
  "M": function() { return /* binding */ FieldError; },
  "N": function() { return /* binding */ FieldLabel; },
  "O": function() { return /* binding */ NumberFieldRoot; },
  "P": function() { return /* binding */ FieldRoot; },
  "R": function() { return /* binding */ ComboboxPositioner; },
  "U": function() { return /* binding */ ComboboxRoot; },
  "V": function() { return /* binding */ ComboboxTrigger; },
  "_": function() { return /* binding */ CollapsibleRoot; },
  "a": function() { return /* binding */ ToastClose; },
  "c": function() { return /* binding */ ToastContent; },
  "d": function() { return /* binding */ ToastProvider; },
  "f": function() { return /* binding */ RadioGroup; },
  "g": function() { return /* binding */ CollapsibleTrigger; },
  "h": function() { return /* binding */ CollapsiblePanel; },
  "i": function() { return /* binding */ ToastPortal; },
  "j": function() { return /* binding */ FieldDescription; },
  "k": function() { return /* binding */ Input; },
  "l": function() { return /* binding */ ToastRoot; },
  "m": function() { return /* binding */ RadioRoot; },
  "o": function() { return /* binding */ ToastTitle; },
  "p": function() { return /* binding */ RadioIndicator; },
  "q": function() { return /* binding */ mergeProps$1; },
  "r": function() { return /* binding */ useToastManager; },
  "s": function() { return /* binding */ ToastDescription; },
  "u": function() { return /* binding */ ToastViewport; },
  "z": function() { return /* binding */ ComboboxPortal; }
});

// UNUSED EXPORTS: A, C, E, G, S, T, W, b, n, t, v, w, x, y

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var src_assert_this_initialized = __webpack_require__(90918);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(60947);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_class_call_check.mjs
var src_class_call_check = __webpack_require__(4656);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_create_class.mjs
var src_create_class = __webpack_require__(69648);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(37705);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_get.mjs + 1 modules
var _get = __webpack_require__(15963);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_get_prototype_of.mjs
var _get_prototype_of = __webpack_require__(8216);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_inherits.mjs
var src_inherits = __webpack_require__(13459);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(88149);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(59106);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var src_sliced_to_array = __webpack_require__(99758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var src_to_consumable_array = __webpack_require__(48417);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_type_of.mjs
var src_type_of = __webpack_require__(94167);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_create_super.mjs + 2 modules
var src_create_super = __webpack_require__(84802);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(92336);
;// CONCATENATED MODULE: ../atoms/lib/chunks/rolldown-runtime-ilr8yh42tu96r5h6.js
"use client";
//#region \0rolldown/runtime.js
var __defProp = Object.defineProperty;
var __exportAll = function(all, no_symbols) {
    var target = {};
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
    if (!no_symbols) __defProp(target, Symbol.toStringTag, {
        value: "Module"
    });
    return target;
};
//#endregion


// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
var react_namespaceObject = /*#__PURE__*/__webpack_require__.t(react, 2);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(31549);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-dom@18.3.1_react@18.3.1/node_modules/react-dom/index.js
var react_dom = __webpack_require__(56321);
// EXTERNAL MODULE: ../../node_modules/.pnpm/use-sync-external-store@1.6.0_react@18.3.1/node_modules/use-sync-external-store/shim/index.js
var shim = __webpack_require__(66740);
// EXTERNAL MODULE: ../../node_modules/.pnpm/use-sync-external-store@1.6.0_react@18.3.1/node_modules/use-sync-external-store/shim/with-selector.js
var with_selector = __webpack_require__(79152);
;// CONCATENATED MODULE: ../atoms/lib/chunks/vendor-base-ui-n0ony04mhklkmnfd.js
"use client";

















var _timer;







//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/formatErrorMessage.js
/**
* Creates a formatErrorMessage function with a custom URL and prefix.
* @param baseUrl - The base URL for the error page (e.g., 'https://base-ui.com/production-error')
* @param prefix - The prefix for the error message (e.g., 'Base UI')
* @returns A function that formats error messages with the given URL and prefix
*/ function createFormatErrorMessage(baseUrl, prefix) {
    return function formatErrorMessage(code) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var url = new URL(baseUrl);
        url.searchParams.set("code", code.toString());
        args.forEach(function(arg) {
            return url.searchParams.append("args[]", arg);
        });
        return "".concat(prefix, " error #").concat(code, "; visit ").concat(url, " for the full message.");
    };
}
/**
* WARNING: Don't import this directly. It's imported by the code generated by
* `@mui/internal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
* constructors to ensure the plugin works as expected. Supported patterns include:
*   throw new Error('My message');
*   throw new Error(`My message: ${foo}`);
*   throw new Error(`My message: ${foo}` + 'another string');
*   ...
*/ var formatErrorMessage = createFormatErrorMessage("https://base-ui.com/production-error", "Base UI");
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/useRefWithInit.js
var UNINITIALIZED = {};
/**
* A React.useRef() that is initialized with a function. Note that it accepts an optional
* initialization argument, so the initialization function doesn't need to be an inline closure.
*
* @usage
*   const ref = useRefWithInit(sortColumns, columns)
*/ function useRefWithInit(init, initArg) {
    var ref = react.useRef(UNINITIALIZED);
    if (ref.current === UNINITIALIZED) ref.current = init(initArg);
    return ref;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/useMergedRefs.js
/**
* Merges refs into a single memoized callback ref or `null`.
* This makes sure multiple refs are updated together and have the same value.
*
* This function accepts up to four refs. If you need to merge more, or have an unspecified number of refs to merge,
* use `useMergedRefsN` instead.
*/ function useMergedRefs(a, b, c, d) {
    var forkRef = useRefWithInit(createForkRef).current;
    if (didChange(forkRef, a, b, c, d)) update(forkRef, [
        a,
        b,
        c,
        d
    ]);
    return forkRef.callback;
}
/**
* Merges an array of refs into a single memoized callback ref or `null`.
*
* If you need to merge a fixed number (up to four) of refs, use `useMergedRefs` instead for better performance.
*/ function useMergedRefsN(refs) {
    var forkRef = useRefWithInit(createForkRef).current;
    if (didChangeN(forkRef, refs)) update(forkRef, refs);
    return forkRef.callback;
}
function createForkRef() {
    return {
        callback: null,
        cleanup: null,
        refs: []
    };
}
function didChange(forkRef, a, b, c, d) {
    return forkRef.refs[0] !== a || forkRef.refs[1] !== b || forkRef.refs[2] !== c || forkRef.refs[3] !== d;
}
function didChangeN(forkRef, newRefs) {
    return forkRef.refs.length !== newRefs.length || forkRef.refs.some(function(ref, index) {
        return ref !== newRefs[index];
    });
}
function update(forkRef, refs) {
    forkRef.refs = refs;
    if (refs.every(function(ref) {
        return ref == null;
    })) {
        forkRef.callback = null;
        return;
    }
    forkRef.callback = function(instance) {
        if (forkRef.cleanup) {
            forkRef.cleanup();
            forkRef.cleanup = null;
        }
        if (instance != null) {
            var cleanupCallbacks = Array(refs.length).fill(null);
            for(var i = 0; i < refs.length; i += 1){
                var ref = refs[i];
                if (ref == null) continue;
                switch(typeof ref === "undefined" ? "undefined" : (0,src_type_of/* default */.Z)(ref)){
                    case "function":
                        {
                            var refCleanup = ref(instance);
                            if (typeof refCleanup === "function") cleanupCallbacks[i] = refCleanup;
                            break;
                        }
                    case "object":
                        ref.current = instance;
                        break;
                    default:
                }
            }
            forkRef.cleanup = function() {
                for(var i = 0; i < refs.length; i += 1){
                    var ref = refs[i];
                    if (ref == null) continue;
                    switch(typeof ref === "undefined" ? "undefined" : (0,src_type_of/* default */.Z)(ref)){
                        case "function":
                            {
                                var cleanupCallback = cleanupCallbacks[i];
                                if (typeof cleanupCallback === "function") cleanupCallback();
                                else ref(null);
                                break;
                            }
                        case "object":
                            ref.current = null;
                            break;
                        default:
                    }
                }
            };
        }
    };
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/reactVersion.js
var majorVersion = parseInt(react.version, 10);
function isReactVersionAtLeast(reactVersionToCheck) {
    return majorVersion >= reactVersionToCheck;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/getReactElementRef.js
/**
* Extracts the `ref` from a React element, handling different React versions.
*/ function getReactElementRef(element) {
    if (!/* @__PURE__ */ /*#__PURE__*/ react.isValidElement(element)) return null;
    var reactElement = element;
    var propsWithRef = reactElement.props;
    var ref;
    return (ref = isReactVersionAtLeast(19) ? propsWithRef === null || propsWithRef === void 0 ? void 0 : propsWithRef.ref : reactElement.ref) !== null && ref !== void 0 ? ref : null;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/mergeObjects.js
function mergeObjects(a, b) {
    if (a && !b) return a;
    if (!a && b) return b;
    if (a || b) return (0,src_object_spread/* default */.Z)({}, a, b);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/warn.js
var set$1;
if (false) {}
function warn() {
    for(var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++){
        messages[_key] = arguments[_key];
    }
    if (false) { var messageKey; }
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/empty.js
function NOOP() {}
var EMPTY_ARRAY$1 = Object.freeze([]);
var EMPTY_OBJECT = Object.freeze({});
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/getStateAttributesProps.js
function getStateAttributesProps(state, customMapping) {
    var props = {};
    for(var key in state){
        var value = state[key];
        if (customMapping === null || customMapping === void 0 ? void 0 : customMapping.hasOwnProperty(key)) {
            var customProps = customMapping[key](value);
            if (customProps != null) Object.assign(props, customProps);
            continue;
        }
        if (value === true) props["data-".concat(key.toLowerCase())] = "";
        else if (value) props["data-".concat(key.toLowerCase())] = value.toString();
    }
    return props;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/utils/resolveClassName.js
/**
* If the provided className is a string, it will be returned as is.
* Otherwise, the function will call the className function with the state as the first argument.
*
* @param className
* @param state
*/ function resolveClassName(className, state) {
    return typeof className === "function" ? className(state) : className;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/utils/resolveStyle.js
/**
* If the provided style is an object, it will be returned as is.
* Otherwise, the function will call the style function with the state as the first argument.
*
* @param style
* @param state
*/ function resolveStyle(style, state) {
    return typeof style === "function" ? style(state) : style;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/merge-props/mergeProps.js
var EMPTY_PROPS = {};
/**
* Merges multiple sets of React props. It follows the Object.assign pattern where the rightmost object's fields overwrite
* the conflicting ones from others. This doesn't apply to event handlers, `className` and `style` props.
*
* Event handlers are merged and called in right-to-left order (rightmost handler executes first, leftmost last).
* For React synthetic events, the rightmost handler can prevent prior (left-positioned) handlers from executing
* by calling `event.preventBaseUIHandler()`. For non-synthetic events (custom events with primitive/object values),
* all handlers always execute without prevention capability.
*
* The `className` prop is merged by concatenating classes in right-to-left order (rightmost class appears first in the string).
* The `style` prop is merged with rightmost styles overwriting the prior ones.
*
* Props can either be provided as objects or as functions that take the previous props as an argument.
* The function will receive the merged props up to that point (going from left to right):
* so in the case of `(obj1, obj2, fn, obj3)`, `fn` will receive the merged props of `obj1` and `obj2`.
* The function is responsible for chaining event handlers if needed (that is, we don't run the merge logic).
*
* Event handlers returned by the functions are not automatically prevented when `preventBaseUIHandler` is called.
* They must check `event.baseUIHandlerPrevented` themselves and bail out if it's true.
*
* @important **`ref` is not merged.**
* @param a Props object to merge.
* @param b Props object to merge. The function will overwrite conflicting props from `a`.
* @param c Props object to merge. The function will overwrite conflicting props from previous parameters.
* @param d Props object to merge. The function will overwrite conflicting props from previous parameters.
* @param e Props object to merge. The function will overwrite conflicting props from previous parameters.
* @returns The merged props.
* @public
*/ function mergeProps$1(a, b, c, d, e) {
    if (!c && !d && !e && !a) return createInitialMergedProps(b);
    var merged = createInitialMergedProps(a);
    if (b) merged = mergeInto(merged, b);
    if (c) merged = mergeInto(merged, c);
    if (d) merged = mergeInto(merged, d);
    if (e) merged = mergeInto(merged, e);
    return merged;
}
/**
* Merges an arbitrary number of React props using the same logic as {@link mergeProps}.
* This function accepts an array of props instead of individual arguments.
*
* This has slightly lower performance than {@link mergeProps} due to accepting an array
* instead of a fixed number of arguments. Prefer {@link mergeProps} when merging 5 or
* fewer prop sets for better performance.
*
* @param props Array of props to merge.
* @returns The merged props.
* @see mergeProps
* @public
*/ function mergePropsN(props) {
    if (props.length === 0) return EMPTY_PROPS;
    if (props.length === 1) return createInitialMergedProps(props[0]);
    var merged = createInitialMergedProps(props[0]);
    for(var i = 1; i < props.length; i += 1)merged = mergeInto(merged, props[i]);
    return merged;
}
function createInitialMergedProps(inputProps) {
    if (isPropsGetter(inputProps)) return (0,src_object_spread/* default */.Z)({}, resolvePropsGetter(inputProps, EMPTY_PROPS));
    return copyInitialProps(inputProps);
}
function mergeInto(merged, inputProps) {
    if (isPropsGetter(inputProps)) return resolvePropsGetter(inputProps, merged);
    return mutablyMergeInto(merged, inputProps);
}
function copyInitialProps(inputProps) {
    var copiedProps = (0,src_object_spread/* default */.Z)({}, inputProps);
    for(var propName in copiedProps){
        var propValue = copiedProps[propName];
        if (isEventHandler(propName, propValue)) copiedProps[propName] = wrapEventHandler(propValue);
    }
    return copiedProps;
}
/**
* Merges two sets of props. In case of conflicts, the external props take precedence.
*/ function mutablyMergeInto(mergedProps, externalProps) {
    if (!externalProps) return mergedProps;
    for(var propName in externalProps){
        var externalPropValue = externalProps[propName];
        switch(propName){
            case "style":
                mergedProps[propName] = mergeObjects(mergedProps.style, externalPropValue);
                break;
            case "className":
                mergedProps[propName] = mergeClassNames(mergedProps.className, externalPropValue);
                break;
            default:
                if (isEventHandler(propName, externalPropValue)) mergedProps[propName] = mergeEventHandlers(mergedProps[propName], externalPropValue);
                else mergedProps[propName] = externalPropValue;
        }
    }
    return mergedProps;
}
function isEventHandler(key, value) {
    var code0 = key.charCodeAt(0);
    var code1 = key.charCodeAt(1);
    var code2 = key.charCodeAt(2);
    return code0 === 111 && code1 === 110 && code2 >= 65 && code2 <= 90 && (typeof value === "function" || typeof value === "undefined");
}
function isPropsGetter(inputProps) {
    return typeof inputProps === "function";
}
function resolvePropsGetter(inputProps, previousProps) {
    if (isPropsGetter(inputProps)) return inputProps(previousProps);
    return inputProps !== null && inputProps !== void 0 ? inputProps : EMPTY_PROPS;
}
function mergeEventHandlers(ourHandler, theirHandler) {
    if (!theirHandler) return ourHandler;
    if (!ourHandler) return wrapEventHandler(theirHandler);
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var event = args[0];
        if (isSyntheticEvent(event)) {
            var baseUIEvent = event;
            makeEventPreventable(baseUIEvent);
            var result = theirHandler.apply(void 0, (0,src_to_consumable_array/* default */.Z)(args));
            if (!baseUIEvent.baseUIHandlerPrevented) ourHandler === null || ourHandler === void 0 ? void 0 : ourHandler.apply(void 0, (0,src_to_consumable_array/* default */.Z)(args));
            return result;
        }
        var result1 = theirHandler.apply(void 0, (0,src_to_consumable_array/* default */.Z)(args));
        ourHandler === null || ourHandler === void 0 ? void 0 : ourHandler.apply(void 0, (0,src_to_consumable_array/* default */.Z)(args));
        return result1;
    };
}
function wrapEventHandler(handler) {
    if (!handler) return handler;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var event = args[0];
        if (isSyntheticEvent(event)) makeEventPreventable(event);
        return handler.apply(void 0, (0,src_to_consumable_array/* default */.Z)(args));
    };
}
function makeEventPreventable(event) {
    event.preventBaseUIHandler = function() {
        event.baseUIHandlerPrevented = true;
    };
    return event;
}
function mergeClassNames(ourClassName, theirClassName) {
    if (theirClassName) {
        if (ourClassName) return theirClassName + " " + ourClassName;
        return theirClassName;
    }
    return ourClassName;
}
function isSyntheticEvent(event) {
    return event != null && typeof event === "object" && "nativeEvent" in event;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/useRenderElement.js
/**
* Renders a Base UI element.
*
* @param element The default HTML element to render. Can be overridden by the `render` prop.
* @param componentProps An object containing the `render` and `className` props to be used for element customization. Other props are ignored.
* @param params Additional parameters for rendering the element.
*/ function useRenderElement(element, componentProps) {
    var params = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var renderProp = componentProps.render;
    var outProps = useRenderElementProps(componentProps, params);
    if (params.enabled === false) return null;
    var _state;
    return evaluateRenderProp(element, renderProp, outProps, (_state = params.state) !== null && _state !== void 0 ? _state : EMPTY_OBJECT);
}
/**
* Computes render element final props.
*/ function useRenderElementProps(componentProps) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var classNameProp = componentProps.className, styleProp = componentProps.style, renderProp = componentProps.render;
    var _state = params.state, state = _state === void 0 ? EMPTY_OBJECT : _state, ref = params.ref, props = params.props, stateAttributesMapping = params.stateAttributesMapping, _enabled = params.enabled, enabled = _enabled === void 0 ? true : _enabled;
    var className = enabled ? resolveClassName(classNameProp, state) : void 0;
    var style = enabled ? resolveStyle(styleProp, state) : void 0;
    var stateProps = enabled ? getStateAttributesProps(state, stateAttributesMapping) : EMPTY_OBJECT;
    var resolvedProps = enabled && props ? resolveRenderFunctionProps(props) : void 0;
    var ref1;
    var outProps = enabled ? (ref1 = mergeObjects(stateProps, resolvedProps)) !== null && ref1 !== void 0 ? ref1 : {} : EMPTY_OBJECT;
    if (typeof document !== "undefined") if (!enabled) useMergedRefs(null, null);
    else if (Array.isArray(ref)) outProps.ref = useMergedRefsN([
        outProps.ref,
        getReactElementRef(renderProp)
    ].concat((0,src_to_consumable_array/* default */.Z)(ref)));
    else outProps.ref = useMergedRefs(outProps.ref, getReactElementRef(renderProp), ref);
    if (!enabled) return EMPTY_OBJECT;
    if (className !== void 0) outProps.className = mergeClassNames(outProps.className, className);
    if (style !== void 0) outProps.style = mergeObjects(outProps.style, style);
    return outProps;
}
function resolveRenderFunctionProps(props) {
    if (Array.isArray(props)) return mergePropsN(props);
    return mergeProps$1(void 0, props);
}
var REACT_LAZY_TYPE = Symbol.for("react.lazy");
var COMPONENT_IDENTIFIER_PATTERN = /^[A-Z][A-Za-z0-9$]*$/;
var LOWERCASE_CHARACTER_PATTERN = /[a-z]/;
function evaluateRenderProp(element, render, props, state) {
    if (render) {
        if (typeof render === "function") {
            if (false) {}
            return render(props, state);
        }
        var mergedProps = mergeProps$1(props, render.props);
        mergedProps.ref = props.ref;
        var newElement = render;
        if ((newElement === null || newElement === void 0 ? void 0 : newElement.$$typeof) === REACT_LAZY_TYPE) newElement = react.Children.toArray(render)[0];
        if (false) {}
        return /* @__PURE__ */ /*#__PURE__*/ react.cloneElement(newElement, mergedProps);
    }
    if (element) {
        if (typeof element === "string") return renderTag(element, props);
    }
    throw new Error( false ? 0 : formatErrorMessage(8));
}
function warnIfRenderPropLooksLikeComponent(renderFn) {
    var functionName = renderFn.name;
    if (functionName.length === 0) return;
    if (!COMPONENT_IDENTIFIER_PATTERN.test(functionName)) return;
    if (!LOWERCASE_CHARACTER_PATTERN.test(functionName)) return;
    warn("The `render` prop received a function named `".concat(functionName, "` that starts with an uppercase letter."), "This usually means a React component was passed directly as `render={Component}`.", "Base UI calls `render` as a plain function, which can break the Rules of Hooks during reconciliation.", "If this is an intentional render callback, rename it to start with a lowercase letter.", "Use `render={<Component />}` or `render={(props) => <Component {...props} />}` instead.", "https://base-ui.com/r/invalid-render-prop");
}
function renderTag(Tag, props) {
    if (Tag === "button") return /* @__PURE__ */ /*#__PURE__*/ (0,react.createElement)("button", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        type: "button"
    }, props), {
        key: props.key
    }));
    if (Tag === "img") return /* @__PURE__ */ /*#__PURE__*/ (0,react.createElement)("img", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        alt: ""
    }, props), {
        key: props.key
    }));
    return /* @__PURE__ */ /*#__PURE__*/ react.createElement(Tag, props);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/use-render/useRender.js
/**
* Renders a Base UI element.
*
* @public
*/ function useRender(params) {
    var _defaultTagName;
    return useRenderElement((_defaultTagName = params.defaultTagName) !== null && _defaultTagName !== void 0 ? _defaultTagName : "div", params, params);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/error.js
var set;
if (false) {}
function error() {
    for(var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++){
        messages[_key] = arguments[_key];
    }
    if (false) { var messageKey; }
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/useControlled.js
function useControlled(param) {
    var controlled = param.controlled, defaultProp = param.default, name = param.name, _state = param.state, state = _state === void 0 ? "value" : _state;
    var ref = react.useRef(controlled !== void 0), isControlled = ref.current;
    var ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState(defaultProp), 2), valueState = ref1[0], setValue = ref1[1];
    var value = isControlled ? controlled : valueState;
    if (false) { var ref2, defaultValue; }
    return [
        value,
        react.useCallback(function(newValue) {
            if (!isControlled) setValue(newValue);
        }, [])
    ];
}
function serializeToDevModeString(input) {
    var nextId = 0;
    var seen = /* @__PURE__ */ new WeakMap();
    try {
        var ref;
        return (ref = JSON.stringify(input, function replacer(key, value) {
            if (key === "_owner" && this != null && typeof this === "object" && "$$typeof" in this) return;
            if ((typeof value === "undefined" ? "undefined" : _type_of(value)) === "bigint") return "__bigint__:".concat(value);
            if (value !== null && typeof value === "object") {
                var id = seen.get(value);
                if (id !== void 0) return "__object__:".concat(id);
                seen.set(value, nextId);
                nextId += 1;
            }
            return value;
        })) !== null && ref !== void 0 ? ref : "__top__:".concat(typeof input === "undefined" ? "undefined" : _type_of(input));
    } catch (e) {
        return "__unserializable__";
    }
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/useStableCallback.js
var useInsertionEffect = react_namespaceObject["useInsertionEffect".concat(Math.random().toFixed(1)).slice(0, -3)];
var useSafeInsertionEffect = useInsertionEffect && useInsertionEffect !== react.useLayoutEffect ? useInsertionEffect : function(fn) {
    return fn();
};
/**
* Stabilizes the function passed so it's always the same between renders.
*
* The function becomes non-reactive to any values it captures.
* It can safely be passed as a dependency of `React.useMemo` and `React.useEffect` without re-triggering them if its captured values change.
*
* The function must only be called inside effects and event handlers, never during render (which throws an error).
*
* This hook is a more permissive version of React 19.2's `React.useEffectEvent` in that it can be passed through contexts and called in event handler props, not just effects.
*/ function useStableCallback(callback) {
    var stable = useRefWithInit(createStableCallback).current;
    stable.next = callback;
    useSafeInsertionEffect(stable.effect);
    return stable.trampoline;
}
function createStableCallback() {
    var stable = {
        next: void 0,
        callback: assertNotCalled,
        trampoline: function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _ref;
            var ref;
            return (ref = stable.callback) === null || ref === void 0 ? void 0 : (_ref = ref).call.apply(_ref, [
                stable
            ].concat((0,src_to_consumable_array/* default */.Z)(args)));
        },
        effect: function() {
            stable.callback = stable.next;
        }
    };
    return stable;
}
function assertNotCalled() {
    if (false) {}
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/useIsoLayoutEffect.js
var noop = function() {};
var useIsoLayoutEffect = typeof document !== "undefined" ? react.useLayoutEffect : noop;
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/visuallyHidden.js
var visuallyHiddenBase = {
    clipPath: "inset(50%)",
    overflow: "hidden",
    whiteSpace: "nowrap",
    border: 0,
    padding: 0,
    width: 1,
    height: 1,
    margin: -1
};
var visuallyHidden = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, visuallyHiddenBase), {
    position: "fixed",
    top: 0,
    left: 0
});
var visuallyHiddenInput = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, visuallyHiddenBase), {
    position: "absolute"
});
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/checkbox/root/CheckboxRootDataAttributes.js
var CheckboxRootDataAttributes = /* @__PURE__ */ function(CheckboxRootDataAttributes) {
    /**
	* Present when the checkbox is checked.
	*/ CheckboxRootDataAttributes["checked"] = "data-checked";
    /**
	* Present when the checkbox is not checked.
	*/ CheckboxRootDataAttributes["unchecked"] = "data-unchecked";
    /**
	* Present when the checkbox is in an indeterminate state.
	*/ CheckboxRootDataAttributes["indeterminate"] = "data-indeterminate";
    /**
	* Present when the checkbox is disabled.
	*/ CheckboxRootDataAttributes["disabled"] = "data-disabled";
    /**
	* Present when the checkbox is readonly.
	*/ CheckboxRootDataAttributes["readonly"] = "data-readonly";
    /**
	* Present when the checkbox is required.
	*/ CheckboxRootDataAttributes["required"] = "data-required";
    /**
	* Present when the checkbox is in a valid state (when wrapped in Field.Root).
	*/ CheckboxRootDataAttributes["valid"] = "data-valid";
    /**
	* Present when the checkbox is in an invalid state (when wrapped in Field.Root).
	*/ CheckboxRootDataAttributes["invalid"] = "data-invalid";
    /**
	* Present when the checkbox has been touched (when wrapped in Field.Root).
	*/ CheckboxRootDataAttributes["touched"] = "data-touched";
    /**
	* Present when the checkbox's value has changed (when wrapped in Field.Root).
	*/ CheckboxRootDataAttributes["dirty"] = "data-dirty";
    /**
	* Present when the checkbox is checked (when wrapped in Field.Root).
	*/ CheckboxRootDataAttributes["filled"] = "data-filled";
    /**
	* Present when the checkbox is focused (when wrapped in Field.Root).
	*/ CheckboxRootDataAttributes["focused"] = "data-focused";
    return CheckboxRootDataAttributes;
}({});
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/field/control/FieldControlDataAttributes.js
var FieldControlDataAttributes = /* @__PURE__ */ function(FieldControlDataAttributes) {
    /**
	* Present when the field is disabled.
	*/ FieldControlDataAttributes["disabled"] = "data-disabled";
    /**
	* Present when the field is in a valid state.
	*/ FieldControlDataAttributes["valid"] = "data-valid";
    /**
	* Present when the field is in an invalid state.
	*/ FieldControlDataAttributes["invalid"] = "data-invalid";
    /**
	* Present when the field has been touched.
	*/ FieldControlDataAttributes["touched"] = "data-touched";
    /**
	* Present when the field's value has changed.
	*/ FieldControlDataAttributes["dirty"] = "data-dirty";
    /**
	* Present when the field is filled.
	*/ FieldControlDataAttributes["filled"] = "data-filled";
    /**
	* Present when the field control is focused.
	*/ FieldControlDataAttributes["focused"] = "data-focused";
    return FieldControlDataAttributes;
}({});
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/field-constants/constants.js
var DEFAULT_VALIDITY_STATE = {
    badInput: false,
    customError: false,
    patternMismatch: false,
    rangeOverflow: false,
    rangeUnderflow: false,
    stepMismatch: false,
    tooLong: false,
    tooShort: false,
    typeMismatch: false,
    valid: null,
    valueMissing: false
};
var DEFAULT_FIELD_STATE_ATTRIBUTES = {
    valid: null,
    touched: false,
    dirty: false,
    filled: false,
    focused: false
};
var DEFAULT_FIELD_ROOT_STATE = (0,src_object_spread/* default */.Z)({
    disabled: false
}, DEFAULT_FIELD_STATE_ATTRIBUTES);
var fieldValidityMapping = {
    valid: function valid(value) {
        if (value === null) return null;
        if (value) return (0,src_define_property/* default */.Z)({}, FieldControlDataAttributes.valid, "");
        return (0,src_define_property/* default */.Z)({}, FieldControlDataAttributes.invalid, "");
    }
};
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/checkbox/utils/useStateAttributesMapping.js
function useStateAttributesMapping(state) {
    return React$1.useMemo(function() {
        return _object_spread({
            checked: function checked(value) {
                if (state.indeterminate) return {};
                if (value) return _define_property({}, CheckboxRootDataAttributes.checked, "");
                return _define_property({}, CheckboxRootDataAttributes.unchecked, "");
            }
        }, fieldValidityMapping);
    }, [
        state.indeterminate
    ]);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/safeReact.js
var SafeReact = (0,src_object_spread/* default */.Z)({}, react_namespaceObject);
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/useId.js
var globalId = 0;
function useGlobalId(idOverride) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "mui";
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(idOverride), 2), defaultId = ref[0], setDefaultId = ref[1];
    var id = idOverride || defaultId;
    react.useEffect(function() {
        if (defaultId == null) {
            globalId += 1;
            setDefaultId("".concat(prefix, "-").concat(globalId));
        }
    }, [
        defaultId,
        prefix
    ]);
    return id;
}
var maybeReactUseId = SafeReact.useId;
/**
*
* @example <div id={useId()} />
* @param idOverride
* @returns {string}
*/ function useId$1(idOverride, prefix) {
    if (maybeReactUseId !== void 0) {
        var reactId = maybeReactUseId();
        return idOverride !== null && idOverride !== void 0 ? idOverride : prefix ? "".concat(prefix, "-").concat(reactId) : reactId;
    }
    return useGlobalId(idOverride, prefix);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/useBaseUiId.js
/**
* Wraps `useId` and prefixes generated `id`s with `base-ui-`
* @param {string | undefined} idOverride overrides the generated id when provided
* @returns {string | undefined}
*/ function useBaseUiId(idOverride) {
    return useId$1(idOverride, "base-ui");
}
//#endregion
//#region ../../node_modules/.pnpm/@floating-ui+utils@0.2.11/node_modules/@floating-ui/utils/dist/floating-ui.utils.dom.mjs
function hasWindow() {
    return "object" !== "undefined";
}
function getNodeName(node) {
    if (isNode(node)) return (node.nodeName || "").toLowerCase();
    return "#document";
}
function getWindow(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
    var _ref;
    return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
    if (!hasWindow()) return false;
    return (0,_instanceof/* default */.Z)(value, Node) || (0,_instanceof/* default */.Z)(value, getWindow(value).Node);
}
function isElement(value) {
    if (!hasWindow()) return false;
    return (0,_instanceof/* default */.Z)(value, Element) || (0,_instanceof/* default */.Z)(value, getWindow(value).Element);
}
function isHTMLElement(value) {
    if (!hasWindow()) return false;
    return (0,_instanceof/* default */.Z)(value, HTMLElement) || (0,_instanceof/* default */.Z)(value, getWindow(value).HTMLElement);
}
function isShadowRoot(value) {
    if (!hasWindow() || typeof ShadowRoot === "undefined") return false;
    return (0,_instanceof/* default */.Z)(value, ShadowRoot) || (0,_instanceof/* default */.Z)(value, getWindow(value).ShadowRoot);
}
function isOverflowElement(element) {
    var ref = getComputedStyle$1(element), overflow = ref.overflow, overflowX = ref.overflowX, overflowY = ref.overflowY, display = ref.display;
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== "inline" && display !== "contents";
}
function isTableElement(element) {
    return /^(table|td|th)$/.test(getNodeName(element));
}
function isTopLayer(element) {
    try {
        if (element.matches(":popover-open")) return true;
    } catch (_e) {}
    try {
        return element.matches(":modal");
    } catch (_e1) {
        return false;
    }
}
var willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
var containRe = /paint|layout|strict|content/;
var isNotNone = function(value) {
    return !!value && value !== "none";
};
var isWebKitValue;
function isContainingBlock(elementOrCss) {
    var css = isElement(elementOrCss) ? getComputedStyle$1(elementOrCss) : elementOrCss;
    return isNotNone(css.transform) || isNotNone(css.translate) || isNotNone(css.scale) || isNotNone(css.rotate) || isNotNone(css.perspective) || !isWebKit$1() && (isNotNone(css.backdropFilter) || isNotNone(css.filter)) || willChangeRe.test(css.willChange || "") || containRe.test(css.contain || "");
}
function getContainingBlock(element) {
    var currentNode = getParentNode(element);
    while(isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)){
        if (isContainingBlock(currentNode)) return currentNode;
        else if (isTopLayer(currentNode)) return null;
        currentNode = getParentNode(currentNode);
    }
    return null;
}
function isWebKit$1() {
    if (isWebKitValue == null) isWebKitValue = typeof CSS !== "undefined" && CSS.supports && CSS.supports("-webkit-backdrop-filter", "none");
    return isWebKitValue;
}
function isLastTraversableNode(node) {
    return /^(html|body|#document)$/.test(getNodeName(node));
}
function getComputedStyle$1(element) {
    return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
    if (isElement(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function getParentNode(node) {
    if (getNodeName(node) === "html") return node;
    var result = node.assignedSlot || node.parentNode || isShadowRoot(node) && node.host || getDocumentElement(node);
    return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
    var parentNode = getParentNode(node);
    if (isLastTraversableNode(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) return parentNode;
    return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    var scrollableAncestor = getNearestOverflowAncestor(node);
    var isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    var win = getWindow(scrollableAncestor);
    if (isBody) {
        var frameElement = getFrameElement(win);
        return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
    } else return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/composite/root/CompositeRootContext.js
var CompositeRootContext = /* @__PURE__ */ /*#__PURE__*/ react.createContext(void 0);
if (false) {}
function useCompositeRootContext() {
    var optional = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var context = react.useContext(CompositeRootContext);
    if (context === void 0 && !optional) throw new Error( false ? 0 : formatErrorMessage(16));
    return context;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/utils/useFocusableWhenDisabled.js
function useFocusableWhenDisabled(parameters) {
    var focusableWhenDisabled = parameters.focusableWhenDisabled, disabled = parameters.disabled, _composite = parameters.composite, composite = _composite === void 0 ? false : _composite, tmp = parameters.tabIndex, tabIndexProp = tmp === void 0 ? 0 : tmp, isNativeButton = parameters.isNativeButton;
    var isFocusableComposite = composite && focusableWhenDisabled !== false;
    var isNonFocusableComposite = composite && focusableWhenDisabled === false;
    return {
        props: react.useMemo(function() {
            var additionalProps = {
                onKeyDown: function onKeyDown(event) {
                    if (disabled && focusableWhenDisabled && event.key !== "Tab") event.preventDefault();
                }
            };
            if (!composite) {
                additionalProps.tabIndex = tabIndexProp;
                if (!isNativeButton && disabled) additionalProps.tabIndex = focusableWhenDisabled ? tabIndexProp : -1;
            }
            if (isNativeButton && (focusableWhenDisabled || isFocusableComposite) || !isNativeButton && disabled) additionalProps["aria-disabled"] = disabled;
            if (isNativeButton && (!focusableWhenDisabled || isNonFocusableComposite)) additionalProps.disabled = disabled;
            return additionalProps;
        }, [
            composite,
            disabled,
            focusableWhenDisabled,
            isFocusableComposite,
            isNonFocusableComposite,
            isNativeButton,
            tabIndexProp
        ])
    };
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/use-button/useButton.js
function useButton() {
    var parameters = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _disabled = parameters.disabled, disabled = _disabled === void 0 ? false : _disabled, focusableWhenDisabled = parameters.focusableWhenDisabled, _tabIndex = parameters.tabIndex, tabIndex = _tabIndex === void 0 ? 0 : _tabIndex, tmp = parameters.native, isNativeButton = tmp === void 0 ? true : tmp, compositeProp = parameters.composite;
    var elementRef = react.useRef(null);
    var compositeRootContext = useCompositeRootContext(true);
    var isCompositeItem = compositeProp !== null && compositeProp !== void 0 ? compositeProp : compositeRootContext !== void 0;
    var ref = useFocusableWhenDisabled({
        focusableWhenDisabled: focusableWhenDisabled,
        disabled: disabled,
        composite: isCompositeItem,
        tabIndex: tabIndex,
        isNativeButton: isNativeButton
    }), focusableWhenDisabledProps = ref.props;
    if (false) {}
    var updateDisabled = react.useCallback(function() {
        var element = elementRef.current;
        if (!isButtonElement(element)) return;
        if (isCompositeItem && disabled && focusableWhenDisabledProps.disabled === void 0 && element.disabled) element.disabled = false;
    }, [
        disabled,
        focusableWhenDisabledProps.disabled,
        isCompositeItem
    ]);
    useIsoLayoutEffect(updateDisabled, [
        updateDisabled
    ]);
    return {
        getButtonProps: react.useCallback(function() {
            var externalProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
            var externalOnClick = externalProps.onClick, externalOnMouseDown = externalProps.onMouseDown, externalOnKeyUp = externalProps.onKeyUp, externalOnKeyDown = externalProps.onKeyDown, externalOnPointerDown = externalProps.onPointerDown, otherExternalProps = (0,src_object_without_properties/* default */.Z)(externalProps, [
                "onClick",
                "onMouseDown",
                "onKeyUp",
                "onKeyDown",
                "onPointerDown"
            ]);
            return mergeProps$1({
                type: isNativeButton ? "button" : void 0,
                onClick: function onClick(event) {
                    if (disabled) {
                        event.preventDefault();
                        return;
                    }
                    externalOnClick === null || externalOnClick === void 0 ? void 0 : externalOnClick(event);
                },
                onMouseDown: function onMouseDown(event) {
                    if (!disabled) externalOnMouseDown === null || externalOnMouseDown === void 0 ? void 0 : externalOnMouseDown(event);
                },
                onKeyDown: function onKeyDown(event) {
                    if (disabled) return;
                    makeEventPreventable(event);
                    externalOnKeyDown === null || externalOnKeyDown === void 0 ? void 0 : externalOnKeyDown(event);
                    if (event.baseUIHandlerPrevented) return;
                    var isCurrentTarget = event.target === event.currentTarget;
                    var currentTarget = event.currentTarget;
                    var isButton = isButtonElement(currentTarget);
                    var isLink = !isNativeButton && isValidLinkElement(currentTarget);
                    var shouldClick = isCurrentTarget && (isNativeButton ? isButton : !isLink);
                    var isEnterKey = event.key === "Enter";
                    var isSpaceKey = event.key === " ";
                    var role = currentTarget.getAttribute("role");
                    var isTextNavigationRole = (role === null || role === void 0 ? void 0 : role.startsWith("menuitem")) || role === "option" || role === "gridcell";
                    if (isCurrentTarget && isCompositeItem && isSpaceKey) {
                        if (event.defaultPrevented && isTextNavigationRole) return;
                        event.preventDefault();
                        if (isLink || isNativeButton && isButton) {
                            currentTarget.click();
                            event.preventBaseUIHandler();
                        } else if (shouldClick) {
                            externalOnClick === null || externalOnClick === void 0 ? void 0 : externalOnClick(event);
                            event.preventBaseUIHandler();
                        }
                        return;
                    }
                    if (shouldClick) {
                        if (!isNativeButton && (isSpaceKey || isEnterKey)) event.preventDefault();
                        if (!isNativeButton && isEnterKey) externalOnClick === null || externalOnClick === void 0 ? void 0 : externalOnClick(event);
                    }
                },
                onKeyUp: function onKeyUp(event) {
                    if (disabled) return;
                    makeEventPreventable(event);
                    externalOnKeyUp === null || externalOnKeyUp === void 0 ? void 0 : externalOnKeyUp(event);
                    if (event.target === event.currentTarget && isNativeButton && isCompositeItem && isButtonElement(event.currentTarget) && event.key === " ") {
                        event.preventDefault();
                        return;
                    }
                    if (event.baseUIHandlerPrevented) return;
                    if (event.target === event.currentTarget && !isNativeButton && !isCompositeItem && event.key === " ") externalOnClick === null || externalOnClick === void 0 ? void 0 : externalOnClick(event);
                },
                onPointerDown: function onPointerDown(event) {
                    if (disabled) {
                        event.preventDefault();
                        return;
                    }
                    externalOnPointerDown === null || externalOnPointerDown === void 0 ? void 0 : externalOnPointerDown(event);
                }
            }, !isNativeButton ? {
                role: "button"
            } : void 0, focusableWhenDisabledProps, otherExternalProps);
        }, [
            disabled,
            focusableWhenDisabledProps,
            isCompositeItem,
            isNativeButton
        ]),
        buttonRef: useStableCallback(function(element) {
            elementRef.current = element;
            updateDisabled();
        })
    };
}
function isButtonElement(elem) {
    return isHTMLElement(elem) && elem.tagName === "BUTTON";
}
function isValidLinkElement(elem) {
    return Boolean((elem === null || elem === void 0 ? void 0 : elem.tagName) === "A" && (elem === null || elem === void 0 ? void 0 : elem.href));
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/field-root-context/FieldRootContext.js
var FieldRootContext = /* @__PURE__ */ /*#__PURE__*/ react.createContext({
    invalid: void 0,
    name: void 0,
    validityData: {
        state: DEFAULT_VALIDITY_STATE,
        errors: [],
        error: "",
        value: "",
        initialValue: null
    },
    setValidityData: NOOP,
    disabled: void 0,
    touched: DEFAULT_FIELD_STATE_ATTRIBUTES.touched,
    setTouched: NOOP,
    dirty: DEFAULT_FIELD_STATE_ATTRIBUTES.dirty,
    setDirty: NOOP,
    filled: DEFAULT_FIELD_STATE_ATTRIBUTES.filled,
    setFilled: NOOP,
    focused: DEFAULT_FIELD_STATE_ATTRIBUTES.focused,
    setFocused: NOOP,
    validate: function() {
        return null;
    },
    validationMode: "onSubmit",
    validationDebounceTime: 0,
    shouldValidateOnChange: function() {
        return false;
    },
    state: DEFAULT_FIELD_ROOT_STATE,
    markedDirtyRef: {
        current: false
    },
    registerFieldControl: NOOP,
    validation: {
        getValidationProps: function() {
            var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : EMPTY_OBJECT;
            return props;
        },
        getInputValidationProps: function() {
            var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : EMPTY_OBJECT;
            return props;
        },
        inputRef: {
            current: null
        },
        commit: /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                return [
                    2
                ];
            });
        })
    }
});
if (false) {}
function useFieldRootContext() {
    var optional = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    var context = react.useContext(FieldRootContext);
    if (context.setValidityData === NOOP && !optional) throw new Error( false ? 0 : formatErrorMessage(28));
    return context;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/field-register-control/useRegisterFieldControl.js
function useRegisterFieldControl(controlRef, params) {
    var _enabled = params.enabled, enabled = _enabled === void 0 ? true : _enabled, getValue = params.getValue, id = params.id, value = params.value;
    var registerFieldControl = useFieldRootContext().registerFieldControl;
    var sourceRef = react.useRef(null);
    if (!sourceRef.current) sourceRef.current = Symbol();
    useIsoLayoutEffect(function() {
        var source = sourceRef.current;
        if (!source || !enabled) return;
        registerFieldControl(source, {
            controlRef: controlRef,
            getValue: getValue,
            id: id,
            value: value
        });
        return function() {
            registerFieldControl(source, void 0);
        };
    }, [
        controlRef,
        enabled,
        getValue,
        id,
        registerFieldControl,
        value
    ]);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/field/item/FieldItemContext.js
var FieldItemContext = /* @__PURE__ */ /*#__PURE__*/ react.createContext({
    disabled: false
});
if (false) {}
function useFieldItemContext() {
    return react.useContext(FieldItemContext);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/form-context/FormContext.js
var FormContext = /* @__PURE__ */ /*#__PURE__*/ react.createContext({
    formRef: {
        current: {
            fields: /* @__PURE__ */ new Map()
        }
    },
    errors: {},
    clearErrors: NOOP,
    validationMode: "onSubmit",
    submitAttemptedRef: {
        current: false
    }
});
if (false) {}
function useFormContext() {
    return react.useContext(FormContext);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/labelable-provider/LabelableContext.js
/**
* A context for providing [labelable elements](https://html.spec.whatwg.org/multipage/forms.html#category-label)\
* with an accessible name (label) and description.
*/ var LabelableContext = /* @__PURE__ */ /*#__PURE__*/ react.createContext({
    controlId: void 0,
    registerControlId: NOOP,
    labelId: void 0,
    setLabelId: NOOP,
    messageIds: [],
    setMessageIds: NOOP,
    getDescriptionProps: function(externalProps) {
        return externalProps;
    }
});
if (false) {}
function useLabelableContext() {
    return react.useContext(LabelableContext);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/labelable-provider/useAriaLabelledBy.js
/**
* @internal
*/ function useAriaLabelledBy(explicitAriaLabelledBy, labelId, labelSourceRef) {
    var enableFallback = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, labelSourceId = arguments.length > 4 ? arguments[4] : void 0;
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(), 2), fallbackAriaLabelledBy = ref[0], setFallbackAriaLabelledBy = ref[1];
    var generatedLabelId = useBaseUiId(labelSourceId ? "".concat(labelSourceId, "-label") : void 0);
    var ref1;
    var ariaLabelledBy = (ref1 = explicitAriaLabelledBy !== null && explicitAriaLabelledBy !== void 0 ? explicitAriaLabelledBy : labelId) !== null && ref1 !== void 0 ? ref1 : fallbackAriaLabelledBy;
    useIsoLayoutEffect(function() {
        var nextAriaLabelledBy = explicitAriaLabelledBy || labelId || !enableFallback ? void 0 : getAriaLabelledBy(labelSourceRef.current, generatedLabelId);
        if (fallbackAriaLabelledBy !== nextAriaLabelledBy) setFallbackAriaLabelledBy(nextAriaLabelledBy);
    });
    return ariaLabelledBy;
}
function getAriaLabelledBy(labelSource, generatedLabelId) {
    var label = findAssociatedLabel(labelSource);
    if (!label) return;
    if (!label.id && generatedLabelId) label.id = generatedLabelId;
    return label.id || void 0;
}
function findAssociatedLabel(labelSource) {
    if (!labelSource) return;
    var parent = labelSource.parentElement;
    if (parent && parent.tagName === "LABEL") return parent;
    var controlId = labelSource.id;
    if (controlId) {
        var nextSibling = labelSource.nextElementSibling;
        if (nextSibling && nextSibling.htmlFor === controlId) return nextSibling;
    }
    var labels = labelSource.labels;
    return labels && labels[0];
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/checkbox-group/CheckboxGroupContext.js
var CheckboxGroupContext = /* @__PURE__ */ /*#__PURE__*/ react.createContext(void 0);
if (false) {}
function useCheckboxGroupContext() {
    var optional = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    var context = React$1.useContext(CheckboxGroupContext);
    if (context === void 0 && !optional) throw new Error( false ? 0 : formatErrorMessage(3));
    return context;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/checkbox/root/CheckboxRootContext.js
var CheckboxRootContext = /* @__PURE__ */ /*#__PURE__*/ react.createContext(void 0);
if (false) {}
function useCheckboxRootContext() {
    var context = React$1.useContext(CheckboxRootContext);
    if (context === void 0) throw new Error( false ? 0 : formatErrorMessage(14));
    return context;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/reason-parts.js
var none = "none";
var triggerPress = "trigger-press";
var outsidePress = "outside-press";
var itemPress = "item-press";
var closePress = "close-press";
var inputChange = "input-change";
var inputClear = "input-clear";
var inputBlur = "input-blur";
var inputPaste = "input-paste";
var inputPress = "input-press";
var focusOut = "focus-out";
var escapeKey = "escape-key";
var listNavigation = "list-navigation";
var keyboard = "keyboard";
var imperativeAction = "imperative-action";
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/createBaseUIEventDetails.js
/**
* Maps a change `reason` string to the corresponding native event type.
*/ /**
* Details of custom change events emitted by Base UI components.
*/ /**
* Details of custom generic events emitted by Base UI components.
*/ /**
* Creates a Base UI event details object with the given reason and utilities
* for preventing Base UI's internal event handling.
*/ function createChangeEventDetails(reason, event, trigger, customProperties) {
    var canceled = false;
    var allowPropagation = false;
    var custom = customProperties !== null && customProperties !== void 0 ? customProperties : EMPTY_OBJECT;
    return (0,src_object_spread/* default */.Z)({
        reason: reason,
        event: event !== null && event !== void 0 ? event : new Event("base-ui"),
        cancel: function cancel() {
            canceled = true;
        },
        allowPropagation: function allowPropagation1() {
            allowPropagation = true;
        },
        get isCanceled () {
            return canceled;
        },
        get isPropagationAllowed () {
            return allowPropagation;
        },
        trigger: trigger
    }, custom);
}
function createGenericEventDetails(reason, event, customProperties) {
    var custom = customProperties !== null && customProperties !== void 0 ? customProperties : EMPTY_OBJECT;
    return (0,src_object_spread/* default */.Z)({
        reason: reason,
        event: event !== null && event !== void 0 ? event : new Event("base-ui")
    }, custom);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/useValueChanged.js
function useValueChanged(value, onChange) {
    var valueRef = react.useRef(value);
    var onChangeCallback = useStableCallback(onChange);
    useIsoLayoutEffect(function() {
        if (valueRef.current === value) return;
        onChangeCallback(valueRef.current);
    }, [
        value,
        onChangeCallback
    ]);
    useIsoLayoutEffect(function() {
        valueRef.current = value;
    }, [
        value
    ]);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/checkbox/root/CheckboxRoot.js
var PARENT_CHECKBOX = "data-parent";
/**
* Represents the checkbox itself.
* Renders a `<span>` element and a hidden `<input>` beside.
*
* Documentation: [Base UI Checkbox](https://base-ui.com/react/components/checkbox)
*/ var CheckboxRoot = /* @__PURE__ */ /*#__PURE__*/ (/* unused pure expression or super */ null && (React$1.forwardRef(function CheckboxRoot(componentProps, forwardedRef) {
    var checkedProp = componentProps.checked, className = componentProps.className, _defaultChecked = componentProps.defaultChecked, defaultChecked = _defaultChecked === void 0 ? false : _defaultChecked, ariaLabelledByProp = componentProps["aria-labelledby"], tmp = componentProps.disabled, disabledProp = tmp === void 0 ? false : tmp, form = componentProps.form, idProp = componentProps.id, _indeterminate = componentProps.indeterminate, indeterminate = _indeterminate === void 0 ? false : _indeterminate, inputRefProp = componentProps.inputRef, nameProp = componentProps.name, onCheckedChangeProp = componentProps.onCheckedChange, _parent = componentProps.parent, parent = _parent === void 0 ? false : _parent, _readOnly = componentProps.readOnly, readOnly = _readOnly === void 0 ? false : _readOnly, render = componentProps.render, _required = componentProps.required, required = _required === void 0 ? false : _required, uncheckedValue = componentProps.uncheckedValue, valueProp = componentProps.value, _nativeButton = componentProps.nativeButton, nativeButton = _nativeButton === void 0 ? false : _nativeButton, style = componentProps.style, elementProps = _object_without_properties(componentProps, [
        "checked",
        "className",
        "defaultChecked",
        "aria-labelledby",
        "disabled",
        "form",
        "id",
        "indeterminate",
        "inputRef",
        "name",
        "onCheckedChange",
        "parent",
        "readOnly",
        "render",
        "required",
        "uncheckedValue",
        "value",
        "nativeButton",
        "style"
    ]);
    var clearErrors = useFormContext().clearErrors;
    var ref = useFieldRootContext(), rootDisabled = ref.disabled, fieldName = ref.name, setDirty = ref.setDirty, setFilled = ref.setFilled, setFocused = ref.setFocused, setTouched = ref.setTouched, fieldState = ref.state, validationMode = ref.validationMode, validityData = ref.validityData, shouldValidateOnChange = ref.shouldValidateOnChange, localValidation = ref.validation;
    var fieldItemContext = useFieldItemContext();
    var ref1 = useLabelableContext(), labelId = ref1.labelId, controlId = ref1.controlId, registerControlId = ref1.registerControlId, getDescriptionProps = ref1.getDescriptionProps;
    var groupContext = useCheckboxGroupContext();
    var parentContext = groupContext === null || groupContext === void 0 ? void 0 : groupContext.parent;
    var isGroupedWithParent = parentContext && groupContext.allValues;
    var disabled = rootDisabled || fieldItemContext.disabled || (groupContext === null || groupContext === void 0 ? void 0 : groupContext.disabled) || disabledProp;
    var name = fieldName !== null && fieldName !== void 0 ? fieldName : nameProp;
    var value = valueProp !== null && valueProp !== void 0 ? valueProp : name;
    var id = useBaseUiId();
    var parentId = useBaseUiId();
    var inputId = controlId;
    if (isGroupedWithParent) inputId = parent ? parentId : "".concat(parentContext.id, "-").concat(value);
    else if (idProp) inputId = idProp;
    var groupProps = {};
    if (isGroupedWithParent) {
        if (parent) groupProps = groupContext.parent.getParentProps();
        else if (value) groupProps = groupContext.parent.getChildProps(value);
    }
    var onCheckedChange = useStableCallback(onCheckedChangeProp);
    var tmp1 = groupProps.checked, groupChecked = tmp1 === void 0 ? checkedProp : tmp1, tmp2 = groupProps.indeterminate, groupIndeterminate = tmp2 === void 0 ? indeterminate : tmp2, groupOnChange = groupProps.onCheckedChange, otherGroupProps = _object_without_properties(groupProps, [
        "checked",
        "indeterminate",
        "onCheckedChange"
    ]);
    var groupValue = groupContext === null || groupContext === void 0 ? void 0 : groupContext.value;
    var setGroupValue = groupContext === null || groupContext === void 0 ? void 0 : groupContext.setValue;
    var defaultGroupValue = groupContext === null || groupContext === void 0 ? void 0 : groupContext.defaultValue;
    var controlRef = React$1.useRef(null);
    var controlSourceRef = useRefWithInit(function() {
        return Symbol("checkbox-control");
    });
    var hasRegisteredRef = React$1.useRef(false);
    var ref2 = useButton({
        disabled: disabled,
        native: nativeButton
    }), getButtonProps = ref2.getButtonProps, buttonRef = ref2.buttonRef;
    var ref3;
    var validation = (ref3 = groupContext === null || groupContext === void 0 ? void 0 : groupContext.validation) !== null && ref3 !== void 0 ? ref3 : localValidation;
    var ref4 = _sliced_to_array(useControlled({
        controlled: value && groupValue && !parent ? groupValue.includes(value) : groupChecked,
        default: value && defaultGroupValue && !parent ? defaultGroupValue.includes(value) : defaultChecked,
        name: "Checkbox",
        state: "checked"
    }), 2), checked = ref4[0], setCheckedState = ref4[1];
    useIsoLayoutEffect(function() {
        if (registerControlId === NOOP) return;
        hasRegisteredRef.current = true;
        registerControlId(controlSourceRef.current, inputId);
    }, [
        inputId,
        groupContext,
        registerControlId,
        parent,
        controlSourceRef
    ]);
    React$1.useEffect(function() {
        var controlSource = controlSourceRef.current;
        return function() {
            if (!hasRegisteredRef.current || registerControlId === NOOP) return;
            hasRegisteredRef.current = false;
            registerControlId(controlSource, void 0);
        };
    }, [
        registerControlId,
        controlSourceRef
    ]);
    useRegisterFieldControl(controlRef, {
        enabled: !groupContext,
        id: id,
        value: checked
    });
    var inputRef = React$1.useRef(null);
    var mergedInputRef = useMergedRefs(inputRefProp, inputRef, validation.inputRef);
    var ariaLabelledBy = useAriaLabelledBy(ariaLabelledByProp, labelId, inputRef, !nativeButton, inputId !== null && inputId !== void 0 ? inputId : void 0);
    useIsoLayoutEffect(function() {
        if (inputRef.current) {
            inputRef.current.indeterminate = groupIndeterminate;
            if (checked) setFilled(true);
        }
    }, [
        checked,
        groupIndeterminate,
        setFilled
    ]);
    useValueChanged(checked, function() {
        if (groupContext && !parent) return;
        clearErrors(name);
        setFilled(checked);
        setDirty(checked !== validityData.initialValue);
        if (shouldValidateOnChange()) validation.commit(checked);
        else validation.commit(checked, true);
    });
    var inputProps = mergeProps$1({
        checked: checked,
        disabled: disabled,
        form: form,
        name: parent ? void 0 : name,
        id: nativeButton ? void 0 : inputId !== null && inputId !== void 0 ? inputId : void 0,
        required: required,
        ref: mergedInputRef,
        style: name ? visuallyHiddenInput : visuallyHidden,
        tabIndex: -1,
        type: "checkbox",
        "aria-hidden": true,
        onChange: function onChange(event) {
            if (event.nativeEvent.defaultPrevented) return;
            if (readOnly) {
                event.preventDefault();
                return;
            }
            var nextChecked = event.currentTarget.checked;
            var details = createChangeEventDetails(none, event.nativeEvent);
            groupOnChange === null || groupOnChange === void 0 ? void 0 : groupOnChange(nextChecked, details);
            onCheckedChange(nextChecked, details);
            if (details.isCanceled) return;
            setCheckedState(nextChecked);
            if (value && groupValue && setGroupValue && !parent && !isGroupedWithParent) setGroupValue(nextChecked ? _to_consumable_array(groupValue).concat([
                value
            ]) : groupValue.filter(function(item) {
                return item !== value;
            }), details);
        },
        onFocus: function onFocus() {
            var ref;
            (ref = controlRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        }
    }, valueProp !== void 0 ? {
        value: (groupContext ? checked && valueProp : valueProp) || ""
    } : EMPTY_OBJECT, getDescriptionProps, groupContext ? validation.getValidationProps : validation.getInputValidationProps);
    var computedChecked = isGroupedWithParent ? Boolean(groupChecked) : checked;
    var computedIndeterminate = isGroupedWithParent ? groupIndeterminate || indeterminate : indeterminate;
    React$1.useEffect(function() {
        if (!parentContext || !value) return;
        var disabledStates = parentContext.disabledStatesRef.current;
        disabledStates.set(value, disabled);
        return function() {
            disabledStates.delete(value);
        };
    }, [
        parentContext,
        disabled,
        value
    ]);
    var state = React$1.useMemo(function() {
        return _object_spread_props(_object_spread({}, fieldState), {
            checked: computedChecked,
            disabled: disabled,
            readOnly: readOnly,
            required: required,
            indeterminate: computedIndeterminate
        });
    }, [
        fieldState,
        computedChecked,
        disabled,
        readOnly,
        required,
        computedIndeterminate
    ]);
    var stateAttributesMapping = useStateAttributesMapping(state);
    var _obj;
    var element = useRenderElement("span", componentProps, {
        state: state,
        ref: [
            buttonRef,
            controlRef,
            forwardedRef,
            groupContext === null || groupContext === void 0 ? void 0 : groupContext.registerControlRef
        ],
        props: [
            (_obj = {
                id: nativeButton ? inputId !== null && inputId !== void 0 ? inputId : void 0 : id,
                role: "checkbox",
                "aria-checked": groupIndeterminate ? "mixed" : checked,
                "aria-readonly": readOnly || void 0,
                "aria-required": required || void 0,
                "aria-labelledby": ariaLabelledBy
            }, _define_property(_obj, PARENT_CHECKBOX, parent ? "" : void 0), _define_property(_obj, "onFocus", function onFocus() {
                setFocused(true);
            }), _define_property(_obj, "onBlur", function onBlur() {
                var inputEl = inputRef.current;
                if (!inputEl) return;
                setTouched(true);
                setFocused(false);
                if (validationMode === "onBlur") validation.commit(groupContext ? groupValue : inputEl.checked);
            }), _define_property(_obj, "onClick", function onClick(event) {
                var ref;
                if (readOnly || disabled) return;
                event.preventDefault();
                (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.dispatchEvent(new PointerEvent("click", {
                    bubbles: true,
                    shiftKey: event.shiftKey,
                    ctrlKey: event.ctrlKey,
                    altKey: event.altKey,
                    metaKey: event.metaKey
                }));
            }), _obj),
            getDescriptionProps,
            validation.getValidationProps,
            elementProps,
            otherGroupProps,
            getButtonProps
        ],
        stateAttributesMapping: stateAttributesMapping
    });
    return /* @__PURE__ */ jsxs(CheckboxRootContext.Provider, {
        value: state,
        children: [
            element,
            !checked && !groupContext && name && !parent && uncheckedValue !== void 0 && /* @__PURE__ */ jsx("input", {
                type: "hidden",
                form: form,
                name: name,
                value: uncheckedValue
            }),
            /* @__PURE__ */ jsx("input", _object_spread_props(_object_spread({}, inputProps), {
                suppressHydrationWarning: true
            }))
        ]
    });
})));
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/useOnMount.js
var EMPTY$2 = [];
/**
* A React.useEffect equivalent that runs once, when the component is mounted.
*/ function useOnMount(fn) {
    react.useEffect(fn, EMPTY$2);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/useAnimationFrame.js
/** Unlike `setTimeout`, rAF doesn't guarantee a positive integer return value, so we can't have
* a monomorphic `uint` type with `0` meaning empty.
* See warning note at:
* https://developer.mozilla.org/en-US/docs/Web/API/Window/requestAnimationFrame#return_value */ var EMPTY$1 = null;
var LAST_RAF = globalThis.requestAnimationFrame;
var Scheduler = /*#__PURE__*/ function() {
    "use strict";
    function Scheduler() {
        var _this = this;
        (0,src_class_call_check/* default */.Z)(this, Scheduler);
        (0,src_define_property/* default */.Z)(this, "callbacks", []);
        (0,src_define_property/* default */.Z)(this, "callbacksCount", 0);
        (0,src_define_property/* default */.Z)(this, "nextId", 1);
        (0,src_define_property/* default */.Z)(this, "startId", 1);
        (0,src_define_property/* default */.Z)(this, "isScheduled", false);
        (0,src_define_property/* default */.Z)(this, "tick", function(timestamp) {
            var ref;
            _this.isScheduled = false;
            var currentCallbacks = _this.callbacks;
            var currentCallbacksCount = _this.callbacksCount;
            _this.callbacks = [];
            _this.callbacksCount = 0;
            _this.startId = _this.nextId;
            if (currentCallbacksCount > 0) for(var i = 0; i < currentCallbacks.length; i += 1)(ref = currentCallbacks[i]) === null || ref === void 0 ? void 0 : ref.call(currentCallbacks, timestamp);
        });
    }
    (0,src_create_class/* default */.Z)(Scheduler, [
        {
            key: "request",
            value: function request(fn) {
                var id = this.nextId;
                this.nextId += 1;
                this.callbacks.push(fn);
                this.callbacksCount += 1;
                var didRAFChange =  false && (0);
                if (!this.isScheduled || didRAFChange) {
                    requestAnimationFrame(this.tick);
                    this.isScheduled = true;
                }
                return id;
            }
        },
        {
            key: "cancel",
            value: function cancel(id) {
                var index = id - this.startId;
                if (index < 0 || index >= this.callbacks.length) return;
                this.callbacks[index] = null;
                this.callbacksCount -= 1;
            }
        }
    ]);
    return Scheduler;
}();
var scheduler = new Scheduler();
var AnimationFrame = /*#__PURE__*/ function() {
    "use strict";
    function AnimationFrame() {
        var _this = this;
        (0,src_class_call_check/* default */.Z)(this, AnimationFrame);
        (0,src_define_property/* default */.Z)(this, "currentId", EMPTY$1);
        (0,src_define_property/* default */.Z)(this, "cancel", function() {
            if (_this.currentId !== EMPTY$1) {
                scheduler.cancel(_this.currentId);
                _this.currentId = EMPTY$1;
            }
        });
        (0,src_define_property/* default */.Z)(this, "disposeEffect", function() {
            return _this.cancel;
        });
    }
    (0,src_create_class/* default */.Z)(AnimationFrame, [
        {
            /**
	* Executes `fn` after `delay`, clearing any previously scheduled call.
	*/ key: "request",
            value: function request(fn) {
                var _this = this;
                this.cancel();
                this.currentId = scheduler.request(function() {
                    _this.currentId = EMPTY$1;
                    fn();
                });
            }
        }
    ], [
        {
            key: "create",
            value: function create() {
                return new AnimationFrame();
            }
        },
        {
            key: "request",
            value: function request(fn) {
                return scheduler.request(fn);
            }
        },
        {
            key: "cancel",
            value: function cancel(id) {
                return scheduler.cancel(id);
            }
        }
    ]);
    return AnimationFrame;
}();
/**
* A `requestAnimationFrame` with automatic cleanup and guard.
*/ function useAnimationFrame() {
    var timeout = useRefWithInit(AnimationFrame.create).current;
    useOnMount(timeout.disposeEffect);
    return timeout;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/utils/resolveRef.js
/**
* If the provided argument is a ref object, returns its `current` value.
* Otherwise, returns the argument itself.
*/ function resolveRef(maybeRef) {
    if (maybeRef == null) return maybeRef;
    return "current" in maybeRef ? maybeRef.current : maybeRef;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/stateAttributesMapping.js
var TransitionStatusDataAttributes = /* @__PURE__ */ function(TransitionStatusDataAttributes) {
    /**
	* Present when the component is animating in.
	*/ TransitionStatusDataAttributes["startingStyle"] = "data-starting-style";
    /**
	* Present when the component is animating out.
	*/ TransitionStatusDataAttributes["endingStyle"] = "data-ending-style";
    return TransitionStatusDataAttributes;
}({});
var STARTING_HOOK = (0,src_define_property/* default */.Z)({}, TransitionStatusDataAttributes.startingStyle, "");
var ENDING_HOOK = (0,src_define_property/* default */.Z)({}, TransitionStatusDataAttributes.endingStyle, "");
var transitionStatusMapping = {
    transitionStatus: function transitionStatus(value) {
        if (value === "starting") return STARTING_HOOK;
        if (value === "ending") return ENDING_HOOK;
        return null;
    }
};
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/useAnimationsFinished.js
/**
* Executes a function once all animations have finished on the provided element.
* @param elementOrRef - The element to watch for animations.
* @param waitForStartingStyleRemoved - Whether to wait for [data-starting-style] to be removed before checking for animations.
* @param treatAbortedAsFinished - Whether to treat aborted animations as finished. If `false`, and there are aborted animations,
*   the function will check again if any new animations have started and wait for them to finish.
* @returns A function that takes a callback to execute once all animations have finished, and an optional AbortSignal to abort the callback
*/ function useAnimationsFinished(elementOrRef) {
    var waitForStartingStyleRemoved = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, treatAbortedAsFinished = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var frame = useAnimationFrame();
    return useStableCallback(function(fnToExecute) {
        var signal = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        frame.cancel();
        var element = resolveRef(elementOrRef);
        if (element == null) return;
        var resolvedElement = element;
        var done = function() {
            react_dom.flushSync(fnToExecute);
        };
        if (typeof resolvedElement.getAnimations !== "function" || globalThis.BASE_UI_ANIMATIONS_DISABLED) {
            fnToExecute();
            return;
        }
        function exec() {
            Promise.all(resolvedElement.getAnimations().map(function(animation) {
                return animation.finished;
            })).then(function() {
                if (!(signal === null || signal === void 0 ? void 0 : signal.aborted)) done();
            }).catch(function() {
                if (treatAbortedAsFinished) {
                    if (!(signal === null || signal === void 0 ? void 0 : signal.aborted)) done();
                    return;
                }
                var currentAnimations = resolvedElement.getAnimations();
                if (!(signal === null || signal === void 0 ? void 0 : signal.aborted) && currentAnimations.length > 0 && currentAnimations.some(function(animation) {
                    return animation.pending || animation.playState !== "finished";
                })) exec();
            });
        }
        if (waitForStartingStyleRemoved) {
            var startingStyleAttribute = TransitionStatusDataAttributes.startingStyle;
            if (!resolvedElement.hasAttribute(startingStyleAttribute)) {
                frame.request(exec);
                return;
            }
            var attributeObserver = new MutationObserver(function() {
                if (!resolvedElement.hasAttribute(startingStyleAttribute)) {
                    attributeObserver.disconnect();
                    exec();
                }
            });
            attributeObserver.observe(resolvedElement, {
                attributes: true,
                attributeFilter: [
                    startingStyleAttribute
                ]
            });
            signal === null || signal === void 0 ? void 0 : signal.addEventListener("abort", function() {
                return attributeObserver.disconnect();
            }, {
                once: true
            });
            return;
        }
        frame.request(exec);
    });
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/useOpenChangeComplete.js
/**
* Calls the provided function when the CSS open/close animation or transition completes.
*/ function useOpenChangeComplete(parameters) {
    var _enabled = parameters.enabled, enabled = _enabled === void 0 ? true : _enabled, open = parameters.open, ref = parameters.ref, onCompleteParam = parameters.onComplete;
    var onComplete = useStableCallback(onCompleteParam);
    var runOnceAnimationsFinish = useAnimationsFinished(ref, open, false);
    react.useEffect(function() {
        if (!enabled) return;
        var abortController = new AbortController();
        runOnceAnimationsFinish(onComplete, abortController.signal);
        return function() {
            abortController.abort();
        };
    }, [
        enabled,
        open,
        onComplete,
        runOnceAnimationsFinish
    ]);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/useTransitionStatus.js
/**
* Provides a status string for CSS animations.
* @param open - a boolean that determines if the element is open.
* @param enableIdleState - a boolean that enables the `'idle'` state between `'starting'` and `'ending'`
*/ function useTransitionStatus(open) {
    var enableIdleState = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, deferEndingState = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(open && enableIdleState ? "idle" : void 0), 2), transitionStatus = ref[0], setTransitionStatus = ref[1];
    var ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState(open), 2), mounted = ref1[0], setMounted = ref1[1];
    if (open && !mounted) {
        setMounted(true);
        setTransitionStatus("starting");
    }
    if (!open && mounted && transitionStatus !== "ending" && !deferEndingState) setTransitionStatus("ending");
    if (!open && !mounted && transitionStatus === "ending") setTransitionStatus(void 0);
    useIsoLayoutEffect(function() {
        if (!open && mounted && transitionStatus !== "ending" && deferEndingState) {
            var frame = AnimationFrame.request(function() {
                setTransitionStatus("ending");
            });
            return function() {
                AnimationFrame.cancel(frame);
            };
        }
    }, [
        open,
        mounted,
        transitionStatus,
        deferEndingState
    ]);
    useIsoLayoutEffect(function() {
        if (!open || enableIdleState) return;
        var frame = AnimationFrame.request(function() {
            setTransitionStatus(void 0);
        });
        return function() {
            AnimationFrame.cancel(frame);
        };
    }, [
        enableIdleState,
        open
    ]);
    useIsoLayoutEffect(function() {
        if (!open || !enableIdleState) return;
        if (open && mounted && transitionStatus !== "idle") setTransitionStatus("starting");
        var frame = AnimationFrame.request(function() {
            setTransitionStatus("idle");
        });
        return function() {
            AnimationFrame.cancel(frame);
        };
    }, [
        enableIdleState,
        open,
        mounted,
        transitionStatus
    ]);
    return {
        mounted: mounted,
        setMounted: setMounted,
        transitionStatus: transitionStatus
    };
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/checkbox/indicator/CheckboxIndicator.js
/**
* Indicates whether the checkbox is ticked.
* Renders a `<span>` element.
*
* Documentation: [Base UI Checkbox](https://base-ui.com/react/components/checkbox)
*/ var CheckboxIndicator = /* @__PURE__ */ /*#__PURE__*/ (/* unused pure expression or super */ null && (React$1.forwardRef(function CheckboxIndicator(componentProps, forwardedRef) {
    var render = componentProps.render, className = componentProps.className, style = componentProps.style, _keepMounted = componentProps.keepMounted, keepMounted = _keepMounted === void 0 ? false : _keepMounted, elementProps = _object_without_properties(componentProps, [
        "render",
        "className",
        "style",
        "keepMounted"
    ]);
    var rootState = useCheckboxRootContext();
    var rendered = rootState.checked || rootState.indeterminate;
    var ref = useTransitionStatus(rendered), mounted = ref.mounted, transitionStatus = ref.transitionStatus, setMounted = ref.setMounted;
    var indicatorRef = React$1.useRef(null);
    var state = _object_spread_props(_object_spread({}, rootState), {
        transitionStatus: transitionStatus
    });
    useOpenChangeComplete({
        open: rendered,
        ref: indicatorRef,
        onComplete: function onComplete() {
            if (!rendered) setMounted(false);
        }
    });
    var baseStateAttributesMapping = useStateAttributesMapping(rootState);
    var stateAttributesMapping = React$1.useMemo(function() {
        return _object_spread({}, baseStateAttributesMapping, transitionStatusMapping, fieldValidityMapping);
    }, [
        baseStateAttributesMapping
    ]);
    var shouldRender = keepMounted || mounted;
    var element = useRenderElement("span", componentProps, {
        ref: [
            forwardedRef,
            indicatorRef
        ],
        state: state,
        stateAttributesMapping: stateAttributesMapping,
        props: elementProps
    });
    if (!shouldRender) return null;
    return element;
})));
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/useOnFirstRender.js
function useOnFirstRender(fn) {
    var ref = react.useRef(true);
    if (ref.current) {
        ref.current = false;
        fn();
    }
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/useValueAsRef.js
/**
* Untracks the provided value by turning it into a ref to remove its reactivity.
*
* Used to access the passed value inside `React.useEffect` without causing the effect to re-run when the value changes.
*/ function useValueAsRef(value) {
    var latest = useRefWithInit(createLatestRef, value).current;
    latest.next = value;
    useIsoLayoutEffect(latest.effect);
    return latest;
}
function createLatestRef(value) {
    var latest = {
        current: value,
        next: value,
        effect: function() {
            latest.current = latest.next;
        }
    };
    return latest;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/store/createSelector.js
/**
* The NoOptionalParams type is a utility type that checks if a function has optional or default parameters.
* If the function has optional or default parameters, it returns a string literal type with an error message.
* Otherwise, it returns the original function type.
*
* This is used to enforce that the combiner function passed to createSelector does not have optional or default parameters,
* as memoization relies on the Function.length property, which does not account for optional or default parameters.
*/ /**
* Creates a selector function that can be used to derive values from the store's state.
*
* The combiner function can have up to three additional parameters, but it **cannot have optional or default parameters**.
*
* This function accepts up to six functions and combines them into a single selector function.
* The resulting selector will take the state from the combined selectors and any additional parameters required by the combiner.
*
* The return type of the resulting selector is determined by the return type of the combiner function.
*
* @example
* const selector = createSelector(
*  (state) => state.disabled
* );
*
* @example
* const selector = createSelector(
*   (state) => state.disabled,
*   (state) => state.open,
*   (disabled, open) => ({ disabled, open })
* );
*/ var createSelector$1 = function(a, b, c, d, e, f) {
    for(var _len = arguments.length, other = new Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++){
        other[_key - 6] = arguments[_key];
    }
    if (other.length > 0) throw new Error( false ? 0 : formatErrorMessage(1));
    var selector;
    if (a && b && c && d && e && f) selector = function(state, a1, a2, a3) {
        return f(a(state, a1, a2, a3), b(state, a1, a2, a3), c(state, a1, a2, a3), d(state, a1, a2, a3), e(state, a1, a2, a3), a1, a2, a3);
    };
    else if (a && b && c && d && e) selector = function(state, a1, a2, a3) {
        return e(a(state, a1, a2, a3), b(state, a1, a2, a3), c(state, a1, a2, a3), d(state, a1, a2, a3), a1, a2, a3);
    };
    else if (a && b && c && d) selector = function(state, a1, a2, a3) {
        return d(a(state, a1, a2, a3), b(state, a1, a2, a3), c(state, a1, a2, a3), a1, a2, a3);
    };
    else if (a && b && c) selector = function(state, a1, a2, a3) {
        return c(a(state, a1, a2, a3), b(state, a1, a2, a3), a1, a2, a3);
    };
    else if (a && b) selector = function(state, a1, a2, a3) {
        return b(a(state, a1, a2, a3), a1, a2, a3);
    };
    else if (a) selector = a;
    else throw new Error("Missing arguments");
    return selector;
};
//#endregion
//#region ../../node_modules/.pnpm/reselect@5.1.1/node_modules/reselect/dist/reselect.mjs
var runIdentityFunctionCheck = function(resultFunc, inputSelectorsResults, outputSelectorResult) {
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        var isInputSameAsOutput = false;
        try {
            var emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            var stack = void 0;
            try {
                throw new Error();
            } catch (e1) {
                stack = e1.stack;
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
var runInputStabilityCheck = function(inputSelectorResultsObject, options, inputSelectorArgs) {
    var memoize = options.memoize, memoizeOptions = options.memoizeOptions;
    var inputSelectorResults = inputSelectorResultsObject.inputSelectorResults, inputSelectorResultsCopy = inputSelectorResultsObject.inputSelectorResultsCopy;
    var createAnEmptyObject = memoize.apply(void 0, [
        function() {
            return {};
        }
    ].concat(_to_consumable_array(memoizeOptions)));
    if (!(createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy))) {
        var stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            stack = e.stack;
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
var globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function assertIsFunction(func) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected a function, instead received ".concat(typeof func === "undefined" ? "undefined" : (0,src_type_of/* default */.Z)(func));
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function assertIsObject(object) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected an object, instead received ".concat(typeof object === "undefined" ? "undefined" : (0,src_type_of/* default */.Z)(object));
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function assertIsArrayOfFunctions(array) {
    var errorMessage = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "expected all items to be functions, instead received the following types: ";
    if (!array.every(function(item) {
        return typeof item === "function";
    })) {
        var itemTypes = array.map(function(item) {
            return typeof item === "function" ? "function ".concat(item.name || "unnamed", "()") : typeof item === "undefined" ? "undefined" : (0,src_type_of/* default */.Z)(item);
        }).join(", ");
        throw new TypeError("".concat(errorMessage, "[").concat(itemTypes, "]"));
    }
}
var ensureIsArray = function(item) {
    return Array.isArray(item) ? item : [
        item
    ];
};
function getDependencies(createSelectorArgs) {
    var dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    assertIsArrayOfFunctions(dependencies, "createSelector expects all input-selectors to be functions, but received the following types: ");
    return dependencies;
}
function collectInputSelectorResults(dependencies, inputSelectorArgs) {
    var inputSelectorResults = [];
    var length = dependencies.length;
    for(var i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var getDevModeChecksExecutionInfo = function(firstRun, devModeChecks) {
    var ref = _object_spread({}, globalDevModeChecks, devModeChecks), identityFunctionCheck = ref.identityFunctionCheck, inputStabilityCheck = ref.inputStabilityCheck;
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: runInputStabilityCheck
        }
    };
};
function createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = void 0;
        }
    };
}
function createLruCache(maxSize, equals) {
    var get = function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        });
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return NOT_FOUND;
    };
    var put = function put(key, value) {
        if (get(key) === NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    };
    var getEntries = function getEntries() {
        return entries;
    };
    var clear = function clear() {
        entries = [];
    };
    var entries = [];
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var referenceEqualityCheck = function(a, b) {
    return a === b;
};
function createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        var length = prev.length;
        for(var i = 0; i < length; i++)if (!equalityCheck(prev[i], next[i])) return false;
        return true;
    };
}
function lruMemoize(func, equalityCheckOrOptions) {
    var memoized = function memoized() {
        var value = cache.get(arguments);
        if (value === NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                var matchingEntry = cache.getEntries().find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    };
    var ref = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    }, _equalityCheck = ref.equalityCheck, equalityCheck = _equalityCheck === void 0 ? referenceEqualityCheck : _equalityCheck, _maxSize = ref.maxSize, maxSize = _maxSize === void 0 ? 1 : _maxSize, resultEqualityCheck = ref.resultEqualityCheck;
    var comparator = createCacheKeyComparator(equalityCheck);
    var resultsCount = 0;
    var cache = maxSize <= 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator);
    memoized.clearCache = function() {
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = function() {
        return resultsCount;
    };
    memoized.resetResultsCount = function() {
        resultsCount = 0;
    };
    return memoized;
}
var StrongRef = /*#__PURE__*/ function() {
    "use strict";
    function StrongRef(value) {
        (0,src_class_call_check/* default */.Z)(this, StrongRef);
        this.value = value;
    }
    (0,src_create_class/* default */.Z)(StrongRef, [
        {
            key: "deref",
            value: function deref() {
                return this.value;
            }
        }
    ]);
    return StrongRef;
}();
var Ref = typeof WeakRef !== "undefined" ? WeakRef : StrongRef;
var UNTERMINATED = 0;
var TERMINATED = 1;
function createCacheNode() {
    return {
        s: UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function weakMapMemoize(func) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var memoized = function memoized() {
        var cacheNode = fnNode;
        var length = arguments.length;
        for(var i = 0, l = length; i < l; i++){
            var arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                var objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                var objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                var primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                var primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        var terminatedNode = cacheNode;
        var result;
        if (cacheNode.s === TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                var ref;
                var ref1;
                var lastResultValue = (ref1 = lastResult === null || lastResult === void 0 ? void 0 : (ref = lastResult.deref) === null || ref === void 0 ? void 0 : ref.call(lastResult)) !== null && ref1 !== void 0 ? ref1 : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                lastResult = typeof result === "object" && result !== null || typeof result === "function" ? new Ref(result) : result;
            }
        }
        terminatedNode.s = TERMINATED;
        terminatedNode.v = result;
        return result;
    };
    var fnNode = createCacheNode();
    var resultEqualityCheck = options.resultEqualityCheck;
    var lastResult;
    var resultsCount = 0;
    memoized.clearCache = function() {
        fnNode = createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = function() {
        return resultsCount;
    };
    memoized.resetResultsCount = function() {
        resultsCount = 0;
    };
    return memoized;
}
function createSelectorCreator(memoizeOrOptions) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    }
    var createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    var createSelector2 = function() {
        for(var _len = arguments.length, createSelectorArgs = new Array(_len), _key = 0; _key < _len; _key++){
            createSelectorArgs[_key] = arguments[_key];
        }
        var recomputations = 0;
        var dependencyRecomputations = 0;
        var lastResult;
        var directlyPassedOptions = {};
        var resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        assertIsFunction(resultFunc, "createSelector expects an output function after the inputs, but received: [".concat(typeof resultFunc === "undefined" ? "undefined" : (0,src_type_of/* default */.Z)(resultFunc), "]"));
        var ref = (0,src_object_spread/* default */.Z)({}, createSelectorCreatorOptions, directlyPassedOptions), memoize = ref.memoize, _memoizeOptions = ref.memoizeOptions, memoizeOptions = _memoizeOptions === void 0 ? [] : _memoizeOptions, _argsMemoize = ref.argsMemoize, argsMemoize = _argsMemoize === void 0 ? weakMapMemoize : _argsMemoize, _argsMemoizeOptions = ref.argsMemoizeOptions, argsMemoizeOptions = _argsMemoizeOptions === void 0 ? [] : _argsMemoizeOptions, _devModeChecks = ref.devModeChecks, devModeChecks = _devModeChecks === void 0 ? {} : _devModeChecks;
        var finalMemoizeOptions = ensureIsArray(memoizeOptions);
        var finalArgsMemoizeOptions = ensureIsArray(argsMemoizeOptions);
        var dependencies = getDependencies(createSelectorArgs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                recomputations++;
                return resultFunc.apply(null, arguments);
            }
        ].concat((0,src_to_consumable_array/* default */.Z)(finalMemoizeOptions)));
        var firstRun = true;
        var selector = argsMemoize.apply(void 0, [
            function dependenciesChecker() {
                dependencyRecomputations++;
                var inputSelectorResults = collectInputSelectorResults(dependencies, arguments);
                lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
                if (false) { var inputSelectorResultsCopy, ref, identityFunctionCheck, inputStabilityCheck; }
                return lastResult;
            }
        ].concat((0,src_to_consumable_array/* default */.Z)(finalArgsMemoizeOptions)));
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: function() {
                return dependencyRecomputations;
            },
            resetDependencyRecomputations: function() {
                dependencyRecomputations = 0;
            },
            lastResult: function() {
                return lastResult;
            },
            recomputations: function() {
                return recomputations;
            },
            resetRecomputations: function() {
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: function() {
            return createSelector2;
        }
    });
    return createSelector2;
}
var createSelector = /* @__PURE__ */ createSelectorCreator(weakMapMemoize);
var createStructuredSelector = Object.assign(function(inputSelectorsObject) {
    var selectorCreator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : createSelector;
    assertIsObject(inputSelectorsObject, "createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ".concat(typeof inputSelectorsObject === "undefined" ? "undefined" : (0,src_type_of/* default */.Z)(inputSelectorsObject)));
    var inputSelectorKeys = Object.keys(inputSelectorsObject);
    return selectorCreator(inputSelectorKeys.map(function(key) {
        return inputSelectorsObject[key];
    }), function() {
        for(var _len = arguments.length, inputSelectorResults = new Array(_len), _key = 0; _key < _len; _key++){
            inputSelectorResults[_key] = arguments[_key];
        }
        return inputSelectorResults.reduce(function(composition, value, index) {
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
}, {
    withTypes: function() {
        return createStructuredSelector;
    }
});
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/store/createSelectorMemoized.js
var reselectCreateSelector = createSelectorCreator({
    memoize: lruMemoize,
    memoizeOptions: {
        maxSize: 1,
        equalityCheck: Object.is
    }
});
var createSelectorMemoized = function() {
    for(var _len = arguments.length, selectors = new Array(_len), _key = 0; _key < _len; _key++){
        selectors[_key] = arguments[_key];
    }
    var cache = /* @__PURE__ */ new WeakMap();
    var nextCacheId = 1;
    var combiner = selectors[selectors.length - 1];
    var nSelectors = selectors.length - 1 || 1;
    var argsLength = combiner.length - nSelectors;
    if (argsLength > 3) throw new Error( false ? 0 : formatErrorMessage(2));
    var selector = function(state, a1, a2, a3) {
        var cacheKey = state.__cacheKey__;
        if (!cacheKey) {
            cacheKey = {
                id: nextCacheId
            };
            state.__cacheKey__ = cacheKey;
            nextCacheId += 1;
        }
        var fn = cache.get(cacheKey);
        if (!fn) {
            var reselectArgs = selectors;
            var selectorArgs = [
                void 0,
                void 0,
                void 0
            ];
            switch(argsLength){
                case 0:
                    break;
                case 1:
                    reselectArgs = (0,src_to_consumable_array/* default */.Z)(selectors.slice(0, -1)).concat([
                        function() {
                            return selectorArgs[0];
                        },
                        combiner
                    ]);
                    break;
                case 2:
                    reselectArgs = (0,src_to_consumable_array/* default */.Z)(selectors.slice(0, -1)).concat([
                        function() {
                            return selectorArgs[0];
                        },
                        function() {
                            return selectorArgs[1];
                        },
                        combiner
                    ]);
                    break;
                case 3:
                    reselectArgs = (0,src_to_consumable_array/* default */.Z)(selectors.slice(0, -1)).concat([
                        function() {
                            return selectorArgs[0];
                        },
                        function() {
                            return selectorArgs[1];
                        },
                        function() {
                            return selectorArgs[2];
                        },
                        combiner
                    ]);
                    break;
                default:
                    throw new Error( false ? 0 : formatErrorMessage(2));
            }
            fn = reselectCreateSelector.apply(void 0, (0,src_to_consumable_array/* default */.Z)(reselectArgs));
            fn.selectorArgs = selectorArgs;
            cache.set(cacheKey, fn);
        }
        fn.selectorArgs[0] = a1;
        fn.selectorArgs[1] = a2;
        fn.selectorArgs[2] = a3;
        switch(argsLength){
            case 0:
                return fn(state);
            case 1:
                return fn(state, a1);
            case 2:
                return fn(state, a1, a2);
            case 3:
                return fn(state, a1, a2, a3);
            default:
                throw new Error("unreachable");
        }
    };
    return selector;
};
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/fastHooks.js
var hooks = [];
var currentInstance = void 0;
function getInstance() {
    return currentInstance;
}
function register(hook) {
    hooks.push(hook);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/store/useStore.js
var useStoreImplementation = isReactVersionAtLeast(19) ? useStoreFast : useStoreLegacy;
function useStore(store, selector, a1, a2, a3) {
    return useStoreImplementation(store, selector, a1, a2, a3);
}
function useStoreR19(store, selector, a1, a2, a3) {
    var getSelection = react.useCallback(function() {
        return selector(store.getSnapshot(), a1, a2, a3);
    }, [
        store,
        selector,
        a1,
        a2,
        a3
    ]);
    return (0,shim.useSyncExternalStore)(store.subscribe, getSelection, getSelection);
}
register({
    before: function before(instance) {
        instance.syncIndex = 0;
        if (!instance.didInitialize) {
            instance.syncTick = 1;
            instance.syncHooks = [];
            instance.didChangeStore = true;
            instance.getSnapshot = function() {
                var didChange = false;
                for(var i = 0; i < instance.syncHooks.length; i += 1){
                    var hook = instance.syncHooks[i];
                    var value = hook.selector(hook.store.state, hook.a1, hook.a2, hook.a3);
                    if (hook.didChange || !Object.is(hook.value, value)) {
                        didChange = true;
                        hook.value = value;
                        hook.didChange = false;
                    }
                }
                if (didChange) instance.syncTick += 1;
                return instance.syncTick;
            };
        }
    },
    after: function after(instance) {
        if (instance.syncHooks.length > 0) {
            if (instance.didChangeStore) {
                instance.didChangeStore = false;
                instance.subscribe = function(onStoreChange) {
                    var stores = /* @__PURE__ */ new Set();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = instance.syncHooks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var hook = _step.value;
                            stores.add(hook.store);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var unsubscribes = [];
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = stores[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var store = _step1.value;
                            unsubscribes.push(store.subscribe(onStoreChange));
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    return function() {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = unsubscribes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var unsubscribe = _step.value;
                                unsubscribe();
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    };
                };
            }
            (0,shim.useSyncExternalStore)(instance.subscribe, instance.getSnapshot, instance.getSnapshot);
        }
    }
});
function useStoreFast(store, selector, a1, a2, a3) {
    var instance = getInstance();
    if (!instance) return useStoreR19(store, selector, a1, a2, a3);
    var index = instance.syncIndex;
    instance.syncIndex += 1;
    var hook;
    if (!instance.didInitialize) {
        hook = {
            store: store,
            selector: selector,
            a1: a1,
            a2: a2,
            a3: a3,
            value: selector(store.getSnapshot(), a1, a2, a3),
            didChange: false
        };
        instance.syncHooks.push(hook);
    } else {
        hook = instance.syncHooks[index];
        if (hook.store !== store || hook.selector !== selector || !Object.is(hook.a1, a1) || !Object.is(hook.a2, a2) || !Object.is(hook.a3, a3)) {
            if (hook.store !== store) instance.didChangeStore = true;
            hook.store = store;
            hook.selector = selector;
            hook.a1 = a1;
            hook.a2 = a2;
            hook.a3 = a3;
            hook.didChange = true;
        }
    }
    return hook.value;
}
function useStoreLegacy(store, selector, a1, a2, a3) {
    return (0,with_selector.useSyncExternalStoreWithSelector)(store.subscribe, store.getSnapshot, store.getSnapshot, function(state) {
        return selector(state, a1, a2, a3);
    });
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/store/Store.js
/**
* A data store implementation that allows subscribing to state changes and updating the state.
* It uses an observer pattern to notify subscribers when the state changes.
*/ var Store = /*#__PURE__*/ function() {
    "use strict";
    function Store(state) {
        var _this = this;
        (0,src_class_call_check/* default */.Z)(this, Store);
        /**
	* Registers a listener that will be called whenever the store's state changes.
	*
	* @param fn The listener function to be called on state changes.
	* @returns A function to unsubscribe the listener.
	*/ (0,src_define_property/* default */.Z)(this, "subscribe", function(fn) {
            _this.listeners.add(fn);
            return function() {
                _this.listeners.delete(fn);
            };
        });
        /**
	* Returns the current state of the store.
	*/ (0,src_define_property/* default */.Z)(this, "getSnapshot", function() {
            return _this.state;
        });
        this.state = state;
        this.listeners = /* @__PURE__ */ new Set();
        this.updateTick = 0;
    }
    (0,src_create_class/* default */.Z)(Store, [
        {
            /**
	* Updates the entire store's state and notifies all registered listeners.
	*
	* @param newState The new state to set for the store.
	*/ key: "setState",
            value: function setState(newState) {
                if (this.state === newState) return;
                this.state = newState;
                this.updateTick += 1;
                var currentTick = this.updateTick;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.listeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var listener = _step.value;
                        if (currentTick !== this.updateTick) return;
                        listener(newState);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            /**
	* Merges the provided changes into the current state and notifies listeners if there are changes.
	*
	* @param changes An object containing the changes to apply to the current state.
	*/ key: "update",
            value: function update(changes) {
                for(var key in changes)if (!Object.is(this.state[key], changes[key])) {
                    this.setState((0,src_object_spread/* default */.Z)({}, this.state, changes));
                    return;
                }
            }
        },
        {
            /**
	* Sets a specific key in the store's state to a new value and notifies listeners if the value has changed.
	*
	* @param key The key in the store's state to update.
	* @param value The new value to set for the specified key.
	*/ key: "set",
            value: function set(key, value) {
                if (!Object.is(this.state[key], value)) this.setState((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, this.state), (0,src_define_property/* default */.Z)({}, key, value)));
            }
        },
        {
            /**
	* Gives the state a new reference and updates all registered listeners.
	*/ key: "notifyAll",
            value: function notifyAll() {
                var newState = (0,src_object_spread/* default */.Z)({}, this.state);
                this.setState(newState);
            }
        },
        {
            key: "use",
            value: function use(selector, a1, a2, a3) {
                return useStore(this, selector, a1, a2, a3);
            }
        }
    ]);
    return Store;
}();
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/store/ReactStore.js
/**
* A Store that supports controlled state keys, non-reactive values and provides utility methods for React.
*/ var ReactStore = /*#__PURE__*/ function(Store) {
    "use strict";
    (0,src_inherits/* default */.Z)(ReactStore, Store);
    var _super = (0,src_create_super/* default */.Z)(ReactStore);
    function ReactStore(state) {
        var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, selectors = arguments.length > 2 ? arguments[2] : void 0;
        (0,src_class_call_check/* default */.Z)(this, ReactStore);
        var _this;
        _this = _super.call(this, state);
        _this.context = context;
        _this.selectors = selectors;
        return _this;
    }
    (0,src_create_class/* default */.Z)(ReactStore, [
        {
            /**
	* Non-reactive values such as refs, callbacks, etc.
	*/ /**
	* Synchronizes a single external value into the store.
	*
	* Note that the while the value in `state` is updated immediately, the value returned
	* by `useState` is updated before the next render (similarly to React's `useState`).
	*/ key: "useSyncedValue",
            value: function useSyncedValue(key, value) {
                var _this = this;
                react.useDebugValue(key);
                useIsoLayoutEffect(function() {
                    if (_this.state[key] !== value) _this.set(key, value);
                }, [
                    key,
                    value
                ]);
            }
        },
        {
            /**
	* Synchronizes a single external value into the store and
	* cleans it up (sets to `undefined`) on unmount.
	*
	* Note that the while the value in `state` is updated immediately, the value returned
	* by `useState` is updated before the next render (similarly to React's `useState`).
	*/ key: "useSyncedValueWithCleanup",
            value: function useSyncedValueWithCleanup(key, value) {
                var store = this;
                useIsoLayoutEffect(function() {
                    if (store.state[key] !== value) store.set(key, value);
                    return function() {
                        store.set(key, void 0);
                    };
                }, [
                    store,
                    key,
                    value
                ]);
            }
        },
        {
            /**
	* Synchronizes multiple external values into the store.
	*
	* Note that the while the values in `state` are updated immediately, the values returned
	* by `useState` are updated before the next render (similarly to React's `useState`).
	*/ key: "useSyncedValues",
            value: function useSyncedValues(statePart) {
                var store = this;
                if (false) { var nextKeys, keys; }
                useIsoLayoutEffect(function() {
                    store.update(statePart);
                }, [
                    store
                ].concat((0,src_to_consumable_array/* default */.Z)(Object.values(statePart))));
            }
        },
        {
            /**
	* Registers a controllable prop pair (`controlled`, `defaultValue`) for a specific key. If `controlled`
	* is non-undefined, the store's state at `key` is updated to match `controlled`.
	*/ key: "useControlledProp",
            value: function useControlledProp(key, controlled) {
                var _this = this;
                react.useDebugValue(key);
                var isControlled = controlled !== void 0;
                useIsoLayoutEffect(function() {
                    if (isControlled && !Object.is(_this.state[key], controlled)) (0,_get/* default */.Z)((0,_get_prototype_of/* default */.Z)(ReactStore.prototype), "setState", _this).call(_this, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, _this.state), (0,src_define_property/* default */.Z)({}, key, controlled)));
                }, [
                    key,
                    controlled,
                    isControlled
                ]);
                if (false) { var previouslyControlled, cache, _controlledValues; }
            }
        },
        {
            /** Gets the current value from the store using a selector with the provided key.
	*
	* @param key Key of the selector to use.
	*/ key: "select",
            value: function select(key, a1, a2, a3) {
                var selector = this.selectors[key];
                return selector(this.state, a1, a2, a3);
            }
        },
        {
            /**
	* Returns a value from the store's state using a selector function.
	* Used to subscribe to specific parts of the state.
	* This methods causes a rerender whenever the selected state changes.
	*
	* @param key Key of the selector to use.
	*/ key: "useState",
            value: function useState(key, a1, a2, a3) {
                react.useDebugValue(key);
                return useStore(this, this.selectors[key], a1, a2, a3);
            }
        },
        {
            /**
	* Wraps a function with `useStableCallback` to ensure it has a stable reference
	* and assigns it to the context.
	*
	* @param key Key of the event callback. Must be a function in the context.
	* @param fn Function to assign.
	*/ key: "useContextCallback",
            value: function useContextCallback(key, fn) {
                react.useDebugValue(key);
                var stableFunction = useStableCallback(fn !== null && fn !== void 0 ? fn : NOOP);
                this.context[key] = stableFunction;
            }
        },
        {
            /**
	* Returns a stable setter function for a specific key in the store's state.
	* It's commonly used to pass as a ref callback to React elements.
	*
	* @param key Key of the state to set.
	*/ key: "useStateSetter",
            value: function useStateSetter(key) {
                var _this = this;
                var ref = react.useRef(void 0);
                if (ref.current === void 0) ref.current = function(value) {
                    _this.set(key, value);
                };
                return ref.current;
            }
        },
        {
            /**
	* Observes changes derived from the store's selectors and calls the listener when the selected value changes.
	*
	* @param key Key of the selector to observe.
	* @param listener Listener function called when the selector result changes.
	*/ key: "observe",
            value: function observe(selector, listener) {
                var _this = this;
                var selectFn;
                if (typeof selector === "function") selectFn = selector;
                else selectFn = this.selectors[selector];
                var prevValue = selectFn(this.state);
                listener(prevValue, prevValue, this);
                return this.subscribe(function(nextState) {
                    var nextValue = selectFn(nextState);
                    if (!Object.is(prevValue, nextValue)) {
                        var oldValue = prevValue;
                        prevValue = nextValue;
                        listener(nextValue, oldValue, _this);
                    }
                });
            }
        }
    ]);
    return ReactStore;
}(Store);
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/mergeCleanups.js
/**
* Combines multiple cleanup functions into a single cleanup function.
*/ function mergeCleanups() {
    for(var _len = arguments.length, cleanups = new Array(_len), _key = 0; _key < _len; _key++){
        cleanups[_key] = arguments[_key];
    }
    return function() {
        for(var i = 0; i < cleanups.length; i += 1){
            var cleanup = cleanups[i];
            if (cleanup) cleanup();
        }
    };
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/owner.js
function ownerDocument(node) {
    return (node === null || node === void 0 ? void 0 : node.ownerDocument) || document;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/addEventListener.js
/**
* Adds an event listener and returns a cleanup function to remove it.
*/ function addEventListener(target, type, listener, options) {
    target.addEventListener(type, listener, options);
    return function() {
        target.removeEventListener(type, listener, options);
    };
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/useForcedRerendering.js
/**
* Returns a function that forces a rerender.
*/ function useForcedRerendering() {
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState({}), 2), setState = ref[1];
    return react.useCallback(function() {
        setState({});
    }, []);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/useTimeout.js
var EMPTY = 0;
var Timeout = /*#__PURE__*/ function() {
    "use strict";
    function Timeout() {
        var _this = this;
        (0,src_class_call_check/* default */.Z)(this, Timeout);
        (0,src_define_property/* default */.Z)(this, "currentId", EMPTY);
        (0,src_define_property/* default */.Z)(this, "clear", function() {
            if (_this.currentId !== EMPTY) {
                clearTimeout(_this.currentId);
                _this.currentId = EMPTY;
            }
        });
        (0,src_define_property/* default */.Z)(this, "disposeEffect", function() {
            return _this.clear;
        });
    }
    (0,src_create_class/* default */.Z)(Timeout, [
        {
            /**
	* Executes `fn` after `delay`, clearing any previously scheduled call.
	*/ key: "start",
            value: function start(delay, fn) {
                var _this = this;
                this.clear();
                this.currentId = setTimeout(function() {
                    _this.currentId = EMPTY;
                    fn();
                }, delay);
            }
        },
        {
            key: "isStarted",
            value: function isStarted() {
                return this.currentId !== EMPTY;
            }
        }
    ], [
        {
            key: "create",
            value: function create() {
                return new Timeout();
            }
        }
    ]);
    return Timeout;
}();
/**
* A `setTimeout` with automatic cleanup and guard.
*/ function useTimeout() {
    var timeout = useRefWithInit(Timeout.create).current;
    useOnMount(timeout.disposeEffect);
    return timeout;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/detectBrowser.js
var hasNavigator = typeof navigator !== "undefined";
var nav = getNavigatorData();
var platform$1 = getPlatform();
var userAgent = getUserAgent();
var isWebKit = typeof CSS === "undefined" || !CSS.supports ? false : CSS.supports("-webkit-backdrop-filter:none");
var isIOS = nav.platform === "MacIntel" && nav.maxTouchPoints > 1 ? true : /iP(hone|ad|od)|iOS/.test(nav.platform);
var isFirefox = hasNavigator && /firefox/i.test(userAgent);
var isSafari = hasNavigator && /apple/i.test(navigator.vendor);
hasNavigator && /Edg/i.test(userAgent);
var isAndroid = hasNavigator && /android/i.test(platform$1) || /android/i.test(userAgent);
hasNavigator && platform$1.toLowerCase().startsWith("mac") && navigator.maxTouchPoints;
var isJSDOM = userAgent.includes("jsdom/");
function getNavigatorData() {
    if (!hasNavigator) return {
        platform: "",
        maxTouchPoints: -1
    };
    var uaData = navigator.userAgentData;
    if (uaData === null || uaData === void 0 ? void 0 : uaData.platform) return {
        platform: uaData.platform,
        maxTouchPoints: navigator.maxTouchPoints
    };
    var _platform, _maxTouchPoints;
    return {
        platform: (_platform = navigator.platform) !== null && _platform !== void 0 ? _platform : "",
        maxTouchPoints: (_maxTouchPoints = navigator.maxTouchPoints) !== null && _maxTouchPoints !== void 0 ? _maxTouchPoints : -1
    };
}
function getUserAgent() {
    if (!hasNavigator) return "";
    var uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) return uaData.brands.map(function(param) {
        var brand = param.brand, version = param.version;
        return "".concat(brand, "/").concat(version);
    }).join(" ");
    return navigator.userAgent;
}
function getPlatform() {
    if (!hasNavigator) return "";
    var uaData = navigator.userAgentData;
    if (uaData === null || uaData === void 0 ? void 0 : uaData.platform) return uaData.platform;
    var _platform;
    return (_platform = navigator.platform) !== null && _platform !== void 0 ? _platform : "";
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/floating-ui-react/utils/event.js
function stopEvent(event) {
    event.preventDefault();
    event.stopPropagation();
}
function isReactEvent(event) {
    return "nativeEvent" in event;
}
function isVirtualClick(event) {
    if (event.pointerType === "" && event.isTrusted) return true;
    if (isAndroid && event.pointerType) return event.type === "click" && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function isVirtualPointerEvent(event) {
    if (isJSDOM) return false;
    return !isAndroid && event.width === 0 && event.height === 0 || isAndroid && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse" || event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "touch";
}
function isMouseLikePointerType(pointerType, strict) {
    var values = [
        "mouse",
        "pen"
    ];
    if (!strict) values.push("", void 0);
    return values.includes(pointerType);
}
function isClickLikeEvent(event) {
    var type = event.type;
    return type === "click" || type === "mousedown" || type === "keydown" || type === "keyup";
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/utils/FocusGuard.js
/**
* @internal
*/ var FocusGuard = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function FocusGuard(props, ref) {
    var _$ref = (0,src_sliced_to_array/* default */.Z)(react.useState(), 2), role = _$ref[0], setRole = _$ref[1];
    useIsoLayoutEffect(function() {
        if (isSafari) setRole("button");
    }, []);
    var restProps = {
        tabIndex: 0,
        role: role
    };
    return /* @__PURE__ */ (0,jsx_runtime.jsx)("span", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
        ref: ref,
        style: visuallyHidden,
        "aria-hidden": role ? void 0 : true
    }), restProps), {
        "data-base-ui-focus-guard": ""
    }));
});
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/floating-ui-react/utils/constants.js
var FOCUSABLE_ATTRIBUTE = "data-base-ui-focusable";
var ARROW_LEFT$1 = "ArrowLeft";
var ARROW_RIGHT$1 = "ArrowRight";
var ARROW_UP$1 = "ArrowUp";
var ARROW_DOWN$1 = "ArrowDown";
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/shadowDom.js
function activeElement(doc) {
    var ref;
    var element = doc.activeElement;
    while((element === null || element === void 0 ? void 0 : (ref = element.shadowRoot) === null || ref === void 0 ? void 0 : ref.activeElement) != null)element = element.shadowRoot.activeElement;
    return element;
}
function contains(parent, child) {
    var ref;
    if (!parent || !child) return false;
    var rootNode = (ref = child.getRootNode) === null || ref === void 0 ? void 0 : ref.call(child);
    if (parent.contains(child)) return true;
    if (rootNode && isShadowRoot(rootNode)) {
        var next = child;
        while(next){
            if (parent === next) return true;
            next = next.parentNode || next.host;
        }
    }
    return false;
}
function getTarget(event) {
    if ("composedPath" in event) return event.composedPath()[0];
    return event.target;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/floating-ui-react/utils/element.js
function isEventTargetWithin(event, node) {
    if (node == null) return false;
    if ("composedPath" in event) return event.composedPath().includes(node);
    var eventAgain = event;
    return eventAgain.target != null && node.contains(eventAgain.target);
}
function isRootElement(element) {
    return element.matches("html,body");
}
function isTypeableElement(element) {
    return isHTMLElement(element) && element.matches("input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])");
}
function isTypeableCombobox(element) {
    if (!element) return false;
    return element.getAttribute("role") === "combobox" && isTypeableElement(element);
}
function matchesFocusVisible(element) {
    if (!element || isJSDOM) return true;
    try {
        return element.matches(":focus-visible");
    } catch (_e) {
        return true;
    }
}
function getFloatingFocusElement(floatingElement) {
    if (!floatingElement) return null;
    return floatingElement.hasAttribute("data-base-ui-focusable") ? floatingElement : floatingElement.querySelector("[data-base-ui-focusable]") || floatingElement;
}
//#endregion
//#region ../../node_modules/.pnpm/@floating-ui+utils@0.2.11/node_modules/@floating-ui/utils/dist/floating-ui.utils.mjs
/**
* Custom positioning reference element.
* @see https://floating-ui.com/docs/virtual-elements
*/ var sides = [
    "top",
    "right",
    "bottom",
    "left"
];
var min = Math.min;
var max = Math.max;
var round = Math.round;
var floor = Math.floor;
var createCoords = function(v) {
    return {
        x: v,
        y: v
    };
};
var oppositeSideMap = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function clamp$1(start, value, end) {
    return max(start, min(value, end));
}
function evaluate(value, param) {
    return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
    return placement.split("-")[0];
}
function getAlignment(placement) {
    return placement.split("-")[1];
}
function getOppositeAxis(axis) {
    return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
    return axis === "y" ? "height" : "width";
}
function getSideAxis(placement) {
    var firstChar = placement[0];
    return firstChar === "t" || firstChar === "b" ? "y" : "x";
}
function getAlignmentAxis(placement) {
    return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    var alignment = getAlignment(placement);
    var alignmentAxis = getAlignmentAxis(placement);
    var length = getAxisLength(alignmentAxis);
    var mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
    return [
        mainAlignmentSide,
        getOppositePlacement(mainAlignmentSide)
    ];
}
function getExpandedPlacements(placement) {
    var oppositePlacement = getOppositePlacement(placement);
    return [
        getOppositeAlignmentPlacement(placement),
        oppositePlacement,
        getOppositeAlignmentPlacement(oppositePlacement)
    ];
}
function getOppositeAlignmentPlacement(placement) {
    return placement.includes("start") ? placement.replace("start", "end") : placement.replace("end", "start");
}
var lrPlacement = [
    "left",
    "right"
];
var rlPlacement = [
    "right",
    "left"
];
var tbPlacement = [
    "top",
    "bottom"
];
var btPlacement = [
    "bottom",
    "top"
];
function getSideList(side, isStart, rtl) {
    switch(side){
        case "top":
        case "bottom":
            if (rtl) return isStart ? rlPlacement : lrPlacement;
            return isStart ? lrPlacement : rlPlacement;
        case "left":
        case "right":
            return isStart ? tbPlacement : btPlacement;
        default:
            return [];
    }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
    var alignment = getAlignment(placement);
    var list = getSideList(getSide(placement), direction === "start", rtl);
    if (alignment) {
        list = list.map(function(side) {
            return side + "-" + alignment;
        });
        if (flipAlignment) list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
    return list;
}
function getOppositePlacement(placement) {
    var side = getSide(placement);
    return oppositeSideMap[side] + placement.slice(side.length);
}
function expandPaddingObject(padding) {
    return (0,src_object_spread/* default */.Z)({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }, padding);
}
function getPaddingObject(padding) {
    return typeof padding !== "number" ? expandPaddingObject(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function rectToClientRect(rect) {
    var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/floating-ui-react/utils/composite.js
function isDifferentGridRow(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function isIndexOutOfListBounds(list, index) {
    return index < 0 || index >= list.length;
}
function getMinListIndex(listRef, disabledIndices) {
    return findNonDisabledListIndex(listRef.current, {
        disabledIndices: disabledIndices
    });
}
function getMaxListIndex(listRef, disabledIndices) {
    return findNonDisabledListIndex(listRef.current, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices: disabledIndices
    });
}
function findNonDisabledListIndex(list) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _startingIndex = ref.startingIndex, startingIndex = _startingIndex === void 0 ? -1 : _startingIndex, _decrement = ref.decrement, decrement = _decrement === void 0 ? false : _decrement, disabledIndices = ref.disabledIndices, _amount = ref.amount, amount = _amount === void 0 ? 1 : _amount;
    var index = startingIndex;
    do index += decrement ? -amount : amount;
    while (index >= 0 && index <= list.length - 1 && isListIndexDisabled(list, index, disabledIndices));
    return index;
}
function getGridNavigatedIndex(list, param) {
    var event = param.event, orientation = param.orientation, loopFocus = param.loopFocus, onLoop = param.onLoop, rtl = param.rtl, cols = param.cols, disabledIndices = param.disabledIndices, minIndex = param.minIndex, maxIndex = param.maxIndex, prevIndex = param.prevIndex, tmp = param.stopEvent, stop = tmp === void 0 ? false : tmp;
    var nextIndex = prevIndex;
    var verticalDirection;
    if (event.key === "ArrowUp") verticalDirection = "up";
    else if (event.key === "ArrowDown") verticalDirection = "down";
    if (verticalDirection) {
        var rows = [];
        var rowIndexMap = [];
        var hasRoleRow = false;
        var visibleItemCount = 0;
        {
            var currentRowEl = null;
            var currentRowIndex = -1;
            list.forEach(function(el, idx) {
                if (el == null) return;
                visibleItemCount += 1;
                var rowEl = el.closest('[role="row"]');
                if (rowEl) hasRoleRow = true;
                if (rowEl !== currentRowEl || currentRowIndex === -1) {
                    currentRowEl = rowEl;
                    currentRowIndex += 1;
                    rows[currentRowIndex] = [];
                }
                rows[currentRowIndex].push(idx);
                rowIndexMap[idx] = currentRowIndex;
            });
        }
        var hasDomRows = false;
        var inferredDomCols = 0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (hasRoleRow) try {
            for(var _iterator = rows[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var row = _step.value;
                var rowLength = row.length;
                if (rowLength > inferredDomCols) inferredDomCols = rowLength;
                if (rowLength !== cols) hasDomRows = true;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var hasVirtualizedGaps = hasDomRows && visibleItemCount < list.length;
        var verticalCols = inferredDomCols || cols;
        var navigateVertically = function(direction) {
            if (!hasDomRows || prevIndex === -1) return;
            var currentRow = rowIndexMap[prevIndex];
            if (currentRow == null) return;
            var colInRow = rows[currentRow].indexOf(prevIndex);
            var step = direction === "up" ? -1 : 1;
            for(var nextRow = currentRow + step, i = 0; i < rows.length; i += 1, nextRow += step){
                if (nextRow < 0 || nextRow >= rows.length) {
                    if (!loopFocus || hasVirtualizedGaps) return;
                    nextRow = nextRow < 0 ? rows.length - 1 : 0;
                    if (onLoop) {
                        var clampedCol = Math.min(colInRow, rows[nextRow].length - 1);
                        var _clampedCol, ref;
                        nextRow = (ref = rowIndexMap[onLoop(event, prevIndex, (_clampedCol = rows[nextRow][clampedCol]) !== null && _clampedCol !== void 0 ? _clampedCol : rows[nextRow][0])]) !== null && ref !== void 0 ? ref : nextRow;
                    }
                }
                var targetRow = rows[nextRow];
                for(var col = Math.min(colInRow, targetRow.length - 1); col >= 0; col -= 1){
                    var candidate = targetRow[col];
                    if (!isListIndexDisabled(list, candidate, disabledIndices)) return candidate;
                }
            }
        };
        var navigateVerticallyWithInferredRows = function(direction) {
            if (!hasVirtualizedGaps || prevIndex === -1) return;
            var colInRow = prevIndex % verticalCols;
            var rowStep = direction === "up" ? -verticalCols : verticalCols;
            var lastRowStart = maxIndex - maxIndex % verticalCols;
            var rowCount = floor(maxIndex / verticalCols) + 1;
            for(var rowStart = prevIndex - colInRow + rowStep, i = 0; i < rowCount; i += 1, rowStart += rowStep){
                if (rowStart < 0 || rowStart > maxIndex) {
                    if (!loopFocus) return;
                    rowStart = rowStart < 0 ? lastRowStart : 0;
                }
                var rowEnd = Math.min(rowStart + verticalCols - 1, maxIndex);
                for(var candidate = Math.min(rowStart + colInRow, rowEnd); candidate >= rowStart; candidate -= 1)if (!isListIndexDisabled(list, candidate, disabledIndices)) return candidate;
            }
        };
        if (stop) stopEvent(event);
        var ref;
        var verticalCandidate = (ref = navigateVertically(verticalDirection)) !== null && ref !== void 0 ? ref : navigateVerticallyWithInferredRows(verticalDirection);
        if (verticalCandidate !== void 0) nextIndex = verticalCandidate;
        else if (prevIndex === -1) nextIndex = verticalDirection === "up" ? maxIndex : minIndex;
        else {
            nextIndex = findNonDisabledListIndex(list, {
                startingIndex: prevIndex,
                amount: verticalCols,
                decrement: verticalDirection === "up",
                disabledIndices: disabledIndices
            });
            if (loopFocus) {
                if (verticalDirection === "up" && (prevIndex - verticalCols < minIndex || nextIndex < 0)) {
                    var col = prevIndex % verticalCols;
                    var maxCol = maxIndex % verticalCols;
                    var offset = maxIndex - (maxCol - col);
                    if (maxCol === col) nextIndex = maxIndex;
                    else nextIndex = maxCol > col ? offset : offset - verticalCols;
                    if (onLoop) nextIndex = onLoop(event, prevIndex, nextIndex);
                }
                if (verticalDirection === "down" && prevIndex + verticalCols > maxIndex) {
                    nextIndex = findNonDisabledListIndex(list, {
                        startingIndex: prevIndex % verticalCols - verticalCols,
                        amount: verticalCols,
                        disabledIndices: disabledIndices
                    });
                    if (onLoop) nextIndex = onLoop(event, prevIndex, nextIndex);
                }
            }
        }
        if (isIndexOutOfListBounds(list, nextIndex)) nextIndex = prevIndex;
    }
    if (orientation === "both") {
        var prevRow = floor(prevIndex / cols);
        if (event.key === (rtl ? "ArrowLeft" : "ArrowRight")) {
            if (stop) stopEvent(event);
            if (prevIndex % cols !== cols - 1) {
                nextIndex = findNonDisabledListIndex(list, {
                    startingIndex: prevIndex,
                    disabledIndices: disabledIndices
                });
                if (loopFocus && isDifferentGridRow(nextIndex, cols, prevRow)) {
                    nextIndex = findNonDisabledListIndex(list, {
                        startingIndex: prevIndex - prevIndex % cols - 1,
                        disabledIndices: disabledIndices
                    });
                    if (onLoop) nextIndex = onLoop(event, prevIndex, nextIndex);
                }
            } else if (loopFocus) {
                nextIndex = findNonDisabledListIndex(list, {
                    startingIndex: prevIndex - prevIndex % cols - 1,
                    disabledIndices: disabledIndices
                });
                if (onLoop) nextIndex = onLoop(event, prevIndex, nextIndex);
            }
            if (isDifferentGridRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        if (event.key === (rtl ? "ArrowRight" : "ArrowLeft")) {
            if (stop) stopEvent(event);
            if (prevIndex % cols !== 0) {
                nextIndex = findNonDisabledListIndex(list, {
                    startingIndex: prevIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                if (loopFocus && isDifferentGridRow(nextIndex, cols, prevRow)) {
                    nextIndex = findNonDisabledListIndex(list, {
                        startingIndex: prevIndex + (cols - prevIndex % cols),
                        decrement: true,
                        disabledIndices: disabledIndices
                    });
                    if (onLoop) nextIndex = onLoop(event, prevIndex, nextIndex);
                }
            } else if (loopFocus) {
                nextIndex = findNonDisabledListIndex(list, {
                    startingIndex: prevIndex + (cols - prevIndex % cols),
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                if (onLoop) nextIndex = onLoop(event, prevIndex, nextIndex);
            }
            if (isDifferentGridRow(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        var lastRow = floor(maxIndex / cols) === prevRow;
        if (isIndexOutOfListBounds(list, nextIndex)) if (loopFocus && lastRow) {
            nextIndex = event.key === (rtl ? "ArrowRight" : "ArrowLeft") ? maxIndex : findNonDisabledListIndex(list, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            if (onLoop) nextIndex = onLoop(event, prevIndex, nextIndex);
        } else nextIndex = prevIndex;
    }
    return nextIndex;
}
/** For each cell index, gets the item index that occupies that cell */ function createGridCellMap(sizes, cols, dense) {
    var cellMap = [];
    var startIndex = 0;
    sizes.forEach(function(param, index) {
        var _loop = function() {
            var targetCells = [];
            for(var i = 0; i < width; i += 1)for(var j = 0; j < height; j += 1)targetCells.push(startIndex + i + j * cols);
            if (startIndex % cols + width <= cols && targetCells.every(function(cell) {
                return cellMap[cell] == null;
            })) {
                targetCells.forEach(function(cell) {
                    cellMap[cell] = index;
                });
                itemPlaced = true;
            } else startIndex += 1;
        };
        var width = param.width, height = param.height;
        if (width > cols) {
            if (false) {}
        }
        var itemPlaced = false;
        if (dense) startIndex = 0;
        while(!itemPlaced)_loop();
    });
    return (0,src_to_consumable_array/* default */.Z)(cellMap);
}
/** Gets cell index of an item's corner or -1 when index is -1. */ function getGridCellIndexOfCorner(index, sizes, cellMap, cols, corner) {
    if (index === -1) return -1;
    var firstCellIndex = cellMap.indexOf(index);
    var sizeItem = sizes[index];
    switch(corner){
        case "tl":
            return firstCellIndex;
        case "tr":
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + sizeItem.width - 1;
        case "bl":
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + (sizeItem.height - 1) * cols;
        case "br":
            return cellMap.lastIndexOf(index);
        default:
            return -1;
    }
}
/** Gets all cell indices that correspond to the specified indices */ function getGridCellIndices(indices, cellMap) {
    return cellMap.flatMap(function(index, cellIndex) {
        return indices.includes(index) ? [
            cellIndex
        ] : [];
    });
}
function isListIndexDisabled(list, index, disabledIndices) {
    var ref;
    if (typeof disabledIndices === "function" ? disabledIndices(index) : (ref = disabledIndices === null || disabledIndices === void 0 ? void 0 : disabledIndices.includes(index)) !== null && ref !== void 0 ? ref : false) return true;
    var element = list[index];
    if (!element) return false;
    if (!isElementVisible(element)) return true;
    return !disabledIndices && (element.hasAttribute("disabled") || element.getAttribute("aria-disabled") === "true");
}
function isHiddenByStyles(styles) {
    return styles.visibility === "hidden" || styles.visibility === "collapse";
}
function isElementVisible(element) {
    var styles = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : element ? getComputedStyle$1(element) : null;
    if (!element || !element.isConnected || !styles || isHiddenByStyles(styles)) return false;
    if (typeof element.checkVisibility === "function") return element.checkVisibility();
    return styles.display !== "none" && styles.display !== "contents";
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/floating-ui-react/utils/tabbable.js
var CANDIDATE_SELECTOR = 'a[href],button,input,select,textarea,summary,details,iframe,object,embed,[tabindex],[contenteditable]:not([contenteditable="false"]),audio[controls],video[controls]';
function getParentElement(element) {
    var assignedSlot = element.assignedSlot;
    if (assignedSlot) return assignedSlot;
    if (element.parentElement) return element.parentElement;
    var rootNode = element.getRootNode();
    return isShadowRoot(rootNode) ? rootNode.host : null;
}
function getDetailsSummary(details) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Array.from(details.children)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var child = _step.value;
            if (getNodeName(child) === "summary") return child;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return null;
}
function isWithinOpenDetailsSummary(element, details) {
    var summary = getDetailsSummary(details);
    return !!summary && (element === summary || contains(summary, element));
}
function isFocusableCandidate(element) {
    var nodeName = element ? getNodeName(element) : "";
    return element != null && element.matches(CANDIDATE_SELECTOR) && (nodeName !== "summary" || element.parentElement != null && getNodeName(element.parentElement) === "details" && getDetailsSummary(element.parentElement) === element) && (nodeName !== "details" || getDetailsSummary(element) == null) && (nodeName !== "input" || element.type !== "hidden");
}
function isFocusableElement(element) {
    if (!isFocusableCandidate(element) || !element.isConnected || element.matches(":disabled")) return false;
    for(var current = element; current; current = getParentElement(current)){
        var isAncestor = current !== element;
        var isSlot = getNodeName(current) === "slot";
        if (current.hasAttribute("inert")) return false;
        if (isAncestor && getNodeName(current) === "details" && !current.open && !isWithinOpenDetailsSummary(element, current) || current.hasAttribute("hidden") || !isSlot && !isVisibleInTabbableTree(current, isAncestor)) return false;
    }
    return true;
}
function isVisibleInTabbableTree(element, isAncestor) {
    var styles = getComputedStyle$1(element);
    if (!isAncestor) return isElementVisible(element, styles);
    return styles.display !== "none";
}
function getTabIndex(element) {
    var tabIndex = element.tabIndex;
    if (tabIndex < 0) {
        var nodeName = getNodeName(element);
        if (nodeName === "details" || nodeName === "audio" || nodeName === "video" || isHTMLElement(element) && element.isContentEditable) return 0;
    }
    return tabIndex;
}
function getNamedRadioInput(element) {
    if (getNodeName(element) !== "input") return null;
    var input = element;
    return input.type === "radio" && input.name !== "" ? input : null;
}
function isTabbableRadio(element, candidates) {
    var input = getNamedRadioInput(element);
    if (!input) return true;
    var checkedRadio = candidates.find(function(candidate) {
        var radio = getNamedRadioInput(candidate);
        return (radio === null || radio === void 0 ? void 0 : radio.name) === input.name && radio.form === input.form && radio.checked;
    });
    if (checkedRadio) return checkedRadio === input;
    return candidates.find(function(candidate) {
        var radio = getNamedRadioInput(candidate);
        return (radio === null || radio === void 0 ? void 0 : radio.name) === input.name && radio.form === input.form;
    }) === input;
}
function getComposedChildren(container) {
    if (isHTMLElement(container) && getNodeName(container) === "slot") {
        var assignedElements = container.assignedElements({
            flatten: true
        });
        if (assignedElements.length > 0) return assignedElements;
    }
    if (isHTMLElement(container) && container.shadowRoot) return Array.from(container.shadowRoot.children);
    return Array.from(container.children);
}
function appendCandidates(container, list) {
    getComposedChildren(container).forEach(function(child) {
        if (isFocusableCandidate(child)) list.push(child);
        appendCandidates(child, list);
    });
}
function appendMatchingElements(container, selector, list) {
    getComposedChildren(container).forEach(function(child) {
        if (isHTMLElement(child) && child.matches(selector)) list.push(child);
        appendMatchingElements(child, selector, list);
    });
}
function isTabbable(element) {
    return isFocusableElement(element) && getTabIndex(element) >= 0;
}
function focusable(container) {
    var candidates = [];
    appendCandidates(container, candidates);
    return candidates.filter(isFocusableElement);
}
function tabbable(container) {
    var candidates = focusable(container);
    return candidates.filter(function(element) {
        return getTabIndex(element) >= 0 && isTabbableRadio(element, candidates);
    });
}
function getTabbableIn(container, dir) {
    var list = tabbable(container);
    var len = list.length;
    if (len === 0) return;
    var active = activeElement(ownerDocument(container));
    var index = list.indexOf(active);
    return list[index === -1 ? dir === 1 ? 0 : len - 1 : index + dir];
}
function getNextTabbable(referenceElement) {
    return getTabbableIn(ownerDocument(referenceElement).body, 1) || referenceElement;
}
function getPreviousTabbable(referenceElement) {
    return getTabbableIn(ownerDocument(referenceElement).body, -1) || referenceElement;
}
function isOutsideEvent(event, container) {
    var containerElement = container || event.currentTarget;
    var relatedTarget = event.relatedTarget;
    return !relatedTarget || !contains(containerElement, relatedTarget);
}
function disableFocusInside(container) {
    tabbable(container).forEach(function(element) {
        element.dataset.tabindex = element.getAttribute("tabindex") || "";
        element.setAttribute("tabindex", "-1");
    });
}
function enableFocusInside(container) {
    var elements = [];
    appendMatchingElements(container, "[data-tabindex]", elements);
    elements.forEach(function(element) {
        var tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute("tabindex", tabindex);
        else element.removeAttribute("tabindex");
    });
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/floating-ui-react/utils/nodes.js
function getNodeChildren(nodes, id) {
    var onlyOpenChildren = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    return nodes.filter(function(node) {
        return node.parentId === id;
    }).flatMap(function(child) {
        var ref;
        return (0,src_to_consumable_array/* default */.Z)(!onlyOpenChildren || ((ref = child.context) === null || ref === void 0 ? void 0 : ref.open) ? [
            child
        ] : []).concat((0,src_to_consumable_array/* default */.Z)(getNodeChildren(nodes, child.id, onlyOpenChildren)));
    });
}
function getNodeAncestors(nodes, id) {
    var ref;
    var allAncestors = [];
    var currentParentId = (ref = nodes.find(function(node) {
        return node.id === id;
    })) === null || ref === void 0 ? void 0 : ref.parentId;
    while(currentParentId){
        var currentNode = nodes.find(function(node) {
            return node.id === currentParentId;
        });
        currentParentId = currentNode === null || currentNode === void 0 ? void 0 : currentNode.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/floating-ui-react/utils/createAttribute.js
function createAttribute(name) {
    return "data-base-ui-".concat(name);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/floating-ui-react/utils/enqueueFocus.js
var rafId = 0;
function enqueueFocus(el) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _preventScroll = options.preventScroll, preventScroll = _preventScroll === void 0 ? false : _preventScroll, _cancelPrevious = options.cancelPrevious, cancelPrevious = _cancelPrevious === void 0 ? true : _cancelPrevious, _sync = options.sync, sync = _sync === void 0 ? false : _sync;
    if (cancelPrevious) cancelAnimationFrame(rafId);
    var exec = function() {
        return el === null || el === void 0 ? void 0 : el.focus({
            preventScroll: preventScroll
        });
    };
    if (sync) {
        exec();
        return NOOP;
    }
    var currentRafId = requestAnimationFrame(exec);
    rafId = currentRafId;
    return function() {
        if (rafId === currentRafId) {
            cancelAnimationFrame(currentRafId);
            rafId = 0;
        }
    };
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/floating-ui-react/utils/markOthers.js
var counters = {
    inert: /* @__PURE__ */ new WeakMap(),
    "aria-hidden": /* @__PURE__ */ new WeakMap()
};
var markerName = "data-base-ui-inert";
var uncontrolledElementsSets = {
    inert: /* @__PURE__ */ new WeakSet(),
    "aria-hidden": /* @__PURE__ */ new WeakSet()
};
var markerCounterMap = /* @__PURE__ */ new WeakMap();
var lockCount = 0;
function getUncontrolledElementsSet(controlAttribute) {
    return uncontrolledElementsSets[controlAttribute];
}
function unwrapHost(node) {
    if (!node) return null;
    return isShadowRoot(node) ? node.host : unwrapHost(node.parentNode);
}
var correctElements = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = unwrapHost(target);
        if (parent.contains(correctedTarget)) return correctedTarget;
        return null;
    }).filter(function(x) {
        return x != null;
    });
};
var buildKeepSet = function(targets) {
    var keep = /* @__PURE__ */ new Set();
    targets.forEach(function(target) {
        var node = target;
        while(node && !keep.has(node)){
            keep.add(node);
            node = node.parentNode;
        }
    });
    return keep;
};
var collectOutsideElements = function(root, keepElements, stopElements) {
    var outside = [];
    var walk = function(parent) {
        if (!parent || stopElements.has(parent)) return;
        Array.from(parent.children).forEach(function(node) {
            if (getNodeName(node) === "script") return;
            if (keepElements.has(node)) walk(node);
            else outside.push(node);
        });
    };
    walk(root);
    return outside;
};
function applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert, param) {
    var _mark = param.mark, mark = _mark === void 0 ? true : _mark, _markerIgnoreElements = param.markerIgnoreElements, markerIgnoreElements = _markerIgnoreElements === void 0 ? [] : _markerIgnoreElements;
    var controlAttribute = inert ? "inert" : ariaHidden ? "aria-hidden" : null;
    var counterMap = null;
    var uncontrolledElementsSet = null;
    var avoidElements = correctElements(body, uncorrectedAvoidElements);
    var markerIgnoreTargets = mark ? correctElements(body, markerIgnoreElements) : [];
    var markerIgnoreSet = new Set(markerIgnoreTargets);
    var markerTargets = mark ? collectOutsideElements(body, buildKeepSet(avoidElements), new Set(avoidElements)).filter(function(target) {
        return !markerIgnoreSet.has(target);
    }) : [];
    var hiddenElements = [];
    var markedElements = [];
    if (controlAttribute) {
        var map = counters[controlAttribute];
        var currentUncontrolledElementsSet = getUncontrolledElementsSet(controlAttribute);
        uncontrolledElementsSet = currentUncontrolledElementsSet;
        counterMap = map;
        var ariaLiveElements = correctElements(body, Array.from(body.querySelectorAll("[aria-live]")));
        var controlElements = avoidElements.concat(ariaLiveElements);
        collectOutsideElements(body, buildKeepSet(controlElements), new Set(controlElements)).forEach(function(node) {
            var attr = node.getAttribute(controlAttribute);
            var alreadyHidden = attr !== null && attr !== "false";
            var counterValue = (map.get(node) || 0) + 1;
            map.set(node, counterValue);
            hiddenElements.push(node);
            if (counterValue === 1 && alreadyHidden) currentUncontrolledElementsSet.add(node);
            if (!alreadyHidden) node.setAttribute(controlAttribute, controlAttribute === "inert" ? "" : "true");
        });
    }
    if (mark) markerTargets.forEach(function(node) {
        var markerValue = (markerCounterMap.get(node) || 0) + 1;
        markerCounterMap.set(node, markerValue);
        markedElements.push(node);
        if (markerValue === 1) node.setAttribute(markerName, "");
    });
    lockCount += 1;
    return function() {
        if (counterMap) hiddenElements.forEach(function(element) {
            var counterValue = (counterMap.get(element) || 0) - 1;
            counterMap.set(element, counterValue);
            if (!counterValue) {
                if (!(uncontrolledElementsSet === null || uncontrolledElementsSet === void 0 ? void 0 : uncontrolledElementsSet.has(element)) && controlAttribute) element.removeAttribute(controlAttribute);
                uncontrolledElementsSet === null || uncontrolledElementsSet === void 0 ? void 0 : uncontrolledElementsSet.delete(element);
            }
        });
        if (mark) markedElements.forEach(function(element) {
            var markerValue = (markerCounterMap.get(element) || 0) - 1;
            markerCounterMap.set(element, markerValue);
            if (!markerValue) element.removeAttribute(markerName);
        });
        lockCount -= 1;
        if (!lockCount) {
            counters.inert = /* @__PURE__ */ new WeakMap();
            counters["aria-hidden"] = /* @__PURE__ */ new WeakMap();
            uncontrolledElementsSets.inert = /* @__PURE__ */ new WeakSet();
            uncontrolledElementsSets["aria-hidden"] = /* @__PURE__ */ new WeakSet();
            markerCounterMap = /* @__PURE__ */ new WeakMap();
        }
    };
}
function markOthers(avoidElements) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _ariaHidden = options.ariaHidden, ariaHidden = _ariaHidden === void 0 ? false : _ariaHidden, _inert = options.inert, inert = _inert === void 0 ? false : _inert, _mark = options.mark, mark = _mark === void 0 ? true : _mark, _markerIgnoreElements = options.markerIgnoreElements, markerIgnoreElements = _markerIgnoreElements === void 0 ? [] : _markerIgnoreElements;
    var body = ownerDocument(avoidElements[0]).body;
    return applyAttributeToOthers(avoidElements, body, ariaHidden, inert, {
        mark: mark,
        markerIgnoreElements: markerIgnoreElements
    });
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/constants.js
var DISABLED_TRANSITIONS_STYLE = {
    style: {
        transition: "none"
    }
};
var CLICK_TRIGGER_IDENTIFIER = "data-base-ui-click-trigger";
var BASE_UI_SWIPE_IGNORE_ATTRIBUTE = "data-base-ui-swipe-ignore";
var LEGACY_SWIPE_IGNORE_ATTRIBUTE = "data-swipe-ignore";
var BASE_UI_SWIPE_IGNORE_SELECTOR = "[".concat(BASE_UI_SWIPE_IGNORE_ATTRIBUTE, "]");
var LEGACY_SWIPE_IGNORE_SELECTOR = "[".concat(LEGACY_SWIPE_IGNORE_ATTRIBUTE, "]");
/**
* Used for dropdowns that usually strictly prefer top/bottom placements and
* use `var(--available-height)` to limit their height.
*/ var DROPDOWN_COLLISION_AVOIDANCE = {
    fallbackAxisSide: "none"
};
/**
* Used by regular popups that usually aren't scrollable and are allowed to
* freely flip to any axis of placement.
*/ var POPUP_COLLISION_AVOIDANCE = {
    fallbackAxisSide: "end"
};
/**
* Special visually hidden styles for the aria-owns owner element to ensure owned element
* accessibility in iOS/Safari/VoiceControl.
* The owner element is an empty span, so most of the common visually hidden styles are not needed.
* @see https://github.com/floating-ui/floating-ui/issues/3403
*/ var ownerVisuallyHidden = {
    clipPath: "inset(50%)",
    position: "fixed",
    top: 0,
    left: 0
};
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/floating-ui-react/components/FloatingPortal.js
var PortalContext = /* @__PURE__ */ /*#__PURE__*/ react.createContext(null);
if (false) {}
var usePortalContext = function() {
    return react.useContext(PortalContext);
};
var attr = createAttribute("portal");
function useFloatingPortalNode() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref;
    var ref1 = props.ref, containerProp = props.container, _componentProps = props.componentProps, componentProps = _componentProps === void 0 ? EMPTY_OBJECT : _componentProps, elementProps = props.elementProps;
    var uniqueId = useId$1();
    var parentPortalNode = (ref = usePortalContext()) === null || ref === void 0 ? void 0 : ref.portalNode;
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), containerElement = ref2[0], setContainerElement = ref2[1];
    var ref3 = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), portalNode = ref3[0], setPortalNode = ref3[1];
    var setPortalNodeRef = useStableCallback(function(node) {
        if (node !== null) setPortalNode(node);
    });
    var containerRef = react.useRef(null);
    useIsoLayoutEffect(function() {
        if (containerProp === null) {
            if (containerRef.current) {
                containerRef.current = null;
                setPortalNode(null);
                setContainerElement(null);
            }
            return;
        }
        if (uniqueId == null) return;
        var ref, ref1;
        var resolvedContainer = (ref1 = (ref = containerProp && (isNode(containerProp) ? containerProp : containerProp.current)) !== null && ref !== void 0 ? ref : parentPortalNode) !== null && ref1 !== void 0 ? ref1 : document.body;
        if (resolvedContainer == null) {
            if (containerRef.current) {
                containerRef.current = null;
                setPortalNode(null);
                setContainerElement(null);
            }
            return;
        }
        if (containerRef.current !== resolvedContainer) {
            containerRef.current = resolvedContainer;
            setPortalNode(null);
            setContainerElement(resolvedContainer);
        }
    }, [
        containerProp,
        parentPortalNode,
        uniqueId
    ]);
    var portalElement = useRenderElement("div", componentProps, {
        ref: [
            ref1,
            setPortalNodeRef
        ],
        props: [
            (0,src_define_property/* default */.Z)({
                id: uniqueId
            }, attr, ""),
            elementProps
        ]
    });
    return {
        portalNode: portalNode,
        portalSubtree: containerElement && portalElement ? /* @__PURE__ */ /*#__PURE__*/ react_dom.createPortal(portalElement, containerElement) : null
    };
}
/**
* Portals the floating element into a given container element — by default,
* outside of the app root and into the body.
* This is necessary to ensure the floating element can appear outside any
* potential parent containers that cause clipping (such as `overflow: hidden`),
* while retaining its location in the React tree.
* @see https://floating-ui.com/docs/FloatingPortal
* @internal
*/ var FloatingPortal = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function FloatingPortal(componentProps, forwardedRef) {
    var children = componentProps.children, container = componentProps.container, className = componentProps.className, render = componentProps.render, renderGuards = componentProps.renderGuards, style = componentProps.style, elementProps = (0,src_object_without_properties/* default */.Z)(componentProps, [
        "children",
        "container",
        "className",
        "render",
        "renderGuards",
        "style"
    ]);
    var ref = useFloatingPortalNode({
        container: container,
        ref: forwardedRef,
        componentProps: componentProps,
        elementProps: elementProps
    }), portalNode = ref.portalNode, portalSubtree = ref.portalSubtree;
    var beforeOutsideRef = react.useRef(null);
    var afterOutsideRef = react.useRef(null);
    var beforeInsideRef = react.useRef(null);
    var afterInsideRef = react.useRef(null);
    var ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), focusManagerState = ref1[0], setFocusManagerState = ref1[1];
    var focusInsideDisabledRef = react.useRef(false);
    var modal = focusManagerState === null || focusManagerState === void 0 ? void 0 : focusManagerState.modal;
    var open = focusManagerState === null || focusManagerState === void 0 ? void 0 : focusManagerState.open;
    var shouldRenderGuards = typeof renderGuards === "boolean" ? renderGuards : !!focusManagerState && !focusManagerState.modal && focusManagerState.open && !!portalNode;
    react.useEffect(function() {
        var onFocus = function onFocus(event) {
            if (portalNode && event.relatedTarget && isOutsideEvent(event)) if (event.type === "focusin") {
                if (focusInsideDisabledRef.current) {
                    enableFocusInside(portalNode);
                    focusInsideDisabledRef.current = false;
                }
            } else {
                disableFocusInside(portalNode);
                focusInsideDisabledRef.current = true;
            }
        };
        if (!portalNode || modal) return;
        return mergeCleanups(addEventListener(portalNode, "focusin", onFocus, true), addEventListener(portalNode, "focusout", onFocus, true));
    }, [
        portalNode,
        modal
    ]);
    react.useEffect(function() {
        if (!portalNode || open !== false) return;
        enableFocusInside(portalNode);
        focusInsideDisabledRef.current = false;
    }, [
        open,
        portalNode
    ]);
    var portalContextValue = react.useMemo(function() {
        return {
            beforeOutsideRef: beforeOutsideRef,
            afterOutsideRef: afterOutsideRef,
            beforeInsideRef: beforeInsideRef,
            afterInsideRef: afterInsideRef,
            portalNode: portalNode,
            setFocusManagerState: setFocusManagerState
        };
    }, [
        portalNode
    ]);
    return /* @__PURE__ */ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            portalSubtree,
            /* @__PURE__ */ (0,jsx_runtime.jsxs)(PortalContext.Provider, {
                value: portalContextValue,
                children: [
                    shouldRenderGuards && portalNode && /* @__PURE__ */ (0,jsx_runtime.jsx)(FocusGuard, {
                        "data-type": "outside",
                        ref: beforeOutsideRef,
                        onFocus: function(event) {
                            var ref, ref1;
                            if (isOutsideEvent(event, portalNode)) (ref = beforeInsideRef.current) === null || ref === void 0 ? void 0 : ref.focus();
                            else (ref1 = getPreviousTabbable(focusManagerState ? focusManagerState.domReference : null)) === null || ref1 === void 0 ? void 0 : ref1.focus();
                        }
                    }),
                    shouldRenderGuards && portalNode && /* @__PURE__ */ (0,jsx_runtime.jsx)("span", {
                        "aria-owns": portalNode.id,
                        style: ownerVisuallyHidden
                    }),
                    portalNode && /* @__PURE__ */ /*#__PURE__*/ react_dom.createPortal(children, portalNode),
                    shouldRenderGuards && portalNode && /* @__PURE__ */ (0,jsx_runtime.jsx)(FocusGuard, {
                        "data-type": "outside",
                        ref: afterOutsideRef,
                        onFocus: function(event) {
                            var ref;
                            if (isOutsideEvent(event, portalNode)) (ref = afterInsideRef.current) === null || ref === void 0 ? void 0 : ref.focus();
                            else {
                                var ref1;
                                (ref1 = getNextTabbable(focusManagerState ? focusManagerState.domReference : null)) === null || ref1 === void 0 ? void 0 : ref1.focus();
                                if (focusManagerState === null || focusManagerState === void 0 ? void 0 : focusManagerState.closeOnFocusOut) focusManagerState === null || focusManagerState === void 0 ? void 0 : focusManagerState.onOpenChange(false, createChangeEventDetails("focus-out", event.nativeEvent));
                            }
                        }
                    })
                ]
            })
        ]
    });
});
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/floating-ui-react/utils/createEventEmitter.js
function createEventEmitter() {
    var map = /* @__PURE__ */ new Map();
    return {
        emit: function emit(event, data) {
            var ref;
            (ref = map.get(event)) === null || ref === void 0 ? void 0 : ref.forEach(function(listener) {
                return listener(data);
            });
        },
        on: function on(event, listener) {
            if (!map.has(event)) map.set(event, /* @__PURE__ */ new Set());
            map.get(event).add(listener);
        },
        off: function off(event, listener) {
            var ref;
            (ref = map.get(event)) === null || ref === void 0 ? void 0 : ref.delete(listener);
        }
    };
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/floating-ui-react/components/FloatingTree.js
var FloatingNodeContext = /* @__PURE__ */ /*#__PURE__*/ react.createContext(null);
if (false) {}
var FloatingTreeContext = /* @__PURE__ */ /*#__PURE__*/ react.createContext(null);
/**
* Returns the parent node id for nested floating elements, if available.
* Returns `null` for top-level floating elements.
*/ if (false) {}
var useFloatingParentNodeId = function() {
    var ref;
    return ((ref = react.useContext(FloatingNodeContext)) === null || ref === void 0 ? void 0 : ref.id) || null;
};
/**
* Returns the nearest floating tree context, if available.
*/ var useFloatingTree = function(externalTree) {
    var contextTree = react.useContext(FloatingTreeContext);
    return externalTree !== null && externalTree !== void 0 ? externalTree : contextTree;
};
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/floating-ui-react/components/FloatingFocusManager.js
function getEventType(event, lastInteractionType) {
    var win = getWindow(getTarget(event));
    if ((0,_instanceof/* default */.Z)(event, win.KeyboardEvent)) return "keyboard";
    if ((0,_instanceof/* default */.Z)(event, win.FocusEvent)) return lastInteractionType || "keyboard";
    if ("pointerType" in event) return event.pointerType || "keyboard";
    if ("touches" in event) return "touch";
    if ((0,_instanceof/* default */.Z)(event, win.MouseEvent)) return lastInteractionType || (event.detail === 0 ? "keyboard" : "mouse");
    return "";
}
var LIST_LIMIT = 20;
var previouslyFocusedElements = [];
function clearDisconnectedPreviouslyFocusedElements() {
    previouslyFocusedElements = previouslyFocusedElements.filter(function(entry) {
        var ref;
        return (ref = entry.deref()) === null || ref === void 0 ? void 0 : ref.isConnected;
    });
}
function addPreviouslyFocusedElement(element) {
    clearDisconnectedPreviouslyFocusedElements();
    if (element && getNodeName(element) !== "body") {
        previouslyFocusedElements.push(new WeakRef(element));
        if (previouslyFocusedElements.length > LIST_LIMIT) previouslyFocusedElements = previouslyFocusedElements.slice(-LIST_LIMIT);
    }
}
function getPreviouslyFocusedElement() {
    var ref;
    clearDisconnectedPreviouslyFocusedElements();
    return (ref = previouslyFocusedElements[previouslyFocusedElements.length - 1]) === null || ref === void 0 ? void 0 : ref.deref();
}
function getFirstTabbableElement(container) {
    if (!container) return null;
    if (isTabbable(container)) return container;
    return tabbable(container)[0] || container;
}
function handleTabIndex(floatingFocusElement, orderRef) {
    var ref;
    if (floatingFocusElement.hasAttribute("tabindex") && !floatingFocusElement.hasAttribute("data-tabindex")) return;
    if (!orderRef.current.includes("floating") && !((ref = floatingFocusElement.getAttribute("role")) === null || ref === void 0 ? void 0 : ref.includes("dialog"))) return;
    var tabbableContent = focusable(floatingFocusElement).filter(function(element) {
        var dataTabIndex = element.getAttribute("data-tabindex") || "";
        return isTabbable(element) || element.hasAttribute("data-tabindex") && !dataTabIndex.startsWith("-");
    });
    var tabIndex = floatingFocusElement.getAttribute("tabindex");
    if (orderRef.current.includes("floating") || tabbableContent.length === 0) {
        if (tabIndex !== "0") floatingFocusElement.setAttribute("tabindex", "0");
    } else if (tabIndex !== "-1" || floatingFocusElement.hasAttribute("data-tabindex") && floatingFocusElement.getAttribute("data-tabindex") !== "-1") {
        floatingFocusElement.setAttribute("tabindex", "-1");
        floatingFocusElement.setAttribute("data-tabindex", "-1");
    }
}
/**
* Provides focus management for the floating element.
* @see https://floating-ui.com/docs/FloatingFocusManager
* @internal
*/ function FloatingFocusManager(props) {
    var context = props.context, children = props.children, _disabled = props.disabled, disabled = _disabled === void 0 ? false : _disabled, _initialFocus = props.initialFocus, initialFocus = _initialFocus === void 0 ? true : _initialFocus, _returnFocus = props.returnFocus, returnFocus = _returnFocus === void 0 ? true : _returnFocus, _restoreFocus = props.restoreFocus, restoreFocus = _restoreFocus === void 0 ? false : _restoreFocus, _modal = props.modal, modal = _modal === void 0 ? true : _modal, _closeOnFocusOut = props.closeOnFocusOut, closeOnFocusOut = _closeOnFocusOut === void 0 ? true : _closeOnFocusOut, _openInteractionType = props.openInteractionType, openInteractionType = _openInteractionType === void 0 ? "" : _openInteractionType, nextFocusableElement = props.nextFocusableElement, previousFocusableElement = props.previousFocusableElement, beforeContentFocusGuardRef = props.beforeContentFocusGuardRef, externalTree = props.externalTree, getInsideElements = props.getInsideElements;
    var store = "rootStore" in context ? context.rootStore : context;
    var open = store.useState("open");
    var domReference = store.useState("domReferenceElement");
    var floating = store.useState("floatingElement");
    var _context = store.context, events = _context.events, dataRef = _context.dataRef;
    var getNodeId = useStableCallback(function() {
        var ref;
        return (ref = dataRef.current.floatingContext) === null || ref === void 0 ? void 0 : ref.nodeId;
    });
    var ignoreInitialFocus = initialFocus === false;
    var isUntrappedTypeableCombobox = isTypeableCombobox(domReference) && ignoreInitialFocus;
    var orderRef = react.useRef([
        "content"
    ]);
    var initialFocusRef = useValueAsRef(initialFocus);
    var returnFocusRef = useValueAsRef(returnFocus);
    var openInteractionTypeRef = useValueAsRef(openInteractionType);
    var tree = useFloatingTree(externalTree);
    var portalContext = usePortalContext();
    var preventReturnFocusRef = react.useRef(false);
    var isPointerDownRef = react.useRef(false);
    var pointerDownOutsideRef = react.useRef(false);
    var lastFocusedTabbableRef = react.useRef(null);
    var closeTypeRef = react.useRef("");
    var lastInteractionTypeRef = react.useRef("");
    var beforeGuardRef = react.useRef(null);
    var afterGuardRef = react.useRef(null);
    var mergedBeforeGuardRef = useMergedRefs(beforeGuardRef, beforeContentFocusGuardRef, portalContext === null || portalContext === void 0 ? void 0 : portalContext.beforeInsideRef);
    var mergedAfterGuardRef = useMergedRefs(afterGuardRef, portalContext === null || portalContext === void 0 ? void 0 : portalContext.afterInsideRef);
    var blurTimeout = useTimeout();
    var pointerDownTimeout = useTimeout();
    var restoreFocusFrame = useAnimationFrame();
    var isInsidePortal = portalContext != null;
    var floatingFocusElement = getFloatingFocusElement(floating);
    var getTabbableContent = useStableCallback(function() {
        var container = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : floatingFocusElement;
        return container ? tabbable(container) : [];
    });
    var ref;
    var getResolvedInsideElements = useStableCallback(function() {
        return (ref = getInsideElements === null || getInsideElements === void 0 ? void 0 : getInsideElements().filter(function(element) {
            return element != null;
        })) !== null && ref !== void 0 ? ref : [];
    });
    react.useEffect(function() {
        var onKeyDown = function onKeyDown(event) {
            if (event.key === "Tab") {
                if (contains(floatingFocusElement, activeElement(ownerDocument(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) stopEvent(event);
            }
        };
        if (disabled || !modal) return;
        return addEventListener(ownerDocument(floatingFocusElement), "keydown", onKeyDown);
    }, [
        disabled,
        domReference,
        floatingFocusElement,
        modal,
        orderRef,
        isUntrappedTypeableCombobox,
        getTabbableContent
    ]);
    react.useEffect(function() {
        var clearPointerDownOutside = function clearPointerDownOutside() {
            pointerDownOutsideRef.current = false;
        };
        var onPointerDown = function onPointerDown(event) {
            var target = getTarget(event);
            var insideElements = getResolvedInsideElements();
            pointerDownOutsideRef.current = !(contains(floating, target) || contains(domReference, target) || contains(portalContext === null || portalContext === void 0 ? void 0 : portalContext.portalNode, target) || insideElements.some(function(element) {
                return element === target || contains(element, target);
            }));
            lastInteractionTypeRef.current = event.pointerType || "keyboard";
            if (target === null || target === void 0 ? void 0 : target.closest("[data-base-ui-click-trigger]")) isPointerDownRef.current = true;
        };
        var onKeyDown = function onKeyDown() {
            lastInteractionTypeRef.current = "keyboard";
        };
        if (disabled || !open) return;
        var doc = ownerDocument(floatingFocusElement);
        return mergeCleanups(addEventListener(doc, "pointerdown", onPointerDown, true), addEventListener(doc, "pointerup", clearPointerDownOutside, true), addEventListener(doc, "pointercancel", clearPointerDownOutside, true), addEventListener(doc, "keydown", onKeyDown, true));
    }, [
        disabled,
        floating,
        domReference,
        floatingFocusElement,
        open,
        portalContext,
        getResolvedInsideElements
    ]);
    react.useEffect(function() {
        var handlePointerDown = function handlePointerDown() {
            isPointerDownRef.current = true;
            pointerDownTimeout.start(0, function() {
                isPointerDownRef.current = false;
            });
        };
        var handleFocusIn = function handleFocusIn(event) {
            var target = getTarget(event);
            if (isTabbable(target)) lastFocusedTabbableRef.current = target;
        };
        var handleFocusOutside = function handleFocusOutside(event) {
            var relatedTarget = event.relatedTarget;
            var currentTarget = event.currentTarget;
            var target = getTarget(event);
            queueMicrotask(function() {
                var nodeId = getNodeId();
                var triggers = store.context.triggerElements;
                var insideElements = getResolvedInsideElements();
                var isRelatedFocusGuard = (relatedTarget === null || relatedTarget === void 0 ? void 0 : relatedTarget.hasAttribute(createAttribute("focus-guard"))) && [
                    beforeGuardRef.current,
                    afterGuardRef.current,
                    portalContext === null || portalContext === void 0 ? void 0 : portalContext.beforeInsideRef.current,
                    portalContext === null || portalContext === void 0 ? void 0 : portalContext.afterInsideRef.current,
                    portalContext === null || portalContext === void 0 ? void 0 : portalContext.beforeOutsideRef.current,
                    portalContext === null || portalContext === void 0 ? void 0 : portalContext.afterOutsideRef.current,
                    resolveRef(previousFocusableElement),
                    resolveRef(nextFocusableElement)
                ].includes(relatedTarget);
                var movedToUnrelatedNode = !(contains(domReference, relatedTarget) || contains(floating, relatedTarget) || contains(relatedTarget, floating) || contains(portalContext === null || portalContext === void 0 ? void 0 : portalContext.portalNode, relatedTarget) || insideElements.some(function(element) {
                    return element === relatedTarget || contains(element, relatedTarget);
                }) || relatedTarget != null && triggers.hasElement(relatedTarget) || triggers.hasMatchingElement(function(trigger) {
                    return contains(trigger, relatedTarget);
                }) || isRelatedFocusGuard || tree && (getNodeChildren(tree.nodesRef.current, nodeId).find(function(node) {
                    var ref, ref1;
                    return contains((ref = node.context) === null || ref === void 0 ? void 0 : ref.elements.floating, relatedTarget) || contains((ref1 = node.context) === null || ref1 === void 0 ? void 0 : ref1.elements.domReference, relatedTarget);
                }) || getNodeAncestors(tree.nodesRef.current, nodeId).find(function(node) {
                    var ref, ref1, ref2;
                    return [
                        (ref = node.context) === null || ref === void 0 ? void 0 : ref.elements.floating,
                        getFloatingFocusElement((ref1 = node.context) === null || ref1 === void 0 ? void 0 : ref1.elements.floating)
                    ].includes(relatedTarget) || ((ref2 = node.context) === null || ref2 === void 0 ? void 0 : ref2.elements.domReference) === relatedTarget;
                })));
                if (currentTarget === domReference && floatingFocusElement) handleTabIndex(floatingFocusElement, orderRef);
                if (restoreFocus && currentTarget !== domReference && !isElementVisible(target) && activeElement(doc) === doc.body) {
                    if (isHTMLElement(floatingFocusElement)) {
                        floatingFocusElement.focus();
                        if (restoreFocus === "popup") {
                            restoreFocusFrame.request(function() {
                                floatingFocusElement.focus();
                            });
                            return;
                        }
                    }
                    var tabbableContent = getTabbableContent();
                    var prevTabbable = lastFocusedTabbableRef.current;
                    var nodeToFocus = (prevTabbable && tabbableContent.includes(prevTabbable) ? prevTabbable : null) || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
                    if (isHTMLElement(nodeToFocus)) nodeToFocus.focus();
                }
                if (dataRef.current.insideReactTree) {
                    dataRef.current.insideReactTree = false;
                    return;
                }
                if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && (isUntrappedTypeableCombobox || relatedTarget !== getPreviouslyFocusedElement())) {
                    preventReturnFocusRef.current = true;
                    store.setOpen(false, createChangeEventDetails(focusOut, event));
                }
            });
        };
        var markInsideReactTree = function markInsideReactTree() {
            if (pointerDownOutsideRef.current) return;
            dataRef.current.insideReactTree = true;
            blurTimeout.start(0, function() {
                dataRef.current.insideReactTree = false;
            });
        };
        if (disabled || !closeOnFocusOut) return;
        var doc = ownerDocument(floatingFocusElement);
        var domReferenceElement = isHTMLElement(domReference) ? domReference : null;
        if (!floating && !domReferenceElement) return;
        return mergeCleanups(domReferenceElement && addEventListener(domReferenceElement, "focusout", handleFocusOutside), domReferenceElement && addEventListener(domReferenceElement, "pointerdown", handlePointerDown), floating && addEventListener(floating, "focusin", handleFocusIn), floating && addEventListener(floating, "focusout", handleFocusOutside), floating && portalContext && addEventListener(floating, "focusout", markInsideReactTree, true));
    }, [
        disabled,
        domReference,
        floating,
        floatingFocusElement,
        modal,
        tree,
        portalContext,
        store,
        closeOnFocusOut,
        restoreFocus,
        getTabbableContent,
        isUntrappedTypeableCombobox,
        getNodeId,
        orderRef,
        dataRef,
        blurTimeout,
        pointerDownTimeout,
        restoreFocusFrame,
        nextFocusableElement,
        previousFocusableElement,
        getResolvedInsideElements
    ]);
    react.useEffect(function() {
        var ref, ref1, ref2;
        if (disabled || !floating || !open) return;
        var portalNodes = Array.from((portalContext === null || portalContext === void 0 ? void 0 : (ref = portalContext.portalNode) === null || ref === void 0 ? void 0 : ref.querySelectorAll("[".concat(createAttribute("portal"), "]"))) || []);
        var rootAncestorComboboxDomReference = (ref1 = (tree ? getNodeAncestors(tree.nodesRef.current, getNodeId()) : []).find(function(node) {
            var ref;
            return isTypeableCombobox(((ref = node.context) === null || ref === void 0 ? void 0 : ref.elements.domReference) || null);
        })) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.context) === null || ref2 === void 0 ? void 0 : ref2.elements.domReference;
        var ariaHiddenCleanup = markOthers((0,src_to_consumable_array/* default */.Z)([
            floating
        ].concat((0,src_to_consumable_array/* default */.Z)(portalNodes), [
            beforeGuardRef.current,
            afterGuardRef.current,
            portalContext === null || portalContext === void 0 ? void 0 : portalContext.beforeOutsideRef.current,
            portalContext === null || portalContext === void 0 ? void 0 : portalContext.afterOutsideRef.current
        ], (0,src_to_consumable_array/* default */.Z)(getResolvedInsideElements()))).concat([
            rootAncestorComboboxDomReference,
            resolveRef(previousFocusableElement),
            resolveRef(nextFocusableElement),
            isUntrappedTypeableCombobox ? domReference : null
        ]).filter(function(x) {
            return x != null;
        }), {
            ariaHidden: modal || isUntrappedTypeableCombobox,
            mark: false
        });
        var markerCleanup = markOthers([
            floating
        ].concat((0,src_to_consumable_array/* default */.Z)(portalNodes)).filter(function(x) {
            return x != null;
        }));
        return function() {
            markerCleanup();
            ariaHiddenCleanup();
        };
    }, [
        open,
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        portalContext,
        isUntrappedTypeableCombobox,
        tree,
        getNodeId,
        nextFocusableElement,
        previousFocusableElement,
        getResolvedInsideElements
    ]);
    useIsoLayoutEffect(function() {
        if (!open || disabled || !isHTMLElement(floatingFocusElement)) return;
        var previouslyFocusedElement = activeElement(ownerDocument(floatingFocusElement));
        queueMicrotask(function() {
            var initialFocusValueOrFn = initialFocusRef.current;
            var resolvedInitialFocus = typeof initialFocusValueOrFn === "function" ? initialFocusValueOrFn(openInteractionTypeRef.current || "") : initialFocusValueOrFn;
            if (resolvedInitialFocus === void 0 || resolvedInitialFocus === false) return;
            if (contains(floatingFocusElement, previouslyFocusedElement)) return;
            var focusableElements = null;
            var getDefaultFocusElement = function() {
                if (focusableElements == null) focusableElements = getTabbableContent(floatingFocusElement);
                return focusableElements[0] || floatingFocusElement;
            };
            var elToFocus;
            if (resolvedInitialFocus === true || resolvedInitialFocus === null) elToFocus = getDefaultFocusElement();
            else elToFocus = resolveRef(resolvedInitialFocus);
            elToFocus = elToFocus || getDefaultFocusElement();
            enqueueFocus(elToFocus, {
                preventScroll: elToFocus === floatingFocusElement
            });
        });
    }, [
        disabled,
        open,
        floatingFocusElement,
        ignoreInitialFocus,
        getTabbableContent,
        initialFocusRef,
        openInteractionTypeRef
    ]);
    useIsoLayoutEffect(function() {
        var onOpenChangeLocal = function onOpenChangeLocal(details) {
            if (!details.open) closeTypeRef.current = getEventType(details.nativeEvent, lastInteractionTypeRef.current);
            if (details.reason === "trigger-hover" && details.nativeEvent.type === "mouseleave") preventReturnFocusRef.current = true;
            if (details.reason !== "outside-press") return;
            if (details.nested) preventReturnFocusRef.current = false;
            else if (isVirtualClick(details.nativeEvent) || isVirtualPointerEvent(details.nativeEvent)) preventReturnFocusRef.current = false;
            else {
                var isPreventScrollSupported = false;
                ownerDocument(floatingFocusElement).createElement("div").focus({
                    get preventScroll () {
                        isPreventScrollSupported = true;
                        return false;
                    }
                });
                if (isPreventScrollSupported) preventReturnFocusRef.current = false;
                else preventReturnFocusRef.current = true;
            }
        };
        var getReturnElement = function getReturnElement() {
            var returnFocusValueOrFn = returnFocusRef.current;
            var resolvedReturnFocusValue = typeof returnFocusValueOrFn === "function" ? returnFocusValueOrFn(closeTypeRef.current) : returnFocusValueOrFn;
            if (resolvedReturnFocusValue === void 0 || resolvedReturnFocusValue === false) return null;
            if (resolvedReturnFocusValue === null) resolvedReturnFocusValue = true;
            if (typeof resolvedReturnFocusValue === "boolean") {
                var el = domReference || getPreviouslyFocusedElement();
                return el && el.isConnected ? el : null;
            }
            var fallback = domReference || getPreviouslyFocusedElement();
            return resolveRef(resolvedReturnFocusValue) || fallback || null;
        };
        if (disabled || !floatingFocusElement) return;
        var doc = ownerDocument(floatingFocusElement);
        addPreviouslyFocusedElement(activeElement(doc));
        events.on("openchange", onOpenChangeLocal);
        return function() {
            events.off("openchange", onOpenChangeLocal);
            var activeEl = activeElement(doc);
            var insideElements = getResolvedInsideElements();
            var isFocusInsideFloatingTree = contains(floating, activeEl) || insideElements.some(function(element) {
                return element === activeEl || contains(element, activeEl);
            }) || tree && getNodeChildren(tree.nodesRef.current, getNodeId(), false).some(function(node) {
                var ref;
                return contains((ref = node.context) === null || ref === void 0 ? void 0 : ref.elements.floating, activeEl);
            });
            var returnFocusValueOrFn = returnFocusRef.current;
            var returnElement = getReturnElement();
            queueMicrotask(function() {
                var tabbableReturnElement = getFirstTabbableElement(returnElement);
                var hasExplicitReturnFocus = typeof returnFocusValueOrFn !== "boolean";
                if (returnFocusValueOrFn && !preventReturnFocusRef.current && isHTMLElement(tabbableReturnElement) && (!hasExplicitReturnFocus && tabbableReturnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) tabbableReturnElement.focus({
                    preventScroll: true
                });
                preventReturnFocusRef.current = false;
            });
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        returnFocusRef,
        dataRef,
        events,
        tree,
        domReference,
        getNodeId,
        getResolvedInsideElements
    ]);
    useIsoLayoutEffect(function() {
        if (!isWebKit || open || !floating) return;
        var activeEl = activeElement(ownerDocument(floating));
        if (!isHTMLElement(activeEl) || !isTypeableElement(activeEl)) return;
        if (contains(floating, activeEl)) activeEl.blur();
    }, [
        open,
        floating
    ]);
    useIsoLayoutEffect(function() {
        if (disabled || !portalContext) return;
        portalContext.setFocusManagerState({
            modal: modal,
            closeOnFocusOut: closeOnFocusOut,
            open: open,
            onOpenChange: store.setOpen,
            domReference: domReference
        });
        return function() {
            portalContext.setFocusManagerState(null);
        };
    }, [
        disabled,
        portalContext,
        modal,
        open,
        store,
        closeOnFocusOut,
        domReference
    ]);
    useIsoLayoutEffect(function() {
        if (disabled || !floatingFocusElement) return;
        handleTabIndex(floatingFocusElement, orderRef);
        return function() {
            queueMicrotask(clearDisconnectedPreviouslyFocusedElements);
        };
    }, [
        disabled,
        floatingFocusElement,
        orderRef
    ]);
    var shouldRenderGuards = !disabled && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
    return /* @__PURE__ */ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            shouldRenderGuards && /* @__PURE__ */ (0,jsx_runtime.jsx)(FocusGuard, {
                "data-type": "inside",
                ref: mergedBeforeGuardRef,
                onFocus: function(event) {
                    if (modal) {
                        var els = getTabbableContent();
                        enqueueFocus(els[els.length - 1]);
                    } else if (portalContext === null || portalContext === void 0 ? void 0 : portalContext.portalNode) {
                        var ref, ref1;
                        preventReturnFocusRef.current = false;
                        if (isOutsideEvent(event, portalContext.portalNode)) (ref = getNextTabbable(domReference)) === null || ref === void 0 ? void 0 : ref.focus();
                        else (ref1 = resolveRef(previousFocusableElement !== null && previousFocusableElement !== void 0 ? previousFocusableElement : portalContext.beforeOutsideRef)) === null || ref1 === void 0 ? void 0 : ref1.focus();
                    }
                }
            }),
            children,
            shouldRenderGuards && /* @__PURE__ */ (0,jsx_runtime.jsx)(FocusGuard, {
                "data-type": "inside",
                ref: mergedAfterGuardRef,
                onFocus: function(event) {
                    if (modal) enqueueFocus(getTabbableContent()[0]);
                    else if (portalContext === null || portalContext === void 0 ? void 0 : portalContext.portalNode) {
                        var ref, ref1;
                        if (closeOnFocusOut) preventReturnFocusRef.current = true;
                        if (isOutsideEvent(event, portalContext.portalNode)) (ref = getPreviousTabbable(domReference)) === null || ref === void 0 ? void 0 : ref.focus();
                        else (ref1 = resolveRef(nextFocusableElement !== null && nextFocusableElement !== void 0 ? nextFocusableElement : portalContext.afterOutsideRef)) === null || ref1 === void 0 ? void 0 : ref1.focus();
                    }
                }
            })
        ]
    });
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/floating-ui-react/hooks/useClick.js
/**
* Opens or closes the floating element when clicking the reference element.
* @see https://floating-ui.com/docs/useClick
*/ function useClick(context) {
    var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var store = "rootStore" in context ? context.rootStore : context;
    var dataRef = store.context.dataRef;
    var _enabled = props.enabled, enabled = _enabled === void 0 ? true : _enabled, tmp = props.event, eventOption = tmp === void 0 ? "click" : tmp, _toggle = props.toggle, toggle = _toggle === void 0 ? true : _toggle, _ignoreMouse = props.ignoreMouse, ignoreMouse = _ignoreMouse === void 0 ? false : _ignoreMouse, _stickIfOpen = props.stickIfOpen, stickIfOpen = _stickIfOpen === void 0 ? true : _stickIfOpen, _touchOpenDelay = props.touchOpenDelay, touchOpenDelay = _touchOpenDelay === void 0 ? 0 : _touchOpenDelay, _reason = props.reason, reason = _reason === void 0 ? triggerPress : _reason;
    var pointerTypeRef = react.useRef(void 0);
    var frame = useAnimationFrame();
    var touchOpenTimeout = useTimeout();
    var reference = react.useMemo(function() {
        return {
            onPointerDown: function onPointerDown(event) {
                pointerTypeRef.current = event.pointerType;
            },
            onMouseDown: function onMouseDown(event) {
                var pointerType = pointerTypeRef.current;
                var nativeEvent = event.nativeEvent;
                var open = store.select("open");
                if (event.button !== 0 || eventOption === "click" || isMouseLikePointerType(pointerType, true) && ignoreMouse) return;
                var openEvent = dataRef.current.openEvent;
                var openEventType = openEvent === null || openEvent === void 0 ? void 0 : openEvent.type;
                var hasClickedOnInactiveTrigger = store.select("domReferenceElement") !== event.currentTarget;
                var nextOpen = open && hasClickedOnInactiveTrigger || !(open && toggle && (openEvent && stickIfOpen ? openEventType === "click" || openEventType === "mousedown" : true));
                var target = getTarget(nativeEvent);
                if (isTypeableElement(target)) {
                    var details = createChangeEventDetails(reason, nativeEvent, target);
                    if (nextOpen && pointerType === "touch" && touchOpenDelay > 0) touchOpenTimeout.start(touchOpenDelay, function() {
                        store.setOpen(true, details);
                    });
                    else store.setOpen(nextOpen, details);
                    return;
                }
                var eventCurrentTarget = event.currentTarget;
                frame.request(function() {
                    var details = createChangeEventDetails(reason, nativeEvent, eventCurrentTarget);
                    if (nextOpen && pointerType === "touch" && touchOpenDelay > 0) touchOpenTimeout.start(touchOpenDelay, function() {
                        store.setOpen(true, details);
                    });
                    else store.setOpen(nextOpen, details);
                });
            },
            onClick: function onClick(event) {
                if (eventOption === "mousedown-only") return;
                var pointerType = pointerTypeRef.current;
                if (eventOption === "mousedown" && pointerType) {
                    pointerTypeRef.current = void 0;
                    return;
                }
                if (isMouseLikePointerType(pointerType, true) && ignoreMouse) return;
                var open = store.select("open");
                var openEvent = dataRef.current.openEvent;
                var hasClickedOnInactiveTrigger = store.select("domReferenceElement") !== event.currentTarget;
                var nextOpen = open && hasClickedOnInactiveTrigger || !(open && toggle && (openEvent && stickIfOpen ? isClickLikeEvent(openEvent) : true));
                var details = createChangeEventDetails(reason, event.nativeEvent, event.currentTarget);
                if (nextOpen && pointerType === "touch" && touchOpenDelay > 0) touchOpenTimeout.start(touchOpenDelay, function() {
                    store.setOpen(true, details);
                });
                else store.setOpen(nextOpen, details);
            },
            onKeyDown: function onKeyDown() {
                pointerTypeRef.current = void 0;
            }
        };
    }, [
        dataRef,
        eventOption,
        ignoreMouse,
        store,
        stickIfOpen,
        toggle,
        frame,
        touchOpenTimeout,
        touchOpenDelay,
        reason
    ]);
    return react.useMemo(function() {
        return enabled ? {
            reference: reference
        } : EMPTY_OBJECT;
    }, [
        enabled,
        reference
    ]);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/floating-ui-react/hooks/useDismiss.js
var bubbleHandlerKeys = {
    intentional: "onClick",
    sloppy: "onPointerDown"
};
function alwaysFalse() {
    return false;
}
function normalizeProp(normalizable) {
    var ref, ref1;
    return {
        escapeKey: typeof normalizable === "boolean" ? normalizable : (ref = normalizable === null || normalizable === void 0 ? void 0 : normalizable.escapeKey) !== null && ref !== void 0 ? ref : false,
        outsidePress: typeof normalizable === "boolean" ? normalizable : (ref1 = normalizable === null || normalizable === void 0 ? void 0 : normalizable.outsidePress) !== null && ref1 !== void 0 ? ref1 : true
    };
}
/**
* Closes the floating element when a dismissal is requested — by default, when
* the user presses the `escape` key or outside of the floating element.
* @see https://floating-ui.com/docs/useDismiss
*/ function useDismiss(context) {
    var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var store = "rootStore" in context ? context.rootStore : context;
    var open = store.useState("open");
    var floatingElement = store.useState("floatingElement");
    var dataRef = store.context.dataRef;
    var _enabled = props.enabled, enabled = _enabled === void 0 ? true : _enabled, tmp = props.escapeKey, escapeKey$1 = tmp === void 0 ? true : tmp, tmp1 = props.outsidePress, outsidePressProp = tmp1 === void 0 ? true : tmp1, _outsidePressEvent = props.outsidePressEvent, outsidePressEvent = _outsidePressEvent === void 0 ? "sloppy" : _outsidePressEvent, _referencePress = props.referencePress, referencePress = _referencePress === void 0 ? alwaysFalse : _referencePress, _referencePressEvent = props.referencePressEvent, referencePressEvent = _referencePressEvent === void 0 ? "sloppy" : _referencePressEvent, bubbles = props.bubbles, externalTree = props.externalTree;
    var tree = useFloatingTree(externalTree);
    var outsidePressFn = useStableCallback(typeof outsidePressProp === "function" ? outsidePressProp : function() {
        return false;
    });
    var outsidePress$1 = typeof outsidePressProp === "function" ? outsidePressFn : outsidePressProp;
    var outsidePressEnabled = outsidePress$1 !== false;
    var getOutsidePressEventProp = useStableCallback(function() {
        return outsidePressEvent;
    });
    var pressStartedInsideRef = react.useRef(false);
    var pressStartPreventedRef = react.useRef(false);
    var suppressNextOutsideClickRef = react.useRef(false);
    var ref = normalizeProp(bubbles), escapeKeyBubbles = ref.escapeKey, outsidePressBubbles = ref.outsidePress;
    var touchStateRef = react.useRef(null);
    var cancelDismissOnEndTimeout = useTimeout();
    var clearInsideReactTreeTimeout = useTimeout();
    var clearInsideReactTree = useStableCallback(function() {
        clearInsideReactTreeTimeout.clear();
        dataRef.current.insideReactTree = false;
    });
    var isComposingRef = react.useRef(false);
    var currentPointerTypeRef = react.useRef("");
    var isReferencePressEnabled = useStableCallback(referencePress);
    var closeOnEscapeKeyDown = useStableCallback(function(event) {
        var ref;
        if (!open || !enabled || !escapeKey$1 || event.key !== "Escape") return;
        if (isComposingRef.current) return;
        var nodeId = (ref = dataRef.current.floatingContext) === null || ref === void 0 ? void 0 : ref.nodeId;
        var children = tree ? getNodeChildren(tree.nodesRef.current, nodeId) : [];
        if (!escapeKeyBubbles) {
            if (children.length > 0) {
                var shouldDismiss = true;
                children.forEach(function(child) {
                    var ref;
                    if (((ref = child.context) === null || ref === void 0 ? void 0 : ref.open) && !child.context.dataRef.current.__escapeKeyBubbles) shouldDismiss = false;
                });
                if (!shouldDismiss) return;
            }
        }
        var eventDetails = createChangeEventDetails(escapeKey, isReactEvent(event) ? event.nativeEvent : event);
        store.setOpen(false, eventDetails);
        if (!escapeKeyBubbles && !eventDetails.isPropagationAllowed) event.stopPropagation();
    });
    var markInsideReactTree = useStableCallback(function() {
        dataRef.current.insideReactTree = true;
        clearInsideReactTreeTimeout.start(0, clearInsideReactTree);
    });
    react.useEffect(function() {
        var handleCompositionStart = function handleCompositionStart() {
            compositionTimeout.clear();
            isComposingRef.current = true;
        };
        var handleCompositionEnd = function handleCompositionEnd() {
            compositionTimeout.start(isWebKit$1() ? 5 : 0, function() {
                isComposingRef.current = false;
            });
        };
        var suppressImmediateOutsideClickAfterPreventedStart = function suppressImmediateOutsideClickAfterPreventedStart() {
            suppressNextOutsideClickRef.current = true;
            preventedPressSuppressionTimeout.start(0, function() {
                suppressNextOutsideClickRef.current = false;
            });
        };
        var resetPressStartState = function resetPressStartState() {
            pressStartedInsideRef.current = false;
            pressStartPreventedRef.current = false;
        };
        var getOutsidePressEvent = function getOutsidePressEvent() {
            var type = currentPointerTypeRef.current;
            var computedType = type === "pen" || !type ? "mouse" : type;
            var outsidePressEventValue = getOutsidePressEventProp();
            var resolved = typeof outsidePressEventValue === "function" ? outsidePressEventValue() : outsidePressEventValue;
            if (typeof resolved === "string") return resolved;
            return resolved[computedType];
        };
        var shouldIgnoreEvent = function shouldIgnoreEvent(event) {
            var computedOutsidePressEvent = getOutsidePressEvent();
            return computedOutsidePressEvent === "intentional" && event.type !== "click" || computedOutsidePressEvent === "sloppy" && event.type === "click";
        };
        var isEventWithinFloatingTree = function isEventWithinFloatingTree(event) {
            var ref;
            var nodeId = (ref = dataRef.current.floatingContext) === null || ref === void 0 ? void 0 : ref.nodeId;
            var targetIsInsideChildren = tree && getNodeChildren(tree.nodesRef.current, nodeId).some(function(node) {
                var ref;
                return isEventTargetWithin(event, (ref = node.context) === null || ref === void 0 ? void 0 : ref.elements.floating);
            });
            return isEventTargetWithin(event, store.select("floatingElement")) || isEventTargetWithin(event, store.select("domReferenceElement")) || targetIsInsideChildren;
        };
        var closeOnPressOutside = function closeOnPressOutside(event) {
            var ref;
            if (shouldIgnoreEvent(event)) {
                clearInsideReactTree();
                return;
            }
            if (dataRef.current.insideReactTree) {
                clearInsideReactTree();
                return;
            }
            var target = getTarget(event);
            var inertSelector = "[".concat(createAttribute("inert"), "]");
            var targetRoot = isElement(target) ? target.getRootNode() : null;
            var markers = Array.from((isShadowRoot(targetRoot) ? targetRoot : ownerDocument(store.select("floatingElement"))).querySelectorAll(inertSelector));
            var triggers = store.context.triggerElements;
            if (target && (triggers.hasElement(target) || triggers.hasMatchingElement(function(trigger) {
                return contains(trigger, target);
            }))) return;
            var targetRootAncestor = isElement(target) ? target : null;
            while(targetRootAncestor && !isLastTraversableNode(targetRootAncestor)){
                var nextParent = getParentNode(targetRootAncestor);
                if (isLastTraversableNode(nextParent) || !isElement(nextParent)) break;
                targetRootAncestor = nextParent;
            }
            if (markers.length && isElement(target) && !isRootElement(target) && !contains(target, store.select("floatingElement")) && markers.every(function(marker) {
                return !contains(targetRootAncestor, marker);
            })) return;
            if (isHTMLElement(target) && !("touches" in event)) {
                var lastTraversableNode = isLastTraversableNode(target);
                var style = getComputedStyle$1(target);
                var scrollRe = /auto|scroll/;
                var isScrollableX = lastTraversableNode || scrollRe.test(style.overflowX);
                var isScrollableY = lastTraversableNode || scrollRe.test(style.overflowY);
                var canScrollX = isScrollableX && target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
                var canScrollY = isScrollableY && target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
                var _$isRTL = style.direction === "rtl";
                var pressedVerticalScrollbar = canScrollY && (_$isRTL ? event.offsetX <= target.offsetWidth - target.clientWidth : event.offsetX > target.clientWidth);
                var pressedHorizontalScrollbar = canScrollX && event.offsetY > target.clientHeight;
                if (pressedVerticalScrollbar || pressedHorizontalScrollbar) return;
            }
            if (isEventWithinFloatingTree(event)) return;
            if (getOutsidePressEvent() === "intentional" && suppressNextOutsideClickRef.current) {
                preventedPressSuppressionTimeout.clear();
                suppressNextOutsideClickRef.current = false;
                return;
            }
            if (typeof outsidePress$1 === "function" && !outsidePress$1(event)) return;
            var nodeId = (ref = dataRef.current.floatingContext) === null || ref === void 0 ? void 0 : ref.nodeId;
            var children = tree ? getNodeChildren(tree.nodesRef.current, nodeId) : [];
            if (children.length > 0) {
                var shouldDismiss = true;
                children.forEach(function(child) {
                    var ref;
                    if (((ref = child.context) === null || ref === void 0 ? void 0 : ref.open) && !child.context.dataRef.current.__outsidePressBubbles) shouldDismiss = false;
                });
                if (!shouldDismiss) return;
            }
            store.setOpen(false, createChangeEventDetails(outsidePress, event));
            clearInsideReactTree();
        };
        var handlePointerDown = function handlePointerDown(event) {
            if (getOutsidePressEvent() !== "sloppy" || event.pointerType === "touch" || !store.select("open") || !enabled || isEventTargetWithin(event, store.select("floatingElement")) || isEventTargetWithin(event, store.select("domReferenceElement"))) return;
            closeOnPressOutside(event);
        };
        var handleTouchStart = function handleTouchStart(event) {
            if (getOutsidePressEvent() !== "sloppy" || !store.select("open") || !enabled || isEventTargetWithin(event, store.select("floatingElement")) || isEventTargetWithin(event, store.select("domReferenceElement"))) return;
            var touch = event.touches[0];
            if (touch) {
                touchStateRef.current = {
                    startTime: Date.now(),
                    startX: touch.clientX,
                    startY: touch.clientY,
                    dismissOnTouchEnd: false,
                    dismissOnMouseDown: true
                };
                cancelDismissOnEndTimeout.start(1e3, function() {
                    if (touchStateRef.current) {
                        touchStateRef.current.dismissOnTouchEnd = false;
                        touchStateRef.current.dismissOnMouseDown = false;
                    }
                });
            }
        };
        var addTargetEventListenerOnce = function addTargetEventListenerOnce(event, listener) {
            var target = getTarget(event);
            if (!target) return;
            var unsubscribe = addEventListener(target, event.type, function() {
                listener(event);
                unsubscribe();
            });
        };
        var handleTouchStartCapture = function handleTouchStartCapture(event) {
            currentPointerTypeRef.current = "touch";
            addTargetEventListenerOnce(event, handleTouchStart);
        };
        var closeOnPressOutsideCapture = function closeOnPressOutsideCapture(event) {
            cancelDismissOnEndTimeout.clear();
            if (event.type === "pointerdown") currentPointerTypeRef.current = event.pointerType;
            if (event.type === "mousedown" && touchStateRef.current && !touchStateRef.current.dismissOnMouseDown) return;
            addTargetEventListenerOnce(event, function(targetEvent) {
                if (targetEvent.type === "pointerdown") handlePointerDown(targetEvent);
                else closeOnPressOutside(targetEvent);
            });
        };
        var handlePressEndCapture = function handlePressEndCapture(event) {
            if (!pressStartedInsideRef.current) return;
            var pressStartedInsideDefaultPrevented = pressStartPreventedRef.current;
            resetPressStartState();
            if (getOutsidePressEvent() !== "intentional") return;
            if (event.type === "pointercancel") {
                if (pressStartedInsideDefaultPrevented) suppressImmediateOutsideClickAfterPreventedStart();
                return;
            }
            if (isEventWithinFloatingTree(event)) return;
            if (pressStartedInsideDefaultPrevented) {
                suppressImmediateOutsideClickAfterPreventedStart();
                return;
            }
            if (typeof outsidePress$1 === "function" && !outsidePress$1(event)) return;
            preventedPressSuppressionTimeout.clear();
            suppressNextOutsideClickRef.current = true;
            clearInsideReactTree();
        };
        var handleTouchMove = function handleTouchMove(event) {
            if (getOutsidePressEvent() !== "sloppy" || !touchStateRef.current || isEventTargetWithin(event, store.select("floatingElement")) || isEventTargetWithin(event, store.select("domReferenceElement"))) return;
            var touch = event.touches[0];
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - touchStateRef.current.startX);
            var deltaY = Math.abs(touch.clientY - touchStateRef.current.startY);
            var distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
            if (distance > 5) touchStateRef.current.dismissOnTouchEnd = true;
            if (distance > 10) {
                closeOnPressOutside(event);
                cancelDismissOnEndTimeout.clear();
                touchStateRef.current = null;
            }
        };
        var handleTouchMoveCapture = function handleTouchMoveCapture(event) {
            addTargetEventListenerOnce(event, handleTouchMove);
        };
        var handleTouchEnd = function handleTouchEnd(event) {
            if (getOutsidePressEvent() !== "sloppy" || !touchStateRef.current || isEventTargetWithin(event, store.select("floatingElement")) || isEventTargetWithin(event, store.select("domReferenceElement"))) return;
            if (touchStateRef.current.dismissOnTouchEnd) closeOnPressOutside(event);
            cancelDismissOnEndTimeout.clear();
            touchStateRef.current = null;
        };
        var handleTouchEndCapture = function handleTouchEndCapture(event) {
            addTargetEventListenerOnce(event, handleTouchEnd);
        };
        if (!open || !enabled) return;
        dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
        dataRef.current.__outsidePressBubbles = outsidePressBubbles;
        var compositionTimeout = new Timeout();
        var preventedPressSuppressionTimeout = new Timeout();
        var doc = ownerDocument(floatingElement);
        var unsubscribe = mergeCleanups(escapeKey$1 && mergeCleanups(addEventListener(doc, "keydown", closeOnEscapeKeyDown), addEventListener(doc, "compositionstart", handleCompositionStart), addEventListener(doc, "compositionend", handleCompositionEnd)), outsidePressEnabled && mergeCleanups(addEventListener(doc, "click", closeOnPressOutsideCapture, true), addEventListener(doc, "pointerdown", closeOnPressOutsideCapture, true), addEventListener(doc, "pointerup", handlePressEndCapture, true), addEventListener(doc, "pointercancel", handlePressEndCapture, true), addEventListener(doc, "mousedown", closeOnPressOutsideCapture, true), addEventListener(doc, "mouseup", handlePressEndCapture, true), addEventListener(doc, "touchstart", handleTouchStartCapture, true), addEventListener(doc, "touchmove", handleTouchMoveCapture, true), addEventListener(doc, "touchend", handleTouchEndCapture, true)));
        return function() {
            unsubscribe();
            compositionTimeout.clear();
            preventedPressSuppressionTimeout.clear();
            resetPressStartState();
            suppressNextOutsideClickRef.current = false;
        };
    }, [
        dataRef,
        floatingElement,
        escapeKey$1,
        outsidePressEnabled,
        outsidePress$1,
        open,
        enabled,
        escapeKeyBubbles,
        outsidePressBubbles,
        closeOnEscapeKeyDown,
        clearInsideReactTree,
        getOutsidePressEventProp,
        tree,
        store,
        cancelDismissOnEndTimeout
    ]);
    react.useEffect(clearInsideReactTree, [
        outsidePress$1,
        clearInsideReactTree
    ]);
    var reference = react.useMemo(function() {
        return (0,src_object_spread/* default */.Z)((0,src_define_property/* default */.Z)({
            onKeyDown: closeOnEscapeKeyDown
        }, bubbleHandlerKeys[referencePressEvent], function(event) {
            if (!isReferencePressEnabled()) return;
            store.setOpen(false, createChangeEventDetails(triggerPress, event.nativeEvent));
        }), referencePressEvent !== "intentional" && {
            onClick: function onClick(event) {
                if (!isReferencePressEnabled()) return;
                store.setOpen(false, createChangeEventDetails("trigger-press", event.nativeEvent));
            }
        });
    }, [
        closeOnEscapeKeyDown,
        store,
        referencePressEvent,
        isReferencePressEnabled
    ]);
    var markPressStartedInsideReactTree = useStableCallback(function(event) {
        if (!open || !enabled || event.button !== 0) return;
        var target = getTarget(event.nativeEvent);
        if (!contains(store.select("floatingElement"), target)) return;
        if (!pressStartedInsideRef.current) {
            pressStartedInsideRef.current = true;
            pressStartPreventedRef.current = false;
        }
    });
    var markInsidePressStartPrevented = useStableCallback(function(event) {
        if (!open || !enabled) return;
        if (!(event.defaultPrevented || event.nativeEvent.defaultPrevented)) return;
        if (pressStartedInsideRef.current) pressStartPreventedRef.current = true;
    });
    var floating = react.useMemo(function() {
        return {
            onKeyDown: closeOnEscapeKeyDown,
            onPointerDown: markInsidePressStartPrevented,
            onMouseDown: markInsidePressStartPrevented,
            onClickCapture: markInsideReactTree,
            onMouseDownCapture: function onMouseDownCapture(event) {
                markInsideReactTree();
                markPressStartedInsideReactTree(event);
            },
            onPointerDownCapture: function onPointerDownCapture(event) {
                markInsideReactTree();
                markPressStartedInsideReactTree(event);
            },
            onMouseUpCapture: markInsideReactTree,
            onTouchEndCapture: markInsideReactTree,
            onTouchMoveCapture: markInsideReactTree
        };
    }, [
        closeOnEscapeKeyDown,
        markInsideReactTree,
        markPressStartedInsideReactTree,
        markInsidePressStartPrevented
    ]);
    return react.useMemo(function() {
        return enabled ? {
            reference: reference,
            floating: floating,
            trigger: reference
        } : {};
    }, [
        enabled,
        reference,
        floating
    ]);
}
//#endregion
//#region ../../node_modules/.pnpm/@floating-ui+core@1.7.5/node_modules/@floating-ui/core/dist/floating-ui.core.mjs
function computeCoordsFromPlacement(_ref, placement, rtl) {
    var reference = _ref.reference, floating = _ref.floating;
    var sideAxis = getSideAxis(placement);
    var alignmentAxis = getAlignmentAxis(placement);
    var alignLength = getAxisLength(alignmentAxis);
    var side = getSide(placement);
    var isVertical = sideAxis === "y";
    var commonX = reference.x + reference.width / 2 - floating.width / 2;
    var commonY = reference.y + reference.height / 2 - floating.height / 2;
    var commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    var coords;
    switch(side){
        case "top":
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case "bottom":
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case "right":
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case "left":
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch(getAlignment(placement)){
        case "start":
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case "end":
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
function detectOverflow(state, options) {
    return _detectOverflow.apply(this, arguments);
}
function _detectOverflow() {
    _detectOverflow = /**
* Resolves with an object of overflow side offsets that determine how much the
* element is overflowing a given clipping boundary on each side.
* - positive = overflowing the boundary by that number of pixels
* - negative = how many pixels left before it will overflow
* - 0 = lies flush with the boundary
* @see https://floating-ui.com/docs/detectOverflow
*/ (0,_async_to_generator/* default */.Z)(function(state, options) {
        var _await$platform$isEle, x, y, platform, rects, elements, strategy, ref, _boundary, boundary, _rootBoundary, rootBoundary, _elementContext, elementContext, _altBoundary, altBoundary, _padding, padding, paddingObject, element, clippingClientRect, _, _tmp, _tmp1, _tmp2, rect, offsetParent, offsetScale, _tmp3, elementClientRect, _tmp4;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (options === void 0) options = {};
                    x = state.x, y = state.y, platform = state.platform, rects = state.rects, elements = state.elements, strategy = state.strategy;
                    ref = evaluate(options, state), _boundary = ref.boundary, boundary = _boundary === void 0 ? "clippingAncestors" : _boundary, _rootBoundary = ref.rootBoundary, rootBoundary = _rootBoundary === void 0 ? "viewport" : _rootBoundary, _elementContext = ref.elementContext, elementContext = _elementContext === void 0 ? "floating" : _elementContext, _altBoundary = ref.altBoundary, altBoundary = _altBoundary === void 0 ? false : _altBoundary, _padding = ref.padding, padding = _padding === void 0 ? 0 : _padding;
                    paddingObject = getPaddingObject(padding);
                    element = elements[altBoundary ? elementContext === "floating" ? "reference" : "floating" : elementContext];
                    _ = platform.getClippingRect;
                    _tmp = {};
                    return [
                        4,
                        platform.isElement == null ? void 0 : platform.isElement(element)
                    ];
                case 1:
                    if (!((_await$platform$isEle = _state.sent()) != null ? _await$platform$isEle : true)) return [
                        3,
                        2
                    ];
                    _tmp1 = element;
                    return [
                        3,
                        5
                    ];
                case 2:
                    _tmp2 = element.contextElement;
                    if (_tmp2) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)
                    ];
                case 3:
                    _tmp2 = _state.sent();
                    _state.label = 4;
                case 4:
                    _tmp1 = _tmp2;
                    _state.label = 5;
                case 5:
                    return [
                        4,
                        _.apply(platform, [
                            (_tmp.element = _tmp1, _tmp.boundary = boundary, _tmp.rootBoundary = rootBoundary, _tmp.strategy = strategy, _tmp)
                        ])
                    ];
                case 6:
                    clippingClientRect = rectToClientRect.apply(void 0, [
                        _state.sent()
                    ]);
                    rect = elementContext === "floating" ? {
                        x: x,
                        y: y,
                        width: rects.floating.width,
                        height: rects.floating.height
                    } : rects.reference;
                    return [
                        4,
                        platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating)
                    ];
                case 7:
                    offsetParent = _state.sent();
                    return [
                        4,
                        platform.isElement == null ? void 0 : platform.isElement(offsetParent)
                    ];
                case 8:
                    if (!_state.sent()) return [
                        3,
                        10
                    ];
                    return [
                        4,
                        platform.getScale == null ? void 0 : platform.getScale(offsetParent)
                    ];
                case 9:
                    _tmp3 = _state.sent() || {
                        x: 1,
                        y: 1
                    };
                    return [
                        3,
                        11
                    ];
                case 10:
                    _tmp3 = {
                        x: 1,
                        y: 1
                    };
                    _state.label = 11;
                case 11:
                    offsetScale = _tmp3;
                    if (!platform.convertOffsetParentRelativeRectToViewportRelativeRect) return [
                        3,
                        13
                    ];
                    return [
                        4,
                        platform.convertOffsetParentRelativeRectToViewportRelativeRect({
                            elements: elements,
                            rect: rect,
                            offsetParent: offsetParent,
                            strategy: strategy
                        })
                    ];
                case 12:
                    _tmp4 = _state.sent();
                    return [
                        3,
                        14
                    ];
                case 13:
                    _tmp4 = rect;
                    _state.label = 14;
                case 14:
                    elementClientRect = rectToClientRect.apply(void 0, [
                        _tmp4
                    ]);
                    return [
                        2,
                        {
                            top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
                            bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
                            left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
                            right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
                        }
                    ];
            }
        });
    });
    return _detectOverflow.apply(this, arguments);
}
var MAX_RESET_COUNT = 50;
/**
* Computes the `x` and `y` coordinates that will place the floating element
* next to a given reference element.
*
* This export does not have any `platform` interface logic. You will need to
* write one for the platform you are using Floating UI with.
*/ var computePosition$1 = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(reference, floating, config) {
        var _placement, placement, _strategy, strategy, _middleware, middleware, platform, platformWithDetectOverflow, rtl, rects, ref, x, y, statefulPlacement, resetCount, middlewareData, i, currentMiddleware, name, fn, ref1, nextX, nextY, data, reset, _tmp, ref2;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _placement = config.placement, placement = _placement === void 0 ? "bottom" : _placement, _strategy = config.strategy, strategy = _strategy === void 0 ? "absolute" : _strategy, _middleware = config.middleware, middleware = _middleware === void 0 ? [] : _middleware, platform = config.platform;
                    platformWithDetectOverflow = platform.detectOverflow ? platform : (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, platform), {
                        detectOverflow: detectOverflow
                    });
                    return [
                        4,
                        platform.isRTL == null ? void 0 : platform.isRTL(floating)
                    ];
                case 1:
                    rtl = _state.sent();
                    return [
                        4,
                        platform.getElementRects({
                            reference: reference,
                            floating: floating,
                            strategy: strategy
                        })
                    ];
                case 2:
                    rects = _state.sent();
                    ref = computeCoordsFromPlacement(rects, placement, rtl), x = ref.x, y = ref.y;
                    statefulPlacement = placement;
                    resetCount = 0;
                    middlewareData = {};
                    i = 0;
                    _state.label = 3;
                case 3:
                    if (!(i < middleware.length)) return [
                        3,
                        11
                    ];
                    currentMiddleware = middleware[i];
                    if (!currentMiddleware) return [
                        3,
                        10
                    ];
                    name = currentMiddleware.name, fn = currentMiddleware.fn;
                    return [
                        4,
                        fn({
                            x: x,
                            y: y,
                            initialPlacement: placement,
                            placement: statefulPlacement,
                            strategy: strategy,
                            middlewareData: middlewareData,
                            rects: rects,
                            platform: platformWithDetectOverflow,
                            elements: {
                                reference: reference,
                                floating: floating
                            }
                        })
                    ];
                case 4:
                    ref1 = _state.sent(), nextX = ref1.x, nextY = ref1.y, data = ref1.data, reset = ref1.reset;
                    x = nextX != null ? nextX : x;
                    y = nextY != null ? nextY : y;
                    middlewareData[name] = (0,src_object_spread/* default */.Z)({}, middlewareData[name], data);
                    if (!(reset && resetCount < MAX_RESET_COUNT)) return [
                        3,
                        10
                    ];
                    resetCount++;
                    if (!(typeof reset === "object")) return [
                        3,
                        9
                    ];
                    if (reset.placement) statefulPlacement = reset.placement;
                    if (!reset.rects) return [
                        3,
                        8
                    ];
                    if (!(reset.rects === true)) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        platform.getElementRects({
                            reference: reference,
                            floating: floating,
                            strategy: strategy
                        })
                    ];
                case 5:
                    _tmp = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    _tmp = reset.rects;
                    _state.label = 7;
                case 7:
                    rects = _tmp;
                    _state.label = 8;
                case 8:
                    ref2 = computeCoordsFromPlacement(rects, statefulPlacement, rtl), x = ref2.x, y = ref2.y, ref2;
                    _state.label = 9;
                case 9:
                    i = -1;
                    _state.label = 10;
                case 10:
                    i++;
                    return [
                        3,
                        3
                    ];
                case 11:
                    return [
                        2,
                        {
                            x: x,
                            y: y,
                            placement: statefulPlacement,
                            strategy: strategy,
                            middlewareData: middlewareData
                        }
                    ];
            }
        });
    });
    return function computePosition$1(reference, floating, config) {
        return _ref.apply(this, arguments);
    };
}();
/**
* Optimizes the visibility of the floating element by flipping the `placement`
* in order to keep it in view when the preferred placement(s) will overflow the
* clipping boundary. Alternative to `autoPlacement`.
* @see https://floating-ui.com/docs/flip
*/ var flip$2 = function flip$2(options) {
    if (options === void 0) options = {};
    return {
        name: "flip",
        options: options,
        fn: function fn(state) {
            return (0,_async_to_generator/* default */.Z)(function() {
                var _fallbackPlacements, _middlewareData$arrow, _middlewareData$flip, placement, middlewareData, rects, initialPlacement, platform, elements, _ref, tmp, checkMainAxis, tmp1, checkCrossAxis, specifiedFallbackPlacements, _fallbackStrategy, fallbackStrategy, _fallbackAxisSideDirection, fallbackAxisSideDirection, _flipAlignment, flipAlignment, detectOverflowOptions, side, initialSideAxis, isBasePlacement, rtl, fallbackPlacements, hasFallbackAxisSideDirection, placements, overflow, overflows, overflowsData, sides, _middlewareData$flip2, _overflowsData$filter, nextIndex, nextPlacement, resetPlacement, _overflowsData$filter2, placement1;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            placement = state.placement, middlewareData = state.middlewareData, rects = state.rects, initialPlacement = state.initialPlacement, platform = state.platform, elements = state.elements;
                            _ref = evaluate(options, state), tmp = _ref.mainAxis, checkMainAxis = tmp === void 0 ? true : tmp, tmp1 = _ref.crossAxis, checkCrossAxis = tmp1 === void 0 ? true : tmp1, specifiedFallbackPlacements = _ref.fallbackPlacements, _fallbackStrategy = _ref.fallbackStrategy, fallbackStrategy = _fallbackStrategy === void 0 ? "bestFit" : _fallbackStrategy, _fallbackAxisSideDirection = _ref.fallbackAxisSideDirection, fallbackAxisSideDirection = _fallbackAxisSideDirection === void 0 ? "none" : _fallbackAxisSideDirection, _flipAlignment = _ref.flipAlignment, flipAlignment = _flipAlignment === void 0 ? true : _flipAlignment, detectOverflowOptions = (0,src_object_without_properties/* default */.Z)(_ref, [
                                "mainAxis",
                                "crossAxis",
                                "fallbackPlacements",
                                "fallbackStrategy",
                                "fallbackAxisSideDirection",
                                "flipAlignment"
                            ]);
                            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return [
                                2,
                                {}
                            ];
                            side = getSide(placement);
                            initialSideAxis = getSideAxis(initialPlacement);
                            isBasePlacement = getSide(initialPlacement) === initialPlacement;
                            return [
                                4,
                                platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                            ];
                        case 1:
                            rtl = _state.sent();
                            fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                                getOppositePlacement(initialPlacement)
                            ] : getExpandedPlacements(initialPlacement));
                            hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
                            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) (_fallbackPlacements = fallbackPlacements).push.apply(_fallbackPlacements, (0,src_to_consumable_array/* default */.Z)(getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl)));
                            placements = [
                                initialPlacement
                            ].concat((0,src_to_consumable_array/* default */.Z)(fallbackPlacements));
                            return [
                                4,
                                platform.detectOverflow(state, detectOverflowOptions)
                            ];
                        case 2:
                            overflow = _state.sent();
                            overflows = [];
                            overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
                            if (checkMainAxis) overflows.push(overflow[side]);
                            if (checkCrossAxis) {
                                sides = getAlignmentSides(placement, rects, rtl);
                                overflows.push(overflow[sides[0]], overflow[sides[1]]);
                            }
                            overflowsData = (0,src_to_consumable_array/* default */.Z)(overflowsData).concat([
                                {
                                    placement: placement,
                                    overflows: overflows
                                }
                            ]);
                            if (!overflows.every(function(side) {
                                return side <= 0;
                            })) {
                                ;
                                nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                                nextPlacement = placements[nextIndex];
                                if (nextPlacement) {
                                    if (!(checkCrossAxis === "alignment" ? initialSideAxis !== getSideAxis(nextPlacement) : false) || overflowsData.every(function(d) {
                                        return getSideAxis(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true;
                                    })) return [
                                        2,
                                        {
                                            data: {
                                                index: nextIndex,
                                                overflows: overflowsData
                                            },
                                            reset: {
                                                placement: nextPlacement
                                            }
                                        }
                                    ];
                                }
                                resetPlacement = (_overflowsData$filter = overflowsData.filter(function(d) {
                                    return d.overflows[0] <= 0;
                                }).sort(function(a, b) {
                                    return a.overflows[1] - b.overflows[1];
                                })[0]) == null ? void 0 : _overflowsData$filter.placement;
                                if (!resetPlacement) switch(fallbackStrategy){
                                    case "bestFit":
                                        {
                                            ;
                                            placement1 = (_overflowsData$filter2 = overflowsData.filter(function(d) {
                                                if (hasFallbackAxisSideDirection) {
                                                    var currentSideAxis = getSideAxis(d.placement);
                                                    return currentSideAxis === initialSideAxis || currentSideAxis === "y";
                                                }
                                                return true;
                                            }).map(function(d) {
                                                return [
                                                    d.placement,
                                                    d.overflows.filter(function(overflow) {
                                                        return overflow > 0;
                                                    }).reduce(function(acc, overflow) {
                                                        return acc + overflow;
                                                    }, 0)
                                                ];
                                            }).sort(function(a, b) {
                                                return a[1] - b[1];
                                            })[0]) == null ? void 0 : _overflowsData$filter2[0];
                                            if (placement1) resetPlacement = placement1;
                                            break;
                                        }
                                    case "initialPlacement":
                                        resetPlacement = initialPlacement;
                                        break;
                                }
                                if (placement !== resetPlacement) return [
                                    2,
                                    {
                                        reset: {
                                            placement: resetPlacement
                                        }
                                    }
                                ];
                            }
                            return [
                                2,
                                {}
                            ];
                    }
                });
            })();
        }
    };
};
function getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function isAnySideFullyClipped(overflow) {
    return sides.some(function(side) {
        return overflow[side] >= 0;
    });
}
/**
* Provides data to hide the floating element in applicable situations, such as
* when it is not in the same clipping context as the reference element.
* @see https://floating-ui.com/docs/hide
*/ var hide$3 = function hide$3(options) {
    if (options === void 0) options = {};
    return {
        name: "hide",
        options: options,
        fn: function fn(state) {
            return (0,_async_to_generator/* default */.Z)(function() {
                var rects, platform, _ref, _strategy, strategy, detectOverflowOptions, offsets, offsets1;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            rects = state.rects, platform = state.platform;
                            _ref = evaluate(options, state), _strategy = _ref.strategy, strategy = _strategy === void 0 ? "referenceHidden" : _strategy, detectOverflowOptions = (0,src_object_without_properties/* default */.Z)(_ref, [
                                "strategy"
                            ]);
                            switch(strategy){
                                case "referenceHidden":
                                    return [
                                        3,
                                        1
                                    ];
                                case "escaped":
                                    return [
                                        3,
                                        3
                                    ];
                            }
                            return [
                                3,
                                5
                            ];
                        case 1:
                            return [
                                4,
                                platform.detectOverflow(state, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, detectOverflowOptions), {
                                    elementContext: "reference"
                                }))
                            ];
                        case 2:
                            offsets = getSideOffsets.apply(void 0, [
                                _state.sent(),
                                rects.reference
                            ]);
                            return [
                                2,
                                {
                                    data: {
                                        referenceHiddenOffsets: offsets,
                                        referenceHidden: isAnySideFullyClipped(offsets)
                                    }
                                }
                            ];
                        case 3:
                            return [
                                4,
                                platform.detectOverflow(state, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, detectOverflowOptions), {
                                    altBoundary: true
                                }))
                            ];
                        case 4:
                            offsets1 = getSideOffsets.apply(void 0, [
                                _state.sent(),
                                rects.floating
                            ]);
                            return [
                                2,
                                {
                                    data: {
                                        escapedOffsets: offsets1,
                                        escaped: isAnySideFullyClipped(offsets1)
                                    }
                                }
                            ];
                        case 5:
                            return [
                                2,
                                {}
                            ];
                        case 6:
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    };
};
var originSides = /* @__PURE__ */ new Set([
    "left",
    "top"
]);
function convertValueToCoords(state, options) {
    return _convertValueToCoords.apply(this, arguments);
}
function _convertValueToCoords() {
    _convertValueToCoords = (0,_async_to_generator/* default */.Z)(function(state, options) {
        var placement, platform, elements, rtl, side, alignment, isVertical, mainAxisMulti, crossAxisMulti, rawValue, ref, mainAxis, crossAxis, alignmentAxis;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    placement = state.placement, platform = state.platform, elements = state.elements;
                    return [
                        4,
                        platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                    ];
                case 1:
                    rtl = _state.sent();
                    side = getSide(placement);
                    alignment = getAlignment(placement);
                    isVertical = getSideAxis(placement) === "y";
                    mainAxisMulti = originSides.has(side) ? -1 : 1;
                    crossAxisMulti = rtl && isVertical ? -1 : 1;
                    rawValue = evaluate(options, state);
                    ref = typeof rawValue === "number" ? {
                        mainAxis: rawValue,
                        crossAxis: 0,
                        alignmentAxis: null
                    } : {
                        mainAxis: rawValue.mainAxis || 0,
                        crossAxis: rawValue.crossAxis || 0,
                        alignmentAxis: rawValue.alignmentAxis
                    }, mainAxis = ref.mainAxis, crossAxis = ref.crossAxis, alignmentAxis = ref.alignmentAxis;
                    if (alignment && typeof alignmentAxis === "number") crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
                    return [
                        2,
                        isVertical ? {
                            x: crossAxis * crossAxisMulti,
                            y: mainAxis * mainAxisMulti
                        } : {
                            x: mainAxis * mainAxisMulti,
                            y: crossAxis * crossAxisMulti
                        }
                    ];
            }
        });
    });
    return _convertValueToCoords.apply(this, arguments);
}
/**
* Modifies the placement by translating the floating element along the
* specified axes.
* A number (shorthand for `mainAxis` or distance), or an axes configuration
* object may be passed.
* @see https://floating-ui.com/docs/offset
*/ var offset$2 = function offset$2(options) {
    if (options === void 0) options = 0;
    return {
        name: "offset",
        options: options,
        fn: function fn(state) {
            return (0,_async_to_generator/* default */.Z)(function() {
                var _middlewareData$offse, _middlewareData$arrow, x, y, placement, middlewareData, diffCoords;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            x = state.x, y = state.y, placement = state.placement, middlewareData = state.middlewareData;
                            return [
                                4,
                                convertValueToCoords(state, options)
                            ];
                        case 1:
                            diffCoords = _state.sent();
                            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return [
                                2,
                                {}
                            ];
                            return [
                                2,
                                {
                                    x: x + diffCoords.x,
                                    y: y + diffCoords.y,
                                    data: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, diffCoords), {
                                        placement: placement
                                    })
                                }
                            ];
                    }
                });
            })();
        }
    };
};
/**
* Optimizes the visibility of the floating element by shifting it in order to
* keep it in view when it will overflow the clipping boundary.
* @see https://floating-ui.com/docs/shift
*/ var shift$2 = function shift$2(options) {
    if (options === void 0) options = {};
    return {
        name: "shift",
        options: options,
        fn: function fn(state) {
            return (0,_async_to_generator/* default */.Z)(function() {
                var x, y, placement, platform, _ref, tmp, checkMainAxis, tmp1, checkCrossAxis, _limiter, limiter, detectOverflowOptions, coords, overflow, crossAxis, mainAxis, mainAxisCoord, crossAxisCoord, minSide, maxSide, min, max, minSide1, maxSide1, min1, max1, _obj, limitedCoords, _obj1;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            x = state.x, y = state.y, placement = state.placement, platform = state.platform;
                            _ref = evaluate(options, state), tmp = _ref.mainAxis, checkMainAxis = tmp === void 0 ? true : tmp, tmp1 = _ref.crossAxis, checkCrossAxis = tmp1 === void 0 ? false : tmp1, _limiter = _ref.limiter, limiter = _limiter === void 0 ? {
                                fn: function(_ref) {
                                    var x = _ref.x, y = _ref.y;
                                    return {
                                        x: x,
                                        y: y
                                    };
                                }
                            } : _limiter, detectOverflowOptions = (0,src_object_without_properties/* default */.Z)(_ref, [
                                "mainAxis",
                                "crossAxis",
                                "limiter"
                            ]);
                            coords = {
                                x: x,
                                y: y
                            };
                            return [
                                4,
                                platform.detectOverflow(state, detectOverflowOptions)
                            ];
                        case 1:
                            overflow = _state.sent();
                            crossAxis = getSideAxis(getSide(placement));
                            mainAxis = getOppositeAxis(crossAxis);
                            mainAxisCoord = coords[mainAxis];
                            crossAxisCoord = coords[crossAxis];
                            if (checkMainAxis) {
                                minSide = mainAxis === "y" ? "top" : "left";
                                maxSide = mainAxis === "y" ? "bottom" : "right";
                                min = mainAxisCoord + overflow[minSide];
                                max = mainAxisCoord - overflow[maxSide];
                                mainAxisCoord = clamp$1(min, mainAxisCoord, max);
                            }
                            if (checkCrossAxis) {
                                minSide1 = crossAxis === "y" ? "top" : "left";
                                maxSide1 = crossAxis === "y" ? "bottom" : "right";
                                min1 = crossAxisCoord + overflow[minSide1];
                                max1 = crossAxisCoord - overflow[maxSide1];
                                crossAxisCoord = clamp$1(min1, crossAxisCoord, max1);
                            }
                            limitedCoords = limiter.fn((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), (_obj = {}, (0,src_define_property/* default */.Z)(_obj, mainAxis, mainAxisCoord), (0,src_define_property/* default */.Z)(_obj, crossAxis, crossAxisCoord), _obj)));
                            return [
                                2,
                                (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, limitedCoords), {
                                    data: {
                                        x: limitedCoords.x - x,
                                        y: limitedCoords.y - y,
                                        enabled: (_obj1 = {}, (0,src_define_property/* default */.Z)(_obj1, mainAxis, checkMainAxis), (0,src_define_property/* default */.Z)(_obj1, crossAxis, checkCrossAxis), _obj1)
                                    }
                                })
                            ];
                    }
                });
            })();
        }
    };
};
/**
* Built-in `limiter` that will stop `shift()` at a certain point.
*/ var limitShift$2 = function limitShift$2(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn: function fn(state) {
            var x = state.x, y = state.y, placement = state.placement, rects = state.rects, middlewareData = state.middlewareData;
            var ref = evaluate(options, state), _offset = ref.offset, offset = _offset === void 0 ? 0 : _offset, tmp = ref.mainAxis, checkMainAxis = tmp === void 0 ? true : tmp, tmp1 = ref.crossAxis, checkCrossAxis = tmp1 === void 0 ? true : tmp1;
            var coords = {
                x: x,
                y: y
            };
            var crossAxis = getSideAxis(placement);
            var mainAxis = getOppositeAxis(crossAxis);
            var mainAxisCoord = coords[mainAxis];
            var crossAxisCoord = coords[crossAxis];
            var rawOffset = evaluate(offset, state);
            var computedOffset = typeof rawOffset === "number" ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : (0,src_object_spread/* default */.Z)({
                mainAxis: 0,
                crossAxis: 0
            }, rawOffset);
            if (checkMainAxis) {
                var len = mainAxis === "y" ? "height" : "width";
                var limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                var limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                var len1 = mainAxis === "y" ? "width" : "height";
                var isOriginSide = originSides.has(getSide(placement));
                var limitMin1 = rects.reference[crossAxis] - rects.floating[len1] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                var limitMax1 = rects.reference[crossAxis] + rects.reference[len1] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin1) crossAxisCoord = limitMin1;
                else if (crossAxisCoord > limitMax1) crossAxisCoord = limitMax1;
            }
            var _obj;
            return _obj = {}, (0,src_define_property/* default */.Z)(_obj, mainAxis, mainAxisCoord), (0,src_define_property/* default */.Z)(_obj, crossAxis, crossAxisCoord), _obj;
        }
    };
};
/**
* Provides data that allows you to change the size of the floating element —
* for instance, prevent it from overflowing the clipping boundary or match the
* width of the reference element.
* @see https://floating-ui.com/docs/size
*/ var size$2 = function size$2(options) {
    if (options === void 0) options = {};
    return {
        name: "size",
        options: options,
        fn: function fn(state) {
            return (0,_async_to_generator/* default */.Z)(function() {
                var _state$middlewareData, _state$middlewareData2, placement, rects, platform, elements, _ref, _apply, apply, detectOverflowOptions, overflow, side, alignment, isYAxis, _floating, width, height, heightSide, widthSide, maximumClippingHeight, maximumClippingWidth, overflowAvailableHeight, overflowAvailableWidth, noShift, availableHeight, availableWidth, xMin, xMax, yMin, yMax, nextDimensions;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            placement = state.placement, rects = state.rects, platform = state.platform, elements = state.elements;
                            _ref = evaluate(options, state), _apply = _ref.apply, apply = _apply === void 0 ? function() {} : _apply, detectOverflowOptions = (0,src_object_without_properties/* default */.Z)(_ref, [
                                "apply"
                            ]);
                            return [
                                4,
                                platform.detectOverflow(state, detectOverflowOptions)
                            ];
                        case 1:
                            overflow = _state.sent();
                            side = getSide(placement);
                            alignment = getAlignment(placement);
                            isYAxis = getSideAxis(placement) === "y";
                            _floating = rects.floating, width = _floating.width, height = _floating.height;
                            if (!(side === "top" || side === "bottom")) return [
                                3,
                                3
                            ];
                            heightSide = side;
                            return [
                                4,
                                platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)
                            ];
                        case 2:
                            widthSide = alignment === (_state.sent() ? "start" : "end") ? "left" : "right";
                            return [
                                3,
                                4
                            ];
                        case 3:
                            widthSide = side;
                            heightSide = alignment === "end" ? "top" : "bottom";
                            _state.label = 4;
                        case 4:
                            maximumClippingHeight = height - overflow.top - overflow.bottom;
                            maximumClippingWidth = width - overflow.left - overflow.right;
                            overflowAvailableHeight = min(height - overflow[heightSide], maximumClippingHeight);
                            overflowAvailableWidth = min(width - overflow[widthSide], maximumClippingWidth);
                            noShift = !state.middlewareData.shift;
                            availableHeight = overflowAvailableHeight;
                            availableWidth = overflowAvailableWidth;
                            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
                            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
                            if (noShift && !alignment) {
                                xMin = max(overflow.left, 0);
                                xMax = max(overflow.right, 0);
                                yMin = max(overflow.top, 0);
                                yMax = max(overflow.bottom, 0);
                                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max(overflow.left, overflow.right));
                                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max(overflow.top, overflow.bottom));
                            }
                            return [
                                4,
                                apply((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                                    availableWidth: availableWidth,
                                    availableHeight: availableHeight
                                }))
                            ];
                        case 5:
                            _state.sent();
                            return [
                                4,
                                platform.getDimensions(elements.floating)
                            ];
                        case 6:
                            nextDimensions = _state.sent();
                            if (width !== nextDimensions.width || height !== nextDimensions.height) return [
                                2,
                                {
                                    reset: {
                                        rects: true
                                    }
                                }
                            ];
                            return [
                                2,
                                {}
                            ];
                    }
                });
            })();
        }
    };
};
//#endregion
//#region ../../node_modules/.pnpm/@floating-ui+dom@1.7.6/node_modules/@floating-ui/dom/dist/floating-ui.dom.mjs
function getCssDimensions(element) {
    var css = getComputedStyle$1(element);
    var width = parseFloat(css.width) || 0;
    var height = parseFloat(css.height) || 0;
    var hasOffset = isHTMLElement(element);
    var offsetWidth = hasOffset ? element.offsetWidth : width;
    var offsetHeight = hasOffset ? element.offsetHeight : height;
    var shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function unwrapElement(element) {
    return !isElement(element) ? element.contextElement : element;
}
function getScale(element) {
    var domElement = unwrapElement(element);
    if (!isHTMLElement(domElement)) return createCoords(1);
    var rect = domElement.getBoundingClientRect();
    var ref = getCssDimensions(domElement), width = ref.width, height = ref.height, $ = ref.$;
    var x = ($ ? round(rect.width) : rect.width) / width;
    var y = ($ ? round(rect.height) : rect.height) / height;
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
var noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(element) {
    var win = getWindow(element);
    if (!isWebKit$1() || !win.visualViewport) return noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) return false;
    return isFixed;
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var domElement = unwrapElement(element);
    var scale = createCoords(1);
    if (includeScale) if (offsetParent) {
        if (isElement(offsetParent)) scale = getScale(offsetParent);
    } else scale = getScale(element);
    var visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
    var x = (clientRect.left + visualOffsets.x) / scale.x;
    var y = (clientRect.top + visualOffsets.y) / scale.y;
    var width = clientRect.width / scale.x;
    var height = clientRect.height / scale.y;
    if (domElement) {
        var win = getWindow(domElement);
        var offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
        var currentWin = win;
        var currentIFrame = getFrameElement(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            var iframeScale = getScale(currentIFrame);
            var iframeRect = currentIFrame.getBoundingClientRect();
            var css = getComputedStyle$1(currentIFrame);
            var left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            var top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = getWindow(currentIFrame);
            currentIFrame = getFrameElement(currentWin);
        }
    }
    return rectToClientRect({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
function getWindowScrollBarX(element, rect) {
    var leftScroll = getNodeScroll(element).scrollLeft;
    if (!rect) return getBoundingClientRect(getDocumentElement(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll) {
    var htmlRect = documentElement.getBoundingClientRect();
    return {
        x: htmlRect.left + scroll.scrollLeft - getWindowScrollBarX(documentElement, htmlRect),
        y: htmlRect.top + scroll.scrollTop
    };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    var elements = _ref.elements, rect = _ref.rect, offsetParent = _ref.offsetParent, strategy = _ref.strategy;
    var isFixed = strategy === "fixed";
    var documentElement = getDocumentElement(offsetParent);
    var topLayer = elements ? isTopLayer(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var scale = createCoords(1);
    var offsets = createCoords(0);
    var isOffsetParentAnElement = isHTMLElement(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) scroll = getNodeScroll(offsetParent);
        if (isOffsetParentAnElement) {
            var offsetRect = getBoundingClientRect(offsetParent);
            scale = getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    var htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function getClientRects(element) {
    return Array.from(element.getClientRects());
}
function getDocumentRect(element) {
    var html = getDocumentElement(element);
    var scroll = getNodeScroll(element);
    var body = element.ownerDocument.body;
    var width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    var height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    var x = -scroll.scrollLeft + getWindowScrollBarX(element);
    var y = -scroll.scrollTop;
    if (getComputedStyle$1(body).direction === "rtl") x += max(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
var SCROLLBAR_MAX = 25;
function getViewportRect(element, strategy) {
    var win = getWindow(element);
    var html = getDocumentElement(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var visualViewportBased = isWebKit$1();
        if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    var windowScrollbarX = getWindowScrollBarX(html);
    if (windowScrollbarX <= 0) {
        var doc = html.ownerDocument;
        var body = doc.body;
        var bodyStyles = getComputedStyle(body);
        var bodyMarginInline = doc.compatMode === "CSS1Compat" ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        var clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        if (clippingStableScrollbarWidth <= SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
    } else if (windowScrollbarX <= SCROLLBAR_MAX) width += windowScrollbarX;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function getInnerBoundingClientRect(element, strategy) {
    var clientRect = getBoundingClientRect(element, true, strategy === "fixed");
    var top = clientRect.top + element.clientTop;
    var left = clientRect.left + element.clientLeft;
    var scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
    return {
        width: element.clientWidth * scale.x,
        height: element.clientHeight * scale.y,
        x: left * scale.x,
        y: top * scale.y
    };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    var rect;
    if (clippingAncestor === "viewport") rect = getViewportRect(element, strategy);
    else if (clippingAncestor === "document") rect = getDocumentRect(getDocumentElement(element));
    else if (isElement(clippingAncestor)) rect = getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        var visualOffsets = getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
    var parentNode = getParentNode(element);
    if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) return false;
    return getComputedStyle$1(parentNode).position === "fixed" || hasFixedPositionAncestor(parentNode, stopNode);
}
function getClippingElementAncestors(element, cache) {
    var cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    var result = getOverflowAncestors(element, [], false).filter(function(el) {
        return isElement(el) && getNodeName(el) !== "body";
    });
    var currentContainingBlockComputedStyle = null;
    var elementIsFixed = getComputedStyle$1(element).position === "fixed";
    var currentNode = elementIsFixed ? getParentNode(element) : element;
    while(isElement(currentNode) && !isLastTraversableNode(currentNode)){
        var computedStyle = getComputedStyle$1(currentNode);
        var currentNodeIsContaining = isContainingBlock(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === "fixed") currentContainingBlockComputedStyle = null;
        if (elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && (currentContainingBlockComputedStyle.position === "absolute" || currentContainingBlockComputedStyle.position === "fixed") || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode)) result = result.filter(function(ancestor) {
            return ancestor !== currentNode;
        });
        else currentContainingBlockComputedStyle = computedStyle;
        currentNode = getParentNode(currentNode);
    }
    cache.set(element, result);
    return result;
}
function getClippingRect(_ref) {
    var element = _ref.element, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, strategy = _ref.strategy;
    var clippingAncestors = (0,src_to_consumable_array/* default */.Z)(boundary === "clippingAncestors" ? isTopLayer(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary)).concat([
        rootBoundary
    ]);
    var firstRect = getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    var top = firstRect.top;
    var right = firstRect.right;
    var bottom = firstRect.bottom;
    var left = firstRect.left;
    for(var i = 1; i < clippingAncestors.length; i++){
        var rect = getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = max(rect.top, top);
        right = min(rect.right, right);
        bottom = min(rect.bottom, bottom);
        left = max(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function getDimensions(element) {
    var ref = getCssDimensions(element), width = ref.width, height = ref.height;
    return {
        width: width,
        height: height
    };
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    var setLeftRTLScrollbarOffset = function setLeftRTLScrollbarOffset() {
        offsets.x = getWindowScrollBarX(documentElement);
    };
    var isOffsetParentAnElement = isHTMLElement(offsetParent);
    var documentElement = getDocumentElement(offsetParent);
    var isFixed = strategy === "fixed";
    var rect = getBoundingClientRect(element, true, isFixed, offsetParent);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = createCoords(0);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) scroll = getNodeScroll(offsetParent);
        if (isOffsetParentAnElement) {
            var offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    var htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
    return {
        x: rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x,
        y: rect.top + scroll.scrollTop - offsets.y - htmlOffset.y,
        width: rect.width,
        height: rect.height
    };
}
function isStaticPositioned(element) {
    return getComputedStyle$1(element).position === "static";
}
function getTrueOffsetParent(element, polyfill) {
    if (!isHTMLElement(element) || getComputedStyle$1(element).position === "fixed") return null;
    if (polyfill) return polyfill(element);
    var rawOffsetParent = element.offsetParent;
    if (getDocumentElement(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
function getOffsetParent(element, polyfill) {
    var win = getWindow(element);
    if (isTopLayer(element)) return win;
    if (!isHTMLElement(element)) {
        var svgOffsetParent = getParentNode(element);
        while(svgOffsetParent && !isLastTraversableNode(svgOffsetParent)){
            if (isElement(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = getParentNode(svgOffsetParent);
        }
        return win;
    }
    var offsetParent = getTrueOffsetParent(element, polyfill);
    while(offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent))offsetParent = getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) return win;
    return offsetParent || getContainingBlock(element) || win;
}
var getElementRects = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(data) {
        var getOffsetParentFn, getDimensionsFn, floatingDimensions, _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    getOffsetParentFn = this.getOffsetParent || getOffsetParent;
                    getDimensionsFn = this.getDimensions;
                    return [
                        4,
                        getDimensionsFn(data.floating)
                    ];
                case 1:
                    floatingDimensions = _state.sent();
                    _tmp = {};
                    _tmp1 = [
                        data.reference
                    ];
                    return [
                        4,
                        getOffsetParentFn(data.floating)
                    ];
                case 2:
                    return [
                        2,
                        (_tmp.reference = getRectRelativeToOffsetParent.apply(void 0, _tmp1.concat(_state.sent(), data.strategy)), _tmp.floating = {
                            x: 0,
                            y: 0,
                            width: floatingDimensions.width,
                            height: floatingDimensions.height
                        }, _tmp)
                    ];
            }
        });
    });
    return function getElementRects(data) {
        return _ref.apply(this, arguments);
    };
}();
function isRTL(element) {
    return getComputedStyle$1(element).direction === "rtl";
}
var platform = {
    convertOffsetParentRelativeRectToViewportRelativeRect: convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: getDocumentElement,
    getClippingRect: getClippingRect,
    getOffsetParent: getOffsetParent,
    getElementRects: getElementRects,
    getClientRects: getClientRects,
    getDimensions: getDimensions,
    getScale: getScale,
    isElement: isElement,
    isRTL: isRTL
};
function rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
function observeMove(element, onMove) {
    var cleanup = function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    };
    var io = null;
    var timeoutId;
    var root = getDocumentElement(element);
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        var elementRectForRootMargin = element.getBoundingClientRect();
        var left = elementRectForRootMargin.left, top = elementRectForRootMargin.top, width = elementRectForRootMargin.width, height = elementRectForRootMargin.height;
        if (!skip) onMove();
        if (!width || !height) return;
        var insetTop = floor(top);
        var insetRight = floor(root.clientWidth - (left + width));
        var insetBottom = floor(root.clientHeight - (top + height));
        var insetLeft = floor(left);
        var options = {
            rootMargin: -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px",
            threshold: max(0, min(1, threshold)) || 1
        };
        var isFirstUpdate = true;
        function handleObserve(entries) {
            var ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) timeoutId = setTimeout(function() {
                    refresh(false, 1e-7);
                }, 1e3);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) refresh();
            isFirstUpdate = false;
        }
        try {
            io = new IntersectionObserver(handleObserve, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, options), {
                root: root.ownerDocument
            }));
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
* Automatically updates the position of the floating element when necessary.
* Should only be called when the floating element is mounted on the DOM or
* visible on the screen.
* @returns cleanup function that should be invoked when the floating element is
* removed from the DOM or hidden from the screen.
* @see https://floating-ui.com/docs/autoUpdate
*/ function autoUpdate(reference, floating, update, options) {
    if (options === void 0) options = {};
    var _ancestorScroll = options.ancestorScroll, ancestorScroll = _ancestorScroll === void 0 ? true : _ancestorScroll, _ancestorResize = options.ancestorResize, ancestorResize = _ancestorResize === void 0 ? true : _ancestorResize, _elementResize = options.elementResize, elementResize = _elementResize === void 0 ? typeof ResizeObserver === "function" : _elementResize, _layoutShift = options.layoutShift, layoutShift = _layoutShift === void 0 ? typeof IntersectionObserver === "function" : _layoutShift, _animationFrame = options.animationFrame, animationFrame = _animationFrame === void 0 ? false : _animationFrame;
    var referenceEl = unwrapElement(reference);
    var ancestors = ancestorScroll || ancestorResize ? (0,src_to_consumable_array/* default */.Z)(referenceEl ? getOverflowAncestors(referenceEl) : []).concat((0,src_to_consumable_array/* default */.Z)(floating ? getOverflowAncestors(floating) : [])) : [];
    ancestors.forEach(function(ancestor) {
        ancestorScroll && ancestor.addEventListener("scroll", update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener("resize", update);
    });
    var cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
    var reobserveFrame = -1;
    var resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver(function(_ref) {
            var __ref = (0,src_sliced_to_array/* default */.Z)(_ref, 1), firstEntry = __ref[0];
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(function() {
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    var frameId;
    var prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        var nextRefRect = getBoundingClientRect(reference);
        if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return function() {
        var _resizeObserver2;
        ancestors.forEach(function(ancestor) {
            ancestorScroll && ancestor.removeEventListener("scroll", update);
            ancestorResize && ancestor.removeEventListener("resize", update);
        });
        cleanupIo === null || cleanupIo === void 0 ? void 0 : cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
* Modifies the placement by translating the floating element along the
* specified axes.
* A number (shorthand for `mainAxis` or distance), or an axes configuration
* object may be passed.
* @see https://floating-ui.com/docs/offset
*/ var offset$1 = offset$2;
/**
* Optimizes the visibility of the floating element by shifting it in order to
* keep it in view when it will overflow the clipping boundary.
* @see https://floating-ui.com/docs/shift
*/ var shift$1 = shift$2;
/**
* Optimizes the visibility of the floating element by flipping the `placement`
* in order to keep it in view when the preferred placement(s) will overflow the
* clipping boundary. Alternative to `autoPlacement`.
* @see https://floating-ui.com/docs/flip
*/ var flip$1 = flip$2;
/**
* Provides data that allows you to change the size of the floating element —
* for instance, prevent it from overflowing the clipping boundary or match the
* width of the reference element.
* @see https://floating-ui.com/docs/size
*/ var size$1 = size$2;
/**
* Provides data to hide the floating element in applicable situations, such as
* when it is not in the same clipping context as the reference element.
* @see https://floating-ui.com/docs/hide
*/ var hide$2 = hide$3;
/**
* Built-in `limiter` that will stop `shift()` at a certain point.
*/ var limitShift$1 = limitShift$2;
/**
* Computes the `x` and `y` coordinates that will place the floating element
* next to a given reference element.
*/ var computePosition = function(reference, floating, options) {
    var cache = /* @__PURE__ */ new Map();
    var mergedOptions = (0,src_object_spread/* default */.Z)({
        platform: platform
    }, options);
    var platformWithCache = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, mergedOptions.platform), {
        _c: cache
    });
    return computePosition$1(reference, floating, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, mergedOptions), {
        platform: platformWithCache
    }));
};
//#endregion
//#region ../../node_modules/.pnpm/@floating-ui+react-dom@2.1.8_@types+react-dom@18.3.7_@types+react@18.3.28__@types+react_5d3ae985ec2a8a20e57d80c464b0f451/node_modules/@floating-ui/react-dom/dist/floating-ui.react-dom.mjs
var index = typeof document !== "undefined" ? react.useLayoutEffect : function noop() {};
function deepEqual(a, b) {
    if (a === b) return true;
    if ((typeof a === "undefined" ? "undefined" : (0,src_type_of/* default */.Z)(a)) !== (typeof b === "undefined" ? "undefined" : (0,src_type_of/* default */.Z)(b))) return false;
    if (typeof a === "function" && a.toString() === b.toString()) return true;
    var length;
    var i;
    var keys;
    if (a && b && typeof a === "object") {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;)if (!deepEqual(a[i], b[i])) return false;
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            if (!deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function getDPR(element) {
    if (false) {}
    return (element.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function roundByDPR(element, value) {
    var dpr = getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function useLatestRef(value) {
    var ref = react.useRef(value);
    index(function() {
        ref.current = value;
    });
    return ref;
}
/**
* Provides data to position a floating element.
* @see https://floating-ui.com/docs/useFloating
*/ function useFloating$1(options) {
    if (options === void 0) options = {};
    var _placement = options.placement, placement = _placement === void 0 ? "bottom" : _placement, _strategy = options.strategy, strategy = _strategy === void 0 ? "absolute" : _strategy, _middleware = options.middleware, middleware = _middleware === void 0 ? [] : _middleware, platform = options.platform, tmp = options.elements, ref = tmp === void 0 ? {} : tmp, externalReference = ref.reference, externalFloating = ref.floating, _transform = options.transform, transform = _transform === void 0 ? true : _transform, whileElementsMounted = options.whileElementsMounted, open = options.open;
    var ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    }), 2), data = ref1[0], setData = ref1[1];
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState(middleware), 2), latestMiddleware = ref2[0], setLatestMiddleware = ref2[1];
    if (!deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    var ref3 = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), _reference = ref3[0], _setReference = ref3[1];
    var ref4 = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), _floating = ref4[0], _setFloating = ref4[1];
    var setReference = react.useCallback(function(node) {
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    var setFloating = react.useCallback(function(node) {
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    var referenceEl = externalReference || _reference;
    var floatingEl = externalFloating || _floating;
    var referenceRef = react.useRef(null);
    var floatingRef = react.useRef(null);
    var dataRef = react.useRef(data);
    var hasWhileElementsMounted = whileElementsMounted != null;
    var whileElementsMountedRef = useLatestRef(whileElementsMounted);
    var platformRef = useLatestRef(platform);
    var openRef = useLatestRef(open);
    var update = react.useCallback(function() {
        if (!referenceRef.current || !floatingRef.current) return;
        var config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        computePosition(referenceRef.current, floatingRef.current, config).then(function(data) {
            var fullData = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, data), {
                isPositioned: openRef.current !== false
            });
            if (isMountedRef.current && !deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                react_dom.flushSync(function() {
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    index(function() {
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData(function(data) {
                return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, data), {
                    isPositioned: false
                });
            });
        }
    }, [
        open
    ]);
    var isMountedRef = react.useRef(false);
    index(function() {
        isMountedRef.current = true;
        return function() {
            isMountedRef.current = false;
        };
    }, []);
    index(function() {
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    var refs = react.useMemo(function() {
        return {
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        };
    }, [
        setReference,
        setFloating
    ]);
    var elements = react.useMemo(function() {
        return {
            reference: referenceEl,
            floating: floatingEl
        };
    }, [
        referenceEl,
        floatingEl
    ]);
    var floatingStyles = react.useMemo(function() {
        var initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        var x = roundByDPR(elements.floating, data.x);
        var y = roundByDPR(elements.floating, data.y);
        if (transform) return (0,src_object_spread/* default */.Z)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, initialStyles), {
            transform: "translate(" + x + "px, " + y + "px)"
        }), getDPR(elements.floating) >= 1.5 && {
            willChange: "transform"
        });
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return react.useMemo(function() {
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, data), {
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        });
    }, [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
* Modifies the placement by translating the floating element along the
* specified axes.
* A number (shorthand for `mainAxis` or distance), or an axes configuration
* object may be passed.
* @see https://floating-ui.com/docs/offset
*/ var offset = function(options, deps) {
    var result = offset$1(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
* Optimizes the visibility of the floating element by shifting it in order to
* keep it in view when it will overflow the clipping boundary.
* @see https://floating-ui.com/docs/shift
*/ var shift = function(options, deps) {
    var result = shift$1(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
* Built-in `limiter` that will stop `shift()` at a certain point.
*/ var limitShift = function(options, deps) {
    return {
        fn: limitShift$1(options).fn,
        options: [
            options,
            deps
        ]
    };
};
/**
* Optimizes the visibility of the floating element by flipping the `placement`
* in order to keep it in view when the preferred placement(s) will overflow the
* clipping boundary. Alternative to `autoPlacement`.
* @see https://floating-ui.com/docs/flip
*/ var flip = function(options, deps) {
    var result = flip$1(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
* Provides data that allows you to change the size of the floating element —
* for instance, prevent it from overflowing the clipping boundary or match the
* width of the reference element.
* @see https://floating-ui.com/docs/size
*/ var size = function(options, deps) {
    var result = size$1(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
* Provides data to hide the floating element in applicable situations, such as
* when it is not in the same clipping context as the reference element.
* @see https://floating-ui.com/docs/hide
*/ var hide$1 = function(options, deps) {
    var result = hide$2(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
var _positionReference;
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/floating-ui-react/components/FloatingRootStore.js
var selectors$3 = {
    open: createSelector$1(function(state) {
        return state.open;
    }),
    transitionStatus: createSelector$1(function(state) {
        return state.transitionStatus;
    }),
    domReferenceElement: createSelector$1(function(state) {
        return state.domReferenceElement;
    }),
    referenceElement: createSelector$1(function(state) {
        return (_positionReference = state.positionReference) !== null && _positionReference !== void 0 ? _positionReference : state.referenceElement;
    }),
    floatingElement: createSelector$1(function(state) {
        return state.floatingElement;
    }),
    floatingId: createSelector$1(function(state) {
        return state.floatingId;
    })
};
var FloatingRootStore = /*#__PURE__*/ function(ReactStore) {
    "use strict";
    (0,src_inherits/* default */.Z)(FloatingRootStore, ReactStore);
    var _super = (0,src_create_super/* default */.Z)(FloatingRootStore);
    function FloatingRootStore(options) {
        (0,src_class_call_check/* default */.Z)(this, FloatingRootStore);
        var _this;
        var syncOnly = options.syncOnly, nested = options.nested, onOpenChange = options.onOpenChange, triggerElements = options.triggerElements, initialState = (0,src_object_without_properties/* default */.Z)(options, [
            "syncOnly",
            "nested",
            "onOpenChange",
            "triggerElements"
        ]);
        _this = _super.call(this, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, initialState), {
            positionReference: initialState.referenceElement,
            domReferenceElement: initialState.referenceElement
        }), {
            onOpenChange: onOpenChange,
            dataRef: {
                current: {}
            },
            events: createEventEmitter(),
            nested: nested,
            triggerElements: triggerElements
        }, selectors$3);
        /**
	* Syncs the event used by hover logic to distinguish hover-open from click-like interaction.
	*/ (0,src_define_property/* default */.Z)((0,src_assert_this_initialized/* default */.Z)(_this), "syncOpenEvent", function(newOpen, event) {
            if (!newOpen || !_this.state.open || event != null && isClickLikeEvent(event)) _this.context.dataRef.current.openEvent = newOpen ? event : void 0;
        });
        /**
	* Runs the root-owned side effects for an open state change.
	*/ (0,src_define_property/* default */.Z)((0,src_assert_this_initialized/* default */.Z)(_this), "dispatchOpenChange", function(newOpen, eventDetails) {
            _this.syncOpenEvent(newOpen, eventDetails.event);
            var details = {
                open: newOpen,
                reason: eventDetails.reason,
                nativeEvent: eventDetails.event,
                nested: _this.context.nested,
                triggerElement: eventDetails.trigger
            };
            _this.context.events.emit("openchange", details);
        });
        /**
	* Emits the `openchange` event through the internal event emitter and calls the `onOpenChange` handler with the provided arguments.
	*
	* @param newOpen The new open state.
	* @param eventDetails Details about the event that triggered the open state change.
	*/ (0,src_define_property/* default */.Z)((0,src_assert_this_initialized/* default */.Z)(_this), "setOpen", function(newOpen, eventDetails) {
            var _context, ref;
            if (_this.syncOnly) {
                var _context1, ref1;
                (ref1 = (_context1 = _this.context).onOpenChange) === null || ref1 === void 0 ? void 0 : ref1.call(_context1, newOpen, eventDetails);
                return;
            }
            _this.dispatchOpenChange(newOpen, eventDetails);
            (ref = (_context = _this.context).onOpenChange) === null || ref === void 0 ? void 0 : ref.call(_context, newOpen, eventDetails);
        });
        _this.syncOnly = syncOnly;
        return _this;
    }
    return FloatingRootStore;
}(ReactStore);
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/utils/popups/popupStoreUtils.js
/**
* Returns a callback ref that registers/unregisters the trigger element in the store.
*
* @param store The Store instance where the trigger should be registered.
*/ function useTriggerRegistration(id, store) {
    var registeredElementIdRef = React$1.useRef(null);
    var registeredElementRef = React$1.useRef(null);
    return React$1.useCallback(function(element) {
        if (id === void 0) return;
        if (registeredElementIdRef.current !== null) {
            var registeredId = registeredElementIdRef.current;
            var registeredElement = registeredElementRef.current;
            var currentElement = store.context.triggerElements.getById(registeredId);
            if (registeredElement && currentElement === registeredElement) store.context.triggerElements.delete(registeredId);
            registeredElementIdRef.current = null;
            registeredElementRef.current = null;
        }
        if (element !== null) {
            registeredElementIdRef.current = id;
            registeredElementRef.current = element;
            store.context.triggerElements.add(id, element);
        }
    }, [
        store,
        id
    ]);
}
/**
* Sets up trigger data forwarding to the store.
*
* @param triggerId Id of the trigger.
* @param triggerElement The trigger DOM element.
* @param store The Store instance managing the popup state.
* @param stateUpdates An object with state updates to apply when the trigger is active.
*/ function useTriggerDataForwarding(triggerId, triggerElementRef, store, stateUpdates) {
    var isMountedByThisTrigger = store.useState("isMountedByTrigger", triggerId);
    var baseRegisterTrigger = useTriggerRegistration(triggerId, store);
    var registerTrigger = useStableCallback(function(element) {
        baseRegisterTrigger(element);
        if (!element || !store.select("open")) return;
        var activeTriggerId = store.select("activeTriggerId");
        if (activeTriggerId === triggerId) {
            store.update(_object_spread({
                activeTriggerElement: element
            }, stateUpdates));
            return;
        }
        if (activeTriggerId == null) store.update(_object_spread({
            activeTriggerId: triggerId,
            activeTriggerElement: element
        }, stateUpdates));
    });
    useIsoLayoutEffect(function() {
        if (isMountedByThisTrigger) store.update(_object_spread({
            activeTriggerElement: triggerElementRef.current
        }, stateUpdates));
    }, [
        isMountedByThisTrigger,
        store,
        triggerElementRef
    ].concat(_to_consumable_array(Object.values(stateUpdates))));
    return {
        registerTrigger: registerTrigger,
        isMountedByThisTrigger: isMountedByThisTrigger
    };
}
/**
* Ensures that when there's only one trigger element registered, it is set as the active trigger.
* This allows controlled popups to work correctly without an explicit triggerId, maintaining compatibility
* with the contained triggers.
*
* This should be called on the Root part.
*
* @param open Whether the popup is open.
* @param store The Store instance managing the popup state.
*/ function useImplicitActiveTrigger(store) {
    var open = store.useState("open");
    useIsoLayoutEffect(function() {
        if (open && !store.select("activeTriggerId") && store.context.triggerElements.size === 1) {
            var iteratorResult = store.context.triggerElements.entries().next();
            if (!iteratorResult.done) {
                var _value = _sliced_to_array(iteratorResult.value, 2), implicitTriggerId = _value[0], implicitTriggerElement = _value[1];
                store.update({
                    activeTriggerId: implicitTriggerId,
                    activeTriggerElement: implicitTriggerElement
                });
            }
        }
    }, [
        open,
        store
    ]);
}
/**
* Mangages the mounted state of the popup.
* Sets up the transition status listeners and handles unmounting when needed.
* Updates the `mounted` and `transitionStatus` states in the store.
*
* @param open Whether the popup is open.
* @param store The Store instance managing the popup state.
* @param onUnmount Optional callback to be called when the popup is unmounted.
*
* @returns A function to forcibly unmount the popup.
*/ function useOpenStateTransitions(open, store, onUnmount) {
    var ref = useTransitionStatus(open), mounted = ref.mounted, setMounted = ref.setMounted, transitionStatus = ref.transitionStatus;
    store.useSyncedValues({
        mounted: mounted,
        transitionStatus: transitionStatus
    });
    var forceUnmount = useStableCallback(function() {
        var _context, ref;
        setMounted(false);
        store.update({
            activeTriggerId: null,
            activeTriggerElement: null,
            mounted: false
        });
        onUnmount === null || onUnmount === void 0 ? void 0 : onUnmount();
        (ref = (_context = store.context).onOpenChangeComplete) === null || ref === void 0 ? void 0 : ref.call(_context, false);
    });
    useOpenChangeComplete({
        enabled: !store.useState("preventUnmountingOnClose"),
        open: open,
        ref: store.context.popupRef,
        onComplete: function onComplete() {
            if (!open) forceUnmount();
        }
    });
    return {
        forceUnmount: forceUnmount,
        transitionStatus: transitionStatus
    };
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/utils/popups/popupTriggerMap.js
/**
* Data structure to keep track of popup trigger elements by their IDs.
* Uses both a set of Elements and a map of IDs to Elements for efficient lookups.
*/ var PopupTriggerMap = /*#__PURE__*/ function() {
    "use strict";
    function PopupTriggerMap() {
        (0,src_class_call_check/* default */.Z)(this, PopupTriggerMap);
        this.elementsSet = /* @__PURE__ */ new Set();
        this.idMap = /* @__PURE__ */ new Map();
    }
    (0,src_create_class/* default */.Z)(PopupTriggerMap, [
        {
            /**
	* Adds a trigger element with the given ID.
	*
	* Note: The provided element is assumed to not be registered under multiple IDs.
	*/ key: "add",
            value: function add(id, element) {
                var existingElement = this.idMap.get(id);
                if (existingElement === element) return;
                if (existingElement !== void 0) this.elementsSet.delete(existingElement);
                this.elementsSet.add(element);
                this.idMap.set(id, element);
                if (false) {}
            }
        },
        {
            /**
	* Removes the trigger element with the given ID.
	*/ key: "delete",
            value: function _delete(id) {
                var element = this.idMap.get(id);
                if (element) {
                    this.elementsSet.delete(element);
                    this.idMap.delete(id);
                }
            }
        },
        {
            /**
	* Whether the given element is registered as a trigger.
	*/ key: "hasElement",
            value: function hasElement(element) {
                return this.elementsSet.has(element);
            }
        },
        {
            /**
	* Whether there is a registered trigger element matching the given predicate.
	*/ key: "hasMatchingElement",
            value: function hasMatchingElement(predicate) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this.elementsSet[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        if (predicate(element)) return true;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return false;
            }
        },
        {
            /**
	* Returns the trigger element associated with the given ID, or undefined if no such element exists.
	*/ key: "getById",
            value: function getById(id) {
                return this.idMap.get(id);
            }
        },
        {
            /**
	* Returns an iterable of all registered trigger entries, where each entry is a tuple of [id, element].
	*/ key: "entries",
            value: function entries() {
                return this.idMap.entries();
            }
        },
        {
            /**
	* Returns an iterable of all registered trigger elements.
	*/ key: "elements",
            value: function elements() {
                return this.elementsSet.values();
            }
        },
        {
            key: "size",
            get: /**
	* Returns the number of registered trigger elements.
	*/ function get() {
                return this.idMap.size;
            }
        }
    ]);
    return PopupTriggerMap;
}();
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/floating-ui-react/utils/getEmptyRootContext.js
function getEmptyRootContext() {
    return new FloatingRootStore({
        open: false,
        transitionStatus: void 0,
        floatingElement: null,
        referenceElement: null,
        triggerElements: new PopupTriggerMap(),
        floatingId: "",
        syncOnly: false,
        nested: false,
        onOpenChange: void 0
    });
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/utils/popups/store.js
/**
* State common to all popup stores.
*/ function createInitialPopupStoreState() {
    return {
        open: false,
        openProp: void 0,
        mounted: false,
        transitionStatus: void 0,
        floatingRootContext: getEmptyRootContext(),
        preventUnmountingOnClose: false,
        payload: void 0,
        activeTriggerId: null,
        activeTriggerElement: null,
        triggerIdProp: void 0,
        popupElement: null,
        positionerElement: null,
        activeTriggerProps: EMPTY_OBJECT,
        inactiveTriggerProps: EMPTY_OBJECT,
        popupProps: EMPTY_OBJECT
    };
}
var _triggerIdProp;
var activeTriggerIdSelector = createSelector$1(function(state) {
    return (_triggerIdProp = state.triggerIdProp) !== null && _triggerIdProp !== void 0 ? _triggerIdProp : state.activeTriggerId;
});
var _openProp;
var popupStoreSelectors = {
    open: createSelector$1(function(state) {
        return (_openProp = state.openProp) !== null && _openProp !== void 0 ? _openProp : state.open;
    }),
    mounted: createSelector$1(function(state) {
        return state.mounted;
    }),
    transitionStatus: createSelector$1(function(state) {
        return state.transitionStatus;
    }),
    floatingRootContext: createSelector$1(function(state) {
        return state.floatingRootContext;
    }),
    preventUnmountingOnClose: createSelector$1(function(state) {
        return state.preventUnmountingOnClose;
    }),
    payload: createSelector$1(function(state) {
        return state.payload;
    }),
    activeTriggerId: activeTriggerIdSelector,
    activeTriggerElement: createSelector$1(function(state) {
        return state.mounted ? state.activeTriggerElement : null;
    }),
    /**
	* Whether the trigger with the given ID was used to open the popup.
	*/ isTriggerActive: createSelector$1(function(state, triggerId) {
        return triggerId !== void 0 && activeTriggerIdSelector(state) === triggerId;
    }),
    /**
	* Whether the popup is open and was activated by a trigger with the given ID.
	*/ isOpenedByTrigger: createSelector$1(function(state, triggerId) {
        return triggerId !== void 0 && activeTriggerIdSelector(state) === triggerId && state.open;
    }),
    /**
	* Whether the popup is mounted and was activated by a trigger with the given ID.
	*/ isMountedByTrigger: createSelector$1(function(state, triggerId) {
        return triggerId !== void 0 && activeTriggerIdSelector(state) === triggerId && state.mounted;
    }),
    triggerProps: createSelector$1(function(state, isActive) {
        return isActive ? state.activeTriggerProps : state.inactiveTriggerProps;
    }),
    popupProps: createSelector$1(function(state) {
        return state.popupProps;
    }),
    popupElement: createSelector$1(function(state) {
        return state.popupElement;
    }),
    positionerElement: createSelector$1(function(state) {
        return state.positionerElement;
    })
};
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/floating-ui-react/hooks/useFloatingRootContext.js
function useFloatingRootContext(options) {
    var _open = options.open, open = _open === void 0 ? false : _open, onOpenChange = options.onOpenChange, _elements = options.elements, elements = _elements === void 0 ? {} : _elements;
    var floatingId = useId$1();
    var nested = useFloatingParentNodeId() != null;
    if (false) { var optionDomReference; }
    var _reference, _floating;
    var store = useRefWithInit(function() {
        return new FloatingRootStore({
            open: open,
            transitionStatus: void 0,
            onOpenChange: onOpenChange,
            referenceElement: (_reference = elements.reference) !== null && _reference !== void 0 ? _reference : null,
            floatingElement: (_floating = elements.floating) !== null && _floating !== void 0 ? _floating : null,
            triggerElements: new PopupTriggerMap(),
            floatingId: floatingId,
            syncOnly: false,
            nested: nested
        });
    }).current;
    useIsoLayoutEffect(function() {
        var valuesToSync = {
            open: open,
            floatingId: floatingId
        };
        if (elements.reference !== void 0) {
            valuesToSync.referenceElement = elements.reference;
            valuesToSync.domReferenceElement = isElement(elements.reference) ? elements.reference : null;
        }
        if (elements.floating !== void 0) valuesToSync.floatingElement = elements.floating;
        store.update(valuesToSync);
    }, [
        open,
        floatingId,
        elements.reference,
        elements.floating,
        store
    ]);
    store.context.onOpenChange = onOpenChange;
    store.context.nested = nested;
    return store;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/floating-ui-react/hooks/useFloating.js
/**
* Provides data to position a floating element and context to add interactions.
* @see https://floating-ui.com/docs/useFloating
*/ function useFloating() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var nodeId = options.nodeId, externalTree = options.externalTree;
    var internalRootStore = useFloatingRootContext(options);
    var rootContext = options.rootContext || internalRootStore;
    var rootContextElements = {
        reference: rootContext.useState("referenceElement"),
        floating: rootContext.useState("floatingElement"),
        domReference: rootContext.useState("domReferenceElement")
    };
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), positionReference = ref[0], setPositionReferenceRaw = ref[1];
    var domReferenceRef = react.useRef(null);
    var tree = useFloatingTree(externalTree);
    useIsoLayoutEffect(function() {
        if (rootContextElements.domReference) domReferenceRef.current = rootContextElements.domReference;
    }, [
        rootContextElements.domReference
    ]);
    var position = useFloating$1((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, options), {
        elements: (0,src_object_spread/* default */.Z)({}, rootContextElements, positionReference && {
            reference: positionReference
        })
    }));
    var setPositionReference = react.useCallback(function(node) {
        var computedPositionReference = isElement(node) ? {
            getBoundingClientRect: function() {
                return node.getBoundingClientRect();
            },
            getClientRects: function() {
                return node.getClientRects();
            },
            contextElement: node
        } : node;
        setPositionReferenceRaw(computedPositionReference);
        position.refs.setReference(computedPositionReference);
    }, [
        position.refs
    ]);
    var ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState(void 0), 2), localDomReference = ref1[0], setLocalDomReference = ref1[1];
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), localFloatingElement = ref2[0], setLocalFloatingElement = ref2[1];
    rootContext.useSyncedValue("referenceElement", localDomReference !== null && localDomReference !== void 0 ? localDomReference : null);
    var localDomReferenceElement = isElement(localDomReference) ? localDomReference : null;
    rootContext.useSyncedValue("domReferenceElement", localDomReference === void 0 ? rootContextElements.domReference : localDomReferenceElement);
    rootContext.useSyncedValue("floatingElement", localFloatingElement);
    var setReference = react.useCallback(function(node) {
        if (isElement(node) || node === null) {
            domReferenceRef.current = node;
            setLocalDomReference(node);
        }
        if (isElement(position.refs.reference.current) || position.refs.reference.current === null || node !== null && !isElement(node)) position.refs.setReference(node);
    }, [
        position.refs,
        setLocalDomReference
    ]);
    var setFloating = react.useCallback(function(node) {
        setLocalFloatingElement(node);
        position.refs.setFloating(node);
    }, [
        position.refs
    ]);
    var refs = react.useMemo(function() {
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, position.refs), {
            setReference: setReference,
            setFloating: setFloating,
            setPositionReference: setPositionReference,
            domReference: domReferenceRef
        });
    }, [
        position.refs,
        setReference,
        setFloating,
        setPositionReference
    ]);
    var elements = react.useMemo(function() {
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, position.elements), {
            domReference: rootContextElements.domReference
        });
    }, [
        position.elements,
        rootContextElements.domReference
    ]);
    var open = rootContext.useState("open");
    var floatingId = rootContext.useState("floatingId");
    var context = react.useMemo(function() {
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, position), {
            dataRef: rootContext.context.dataRef,
            open: open,
            onOpenChange: rootContext.setOpen,
            events: rootContext.context.events,
            floatingId: floatingId,
            refs: refs,
            elements: elements,
            nodeId: nodeId,
            rootStore: rootContext
        });
    }, [
        position,
        refs,
        elements,
        nodeId,
        rootContext,
        open,
        floatingId
    ]);
    useIsoLayoutEffect(function() {
        rootContext.context.dataRef.current.floatingContext = context;
        var node = tree === null || tree === void 0 ? void 0 : tree.nodesRef.current.find(function(n) {
            return n.id === nodeId;
        });
        if (node) node.context = context;
    });
    return react.useMemo(function() {
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, position), {
            context: context,
            refs: refs,
            elements: elements,
            rootStore: rootContext
        });
    }, [
        position,
        refs,
        elements,
        context,
        rootContext
    ]);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/floating-ui-react/hooks/useSyncedFloatingRootContext.js
/**
* Initializes a FloatingRootStore that is kept in sync with the provided PopupStore.
* The new instance is created only once and updated on every render.
*/ function useSyncedFloatingRootContext(options) {
    var popupStore = options.popupStore, _treatPopupAsFloatingElement = options.treatPopupAsFloatingElement, treatPopupAsFloatingElement = _treatPopupAsFloatingElement === void 0 ? false : _treatPopupAsFloatingElement, onOpenChange = options.onOpenChange;
    var floatingId = useId$1();
    var nested = useFloatingParentNodeId() != null;
    var open = popupStore.useState("open");
    var referenceElement = popupStore.useState("activeTriggerElement");
    var floatingElement = popupStore.useState(treatPopupAsFloatingElement ? "popupElement" : "positionerElement");
    var triggerElements = popupStore.context.triggerElements;
    var store = useRefWithInit(function() {
        return new FloatingRootStore({
            open: open,
            transitionStatus: void 0,
            referenceElement: referenceElement,
            floatingElement: floatingElement,
            triggerElements: triggerElements,
            onOpenChange: onOpenChange,
            floatingId: floatingId,
            syncOnly: true,
            nested: nested
        });
    }).current;
    useIsoLayoutEffect(function() {
        var valuesToSync = {
            open: open,
            floatingId: floatingId,
            referenceElement: referenceElement,
            floatingElement: floatingElement
        };
        if (isElement(referenceElement)) valuesToSync.domReferenceElement = referenceElement;
        if (store.state.positionReference === store.state.referenceElement) valuesToSync.positionReference = referenceElement;
        store.update(valuesToSync);
    }, [
        open,
        floatingId,
        referenceElement,
        floatingElement,
        store
    ]);
    store.context.onOpenChange = onOpenChange;
    store.context.nested = nested;
    return store;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/floating-ui-react/hooks/useInteractions.js
/**
* Merges an array of interaction hooks' props into prop getters, allowing
* event handler functions to be composed together without overwriting one
* another.
* @see https://floating-ui.com/docs/useInteractions
*/ function useInteractions() {
    var propsList = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var referenceDeps = propsList.map(function(key) {
        return key === null || key === void 0 ? void 0 : key.reference;
    });
    var floatingDeps = propsList.map(function(key) {
        return key === null || key === void 0 ? void 0 : key.floating;
    });
    var itemDeps = propsList.map(function(key) {
        return key === null || key === void 0 ? void 0 : key.item;
    });
    var triggerDeps = propsList.map(function(key) {
        return key === null || key === void 0 ? void 0 : key.trigger;
    });
    var getReferenceProps = react.useCallback(function(userProps) {
        return mergeProps(userProps, propsList, "reference");
    }, referenceDeps);
    var getFloatingProps = react.useCallback(function(userProps) {
        return mergeProps(userProps, propsList, "floating");
    }, floatingDeps);
    var getItemProps = react.useCallback(function(userProps) {
        return mergeProps(userProps, propsList, "item");
    }, itemDeps);
    var getTriggerProps = react.useCallback(function(userProps) {
        return mergeProps(userProps, propsList, "trigger");
    }, triggerDeps);
    return react.useMemo(function() {
        return {
            getReferenceProps: getReferenceProps,
            getFloatingProps: getFloatingProps,
            getItemProps: getItemProps,
            getTriggerProps: getTriggerProps
        };
    }, [
        getReferenceProps,
        getFloatingProps,
        getItemProps,
        getTriggerProps
    ]);
}
function mergeProps(userProps, propsList, elementKey) {
    var eventHandlers = /* @__PURE__ */ new Map();
    var isItem = elementKey === "item";
    var outputProps = {};
    if (elementKey === "floating") {
        outputProps.tabIndex = -1;
        outputProps[FOCUSABLE_ATTRIBUTE] = "";
    }
    for(var key in userProps){
        if (isItem && userProps) {
            if (key === "active" || key === "selected") continue;
        }
        outputProps[key] = userProps[key];
    }
    for(var i = 0; i < propsList.length; i += 1){
        var ref;
        var props = void 0;
        var propsOrGetProps = (ref = propsList[i]) === null || ref === void 0 ? void 0 : ref[elementKey];
        if (typeof propsOrGetProps === "function") props = userProps ? propsOrGetProps(userProps) : null;
        else props = propsOrGetProps;
        if (!props) continue;
        mutablyMergeProps(outputProps, props, isItem, eventHandlers);
    }
    mutablyMergeProps(outputProps, userProps, isItem, eventHandlers);
    return outputProps;
}
function mutablyMergeProps(outputProps, props, isItem, eventHandlers) {
    var _loop = function(key) {
        var value = props[key];
        if (isItem && (key === "active" || key === "selected")) return "continue";
        if (!key.startsWith("on")) outputProps[key] = value;
        else {
            if (!eventHandlers.has(key)) eventHandlers.set(key, []);
            if (typeof value === "function") {
                var ref;
                (ref = eventHandlers.get(key)) === null || ref === void 0 ? void 0 : ref.push(value);
                outputProps[key] = function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    var ref;
                    return (ref = eventHandlers.get(key)) === null || ref === void 0 ? void 0 : ref.map(function(fn) {
                        return fn.apply(void 0, (0,src_to_consumable_array/* default */.Z)(args));
                    }).find(function(val) {
                        return val !== void 0;
                    });
                };
            }
        }
    };
    for(var key in props)_loop(key);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/floating-ui-react/hooks/useListNavigation.js
var ESCAPE = "Escape";
function doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case "vertical":
            return vertical;
        case "horizontal":
            return horizontal;
        default:
            return vertical || horizontal;
    }
}
function isMainOrientationKey(key, orientation) {
    return doSwitch(orientation, key === "ArrowUp" || key === "ArrowDown", key === "ArrowLeft" || key === "ArrowRight");
}
function isMainOrientationToEndKey(key, orientation, rtl) {
    return doSwitch(orientation, key === "ArrowDown", rtl ? key === "ArrowLeft" : key === "ArrowRight") || key === "Enter" || key === " " || key === "";
}
function isCrossOrientationOpenKey(key, orientation, rtl) {
    return doSwitch(orientation, rtl ? key === ARROW_LEFT$1 : key === ARROW_RIGHT$1, key === ARROW_DOWN$1);
}
function isCrossOrientationCloseKey(key, orientation, rtl, cols) {
    var vertical = rtl ? key === ARROW_RIGHT$1 : key === ARROW_LEFT$1;
    var horizontal = key === ARROW_UP$1;
    if (orientation === "both" || orientation === "horizontal" && cols && cols > 1) return key === ESCAPE;
    return doSwitch(orientation, vertical, horizontal);
}
/**
* Adds arrow key-based navigation of a list of items, either using real DOM
* focus or virtual focus.
* @see https://floating-ui.com/docs/useListNavigation
*/ function useListNavigation(context, props) {
    var store = "rootStore" in context ? context.rootStore : context;
    var open = store.useState("open");
    var floatingElement = store.useState("floatingElement");
    var domReferenceElement = store.useState("domReferenceElement");
    var dataRef = store.context.dataRef;
    var listRef = props.listRef, activeIndex = props.activeIndex, tmp = props.onNavigate, onNavigateProp = tmp === void 0 ? function() {} : tmp, _enabled = props.enabled, enabled = _enabled === void 0 ? true : _enabled, _selectedIndex = props.selectedIndex, selectedIndex = _selectedIndex === void 0 ? null : _selectedIndex, _allowEscape = props.allowEscape, allowEscape = _allowEscape === void 0 ? false : _allowEscape, _loopFocus = props.loopFocus, loopFocus = _loopFocus === void 0 ? false : _loopFocus, _nested = props.nested, nested = _nested === void 0 ? false : _nested, _rtl = props.rtl, rtl = _rtl === void 0 ? false : _rtl, _virtual = props.virtual, virtual = _virtual === void 0 ? false : _virtual, _focusItemOnOpen = props.focusItemOnOpen, focusItemOnOpen = _focusItemOnOpen === void 0 ? "auto" : _focusItemOnOpen, _focusItemOnHover = props.focusItemOnHover, focusItemOnHover = _focusItemOnHover === void 0 ? true : _focusItemOnHover, _openOnArrowKeyDown = props.openOnArrowKeyDown, openOnArrowKeyDown = _openOnArrowKeyDown === void 0 ? true : _openOnArrowKeyDown, _disabledIndices = props.disabledIndices, disabledIndices = _disabledIndices === void 0 ? void 0 : _disabledIndices, _orientation = props.orientation, orientation = _orientation === void 0 ? "vertical" : _orientation, parentOrientation = props.parentOrientation, _cols = props.cols, cols = _cols === void 0 ? 1 : _cols, id = props.id, _resetOnPointerLeave = props.resetOnPointerLeave, resetOnPointerLeave = _resetOnPointerLeave === void 0 ? true : _resetOnPointerLeave, externalTree = props.externalTree;
    if (false) {}
    var floatingFocusElementRef = useValueAsRef(getFloatingFocusElement(floatingElement));
    var parentId = useFloatingParentNodeId();
    var tree = useFloatingTree(externalTree);
    useIsoLayoutEffect(function() {
        dataRef.current.orientation = orientation;
    }, [
        dataRef,
        orientation
    ]);
    var typeableComboboxReference = isTypeableCombobox(domReferenceElement);
    var focusItemOnOpenRef = react.useRef(focusItemOnOpen);
    var indexRef = react.useRef(selectedIndex !== null && selectedIndex !== void 0 ? selectedIndex : -1);
    var keyRef = react.useRef(null);
    var isPointerModalityRef = react.useRef(true);
    var onNavigate = useStableCallback(function(event) {
        onNavigateProp(indexRef.current === -1 ? null : indexRef.current, event);
    });
    var previousOnNavigateRef = react.useRef(onNavigate);
    var previousMountedRef = react.useRef(!!floatingElement);
    var previousOpenRef = react.useRef(open);
    var forceSyncFocusRef = react.useRef(false);
    var forceScrollIntoViewRef = react.useRef(false);
    var cancelQueuedFocusRef = react.useRef(null);
    var disabledIndicesRef = useValueAsRef(disabledIndices);
    var latestOpenRef = useValueAsRef(open);
    var selectedIndexRef = useValueAsRef(selectedIndex);
    var resetOnPointerLeaveRef = useValueAsRef(resetOnPointerLeave);
    var focusItem = useStableCallback(function() {
        var runFocus = function runFocus(item) {
            if (virtual) tree === null || tree === void 0 ? void 0 : tree.events.emit("virtualfocus", item);
            else cancelQueuedFocusRef.current = enqueueFocus(item, {
                sync: forceSyncFocusRef.current,
                preventScroll: true
            });
        };
        var initialItem = listRef.current[indexRef.current];
        var forceScrollIntoView = forceScrollIntoViewRef.current;
        if (initialItem) runFocus(initialItem);
        (forceSyncFocusRef.current ? function(v) {
            return v();
        } : requestAnimationFrame)(function() {
            var ref;
            var waitedItem = listRef.current[indexRef.current] || initialItem;
            if (!waitedItem) return;
            if (!initialItem) runFocus(waitedItem);
            if (item && (forceScrollIntoView || !isPointerModalityRef.current)) (ref = waitedItem.scrollIntoView) === null || ref === void 0 ? void 0 : ref.call(waitedItem, {
                block: "nearest",
                inline: "nearest"
            });
        });
    });
    useIsoLayoutEffect(function() {
        if (!enabled) return;
        if (open && floatingElement) {
            indexRef.current = selectedIndex !== null && selectedIndex !== void 0 ? selectedIndex : -1;
            if (focusItemOnOpenRef.current && selectedIndex != null) {
                forceScrollIntoViewRef.current = true;
                onNavigate();
            }
        } else if (previousMountedRef.current) {
            indexRef.current = -1;
            previousOnNavigateRef.current();
        }
    }, [
        enabled,
        open,
        floatingElement,
        selectedIndex,
        onNavigate
    ]);
    useIsoLayoutEffect(function() {
        if (!enabled) return;
        if (!open) {
            forceSyncFocusRef.current = false;
            return;
        }
        if (!floatingElement) return;
        if (activeIndex == null) {
            forceSyncFocusRef.current = false;
            if (selectedIndexRef.current != null) return;
            if (previousMountedRef.current) {
                indexRef.current = -1;
                focusItem();
            }
            if ((!previousOpenRef.current || !previousMountedRef.current) && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                var runs = 0;
                var waitForListPopulated = function() {
                    if (listRef.current[0] == null) {
                        if (runs < 2) (runs ? requestAnimationFrame : queueMicrotask)(waitForListPopulated);
                        runs += 1;
                    } else {
                        indexRef.current = keyRef.current == null || isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? getMinListIndex(listRef) : getMaxListIndex(listRef);
                        keyRef.current = null;
                        onNavigate();
                    }
                };
                waitForListPopulated();
            }
        } else if (!isIndexOutOfListBounds(listRef.current, activeIndex)) {
            indexRef.current = activeIndex;
            focusItem();
            forceScrollIntoViewRef.current = false;
        }
    }, [
        enabled,
        open,
        floatingElement,
        activeIndex,
        selectedIndexRef,
        nested,
        listRef,
        orientation,
        rtl,
        onNavigate,
        focusItem,
        disabledIndicesRef
    ]);
    useIsoLayoutEffect(function() {
        var ref, ref1;
        if (!enabled || floatingElement || !tree || virtual || !previousMountedRef.current) return;
        var nodes = tree.nodesRef.current;
        var parent = (ref = nodes.find(function(node) {
            return node.id === parentId;
        })) === null || ref === void 0 ? void 0 : (ref1 = ref.context) === null || ref1 === void 0 ? void 0 : ref1.elements.floating;
        var activeEl = activeElement(ownerDocument(floatingElement));
        var treeContainsActiveEl = nodes.some(function(node) {
            return node.context && contains(node.context.elements.floating, activeEl);
        });
        if (parent && !treeContainsActiveEl && isPointerModalityRef.current) parent.focus({
            preventScroll: true
        });
    }, [
        enabled,
        floatingElement,
        tree,
        parentId,
        virtual
    ]);
    useIsoLayoutEffect(function() {
        previousOnNavigateRef.current = onNavigate;
        previousOpenRef.current = open;
        previousMountedRef.current = !!floatingElement;
    });
    useIsoLayoutEffect(function() {
        if (!open) {
            keyRef.current = null;
            focusItemOnOpenRef.current = focusItemOnOpen;
        }
    }, [
        open,
        focusItemOnOpen
    ]);
    var hasActiveIndex = activeIndex != null;
    var syncCurrentTarget = useStableCallback(function(event) {
        if (!latestOpenRef.current) return;
        var index = listRef.current.indexOf(event.currentTarget);
        if (index !== -1 && (indexRef.current !== index || activeIndex !== index)) {
            indexRef.current = index;
            onNavigate(event);
        }
    });
    var item = react.useMemo(function() {
        return {
            onFocus: function onFocus(event) {
                forceSyncFocusRef.current = true;
                syncCurrentTarget(event);
            },
            onClick: function(param) {
                var currentTarget = param.currentTarget;
                return currentTarget.focus({
                    preventScroll: true
                });
            },
            onMouseMove: function onMouseMove(event) {
                forceSyncFocusRef.current = true;
                forceScrollIntoViewRef.current = false;
                if (focusItemOnHover) syncCurrentTarget(event);
            },
            onPointerLeave: function onPointerLeave(event) {
                var ref;
                if (!latestOpenRef.current || !isPointerModalityRef.current || event.pointerType === "touch") return;
                forceSyncFocusRef.current = true;
                var relatedTarget = event.relatedTarget;
                if (!focusItemOnHover || listRef.current.includes(relatedTarget)) return;
                if (!resetOnPointerLeaveRef.current) return;
                (ref = cancelQueuedFocusRef.current) === null || ref === void 0 ? void 0 : ref.call(cancelQueuedFocusRef);
                cancelQueuedFocusRef.current = null;
                indexRef.current = -1;
                onNavigate(event);
                if (!virtual) {
                    var floatingFocusEl = floatingFocusElementRef.current;
                    var activeEl = activeElement(ownerDocument(floatingFocusEl));
                    if (floatingFocusEl && contains(floatingFocusEl, activeEl)) floatingFocusEl.focus({
                        preventScroll: true
                    });
                }
            }
        };
    }, [
        syncCurrentTarget,
        latestOpenRef,
        floatingFocusElementRef,
        focusItemOnHover,
        listRef,
        onNavigate,
        resetOnPointerLeaveRef,
        virtual
    ]);
    var getParentOrientation = react.useCallback(function() {
        var ref, ref1, ref2;
        return parentOrientation !== null && parentOrientation !== void 0 ? parentOrientation : (ref = tree === null || tree === void 0 ? void 0 : tree.nodesRef.current.find(function(node) {
            return node.id === parentId;
        })) === null || ref === void 0 ? void 0 : (ref1 = ref.context) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.dataRef) === null || ref2 === void 0 ? void 0 : ref2.current.orientation;
    }, [
        parentId,
        tree,
        parentOrientation
    ]);
    var commonOnKeyDown = useStableCallback(function(event) {
        isPointerModalityRef.current = false;
        forceSyncFocusRef.current = true;
        if (event.which === 229) return;
        if (!latestOpenRef.current && event.currentTarget === floatingFocusElementRef.current) return;
        if (nested && isCrossOrientationCloseKey(event.key, orientation, rtl, cols)) {
            if (!isMainOrientationKey(event.key, getParentOrientation())) stopEvent(event);
            store.setOpen(false, createChangeEventDetails(listNavigation, event.nativeEvent));
            if (isHTMLElement(domReferenceElement)) if (virtual) tree === null || tree === void 0 ? void 0 : tree.events.emit("virtualfocus", domReferenceElement);
            else domReferenceElement.focus();
            return;
        }
        var currentIndex = indexRef.current;
        var minIndex = getMinListIndex(listRef, disabledIndices);
        var maxIndex = getMaxListIndex(listRef, disabledIndices);
        if (!typeableComboboxReference) {
            if (event.key === "Home") {
                stopEvent(event);
                indexRef.current = minIndex;
                onNavigate(event);
            }
            if (event.key === "End") {
                stopEvent(event);
                indexRef.current = maxIndex;
                onNavigate(event);
            }
        }
        if (cols > 1) {
            var sizes = Array.from({
                length: listRef.current.length
            }, function() {
                return {
                    width: 1,
                    height: 1
                };
            });
            var cellMap = createGridCellMap(sizes, cols, false);
            var minGridIndex = cellMap.findIndex(function(index) {
                return index != null && !isListIndexDisabled(listRef.current, index, disabledIndices);
            });
            var maxGridIndex = cellMap.reduce(function(foundIndex, index, cellIndex) {
                return index != null && !isListIndexDisabled(listRef.current, index, disabledIndices) ? cellIndex : foundIndex;
            }, -1);
            var index = cellMap[getGridNavigatedIndex(cellMap.map(function(itemIndex) {
                return itemIndex != null ? listRef.current[itemIndex] : null;
            }), {
                event: event,
                orientation: orientation,
                loopFocus: loopFocus,
                rtl: rtl,
                cols: cols,
                disabledIndices: getGridCellIndices((0,src_to_consumable_array/* default */.Z)((typeof disabledIndices !== "function" ? disabledIndices : null) || listRef.current.map(function(_, listIndex) {
                    return isListIndexDisabled(listRef.current, listIndex, disabledIndices) ? listIndex : void 0;
                })).concat([
                    void 0
                ]), cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: getGridCellIndexOfCorner(indexRef.current > maxIndex ? minIndex : indexRef.current, sizes, cellMap, cols, event.key === "ArrowDown" ? "bl" : event.key === (rtl ? "ArrowLeft" : "ArrowRight") ? "tr" : "tl"),
                stopEvent: true
            })];
            if (index != null) {
                indexRef.current = index;
                onNavigate(event);
            }
            if (orientation === "both") return;
        }
        if (isMainOrientationKey(event.key, orientation)) {
            stopEvent(event);
            if (open && !virtual && activeElement(event.currentTarget.ownerDocument) === event.currentTarget) {
                indexRef.current = isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
                onNavigate(event);
                return;
            }
            if (isMainOrientationToEndKey(event.key, orientation, rtl)) if (loopFocus) if (currentIndex >= maxIndex) if (allowEscape && currentIndex !== listRef.current.length) indexRef.current = -1;
            else {
                forceSyncFocusRef.current = false;
                indexRef.current = minIndex;
            }
            else indexRef.current = findNonDisabledListIndex(listRef.current, {
                startingIndex: currentIndex,
                disabledIndices: disabledIndices
            });
            else indexRef.current = Math.min(maxIndex, findNonDisabledListIndex(listRef.current, {
                startingIndex: currentIndex,
                disabledIndices: disabledIndices
            }));
            else if (loopFocus) if (currentIndex <= minIndex) if (allowEscape && currentIndex !== -1) indexRef.current = listRef.current.length;
            else {
                forceSyncFocusRef.current = false;
                indexRef.current = maxIndex;
            }
            else indexRef.current = findNonDisabledListIndex(listRef.current, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            });
            else indexRef.current = Math.max(minIndex, findNonDisabledListIndex(listRef.current, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            }));
            if (isIndexOutOfListBounds(listRef.current, indexRef.current)) indexRef.current = -1;
            onNavigate(event);
        }
    });
    var ariaActiveDescendantProp = react.useMemo(function() {
        return virtual && open && hasActiveIndex && {
            "aria-activedescendant": "".concat(id, "-").concat(activeIndex)
        };
    }, [
        virtual,
        open,
        hasActiveIndex,
        id,
        activeIndex
    ]);
    var floating = react.useMemo(function() {
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            "aria-orientation": orientation === "both" ? void 0 : orientation
        }, !typeableComboboxReference ? ariaActiveDescendantProp : {}), {
            onKeyDown: function onKeyDown(event) {
                if (event.key === "Tab" && event.shiftKey && open && !virtual) {
                    var target = getTarget(event.nativeEvent);
                    if (target && !contains(floatingFocusElementRef.current, target)) return;
                    stopEvent(event);
                    store.setOpen(false, createChangeEventDetails(focusOut, event.nativeEvent));
                    if (isHTMLElement(domReferenceElement)) domReferenceElement.focus();
                    return;
                }
                commonOnKeyDown(event);
            },
            onPointerMove: function onPointerMove() {
                isPointerModalityRef.current = true;
            }
        });
    }, [
        ariaActiveDescendantProp,
        commonOnKeyDown,
        floatingFocusElementRef,
        orientation,
        typeableComboboxReference,
        store,
        open,
        virtual,
        domReferenceElement
    ]);
    var trigger = react.useMemo(function() {
        var checkVirtualMouse = function checkVirtualMouse(event) {
            if (focusItemOnOpen === "auto" && isVirtualClick(event.nativeEvent)) focusItemOnOpenRef.current = !virtual;
        };
        var checkVirtualPointer = function checkVirtualPointer(event) {
            focusItemOnOpenRef.current = focusItemOnOpen;
            if (focusItemOnOpen === "auto" && isVirtualPointerEvent(event.nativeEvent)) focusItemOnOpenRef.current = true;
        };
        return {
            onKeyDown: function onKeyDown(event) {
                var currentOpen = store.select("open");
                isPointerModalityRef.current = false;
                var isArrowKey = event.key.startsWith("Arrow");
                var isParentCrossOpenKey = isCrossOrientationOpenKey(event.key, getParentOrientation(), rtl);
                var isMainKey = isMainOrientationKey(event.key, orientation);
                var isNavigationKey = (nested ? isParentCrossOpenKey : isMainKey) || event.key === "Enter" || event.key.trim() === "";
                if (virtual && currentOpen) return commonOnKeyDown(event);
                if (!currentOpen && !openOnArrowKeyDown && isArrowKey) return;
                if (isNavigationKey) {
                    var isParentMainKey = isMainOrientationKey(event.key, getParentOrientation());
                    keyRef.current = nested && isParentMainKey ? null : event.key;
                }
                if (nested) {
                    if (isParentCrossOpenKey) {
                        stopEvent(event);
                        if (currentOpen) {
                            indexRef.current = getMinListIndex(listRef, disabledIndicesRef.current);
                            onNavigate(event);
                        } else store.setOpen(true, createChangeEventDetails(listNavigation, event.nativeEvent, event.currentTarget));
                    }
                    return;
                }
                if (isMainKey) {
                    if (selectedIndexRef.current != null) indexRef.current = selectedIndexRef.current;
                    stopEvent(event);
                    if (!currentOpen && openOnArrowKeyDown) store.setOpen(true, createChangeEventDetails(listNavigation, event.nativeEvent, event.currentTarget));
                    else commonOnKeyDown(event);
                    if (currentOpen) onNavigate(event);
                }
            },
            onFocus: function onFocus(event) {
                if (store.select("open") && !virtual) {
                    indexRef.current = -1;
                    onNavigate(event);
                }
            },
            onPointerDown: checkVirtualPointer,
            onPointerEnter: checkVirtualPointer,
            onMouseDown: checkVirtualMouse,
            onClick: checkVirtualMouse
        };
    }, [
        commonOnKeyDown,
        disabledIndicesRef,
        focusItemOnOpen,
        listRef,
        nested,
        onNavigate,
        store,
        openOnArrowKeyDown,
        orientation,
        getParentOrientation,
        rtl,
        selectedIndexRef,
        virtual
    ]);
    var reference = react.useMemo(function() {
        return (0,src_object_spread/* default */.Z)({}, ariaActiveDescendantProp, trigger);
    }, [
        ariaActiveDescendantProp,
        trigger
    ]);
    return react.useMemo(function() {
        return enabled ? {
            reference: reference,
            floating: floating,
            item: item,
            trigger: trigger
        } : {};
    }, [
        enabled,
        reference,
        floating,
        trigger,
        item
    ]);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/floating-ui-react/hooks/useRole.js
var componentRoleToAriaRoleMap = new Map([
    [
        "select",
        "listbox"
    ],
    [
        "combobox",
        "listbox"
    ],
    [
        "label",
        false
    ]
]);
/**
* Adds base screen reader props to the reference and floating elements for a
* given floating element `role`.
* @see https://floating-ui.com/docs/useRole
*/ function useRole(context) {
    var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var store = "rootStore" in context ? context.rootStore : context;
    var open = store.useState("open");
    var defaultFloatingId = store.useState("floatingId");
    var domReference = store.useState("domReferenceElement");
    var floatingElement = store.useState("floatingElement");
    var _role = props.role, role = _role === void 0 ? "dialog" : _role;
    var defaultReferenceId = useId$1();
    var referenceId = (domReference === null || domReference === void 0 ? void 0 : domReference.id) || defaultReferenceId;
    var floatingId = React$1.useMemo(function() {
        var ref;
        return ((ref = getFloatingFocusElement(floatingElement)) === null || ref === void 0 ? void 0 : ref.id) || defaultFloatingId;
    }, [
        floatingElement,
        defaultFloatingId
    ]);
    var ref;
    var ariaRole = (ref = componentRoleToAriaRoleMap.get(role)) !== null && ref !== void 0 ? ref : role;
    var isNested = useFloatingParentNodeId() != null;
    var trigger = React$1.useMemo(function() {
        if (ariaRole === "tooltip" || role === "label") return EMPTY_OBJECT;
        return _object_spread({
            "aria-haspopup": ariaRole === "alertdialog" ? "dialog" : ariaRole,
            "aria-expanded": "false"
        }, ariaRole === "listbox" && {
            role: "combobox"
        }, ariaRole === "menu" && isNested && {
            role: "menuitem"
        }, role === "select" && {
            "aria-autocomplete": "none"
        }, role === "combobox" && {
            "aria-autocomplete": "list"
        });
    }, [
        ariaRole,
        isNested,
        role
    ]);
    var reference = React$1.useMemo(function() {
        if (ariaRole === "tooltip" || role === "label") return _define_property({}, "aria-".concat(role === "label" ? "labelledby" : "describedby"), open ? floatingId : void 0);
        return _object_spread(_object_spread_props(_object_spread({}, trigger), {
            "aria-expanded": open ? "true" : "false",
            "aria-controls": open ? floatingId : void 0
        }), ariaRole === "menu" && {
            id: referenceId
        });
    }, [
        ariaRole,
        floatingId,
        open,
        referenceId,
        role,
        trigger
    ]);
    var floating = React$1.useMemo(function() {
        var floatingProps = _object_spread({
            id: floatingId
        }, ariaRole && {
            role: ariaRole
        });
        if (ariaRole === "tooltip" || role === "label") return floatingProps;
        return _object_spread({}, floatingProps, ariaRole === "menu" && {
            "aria-labelledby": referenceId
        });
    }, [
        ariaRole,
        floatingId,
        referenceId,
        role
    ]);
    var item = React$1.useCallback(function(param) {
        var active = param.active, selected = param.selected;
        var commonProps = _object_spread({
            role: "option"
        }, active && {
            id: "".concat(floatingId, "-fui-option")
        });
        switch(role){
            case "select":
            case "combobox":
                return _object_spread_props(_object_spread({}, commonProps), {
                    "aria-selected": selected
                });
            default:
        }
        return {};
    }, [
        floatingId,
        role
    ]);
    return React$1.useMemo(function() {
        return {
            reference: reference,
            floating: floating,
            item: item,
            trigger: trigger
        };
    }, [
        reference,
        floating,
        trigger,
        item
    ]);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/floating-ui-react/hooks/useTypeahead.js
/**
* Provides a matching callback that can be used to focus an item as the user
* types, often used in tandem with `useListNavigation()`.
* @see https://floating-ui.com/docs/useTypeahead
*/ function useTypeahead(context, props) {
    var store = "rootStore" in context ? context.rootStore : context;
    var dataRef = store.context.dataRef;
    var open = store.useState("open");
    var listRef = props.listRef, elementsRef = props.elementsRef, activeIndex = props.activeIndex, onMatchProp = props.onMatch, onTypingChange = props.onTypingChange, _enabled = props.enabled, enabled = _enabled === void 0 ? true : _enabled, _resetMs = props.resetMs, resetMs = _resetMs === void 0 ? 750 : _resetMs, _selectedIndex = props.selectedIndex, selectedIndex = _selectedIndex === void 0 ? null : _selectedIndex;
    var timeout = useTimeout();
    var stringRef = react.useRef("");
    var ref;
    var prevIndexRef = react.useRef((ref = selectedIndex !== null && selectedIndex !== void 0 ? selectedIndex : activeIndex) !== null && ref !== void 0 ? ref : -1);
    var matchIndexRef = react.useRef(null);
    useIsoLayoutEffect(function() {
        if (!open && selectedIndex !== null) return;
        timeout.clear();
        matchIndexRef.current = null;
        if (stringRef.current !== "") stringRef.current = "";
    }, [
        open,
        selectedIndex,
        timeout
    ]);
    useIsoLayoutEffect(function() {
        var ref;
        if (open && stringRef.current === "") prevIndexRef.current = (ref = selectedIndex !== null && selectedIndex !== void 0 ? selectedIndex : activeIndex) !== null && ref !== void 0 ? ref : -1;
    }, [
        open,
        selectedIndex,
        activeIndex
    ]);
    var setTypingChange = useStableCallback(function(value) {
        if (value) {
            if (!dataRef.current.typing) {
                dataRef.current.typing = value;
                onTypingChange === null || onTypingChange === void 0 ? void 0 : onTypingChange(value);
            }
        } else if (dataRef.current.typing) {
            dataRef.current.typing = value;
            onTypingChange === null || onTypingChange === void 0 ? void 0 : onTypingChange(value);
        }
    });
    var onKeyDown = useStableCallback(function(event) {
        var isVisible = function isVisible(index) {
            var element = elementsRef === null || elementsRef === void 0 ? void 0 : elementsRef.current[index];
            return !element || isElementVisible(element);
        };
        var getMatchingIndex = function getMatchingIndex(list, string) {
            var startIndex = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
            if (list.length === 0) return -1;
            var normalizedStartIndex = (startIndex % list.length + list.length) % list.length;
            var lowerString = string.toLocaleLowerCase();
            for(var offset = 0; offset < list.length; offset += 1){
                var ref;
                var index = (normalizedStartIndex + offset) % list.length;
                if (!((ref = list[index]) === null || ref === void 0 ? void 0 : ref.toLocaleLowerCase().startsWith(lowerString)) || !isVisible(index)) continue;
                return index;
            }
            return -1;
        };
        var listContent = listRef.current;
        if (stringRef.current.length > 0 && event.key === " ") {
            stopEvent(event);
            setTypingChange(true);
        }
        if (stringRef.current.length > 0 && stringRef.current[0] !== " ") {
            if (getMatchingIndex(listContent, stringRef.current) === -1 && event.key !== " ") setTypingChange(false);
        }
        if (listContent == null || event.key.length !== 1 || event.ctrlKey || event.metaKey || event.altKey) return;
        if (open && event.key !== " ") {
            stopEvent(event);
            setTypingChange(true);
        }
        var isNewSession = stringRef.current === "";
        var ref;
        if (isNewSession) prevIndexRef.current = (ref = selectedIndex !== null && selectedIndex !== void 0 ? selectedIndex : activeIndex) !== null && ref !== void 0 ? ref : -1;
        if (listContent.every(function(text) {
            var ref, ref1;
            return text ? ((ref = text[0]) === null || ref === void 0 ? void 0 : ref.toLocaleLowerCase()) !== ((ref1 = text[1]) === null || ref1 === void 0 ? void 0 : ref1.toLocaleLowerCase()) : true;
        }) && stringRef.current === event.key) {
            stringRef.current = "";
            prevIndexRef.current = matchIndexRef.current;
        }
        stringRef.current += event.key;
        timeout.start(resetMs, function() {
            stringRef.current = "";
            prevIndexRef.current = matchIndexRef.current;
            setTypingChange(false);
        });
        var ref1, ref2;
        var startIndex = ((ref2 = isNewSession ? (ref1 = selectedIndex !== null && selectedIndex !== void 0 ? selectedIndex : activeIndex) !== null && ref1 !== void 0 ? ref1 : -1 : prevIndexRef.current) !== null && ref2 !== void 0 ? ref2 : 0) + 1;
        var index = getMatchingIndex(listContent, stringRef.current, startIndex);
        if (index !== -1) {
            onMatchProp === null || onMatchProp === void 0 ? void 0 : onMatchProp(index);
            matchIndexRef.current = index;
        } else if (event.key !== " ") {
            stringRef.current = "";
            setTypingChange(false);
        }
    });
    var onBlur = useStableCallback(function(event) {
        var next = event.relatedTarget;
        var currentDomReferenceElement = store.select("domReferenceElement");
        var currentFloatingElement = store.select("floatingElement");
        var withinReference = contains(currentDomReferenceElement, next);
        var withinFloating = contains(currentFloatingElement, next);
        if (withinReference || withinFloating) return;
        timeout.clear();
        stringRef.current = "";
        prevIndexRef.current = matchIndexRef.current;
        setTypingChange(false);
    });
    var reference = react.useMemo(function() {
        return {
            onKeyDown: onKeyDown,
            onBlur: onBlur
        };
    }, [
        onKeyDown,
        onBlur
    ]);
    var floating = react.useMemo(function() {
        return {
            onKeyDown: onKeyDown,
            onBlur: onBlur
        };
    }, [
        onKeyDown,
        onBlur
    ]);
    return react.useMemo(function() {
        return enabled ? {
            reference: reference,
            floating: floating
        } : {};
    }, [
        enabled,
        reference,
        floating
    ]);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/combobox/root/ComboboxRootContext.js
var ComboboxRootContext = /* @__PURE__ */ /*#__PURE__*/ react.createContext(void 0);
if (false) {}
var ComboboxFloatingContext = /* @__PURE__ */ /*#__PURE__*/ react.createContext(void 0);
if (false) {}
var ComboboxDerivedItemsContext = /* @__PURE__ */ /*#__PURE__*/ react.createContext(void 0);
if (false) {}
var ComboboxInputValueContext = /* @__PURE__ */ /*#__PURE__*/ react.createContext("");
if (false) {}
function useComboboxRootContext() {
    var context = react.useContext(ComboboxRootContext);
    if (!context) throw new Error( false ? 0 : formatErrorMessage(22));
    return context;
}
function useComboboxFloatingContext() {
    var context = react.useContext(ComboboxFloatingContext);
    if (!context) throw new Error( false ? 0 : formatErrorMessage(23));
    return context;
}
function useComboboxDerivedItemsContext() {
    var context = react.useContext(ComboboxDerivedItemsContext);
    if (!context) throw new Error( false ? 0 : formatErrorMessage(24));
    return context;
}
function useComboboxInputValueContext() {
    return react.useContext(ComboboxInputValueContext);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/itemEquality.js
var defaultItemEquality = function(itemValue, selectedValue) {
    return Object.is(itemValue, selectedValue);
};
function compareItemEquality(itemValue, selectedValue, comparer) {
    if (itemValue == null || selectedValue == null) return Object.is(itemValue, selectedValue);
    return comparer(itemValue, selectedValue);
}
function selectedValueIncludes(selectedValues, itemValue, comparer) {
    if (!selectedValues || selectedValues.length === 0) return false;
    return selectedValues.some(function(selectedValue) {
        if (selectedValue === void 0) return false;
        return compareItemEquality(itemValue, selectedValue, comparer);
    });
}
function findItemIndex(itemValues, selectedValue, comparer) {
    if (!itemValues || itemValues.length === 0) return -1;
    return itemValues.findIndex(function(itemValue) {
        if (itemValue === void 0) return false;
        return compareItemEquality(itemValue, selectedValue, comparer);
    });
}
function removeItem(selectedValues, itemValue, comparer) {
    return selectedValues.filter(function(selectedValue) {
        return !compareItemEquality(itemValue, selectedValue, comparer);
    });
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/serializeValue.js
function serializeValue(value) {
    if (value == null) return "";
    if (typeof value === "string") return value;
    try {
        return JSON.stringify(value);
    } catch (e) {
        return String(value);
    }
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/resolveValueLabel.js
function isGroupedItems(items) {
    return items != null && items.length > 0 && typeof items[0] === "object" && items[0] != null && "items" in items[0];
}
/**
* Checks if the items array contains an item with a null value that has a non-null label.
*/ function hasNullItemLabel(items) {
    if (!Array.isArray(items)) return items != null && "null" in items;
    var arrayItems = items;
    if (isGroupedItems(arrayItems)) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator = arrayItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                var group = _step.value;
                try {
                    for(var _iterator1 = group.items[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                        var item = _step1.value;
                        if (item && item.value == null && item.label != null) return true;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        return false;
    }
    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
    try {
        for(var _iterator2 = arrayItems[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var item1 = _step2.value;
            if (item1 && item1.value == null && item1.label != null) return true;
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
            }
        } finally{
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }
    return false;
}
function stringifyAsLabel(item, itemToStringLabel) {
    var ref;
    if (itemToStringLabel && item != null) return (ref = itemToStringLabel(item)) !== null && ref !== void 0 ? ref : "";
    if (item && typeof item === "object") {
        if ("label" in item && item.label != null) return String(item.label);
        if ("value" in item) return String(item.value);
    }
    return serializeValue(item);
}
function stringifyAsValue(item, itemToStringValue) {
    var ref;
    if (itemToStringValue && item != null) return (ref = itemToStringValue(item)) !== null && ref !== void 0 ? ref : "";
    if (item && typeof item === "object" && "value" in item && "label" in item) return serializeValue(item.value);
    return serializeValue(item);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/combobox/store.js
var selectors$2 = {
    id: createSelector$1(function(state) {
        return state.id;
    }),
    labelId: createSelector$1(function(state) {
        return state.labelId;
    }),
    items: createSelector$1(function(state) {
        return state.items;
    }),
    selectedValue: createSelector$1(function(state) {
        return state.selectedValue;
    }),
    hasSelectionChips: createSelector$1(function(state) {
        var selectedValue = state.selectedValue;
        return Array.isArray(selectedValue) && selectedValue.length > 0;
    }),
    hasSelectedValue: createSelector$1(function(state) {
        var selectedValue = state.selectedValue, selectionMode = state.selectionMode;
        if (selectedValue == null) return false;
        if (selectionMode === "multiple" && Array.isArray(selectedValue)) return selectedValue.length > 0;
        return true;
    }),
    hasNullItemLabel: createSelector$1(function(state, enabled) {
        return enabled ? hasNullItemLabel(state.items) : false;
    }),
    open: createSelector$1(function(state) {
        return state.open;
    }),
    mounted: createSelector$1(function(state) {
        return state.mounted;
    }),
    forceMounted: createSelector$1(function(state) {
        return state.forceMounted;
    }),
    inline: createSelector$1(function(state) {
        return state.inline;
    }),
    activeIndex: createSelector$1(function(state) {
        return state.activeIndex;
    }),
    selectedIndex: createSelector$1(function(state) {
        return state.selectedIndex;
    }),
    isActive: createSelector$1(function(state, index) {
        return state.activeIndex === index;
    }),
    isSelected: createSelector$1(function(state, itemValue) {
        var comparer = state.isItemEqualToValue;
        var selectedValue = state.selectedValue;
        if (Array.isArray(selectedValue)) return selectedValue.some(function(selectedItem) {
            return compareItemEquality(itemValue, selectedItem, comparer);
        });
        return compareItemEquality(itemValue, selectedValue, comparer);
    }),
    transitionStatus: createSelector$1(function(state) {
        return state.transitionStatus;
    }),
    popupProps: createSelector$1(function(state) {
        return state.popupProps;
    }),
    inputProps: createSelector$1(function(state) {
        return state.inputProps;
    }),
    triggerProps: createSelector$1(function(state) {
        return state.triggerProps;
    }),
    getItemProps: createSelector$1(function(state) {
        return state.getItemProps;
    }),
    positionerElement: createSelector$1(function(state) {
        return state.positionerElement;
    }),
    listElement: createSelector$1(function(state) {
        return state.listElement;
    }),
    triggerElement: createSelector$1(function(state) {
        return state.triggerElement;
    }),
    inputElement: createSelector$1(function(state) {
        return state.inputElement;
    }),
    inputGroupElement: createSelector$1(function(state) {
        return state.inputGroupElement;
    }),
    popupSide: createSelector$1(function(state) {
        return state.popupSide;
    }),
    openMethod: createSelector$1(function(state) {
        return state.openMethod;
    }),
    inputInsidePopup: createSelector$1(function(state) {
        return state.inputInsidePopup;
    }),
    selectionMode: createSelector$1(function(state) {
        return state.selectionMode;
    }),
    name: createSelector$1(function(state) {
        return state.name;
    }),
    form: createSelector$1(function(state) {
        return state.form;
    }),
    disabled: createSelector$1(function(state) {
        return state.disabled;
    }),
    readOnly: createSelector$1(function(state) {
        return state.readOnly;
    }),
    required: createSelector$1(function(state) {
        return state.required;
    }),
    grid: createSelector$1(function(state) {
        return state.grid;
    }),
    virtualized: createSelector$1(function(state) {
        return state.virtualized;
    }),
    itemToStringLabel: createSelector$1(function(state) {
        return state.itemToStringLabel;
    }),
    isItemEqualToValue: createSelector$1(function(state) {
        return state.isItemEqualToValue;
    }),
    modal: createSelector$1(function(state) {
        return state.modal;
    }),
    autoHighlight: createSelector$1(function(state) {
        return state.autoHighlight;
    }),
    submitOnItemClick: createSelector$1(function(state) {
        return state.submitOnItemClick;
    })
};
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/labelable-provider/useLabelableId.js
function useLabelableId() {
    var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var id = params.id, _implicit = params.implicit, implicit = _implicit === void 0 ? false : _implicit, controlRef = params.controlRef;
    var ref = useLabelableContext(), controlId = ref.controlId, registerControlId = ref.registerControlId;
    var defaultId = useBaseUiId(id);
    var controlIdForEffect = implicit ? controlId : void 0;
    var controlSourceRef = useRefWithInit(function() {
        return Symbol("labelable-control");
    });
    var hasRegisteredRef = react.useRef(false);
    var hadExplicitIdRef = react.useRef(id != null);
    var unregisterControlId = useStableCallback(function() {
        if (!hasRegisteredRef.current || registerControlId === NOOP) return;
        hasRegisteredRef.current = false;
        registerControlId(controlSourceRef.current, void 0);
    });
    useIsoLayoutEffect(function() {
        if (registerControlId === NOOP) return;
        var nextId;
        if (implicit) {
            var elem = controlRef === null || controlRef === void 0 ? void 0 : controlRef.current;
            if (isElement(elem) && elem.closest("label") != null) nextId = id !== null && id !== void 0 ? id : null;
            else nextId = controlIdForEffect !== null && controlIdForEffect !== void 0 ? controlIdForEffect : defaultId;
        } else if (id != null) {
            hadExplicitIdRef.current = true;
            nextId = id;
        } else if (hadExplicitIdRef.current) nextId = defaultId;
        else {
            unregisterControlId();
            return;
        }
        if (nextId === void 0) {
            unregisterControlId();
            return;
        }
        hasRegisteredRef.current = true;
        registerControlId(controlSourceRef.current, nextId);
    }, [
        id,
        controlRef,
        controlIdForEffect,
        registerControlId,
        implicit,
        defaultId,
        controlSourceRef,
        unregisterControlId
    ]);
    react.useEffect(function() {
        return unregisterControlId;
    }, [
        unregisterControlId
    ]);
    return controlId !== null && controlId !== void 0 ? controlId : defaultId;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/combobox/root/utils/index.js
/**
* Enhanced filter using Intl.Collator for more robust string matching.
* Uses the provided `itemToStringLabel` function if available, otherwise falls back to:
* • When `item` is an object with a `value` property, that property is used.
* • When `item` is a primitive (e.g. `string`), it is used directly.
*/ function createCollatorItemFilter(collatorFilter, itemToStringLabel) {
    return function(item, query) {
        if (item == null) return false;
        var itemString = stringifyAsLabel(item, itemToStringLabel);
        return collatorFilter.contains(itemString, query);
    };
}
/**
* Enhanced filter for single selection mode using Intl.Collator that shows all items
* when query is empty or matches the current selection, making it easier to browse options.
*/ function createSingleSelectionCollatorFilter(collatorFilter, itemToStringLabel, selectedValue) {
    return function(item, query) {
        if (item == null) return false;
        if (!query) return true;
        var itemString = stringifyAsLabel(item, itemToStringLabel);
        var selectedString = selectedValue != null ? stringifyAsLabel(selectedValue, itemToStringLabel) : "";
        if (selectedString && collatorFilter.contains(selectedString, query) && selectedString.length === query.length) return true;
        return collatorFilter.contains(itemString, query);
    };
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/filter.js
var filterCache = /* @__PURE__ */ new Map();
function getFilter() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var mergedOptions = (0,src_object_spread/* default */.Z)({
        usage: "search",
        sensitivity: "base",
        ignorePunctuation: true
    }, options);
    var cacheKey = "".concat(stringifyLocale(options.locale), "|").concat(JSON.stringify(mergedOptions));
    var cachedFilter = filterCache.get(cacheKey);
    if (cachedFilter) return cachedFilter;
    var collator = new Intl.Collator(options.locale, mergedOptions);
    var filter = {
        contains: function contains(item, query, itemToString) {
            if (!query) return true;
            var itemString = stringifyAsLabel(item, itemToString);
            for(var i = 0; i <= itemString.length - query.length; i += 1)if (collator.compare(itemString.slice(i, i + query.length), query) === 0) return true;
            return false;
        },
        startsWith: function startsWith(item, query, itemToString) {
            if (!query) return true;
            var itemString = stringifyAsLabel(item, itemToString);
            return collator.compare(itemString.slice(0, query.length), query) === 0;
        },
        endsWith: function endsWith(item, query, itemToString) {
            if (!query) return true;
            var itemString = stringifyAsLabel(item, itemToString);
            var queryLength = query.length;
            return itemString.length >= queryLength && collator.compare(itemString.slice(itemString.length - queryLength), query) === 0;
        }
    };
    filterCache.set(cacheKey, filter);
    return filter;
}
function stringifyLocale(locale) {
    if (Array.isArray(locale)) return locale.map(function(value) {
        return stringifyLocale(value);
    }).join(",");
    if (locale == null) return "";
    return String(locale);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/combobox/root/utils/useFilter.js
/**
* Matches items against a query using `Intl.Collator` for robust string matching.
*/ var useCoreFilter = getFilter;
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/useEnhancedClickHandler.js
/**
* Provides a cross-browser way to determine the type of the pointer used to click.
* Safari and Firefox do not provide the PointerEvent to the click handler (they use MouseEvent) yet.
* Additionally, this implementation detects if the click was triggered by the keyboard.
*
* @param handler The function to be called when the button is clicked. The first parameter is the original event and the second parameter is the pointer type.
*/ function useEnhancedClickHandler(handler) {
    var lastClickInteractionTypeRef = react.useRef("");
    var handlePointerDown = react.useCallback(function(event) {
        if (event.defaultPrevented) return;
        lastClickInteractionTypeRef.current = event.pointerType;
        handler(event, event.pointerType);
    }, [
        handler
    ]);
    return {
        onClick: react.useCallback(function(event) {
            if (event.detail === 0) {
                handler(event, "keyboard");
                return;
            }
            if ("pointerType" in event) handler(event, event.pointerType);
            else handler(event, lastClickInteractionTypeRef.current);
            lastClickInteractionTypeRef.current = "";
        }, [
            handler
        ]),
        onPointerDown: handlePointerDown
    };
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/utils/useOpenInteractionType.js
/**
* Determines the interaction type (keyboard, mouse, touch, etc.) that opened the component.
*
* @param open The open state of the component.
*/ function useOpenInteractionType(open) {
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), openMethod = ref[0], setOpenMethod = ref[1];
    var handleTriggerClick = useStableCallback(function(_, interactionType) {
        if (!open) setOpenMethod(interactionType || (isIOS ? "touch" : ""));
    });
    useValueChanged(open, function(previousOpen) {
        if (previousOpen && !open) setOpenMethod(null);
    });
    var ref1 = useEnhancedClickHandler(handleTriggerClick), onClick = ref1.onClick, onPointerDown = ref1.onPointerDown;
    return react.useMemo(function() {
        return {
            openMethod: openMethod,
            triggerProps: {
                onClick: onClick,
                onPointerDown: onPointerDown
            }
        };
    }, [
        openMethod,
        onClick,
        onPointerDown
    ]);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/combobox/root/utils/constants.js
var NO_ACTIVE_VALUE = Symbol("none");
var INITIAL_LAST_HIGHLIGHT = {
    value: NO_ACTIVE_VALUE,
    index: -1
};
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/combobox/root/AriaCombobox.js
/**
* @internal
*/ function AriaCombobox(props) {
    var idProp = props.id, onOpenChangeCompleteProp = props.onOpenChangeComplete, _defaultSelectedValue = props.defaultSelectedValue, defaultSelectedValue = _defaultSelectedValue === void 0 ? null : _defaultSelectedValue, selectedValueProp = props.selectedValue, onSelectedValueChange = props.onSelectedValueChange, defaultInputValueProp = props.defaultInputValue, inputValueProp = props.inputValue, openProp = props.open, _defaultOpen = props.defaultOpen, defaultOpen = _defaultOpen === void 0 ? false : _defaultOpen, _selectionMode = props.selectionMode, selectionMode = _selectionMode === void 0 ? "none" : _selectionMode, onItemHighlightedProp = props.onItemHighlighted, nameProp = props.name, form = props.form, tmp = props.disabled, disabledProp = tmp === void 0 ? false : tmp, _readOnly = props.readOnly, readOnly = _readOnly === void 0 ? false : _readOnly, _required = props.required, required = _required === void 0 ? false : _required, inputRefProp = props.inputRef, _grid = props.grid, grid = _grid === void 0 ? false : _grid, items = props.items, filteredItemsProp = props.filteredItems, filterProp = props.filter, _openOnInputClick = props.openOnInputClick, openOnInputClick = _openOnInputClick === void 0 ? true : _openOnInputClick, _autoHighlight = props.autoHighlight, autoHighlight = _autoHighlight === void 0 ? false : _autoHighlight, _keepHighlight = props.keepHighlight, keepHighlight = _keepHighlight === void 0 ? false : _keepHighlight, _highlightItemOnHover = props.highlightItemOnHover, highlightItemOnHover = _highlightItemOnHover === void 0 ? true : _highlightItemOnHover, _loopFocus = props.loopFocus, loopFocus = _loopFocus === void 0 ? true : _loopFocus, itemToStringLabel = props.itemToStringLabel, itemToStringValue = props.itemToStringValue, _isItemEqualToValue = props.isItemEqualToValue, isItemEqualToValue = _isItemEqualToValue === void 0 ? defaultItemEquality : _isItemEqualToValue, _virtualized = props.virtualized, virtualized = _virtualized === void 0 ? false : _virtualized, tmp1 = props.inline, inlineProp = tmp1 === void 0 ? false : tmp1, _fillInputOnItemPress = props.fillInputOnItemPress, fillInputOnItemPress = _fillInputOnItemPress === void 0 ? true : _fillInputOnItemPress, _modal = props.modal, modal = _modal === void 0 ? false : _modal, _limit = props.limit, limit = _limit === void 0 ? -1 : _limit, _autoComplete = props.autoComplete, autoComplete = _autoComplete === void 0 ? "list" : _autoComplete, formAutoComplete = props.formAutoComplete, locale = props.locale, _submitOnItemClick = props.submitOnItemClick, submitOnItemClick = _submitOnItemClick === void 0 ? false : _submitOnItemClick;
    var clearErrors = useFormContext().clearErrors;
    var ref = useFieldRootContext(), setDirty = ref.setDirty, validityData = ref.validityData, shouldValidateOnChange = ref.shouldValidateOnChange, setFilled = ref.setFilled, fieldName = ref.name, fieldDisabled = ref.disabled, setTouched = ref.setTouched, setFocused = ref.setFocused, validationMode = ref.validationMode, validation = ref.validation;
    var id = useLabelableId({
        id: idProp
    });
    var collatorFilter = useCoreFilter({
        locale: locale
    });
    var ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), queryChangedAfterOpen = ref1[0], setQueryChangedAfterOpen = ref1[1];
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), closeQuery = ref2[0], setCloseQuery = ref2[1];
    var listRef = react.useRef([]);
    var labelsRef = react.useRef([]);
    var popupRef = react.useRef(null);
    var inputRef = react.useRef(null);
    var startDismissRef = react.useRef(null);
    var endDismissRef = react.useRef(null);
    var emptyRef = react.useRef(null);
    var keyboardActiveRef = react.useRef(true);
    var hadInputClearRef = react.useRef(false);
    var chipsContainerRef = react.useRef(null);
    var clearRef = react.useRef(null);
    var selectionEventRef = react.useRef(null);
    var lastHighlightRef = react.useRef(INITIAL_LAST_HIGHLIGHT);
    var pendingQueryHighlightRef = react.useRef(null);
    /**
	* Contains the currently visible list of item values post-filtering.
	*/ var valuesRef = react.useRef([]);
    /**
	* Contains all item values in a stable, unfiltered order.
	* This is only used when `items` prop is not provided.
	* It accumulates values on first mount and does not remove them on unmount due to
	* filtering, providing a stable index for selected value tracking.
	*/ var allValuesRef = react.useRef([]);
    var disabled = fieldDisabled || disabledProp;
    var name = fieldName !== null && fieldName !== void 0 ? fieldName : nameProp;
    var multiple = selectionMode === "multiple";
    var single = selectionMode === "single";
    var hasInputValue = inputValueProp !== void 0 || defaultInputValueProp !== void 0;
    var hasItems = items !== void 0;
    var hasFilteredItemsProp = filteredItemsProp !== void 0;
    var autoHighlightMode;
    if (autoHighlight === "always") autoHighlightMode = "always";
    else autoHighlightMode = autoHighlight ? "input-change" : false;
    var ref3 = (0,src_sliced_to_array/* default */.Z)(useControlled({
        controlled: selectedValueProp,
        default: multiple ? defaultSelectedValue !== null && defaultSelectedValue !== void 0 ? defaultSelectedValue : EMPTY_ARRAY$1 : defaultSelectedValue,
        name: "Combobox",
        state: "selectedValue"
    }), 2), selectedValue = ref3[0], setSelectedValueUnwrapped = ref3[1];
    var filter = react.useMemo(function() {
        if (filterProp === null) return function() {
            return true;
        };
        if (filterProp !== void 0) return filterProp;
        if (single && !queryChangedAfterOpen) return createSingleSelectionCollatorFilter(collatorFilter, itemToStringLabel, selectedValue);
        return createCollatorItemFilter(collatorFilter, itemToStringLabel);
    }, [
        filterProp,
        single,
        selectedValue,
        queryChangedAfterOpen,
        collatorFilter,
        itemToStringLabel
    ]);
    var initialDefaultInputValue = useRefWithInit(function() {
        if (hasInputValue) return defaultInputValueProp !== null && defaultInputValueProp !== void 0 ? defaultInputValueProp : "";
        if (single) return stringifyAsLabel(selectedValue, itemToStringLabel);
        return "";
    }).current;
    var ref4 = (0,src_sliced_to_array/* default */.Z)(useControlled({
        controlled: inputValueProp,
        default: initialDefaultInputValue,
        name: "Combobox",
        state: "inputValue"
    }), 2), inputValue = ref4[0], setInputValueUnwrapped = ref4[1];
    var ref5 = (0,src_sliced_to_array/* default */.Z)(useControlled({
        controlled: openProp,
        default: defaultOpen,
        name: "Combobox",
        state: "open"
    }), 2), open = ref5[0], setOpenUnwrapped = ref5[1];
    var isGrouped = isGroupedItems(items);
    var query = closeQuery !== null && closeQuery !== void 0 ? closeQuery : inputValue === "" ? "" : String(inputValue).trim();
    var selectedLabelString = single ? stringifyAsLabel(selectedValue, itemToStringLabel) : "";
    var shouldBypassFiltering = single && !queryChangedAfterOpen && query !== "" && selectedLabelString !== "" && selectedLabelString.length === query.length && collatorFilter.contains(selectedLabelString, query);
    var filterQuery = shouldBypassFiltering ? "" : query;
    var shouldIgnoreExternalFiltering = hasItems && hasFilteredItemsProp && shouldBypassFiltering;
    var flatItems = react.useMemo(function() {
        if (!items) return EMPTY_ARRAY$1;
        if (isGrouped) return items.flatMap(function(group) {
            return group.items;
        });
        return items;
    }, [
        items,
        isGrouped
    ]);
    var filteredItems = react.useMemo(function() {
        if (filteredItemsProp && !shouldIgnoreExternalFiltering) return filteredItemsProp;
        if (!items) return EMPTY_ARRAY$1;
        if (isGrouped) {
            var groupedItems = items;
            var resultingGroups = [];
            var currentCount = 0;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = groupedItems[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var group = _step.value;
                    if (limit > -1 && currentCount >= limit) break;
                    var candidateItems = filterQuery === "" ? group.items : group.items.filter(function(item) {
                        return filter(item, filterQuery, itemToStringLabel);
                    });
                    if (candidateItems.length === 0) continue;
                    var remainingLimit = limit > -1 ? limit - currentCount : Infinity;
                    var itemsToTake = candidateItems.slice(0, remainingLimit);
                    if (itemsToTake.length > 0) {
                        var newGroup = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, group), {
                            items: itemsToTake
                        });
                        resultingGroups.push(newGroup);
                        currentCount += itemsToTake.length;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return resultingGroups;
        }
        if (filterQuery === "") return limit > -1 ? flatItems.slice(0, limit) : flatItems;
        var limitedItems = [];
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = flatItems[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var item = _step1.value;
                if (limit > -1 && limitedItems.length >= limit) break;
                if (filter(item, filterQuery, itemToStringLabel)) limitedItems.push(item);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
        return limitedItems;
    }, [
        filteredItemsProp,
        shouldIgnoreExternalFiltering,
        items,
        isGrouped,
        filterQuery,
        limit,
        filter,
        itemToStringLabel,
        flatItems
    ]);
    var flatFilteredItems = react.useMemo(function() {
        if (isGrouped) return filteredItems.flatMap(function(g) {
            return g.items;
        });
        return filteredItems;
    }, [
        filteredItems,
        isGrouped
    ]);
    var store = useRefWithInit(function() {
        return new Store({
            id: id,
            labelId: void 0,
            selectedValue: selectedValue,
            open: open,
            filter: filter,
            query: query,
            items: items,
            selectionMode: selectionMode,
            listRef: listRef,
            labelsRef: labelsRef,
            popupRef: popupRef,
            emptyRef: emptyRef,
            inputRef: inputRef,
            startDismissRef: startDismissRef,
            endDismissRef: endDismissRef,
            keyboardActiveRef: keyboardActiveRef,
            chipsContainerRef: chipsContainerRef,
            clearRef: clearRef,
            valuesRef: valuesRef,
            allValuesRef: allValuesRef,
            selectionEventRef: selectionEventRef,
            name: name,
            form: form,
            disabled: disabled,
            readOnly: readOnly,
            required: required,
            grid: grid,
            isGrouped: isGrouped,
            virtualized: virtualized,
            openOnInputClick: openOnInputClick,
            itemToStringLabel: itemToStringLabel,
            isItemEqualToValue: isItemEqualToValue,
            modal: modal,
            autoHighlight: autoHighlightMode,
            submitOnItemClick: submitOnItemClick,
            hasInputValue: hasInputValue,
            mounted: false,
            forceMounted: false,
            transitionStatus: "idle",
            inline: inlineProp,
            activeIndex: null,
            selectedIndex: null,
            popupProps: {},
            inputProps: {},
            triggerProps: {},
            positionerElement: null,
            listElement: null,
            triggerElement: null,
            inputElement: null,
            inputGroupElement: null,
            popupSide: null,
            openMethod: null,
            inputInsidePopup: true,
            onOpenChangeComplete: onOpenChangeCompleteProp || NOOP,
            setOpen: NOOP,
            setInputValue: NOOP,
            setSelectedValue: NOOP,
            setIndices: NOOP,
            onItemHighlighted: NOOP,
            handleSelection: NOOP,
            getItemProps: function() {
                return EMPTY_OBJECT;
            },
            forceMount: NOOP,
            requestSubmit: NOOP
        });
    }).current;
    var fieldRawValue = selectionMode === "none" ? inputValue : selectedValue;
    var fieldStringValue = react.useMemo(function() {
        if (selectionMode === "none") return fieldRawValue;
        if (Array.isArray(selectedValue)) return selectedValue.map(function(value) {
            return stringifyAsValue(value, itemToStringValue);
        });
        return stringifyAsValue(selectedValue, itemToStringValue);
    }, [
        fieldRawValue,
        itemToStringValue,
        selectionMode,
        selectedValue
    ]);
    var onItemHighlighted = useStableCallback(onItemHighlightedProp);
    var onOpenChangeComplete = useStableCallback(onOpenChangeCompleteProp);
    var activeIndex = useStore(store, selectors$2.activeIndex);
    var selectedIndex = useStore(store, selectors$2.selectedIndex);
    var positionerElement = useStore(store, selectors$2.positionerElement);
    var listElement = useStore(store, selectors$2.listElement);
    var triggerElement = useStore(store, selectors$2.triggerElement);
    var inputElement = useStore(store, selectors$2.inputElement);
    var inputGroupElement = useStore(store, selectors$2.inputGroupElement);
    var inline = useStore(store, selectors$2.inline);
    var inputInsidePopup = useStore(store, selectors$2.inputInsidePopup);
    var triggerRef = useValueAsRef(triggerElement);
    var ref6 = useTransitionStatus(open), mounted = ref6.mounted, setMounted = ref6.setMounted, transitionStatus = ref6.transitionStatus;
    var ref7 = useOpenInteractionType(open), openMethod = ref7.openMethod, triggerProps = ref7.triggerProps;
    var getFieldValue = useStableCallback(function() {
        return fieldStringValue;
    });
    useRegisterFieldControl(inputInsidePopup ? triggerRef : inputRef, {
        id: id,
        value: fieldRawValue,
        getValue: getFieldValue
    });
    var forceMount = useStableCallback(function() {
        if (items) labelsRef.current = flatFilteredItems.map(function(item) {
            return stringifyAsLabel(item, itemToStringLabel);
        });
        else store.set("forceMounted", true);
    });
    var initialSelectedValueRef = react.useRef(selectedValue);
    useIsoLayoutEffect(function() {
        if (selectedValue !== initialSelectedValueRef.current) forceMount();
    }, [
        forceMount,
        selectedValue
    ]);
    var setIndices = useStableCallback(function(options) {
        store.update(options);
        var type = options.type || "none";
        if (options.activeIndex === void 0) return;
        if (options.activeIndex === null) {
            if (lastHighlightRef.current !== INITIAL_LAST_HIGHLIGHT) {
                lastHighlightRef.current = INITIAL_LAST_HIGHLIGHT;
                onItemHighlighted(void 0, createGenericEventDetails(type, void 0, {
                    index: -1
                }));
            }
        } else {
            var activeValue = valuesRef.current[options.activeIndex];
            lastHighlightRef.current = {
                value: activeValue,
                index: options.activeIndex
            };
            onItemHighlighted(activeValue, createGenericEventDetails(type, void 0, {
                index: options.activeIndex
            }));
        }
    });
    var setInputValue = useStableCallback(function(next, eventDetails) {
        var ref;
        hadInputClearRef.current = eventDetails.reason === inputClear;
        (ref = props.onInputValueChange) === null || ref === void 0 ? void 0 : ref.call(props, next, eventDetails);
        if (eventDetails.isCanceled) return;
        if (eventDetails.reason === "input-change") {
            var event = eventDetails.event;
            var inputType = event.inputType;
            if (event.type === "compositionend" || inputType != null && inputType !== "" && inputType !== "insertReplacementText") {
                var hasQuery = next.trim() !== "";
                if (hasQuery) setQueryChangedAfterOpen(true);
                pendingQueryHighlightRef.current = {
                    hasQuery: hasQuery
                };
                if (hasQuery && autoHighlightMode && store.state.activeIndex == null) store.set("activeIndex", 0);
            }
        }
        setInputValueUnwrapped(next);
    });
    var setOpen = useStableCallback(function(nextOpen, eventDetails) {
        var ref;
        if (open === nextOpen) return;
        if (eventDetails.reason === "escape-key" && hasItems && flatFilteredItems.length === 0 && !store.state.emptyRef.current) eventDetails.allowPropagation();
        (ref = props.onOpenChange) === null || ref === void 0 ? void 0 : ref.call(props, nextOpen, eventDetails);
        if (eventDetails.isCanceled) return;
        if (!nextOpen && queryChangedAfterOpen) {
            if (single) {
                if (!inline) setCloseQuery(query);
                if (query === "") setQueryChangedAfterOpen(false);
            } else if (multiple) {
                if (inline || inputInsidePopup) setIndices({
                    activeIndex: null
                });
                else setCloseQuery(query);
                setInputValue("", createChangeEventDetails(inputClear, eventDetails.event));
            }
        }
        setOpenUnwrapped(nextOpen);
        if (!nextOpen && inputInsidePopup && (eventDetails.reason === "focus-out" || eventDetails.reason === "outside-press")) {
            setTouched(true);
            setFocused(false);
            if (validationMode === "onBlur") {
                var valueToValidate = selectionMode === "none" ? inputValue : selectedValue;
                validation.commit(valueToValidate);
            }
        }
    });
    var setSelectedValue = useStableCallback(function(nextValue, eventDetails) {
        onSelectedValueChange === null || onSelectedValueChange === void 0 ? void 0 : onSelectedValueChange(nextValue, eventDetails);
        if (eventDetails.isCanceled) return;
        setSelectedValueUnwrapped(nextValue);
        if (selectionMode === "none" && popupRef.current && fillInputOnItemPress || single && !store.state.inputInsidePopup) setInputValue(stringifyAsLabel(nextValue, itemToStringLabel), createChangeEventDetails(eventDetails.reason, eventDetails.event));
        if (single && nextValue != null && eventDetails.reason !== "input-change" && queryChangedAfterOpen && !inline) setCloseQuery(query);
    });
    var handleSelection = useStableCallback(function(event, passedValue) {
        var ref;
        var itemValue = passedValue;
        if (itemValue === void 0) {
            if (activeIndex === null) return;
            itemValue = valuesRef.current[activeIndex];
        }
        var targetEl = getTarget(event);
        var _current;
        var overrideEvent = (_current = selectionEventRef.current) !== null && _current !== void 0 ? _current : event;
        selectionEventRef.current = null;
        var eventDetails = createChangeEventDetails(itemPress, overrideEvent);
        var href = (ref = targetEl === null || targetEl === void 0 ? void 0 : targetEl.closest("a")) === null || ref === void 0 ? void 0 : ref.getAttribute("href");
        if (href) {
            if (href.startsWith("#")) setOpen(false, eventDetails);
            return;
        }
        if (multiple) {
            var currentSelectedValue = Array.isArray(selectedValue) ? selectedValue : [];
            setSelectedValue(selectedValueIncludes(currentSelectedValue, itemValue, store.state.isItemEqualToValue) ? removeItem(currentSelectedValue, itemValue, store.state.isItemEqualToValue) : (0,src_to_consumable_array/* default */.Z)(currentSelectedValue).concat([
                itemValue
            ]), eventDetails);
            if (!(inputRef.current ? inputRef.current.value.trim() !== "" : false)) return;
            if (store.state.inputInsidePopup) setInputValue("", createChangeEventDetails(inputClear, eventDetails.event));
            else setOpen(false, eventDetails);
        } else {
            setSelectedValue(itemValue, eventDetails);
            setOpen(false, eventDetails);
        }
    });
    var requestSubmit = useStableCallback(function() {
        var ref, ref1;
        if (!store.state.submitOnItemClick) return;
        var ref2;
        var formElement = (ref2 = (ref = validation.inputRef.current) === null || ref === void 0 ? void 0 : ref.form) !== null && ref2 !== void 0 ? ref2 : (ref1 = store.state.inputElement) === null || ref1 === void 0 ? void 0 : ref1.form;
        if (formElement && typeof formElement.requestSubmit === "function") formElement.requestSubmit();
    });
    var handleUnmount = useStableCallback(function() {
        setMounted(false);
        onOpenChangeComplete === null || onOpenChangeComplete === void 0 ? void 0 : onOpenChangeComplete(false);
        setQueryChangedAfterOpen(false);
        setCloseQuery(null);
        if (selectionMode === "none") setIndices({
            activeIndex: null,
            selectedIndex: null
        });
        else setIndices({
            activeIndex: null
        });
        if (multiple && inputRef.current && inputRef.current.value !== "" && !hadInputClearRef.current) setInputValue("", createChangeEventDetails(inputClear));
        if (single) if (store.state.inputInsidePopup) {
            if (inputRef.current && inputRef.current.value !== "") setInputValue("", createChangeEventDetails(inputClear));
        } else {
            var stringVal = stringifyAsLabel(selectedValue, itemToStringLabel);
            if (inputRef.current && inputRef.current.value !== stringVal) setInputValue(stringVal, createChangeEventDetails(stringVal === "" ? inputClear : none));
        }
    });
    var resolvedPopupRef = react.useMemo(function() {
        if (inline && positionerElement) return {
            current: positionerElement.closest('[role="dialog"]')
        };
        return popupRef;
    }, [
        inline,
        positionerElement
    ]);
    useOpenChangeComplete({
        enabled: !props.actionsRef,
        open: open,
        ref: resolvedPopupRef,
        onComplete: function onComplete() {
            if (!open) handleUnmount();
        }
    });
    react.useImperativeHandle(props.actionsRef, function() {
        return {
            unmount: handleUnmount
        };
    }, [
        handleUnmount
    ]);
    useIsoLayoutEffect(function syncSelectedIndex() {
        if (open || selectionMode === "none") return;
        var registry = items ? flatItems : allValuesRef.current;
        if (multiple) {
            var currentValue = Array.isArray(selectedValue) ? selectedValue : [];
            var lastValue = currentValue[currentValue.length - 1];
            var lastIndex = findItemIndex(registry, lastValue, isItemEqualToValue);
            setIndices({
                selectedIndex: lastIndex === -1 ? null : lastIndex
            });
        } else {
            var index = findItemIndex(registry, selectedValue, isItemEqualToValue);
            setIndices({
                selectedIndex: index === -1 ? null : index
            });
        }
    }, [
        open,
        selectedValue,
        items,
        selectionMode,
        flatItems,
        multiple,
        isItemEqualToValue,
        setIndices
    ]);
    useIsoLayoutEffect(function() {
        if (items) {
            valuesRef.current = flatFilteredItems;
            listRef.current.length = flatFilteredItems.length;
        }
    }, [
        items,
        flatFilteredItems
    ]);
    useIsoLayoutEffect(function() {
        var pendingHighlight = pendingQueryHighlightRef.current;
        if (pendingHighlight) {
            if (pendingHighlight.hasQuery) {
                if (autoHighlightMode) store.set("activeIndex", 0);
            } else if (autoHighlightMode === "always") store.set("activeIndex", 0);
            pendingQueryHighlightRef.current = null;
        }
        if (!open && !inline) return;
        var candidateItems = hasItems || hasFilteredItemsProp ? flatFilteredItems : valuesRef.current;
        var storeActiveIndex = store.state.activeIndex;
        if (storeActiveIndex == null) {
            if (autoHighlightMode === "always" && candidateItems.length > 0) {
                store.set("activeIndex", 0);
                return;
            }
            if (lastHighlightRef.current !== INITIAL_LAST_HIGHLIGHT) {
                lastHighlightRef.current = INITIAL_LAST_HIGHLIGHT;
                store.state.onItemHighlighted(void 0, createGenericEventDetails(none, void 0, {
                    index: -1
                }));
            }
            return;
        }
        if (storeActiveIndex >= candidateItems.length) {
            if (lastHighlightRef.current !== INITIAL_LAST_HIGHLIGHT) {
                lastHighlightRef.current = INITIAL_LAST_HIGHLIGHT;
                store.state.onItemHighlighted(void 0, createGenericEventDetails(none, void 0, {
                    index: -1
                }));
            }
            store.set("activeIndex", null);
            return;
        }
        var itemValue = candidateItems[storeActiveIndex];
        var previouslyHighlightedItemValue = lastHighlightRef.current.value;
        var isSameItem = previouslyHighlightedItemValue !== NO_ACTIVE_VALUE && compareItemEquality(itemValue, previouslyHighlightedItemValue, store.state.isItemEqualToValue);
        if (lastHighlightRef.current.index !== storeActiveIndex || !isSameItem) {
            lastHighlightRef.current = {
                value: itemValue,
                index: storeActiveIndex
            };
            store.state.onItemHighlighted(itemValue, createGenericEventDetails(none, void 0, {
                index: storeActiveIndex
            }));
        }
    }, [
        activeIndex,
        autoHighlightMode,
        hasFilteredItemsProp,
        hasItems,
        flatFilteredItems,
        inline,
        open,
        store
    ]);
    useIsoLayoutEffect(function() {
        if (selectionMode === "none") {
            setFilled(String(inputValue) !== "");
            return;
        }
        setFilled(multiple ? Array.isArray(selectedValue) && selectedValue.length > 0 : selectedValue != null);
    }, [
        setFilled,
        selectionMode,
        inputValue,
        selectedValue,
        multiple
    ]);
    react.useEffect(function() {
        if (hasItems && autoHighlightMode && flatFilteredItems.length === 0) setIndices({
            activeIndex: null
        });
    }, [
        hasItems,
        autoHighlightMode,
        flatFilteredItems.length,
        setIndices
    ]);
    useValueChanged(query, function() {
        if (!open || query === "" || query === String(initialDefaultInputValue)) return;
        setQueryChangedAfterOpen(true);
    });
    useValueChanged(selectedValue, function() {
        if (selectionMode === "none") return;
        clearErrors(name);
        setDirty(selectedValue !== validityData.initialValue);
        if (shouldValidateOnChange()) validation.commit(selectedValue);
        else validation.commit(selectedValue, true);
        if (single && !hasInputValue && !inputInsidePopup) {
            var nextInputValue = stringifyAsLabel(selectedValue, itemToStringLabel);
            if (inputValue !== nextInputValue) setInputValue(nextInputValue, createChangeEventDetails(none));
        }
    });
    useValueChanged(inputValue, function() {
        if (selectionMode !== "none") return;
        clearErrors(name);
        setDirty(inputValue !== validityData.initialValue);
        if (shouldValidateOnChange()) validation.commit(inputValue);
        else validation.commit(inputValue, true);
    });
    useValueChanged(items, function() {
        if (!single || hasInputValue || inputInsidePopup || queryChangedAfterOpen) return;
        var nextInputValue = stringifyAsLabel(selectedValue, itemToStringLabel);
        if (inputValue !== nextInputValue) setInputValue(nextInputValue, createChangeEventDetails(none));
    });
    var floatingRootContext = useFloatingRootContext({
        open: inline ? true : open,
        onOpenChange: setOpen,
        elements: {
            reference: inputInsidePopup ? triggerElement : inputElement,
            floating: positionerElement
        }
    });
    var ariaHasPopup;
    var ariaExpanded;
    if (!inline) {
        ariaHasPopup = grid ? "grid" : "listbox";
        ariaExpanded = open ? "true" : "false";
    }
    var ref8 = useInteractions([
        react.useMemo(function() {
            var isPlainInput = (inputElement === null || inputElement === void 0 ? void 0 : inputElement.tagName) === "INPUT";
            var shouldTreatAsInput = inputElement == null || isPlainInput;
            var shouldApplyAria = shouldTreatAsInput || open;
            var reference = shouldTreatAsInput ? {
                autoComplete: "off",
                spellCheck: "false",
                autoCorrect: "off",
                autoCapitalize: "none"
            } : {};
            if (shouldApplyAria) {
                reference.role = "combobox";
                reference["aria-expanded"] = ariaExpanded;
                reference["aria-haspopup"] = ariaHasPopup;
                reference["aria-controls"] = open ? listElement === null || listElement === void 0 ? void 0 : listElement.id : void 0;
                reference["aria-autocomplete"] = autoComplete;
            }
            return {
                reference: reference,
                floating: {
                    role: "presentation"
                }
            };
        }, [
            inputElement,
            open,
            ariaExpanded,
            ariaHasPopup,
            listElement === null || listElement === void 0 ? void 0 : listElement.id,
            autoComplete
        ]),
        useClick(floatingRootContext, {
            enabled: !readOnly && !disabled && openOnInputClick,
            event: "mousedown-only",
            toggle: false,
            touchOpenDelay: inputInsidePopup ? 0 : 100,
            reason: inputPress
        }),
        useDismiss(floatingRootContext, {
            enabled: !readOnly && !disabled && !inline,
            outsidePressEvent: {
                mouse: "sloppy",
                touch: "intentional"
            },
            bubbles: inline ? true : void 0,
            outsidePress: function outsidePress(event) {
                var target = getTarget(event);
                return !contains(triggerElement, target) && !contains(clearRef.current, target) && !contains(chipsContainerRef.current, target) && !contains(inputGroupElement, target);
            }
        }),
        useListNavigation(floatingRootContext, {
            enabled: !readOnly && !disabled,
            id: id,
            listRef: listRef,
            activeIndex: activeIndex,
            selectedIndex: selectedIndex,
            virtual: true,
            loopFocus: loopFocus,
            allowEscape: loopFocus && !autoHighlightMode,
            focusItemOnOpen: queryChangedAfterOpen || selectionMode === "none" && !autoHighlightMode ? false : "auto",
            focusItemOnHover: highlightItemOnHover,
            resetOnPointerLeave: !keepHighlight,
            cols: grid ? 2 : 1,
            orientation: grid ? "horizontal" : void 0,
            disabledIndices: EMPTY_ARRAY$1,
            onNavigate: function onNavigate(nextActiveIndex, event) {
                if (!event && !open || transitionStatus === "ending") return;
                if (!event) setIndices({
                    activeIndex: nextActiveIndex
                });
                else setIndices({
                    activeIndex: nextActiveIndex,
                    type: keyboardActiveRef.current ? "keyboard" : "pointer"
                });
            }
        })
    ]), getReferenceProps = ref8.getReferenceProps, getFloatingProps = ref8.getFloatingProps, getItemProps = ref8.getItemProps;
    useOnFirstRender(function() {
        store.update({
            inline: inlineProp,
            popupProps: getFloatingProps(),
            inputProps: getReferenceProps(),
            triggerProps: triggerProps,
            getItemProps: getItemProps,
            setOpen: setOpen,
            setInputValue: setInputValue,
            setSelectedValue: setSelectedValue,
            setIndices: setIndices,
            onItemHighlighted: onItemHighlighted,
            handleSelection: handleSelection,
            forceMount: forceMount,
            requestSubmit: requestSubmit
        });
    });
    useIsoLayoutEffect(function() {
        store.update({
            id: id,
            selectedValue: selectedValue,
            open: open,
            mounted: mounted,
            transitionStatus: transitionStatus,
            items: items,
            inline: inlineProp,
            popupProps: getFloatingProps(),
            inputProps: getReferenceProps(),
            triggerProps: triggerProps,
            openMethod: openMethod,
            getItemProps: getItemProps,
            selectionMode: selectionMode,
            name: name,
            form: form,
            disabled: disabled,
            readOnly: readOnly,
            required: required,
            grid: grid,
            isGrouped: isGrouped,
            virtualized: virtualized,
            onOpenChangeComplete: onOpenChangeComplete,
            openOnInputClick: openOnInputClick,
            itemToStringLabel: itemToStringLabel,
            modal: modal,
            autoHighlight: autoHighlightMode,
            isItemEqualToValue: isItemEqualToValue,
            submitOnItemClick: submitOnItemClick,
            hasInputValue: hasInputValue,
            requestSubmit: requestSubmit
        });
    }, [
        store,
        id,
        selectedValue,
        open,
        mounted,
        transitionStatus,
        items,
        getFloatingProps,
        getReferenceProps,
        getItemProps,
        openMethod,
        triggerProps,
        selectionMode,
        name,
        disabled,
        readOnly,
        required,
        validation,
        grid,
        isGrouped,
        virtualized,
        onOpenChangeComplete,
        openOnInputClick,
        itemToStringLabel,
        modal,
        isItemEqualToValue,
        submitOnItemClick,
        hasInputValue,
        inlineProp,
        requestSubmit,
        autoHighlightMode,
        form
    ]);
    var hiddenInputRef = useMergedRefs(inputRefProp, validation.inputRef);
    var itemsContextValue = react.useMemo(function() {
        return {
            query: query,
            hasItems: hasItems,
            filteredItems: filteredItems,
            flatFilteredItems: flatFilteredItems
        };
    }, [
        query,
        hasItems,
        filteredItems,
        flatFilteredItems
    ]);
    var serializedValue = react.useMemo(function() {
        if (Array.isArray(fieldRawValue)) return "";
        return stringifyAsValue(fieldRawValue, itemToStringValue);
    }, [
        fieldRawValue,
        itemToStringValue
    ]);
    var hasMultipleSelection = multiple && Array.isArray(selectedValue) && selectedValue.length > 0;
    var hiddenInputName = multiple || selectionMode === "none" ? void 0 : name;
    var hiddenInputs = react.useMemo(function() {
        if (!multiple || !Array.isArray(selectedValue) || !name) return null;
        return selectedValue.map(function(value) {
            var currentSerializedValue = stringifyAsValue(value, itemToStringValue);
            return /* @__PURE__ */ (0,jsx_runtime.jsx)("input", {
                type: "hidden",
                form: form,
                name: name,
                value: currentSerializedValue
            }, currentSerializedValue);
        });
    }, [
        multiple,
        selectedValue,
        form,
        name,
        itemToStringValue
    ]);
    var children = /* @__PURE__ */ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            props.children,
            /* @__PURE__ */ (0,jsx_runtime.jsx)("input", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validation.getInputValidationProps({
                onFocus: function onFocus() {
                    var ref;
                    if (inputInsidePopup) {
                        triggerElement === null || triggerElement === void 0 ? void 0 : triggerElement.focus();
                        return;
                    }
                    (ref = inputRef.current || triggerElement) === null || ref === void 0 ? void 0 : ref.focus();
                },
                onChange: function onChange(event) {
                    var handleChange = function handleChange() {
                        if (multiple) return;
                        if (selectionMode === "none") {
                            setDirty(nextValue !== validityData.initialValue);
                            setInputValue(nextValue, details);
                            if (shouldValidateOnChange()) validation.commit(nextValue);
                            return;
                        }
                        var matchingValue = valuesRef.current.find(function(v) {
                            if (stringifyAsValue(v, itemToStringValue).toLowerCase() === nextValue.toLowerCase()) return true;
                            if (stringifyAsLabel(v, itemToStringLabel).toLowerCase() === nextValue.toLowerCase()) return true;
                            return false;
                        });
                        if (matchingValue != null) {
                            setDirty(matchingValue !== validityData.initialValue);
                            setSelectedValue === null || setSelectedValue === void 0 ? void 0 : setSelectedValue(matchingValue, details);
                            if (shouldValidateOnChange()) validation.commit(matchingValue);
                        }
                    };
                    if (event.nativeEvent.defaultPrevented) return;
                    var nextValue = event.currentTarget.value;
                    var details = createChangeEventDetails(none, event.nativeEvent);
                    if (items) handleChange();
                    else {
                        forceMount();
                        queueMicrotask(handleChange);
                    }
                }
            })), {
                id: id && hiddenInputName == null ? "".concat(id, "-hidden-input") : void 0,
                form: form,
                name: hiddenInputName,
                autoComplete: formAutoComplete,
                disabled: disabled,
                required: required && !hasMultipleSelection,
                readOnly: readOnly,
                value: serializedValue,
                ref: hiddenInputRef,
                style: hiddenInputName ? visuallyHiddenInput : visuallyHidden,
                tabIndex: -1,
                "aria-hidden": true,
                suppressHydrationWarning: true
            })),
            hiddenInputs
        ]
    });
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(ComboboxRootContext.Provider, {
        value: store,
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(ComboboxFloatingContext.Provider, {
            value: floatingRootContext,
            children: /* @__PURE__ */ (0,jsx_runtime.jsx)(ComboboxDerivedItemsContext.Provider, {
                value: itemsContextValue,
                children: /* @__PURE__ */ (0,jsx_runtime.jsx)(ComboboxInputValueContext.Provider, {
                    value: inputValue,
                    children: children
                })
            })
        })
    });
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/combobox/root/ComboboxRoot.js
/**
* Groups all parts of the combobox.
* Doesn't render its own HTML element.
*
* Documentation: [Base UI Combobox](https://base-ui.com/react/components/combobox)
*/ function ComboboxRoot(props) {
    var _multiple = props.multiple, multiple = _multiple === void 0 ? false : _multiple, defaultValue = props.defaultValue, value = props.value, onValueChange = props.onValueChange, autoComplete = props.autoComplete, other = (0,src_object_without_properties/* default */.Z)(props, [
        "multiple",
        "defaultValue",
        "value",
        "onValueChange",
        "autoComplete"
    ]);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(AriaCombobox, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, other), {
        selectionMode: multiple ? "multiple" : "single",
        selectedValue: value,
        defaultSelectedValue: defaultValue,
        onSelectedValueChange: onValueChange,
        formAutoComplete: autoComplete
    }));
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/utils/useRegisteredLabelId.js
function useRegisteredLabelId(idProp, setLabelId) {
    var id = useBaseUiId(idProp);
    useIsoLayoutEffect(function() {
        setLabelId(id);
        return function() {
            setLabelId(void 0);
        };
    }, [
        id,
        setLabelId
    ]);
    return id;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/labelable-provider/useLabel.js
function useLabel() {
    var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var focusControl = function focusControl(event) {
        if (focusControlProp) {
            focusControlProp(event, resolvedControlId);
            return;
        }
        if (!resolvedControlId) return;
        var controlElement = ownerDocument(event.currentTarget).getElementById(resolvedControlId);
        if (isHTMLElement(controlElement)) focusElementWithVisible(controlElement);
    };
    var handleInteraction = function handleInteraction(event) {
        var ref;
        if ((ref = getTarget(event.nativeEvent)) === null || ref === void 0 ? void 0 : ref.closest("button,input,select,textarea")) return;
        if (!event.defaultPrevented && event.detail > 1) event.preventDefault();
        if (native) return;
        focusControl(event);
    };
    var idProp = params.id, fallbackControlId = params.fallbackControlId, _native = params.native, native = _native === void 0 ? false : _native, setLabelIdProp = params.setLabelId, focusControlProp = params.focusControl;
    var ref = useLabelableContext(), contextControlId = ref.controlId, setContextLabelId = ref.setLabelId;
    var id = useRegisteredLabelId(idProp, useStableCallback(function(nextLabelId) {
        setContextLabelId(nextLabelId);
        setLabelIdProp === null || setLabelIdProp === void 0 ? void 0 : setLabelIdProp(nextLabelId);
    }));
    var resolvedControlId = contextControlId !== null && contextControlId !== void 0 ? contextControlId : fallbackControlId;
    return native ? {
        id: id,
        htmlFor: resolvedControlId !== null && resolvedControlId !== void 0 ? resolvedControlId : void 0,
        onMouseDown: handleInteraction
    } : {
        id: id,
        onClick: handleInteraction,
        onPointerDown: function onPointerDown(event) {
            event.preventDefault();
        }
    };
}
function focusElementWithVisible(element) {
    element.focus({
        focusVisible: true
    });
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/utils/resolveAriaLabelledBy.js
function resolveAriaLabelledBy(fieldLabelId, localLabelId) {
    return fieldLabelId !== null && fieldLabelId !== void 0 ? fieldLabelId : localLabelId;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/utils/popupStateMapping.js
var CommonPopupDataAttributes = function(CommonPopupDataAttributes) {
    /**
	* Present when the popup is open.
	*/ CommonPopupDataAttributes["open"] = "data-open";
    /**
	* Present when the popup is closed.
	*/ CommonPopupDataAttributes["closed"] = "data-closed";
    /**
	* Present when the popup is animating in.
	*/ CommonPopupDataAttributes[CommonPopupDataAttributes["startingStyle"] = TransitionStatusDataAttributes.startingStyle] = "startingStyle";
    /**
	* Present when the popup is animating out.
	*/ CommonPopupDataAttributes[CommonPopupDataAttributes["endingStyle"] = TransitionStatusDataAttributes.endingStyle] = "endingStyle";
    /**
	* Present when the anchor is hidden.
	*/ CommonPopupDataAttributes["anchorHidden"] = "data-anchor-hidden";
    /**
	* Indicates which side the popup is positioned relative to the trigger.
	* @type { 'top' | 'bottom' | 'left' | 'right' | 'inline-end' | 'inline-start'}
	*/ CommonPopupDataAttributes["side"] = "data-side";
    /**
	* Indicates how the popup is aligned relative to specified side.
	* @type {'start' | 'center' | 'end'}
	*/ CommonPopupDataAttributes["align"] = "data-align";
    return CommonPopupDataAttributes;
}({});
var CommonTriggerDataAttributes = /* @__PURE__ */ function(CommonTriggerDataAttributes) {
    /**
	* Present when the popup is open.
	*/ CommonTriggerDataAttributes["popupOpen"] = "data-popup-open";
    /**
	* Present when a pressable trigger is pressed.
	*/ CommonTriggerDataAttributes["pressed"] = "data-pressed";
    return CommonTriggerDataAttributes;
}({});
var TRIGGER_HOOK = (0,src_define_property/* default */.Z)({}, CommonTriggerDataAttributes.popupOpen, "");
var _obj;
var PRESSABLE_TRIGGER_HOOK = (_obj = {}, (0,src_define_property/* default */.Z)(_obj, CommonTriggerDataAttributes.popupOpen, ""), (0,src_define_property/* default */.Z)(_obj, CommonTriggerDataAttributes.pressed, ""), _obj);
var POPUP_OPEN_HOOK = (0,src_define_property/* default */.Z)({}, CommonPopupDataAttributes.open, "");
var POPUP_CLOSED_HOOK = (0,src_define_property/* default */.Z)({}, CommonPopupDataAttributes.closed, "");
var ANCHOR_HIDDEN_HOOK = (0,src_define_property/* default */.Z)({}, CommonPopupDataAttributes.anchorHidden, "");
var triggerOpenStateMapping$1 = {
    open: function open(value) {
        if (value) return TRIGGER_HOOK;
        return null;
    }
};
var pressableTriggerOpenStateMapping = {
    open: function open(value) {
        if (value) return PRESSABLE_TRIGGER_HOOK;
        return null;
    }
};
var popupStateMapping = {
    open: function open(value) {
        if (value) return POPUP_OPEN_HOOK;
        return POPUP_CLOSED_HOOK;
    },
    anchorHidden: function anchorHidden(value) {
        if (value) return ANCHOR_HIDDEN_HOOK;
        return null;
    }
};
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/combobox/utils/stateAttributesMapping.js
var triggerStateAttributesMapping = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, pressableTriggerOpenStateMapping, fieldValidityMapping), {
    popupSide: function(side) {
        return side ? {
            "data-popup-side": side
        } : null;
    },
    listEmpty: function(empty) {
        return empty ? {
            "data-list-empty": ""
        } : null;
    }
});
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/combobox/chips/ComboboxChipsContext.js
var ComboboxChipsContext = /* @__PURE__ */ /*#__PURE__*/ react.createContext(void 0);
if (false) {}
function useComboboxChipsContext() {
    return react.useContext(ComboboxChipsContext);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/combobox/positioner/ComboboxPositionerContext.js
var ComboboxPositionerContext = /* @__PURE__ */ /*#__PURE__*/ react.createContext(void 0);
if (false) {}
function useComboboxPositionerContext(optional) {
    var context = react.useContext(ComboboxPositionerContext);
    if (context === void 0 && !optional) throw new Error( false ? 0 : formatErrorMessage(21));
    return context;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/direction-context/DirectionContext.js
/**
* @internal
*/ var DirectionContext = /* @__PURE__ */ /*#__PURE__*/ react.createContext(void 0);
if (false) {}
function useDirection() {
    var ref;
    var ref1;
    return (ref1 = (ref = react.useContext(DirectionContext)) === null || ref === void 0 ? void 0 : ref.direction) !== null && ref1 !== void 0 ? ref1 : "ltr";
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/combobox/utils/ComboboxInternalDismissButton.js
/**
* @internal
*/ var ComboboxInternalDismissButton = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function ComboboxInternalDismissButton(_, forwardedRef) {
    var store = useComboboxRootContext();
    var ref = useButton({
        native: false
    }), buttonRef = ref.buttonRef, getButtonProps = ref.getButtonProps;
    return /* @__PURE__ */ (0,jsx_runtime.jsx)("span", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        ref: useMergedRefs(forwardedRef, buttonRef)
    }, getButtonProps({
        onClick: useStableCallback(function(event) {
            store.state.setOpen(false, createChangeEventDetails(closePress, event.nativeEvent, event.currentTarget));
        })
    })), {
        "aria-label": "Dismiss",
        tabIndex: void 0,
        style: visuallyHiddenInput
    }));
});
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/combobox/input/ComboboxInput.js
/**
* A text input to search for items in the list.
* Renders an `<input>` element.
*
* Documentation: [Base UI Combobox](https://base-ui.com/react/components/combobox)
*/ var ComboboxInput = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function ComboboxInput(componentProps, forwardedRef) {
    var handleKeyDown = function handleKeyDown(event) {
        if (!comboboxChipsContext) return;
        var nextIndex;
        var highlightedChipIndex = comboboxChipsContext.highlightedChipIndex;
        var renderedChipsCount = comboboxChipsContext.chipsRef.current.length;
        if (highlightedChipIndex !== void 0) {
            if (event.key === "ArrowLeft") {
                event.preventDefault();
                if (highlightedChipIndex > 0) nextIndex = highlightedChipIndex - 1;
                else nextIndex = void 0;
            } else if (event.key === "ArrowRight") {
                event.preventDefault();
                if (highlightedChipIndex < renderedChipsCount - 1) nextIndex = highlightedChipIndex + 1;
                else nextIndex = void 0;
            } else if (event.key === "Backspace" || event.key === "Delete") {
                event.preventDefault();
                var computedNextIndex = highlightedChipIndex >= selectedValue.length - 1 ? selectedValue.length - 2 : highlightedChipIndex;
                nextIndex = computedNextIndex >= 0 ? computedNextIndex : void 0;
                store.state.setIndices({
                    activeIndex: null,
                    selectedIndex: null,
                    type: "keyboard"
                });
            }
            return nextIndex;
        }
        var _selectionStart;
        if (event.key === "ArrowLeft" && ((_selectionStart = event.currentTarget.selectionStart) !== null && _selectionStart !== void 0 ? _selectionStart : 0) === 0 && selectedValue.length > 0) {
            event.preventDefault();
            nextIndex = renderedChipsCount > 0 ? renderedChipsCount - 1 : void 0;
        } else if (event.key === "Backspace" && event.currentTarget.value === "" && selectedValue.length > 0) {
            store.state.setIndices({
                activeIndex: null,
                selectedIndex: null,
                type: "keyboard"
            });
            event.preventDefault();
        }
        return nextIndex;
    };
    var render = componentProps.render, className = componentProps.className, tmp = componentProps.disabled, disabledProp = tmp === void 0 ? false : tmp, idProp = componentProps.id, style = componentProps.style, elementProps = (0,src_object_without_properties/* default */.Z)(componentProps, [
        "render",
        "className",
        "disabled",
        "id",
        "style"
    ]);
    var ref = useFieldRootContext(), fieldState = ref.state, fieldDisabled = ref.disabled, setTouched = ref.setTouched, setFocused = ref.setFocused, validationMode = ref.validationMode, validation = ref.validation;
    var ref1 = useLabelableContext(), fieldLabelId = ref1.labelId;
    var comboboxChipsContext = useComboboxChipsContext();
    var positioning = useComboboxPositionerContext(true);
    var hasPositionerParent = Boolean(positioning);
    var store = useComboboxRootContext();
    var filteredItems = useComboboxDerivedItemsContext().filteredItems;
    var inputValue = useComboboxInputValueContext();
    var direction = useDirection();
    var required = useStore(store, selectors$2.required);
    var comboboxDisabled = useStore(store, selectors$2.disabled);
    var readOnly = useStore(store, selectors$2.readOnly);
    var name = useStore(store, selectors$2.name);
    var form = useStore(store, selectors$2.form);
    var selectionMode = useStore(store, selectors$2.selectionMode);
    var autoHighlightMode = useStore(store, selectors$2.autoHighlight);
    var inputProps = useStore(store, selectors$2.inputProps);
    var triggerProps = useStore(store, selectors$2.triggerProps);
    var open = useStore(store, selectors$2.open);
    var mounted = useStore(store, selectors$2.mounted);
    var selectedValue = useStore(store, selectors$2.selectedValue);
    var popupSideValue = useStore(store, selectors$2.popupSide);
    var positionerElement = useStore(store, selectors$2.positionerElement);
    var rootId = useStore(store, selectors$2.id);
    var inline = useStore(store, selectors$2.inline);
    var modal = useStore(store, selectors$2.modal);
    var autoHighlightEnabled = Boolean(autoHighlightMode);
    var popupSide = mounted && positionerElement ? popupSideValue : null;
    var disabled = fieldDisabled || comboboxDisabled || disabledProp;
    var listEmpty = filteredItems.length === 0;
    var isInsidePopup = hasPositionerParent || inline;
    var focusManagerModal = !isInsidePopup || modal;
    var id = useBaseUiId(idProp !== null && idProp !== void 0 ? idProp : !isInsidePopup ? rootId : void 0);
    var ariaLabelledBy = resolveAriaLabelledBy(fieldLabelId, void 0);
    var fieldStateForInput = hasPositionerParent ? DEFAULT_FIELD_STATE_ATTRIBUTES : fieldState;
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), composingValue = ref2[0], setComposingValue = ref2[1];
    var isComposingRef = react.useRef(false);
    var lastActiveIndexRef = react.useRef(null);
    var shouldRestoreActiveIndexRef = react.useRef(false);
    var setInputElement = useStableCallback(function(element) {
        var nextIsInsidePopup = hasPositionerParent || store.state.inline;
        if (nextIsInsidePopup && !store.state.hasInputValue) store.state.setInputValue("", createChangeEventDetails(none));
        store.update({
            inputElement: element,
            inputInsidePopup: nextIsInsidePopup
        });
    });
    var validationProps = hasPositionerParent || !validation ? elementProps : validation.getValidationProps(elementProps);
    var state = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, fieldStateForInput), {
        open: open,
        disabled: disabled,
        readOnly: readOnly,
        popupSide: popupSide,
        listEmpty: listEmpty
    });
    var _value, ref3;
    var element = useRenderElement("input", componentProps, {
        state: state,
        ref: [
            forwardedRef,
            store.state.inputRef,
            setInputElement
        ],
        props: [
            inputProps,
            triggerProps,
            (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                type: "text",
                value: (ref3 = (_value = componentProps.value) !== null && _value !== void 0 ? _value : composingValue) !== null && ref3 !== void 0 ? ref3 : inputValue,
                "aria-readonly": readOnly || void 0,
                "aria-required": required || void 0,
                "aria-labelledby": ariaLabelledBy,
                disabled: disabled,
                readOnly: readOnly,
                required: selectionMode === "none" ? required : void 0,
                form: form
            }, selectionMode === "none" && name && {
                name: name
            }), {
                id: id,
                onFocus: function onFocus() {
                    setFocused(true);
                    if (!inline || !shouldRestoreActiveIndexRef.current) return;
                    shouldRestoreActiveIndexRef.current = false;
                    var nextActiveIndex = lastActiveIndexRef.current;
                    if (nextActiveIndex == null || !Object.hasOwn(store.state.valuesRef.current, nextActiveIndex)) return;
                    store.state.setIndices({
                        activeIndex: nextActiveIndex
                    });
                },
                onBlur: function onBlur() {
                    setTouched(true);
                    setFocused(false);
                    var activeIndex = store.state.activeIndex;
                    if (inline && activeIndex !== null && autoHighlightMode !== "always") {
                        lastActiveIndexRef.current = activeIndex;
                        shouldRestoreActiveIndexRef.current = true;
                        store.state.setIndices({
                            activeIndex: null
                        });
                    }
                    if (validationMode === "onBlur") {
                        var valueToValidate = selectionMode === "none" ? inputValue : selectedValue;
                        validation.commit(valueToValidate);
                    }
                },
                onCompositionStart: function onCompositionStart(event) {
                    if (isAndroid) return;
                    isComposingRef.current = true;
                    setComposingValue(event.currentTarget.value);
                },
                onCompositionEnd: function onCompositionEnd(event) {
                    isComposingRef.current = false;
                    var next = event.currentTarget.value;
                    setComposingValue(null);
                    store.state.setInputValue(next, createChangeEventDetails(inputChange, event.nativeEvent));
                },
                onChange: function onChange(event) {
                    var inputType = event.nativeEvent.inputType;
                    var autofillLikeInput = !inputType || inputType === "insertReplacementText";
                    var shouldOpenOnInput = isComposingRef.current || !autofillLikeInput;
                    if (isComposingRef.current) {
                        var nextVal = event.currentTarget.value;
                        setComposingValue(nextVal);
                        if (nextVal === "" && !store.state.openOnInputClick && !store.state.inputInsidePopup) store.state.setOpen(false, createChangeEventDetails(inputClear, event.nativeEvent));
                        var trimmed = nextVal.trim();
                        var shouldMaintainHighlight = autoHighlightEnabled && trimmed !== "";
                        if (!readOnly && !disabled && trimmed) {
                            if (shouldOpenOnInput) {
                                store.state.setOpen(true, createChangeEventDetails(inputChange, event.nativeEvent));
                                if (!autoHighlightEnabled) store.state.setIndices({
                                    activeIndex: null,
                                    selectedIndex: null,
                                    type: store.state.keyboardActiveRef.current ? "keyboard" : "pointer"
                                });
                            }
                        }
                        if (open && store.state.activeIndex !== null && !shouldMaintainHighlight) store.state.setIndices({
                            activeIndex: null,
                            selectedIndex: null,
                            type: store.state.keyboardActiveRef.current ? "keyboard" : "pointer"
                        });
                        return;
                    }
                    store.state.setInputValue(event.currentTarget.value, createChangeEventDetails(inputChange, event.nativeEvent));
                    var empty = event.currentTarget.value === "";
                    var clearDetails = createChangeEventDetails(inputClear, event.nativeEvent);
                    if (empty && !store.state.inputInsidePopup) {
                        if (selectionMode === "single") store.state.setSelectedValue(null, clearDetails);
                        if (!store.state.openOnInputClick) store.state.setOpen(false, clearDetails);
                    }
                    var trimmed1 = event.currentTarget.value.trim();
                    if (!readOnly && !disabled && trimmed1) {
                        if (shouldOpenOnInput) {
                            store.state.setOpen(true, createChangeEventDetails(inputChange, event.nativeEvent));
                            if (!autoHighlightEnabled) store.state.setIndices({
                                activeIndex: null,
                                selectedIndex: null,
                                type: store.state.keyboardActiveRef.current ? "keyboard" : "pointer"
                            });
                        }
                    }
                    if (open && store.state.activeIndex !== null && !autoHighlightEnabled) store.state.setIndices({
                        activeIndex: null,
                        selectedIndex: null,
                        type: store.state.keyboardActiveRef.current ? "keyboard" : "pointer"
                    });
                },
                onKeyDown: function onKeyDown(event) {
                    var ref, ref1;
                    if (disabled || readOnly) return;
                    if (event.ctrlKey || event.shiftKey || event.altKey || event.metaKey) return;
                    store.state.keyboardActiveRef.current = true;
                    var input = event.currentTarget;
                    var scrollAmount = input.scrollWidth - input.clientWidth;
                    var _$isRTL = direction === "rtl";
                    if (event.key === "Home") {
                        stopEvent(event);
                        var cursor = isFirefox && _$isRTL ? input.value.length : 0;
                        input.setSelectionRange(cursor, cursor);
                        input.scrollLeft = 0;
                        return;
                    }
                    if (event.key === "End") {
                        stopEvent(event);
                        var cursor1 = isFirefox && _$isRTL ? 0 : input.value.length;
                        input.setSelectionRange(cursor1, cursor1);
                        input.scrollLeft = _$isRTL ? -scrollAmount : scrollAmount;
                        return;
                    }
                    if (!mounted && event.key === "Escape") {
                        var isClear = selectionMode === "multiple" && Array.isArray(selectedValue) ? selectedValue.length === 0 : selectedValue === null;
                        var details = createChangeEventDetails(escapeKey, event.nativeEvent);
                        var value = selectionMode === "multiple" ? [] : null;
                        store.state.setInputValue("", details);
                        store.state.setSelectedValue(value, details);
                        if (!isClear && !store.state.inline && !details.isPropagationAllowed) event.stopPropagation();
                        return;
                    }
                    if (comboboxChipsContext && event.key === "Backspace" && input.value === "" && comboboxChipsContext.highlightedChipIndex === void 0 && Array.isArray(selectedValue) && selectedValue.length > 0) {
                        var renderedChipsCount = comboboxChipsContext.chipsRef.current.length;
                        var removalIndex = renderedChipsCount > 0 ? renderedChipsCount - 1 : selectedValue.length - 1;
                        var newValue = selectedValue.filter(function(_, index) {
                            return index !== removalIndex;
                        });
                        store.state.setIndices({
                            activeIndex: null,
                            selectedIndex: null,
                            type: store.state.keyboardActiveRef.current ? "keyboard" : "pointer"
                        });
                        store.state.setSelectedValue(newValue, createChangeEventDetails(none, event.nativeEvent));
                        return;
                    }
                    var hadHighlightedChip = (comboboxChipsContext === null || comboboxChipsContext === void 0 ? void 0 : comboboxChipsContext.highlightedChipIndex) !== void 0;
                    var nextIndex = handleKeyDown(event);
                    comboboxChipsContext === null || comboboxChipsContext === void 0 ? void 0 : comboboxChipsContext.setHighlightedChipIndex(nextIndex);
                    if (nextIndex !== void 0) (ref = comboboxChipsContext === null || comboboxChipsContext === void 0 ? void 0 : comboboxChipsContext.chipsRef.current[nextIndex]) === null || ref === void 0 ? void 0 : ref.focus();
                    else if (hadHighlightedChip) (ref1 = store.state.inputRef.current) === null || ref1 === void 0 ? void 0 : ref1.focus();
                    if (event.which === 229) return;
                    if (event.key === "Enter" && open) {
                        var activeIndex = store.state.activeIndex;
                        var nativeEvent = event.nativeEvent;
                        if (activeIndex === null) {
                            if (inline) return;
                            store.state.setOpen(false, createChangeEventDetails(none, nativeEvent));
                            return;
                        }
                        stopEvent(event);
                        var listItem = store.state.listRef.current[activeIndex];
                        if (listItem) {
                            store.state.selectionEventRef.current = nativeEvent;
                            listItem.click();
                            store.state.selectionEventRef.current = null;
                        }
                    }
                },
                onPointerMove: function onPointerMove() {
                    store.state.keyboardActiveRef.current = false;
                },
                onPointerDown: function onPointerDown() {
                    store.state.keyboardActiveRef.current = false;
                }
            }),
            validationProps
        ],
        stateAttributesMapping: triggerStateAttributesMapping
    });
    return /* @__PURE__ */ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            open && focusManagerModal && /* @__PURE__ */ (0,jsx_runtime.jsx)(ComboboxInternalDismissButton, {
                ref: store.state.startDismissRef
            }),
            element
        ]
    });
});
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/utils/getPseudoElementBounds.js
function getPseudoElementBounds(element) {
    var elementRect = element.getBoundingClientRect();
    if (false) {}
    var win = getWindow(element);
    var beforeStyles = win.getComputedStyle(element, "::before");
    var afterStyles = win.getComputedStyle(element, "::after");
    if (!(beforeStyles.content !== "none" || afterStyles.content !== "none")) return elementRect;
    var beforeWidth = parseFloat(beforeStyles.width) || 0;
    var beforeHeight = parseFloat(beforeStyles.height) || 0;
    var afterWidth = parseFloat(afterStyles.width) || 0;
    var afterHeight = parseFloat(afterStyles.height) || 0;
    var totalWidth = Math.max(elementRect.width, beforeWidth, afterWidth);
    var totalHeight = Math.max(elementRect.height, beforeHeight, afterHeight);
    var widthDiff = totalWidth - elementRect.width;
    var heightDiff = totalHeight - elementRect.height;
    return {
        left: elementRect.left - widthDiff / 2,
        right: elementRect.right + widthDiff / 2,
        top: elementRect.top - heightDiff / 2,
        bottom: elementRect.bottom + heightDiff / 2
    };
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/combobox/trigger/ComboboxTrigger.js
var BOUNDARY_OFFSET = 2;
/**
* A button that opens the popup.
* Renders a `<button>` element.
*
* Documentation: [Base UI Combobox](https://base-ui.com/react/components/combobox)
*/ var ComboboxTrigger = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function ComboboxTrigger(componentProps, forwardedRef) {
    var trackPointerType = function trackPointerType(event) {
        currentPointerTypeRef.current = event.pointerType;
    };
    var render = componentProps.render, className = componentProps.className, _nativeButton = componentProps.nativeButton, nativeButton = _nativeButton === void 0 ? true : _nativeButton, tmp = componentProps.disabled, disabledProp = tmp === void 0 ? false : tmp, idProp = componentProps.id, style = componentProps.style, elementProps = (0,src_object_without_properties/* default */.Z)(componentProps, [
        "render",
        "className",
        "nativeButton",
        "disabled",
        "id",
        "style"
    ]);
    var ref = useFieldRootContext(), fieldState = ref.state, fieldDisabled = ref.disabled, setTouched = ref.setTouched, setFocused = ref.setFocused, validationMode = ref.validationMode, validation = ref.validation;
    var ref1 = useLabelableContext(), fieldLabelId = ref1.labelId;
    var store = useComboboxRootContext();
    var filteredItems = useComboboxDerivedItemsContext().filteredItems;
    var selectionMode = useStore(store, selectors$2.selectionMode);
    var comboboxDisabled = useStore(store, selectors$2.disabled);
    var readOnly = useStore(store, selectors$2.readOnly);
    var required = useStore(store, selectors$2.required);
    var mounted = useStore(store, selectors$2.mounted);
    var popupSideValue = useStore(store, selectors$2.popupSide);
    var positionerElement = useStore(store, selectors$2.positionerElement);
    var listElement = useStore(store, selectors$2.listElement);
    var triggerProps = useStore(store, selectors$2.triggerProps);
    var triggerElement = useStore(store, selectors$2.triggerElement);
    var inputInsidePopup = useStore(store, selectors$2.inputInsidePopup);
    var rootId = useStore(store, selectors$2.id);
    var comboboxLabelId = useStore(store, selectors$2.labelId);
    var open = useStore(store, selectors$2.open);
    var selectedValue = useStore(store, selectors$2.selectedValue);
    var activeIndex = useStore(store, selectors$2.activeIndex);
    var selectedIndex = useStore(store, selectors$2.selectedIndex);
    var hasSelectedValue = useStore(store, selectors$2.hasSelectedValue);
    var floatingRootContext = useComboboxFloatingContext();
    var inputValue = useComboboxInputValueContext();
    var focusTimeout = useTimeout();
    var disabled = fieldDisabled || comboboxDisabled || disabledProp;
    var listEmpty = filteredItems.length === 0;
    var popupSide = mounted && positionerElement ? popupSideValue : null;
    useLabelableId({
        id: inputInsidePopup ? idProp : void 0
    });
    var id = inputInsidePopup ? idProp !== null && idProp !== void 0 ? idProp : rootId : idProp;
    var ariaLabelledBy = resolveAriaLabelledBy(fieldLabelId, comboboxLabelId);
    var currentPointerTypeRef = react.useRef("");
    var domReference = floatingRootContext.useState("domReferenceElement");
    react.useEffect(function() {
        if (!inputInsidePopup) return;
        if (triggerElement && triggerElement !== domReference) floatingRootContext.set("domReferenceElement", triggerElement);
    }, [
        triggerElement,
        domReference,
        floatingRootContext,
        inputInsidePopup
    ]);
    var ref2 = useTypeahead(floatingRootContext, {
        enabled: !open && !readOnly && !comboboxDisabled && selectionMode === "single",
        listRef: store.state.labelsRef,
        activeIndex: activeIndex,
        selectedIndex: selectedIndex,
        onMatch: function onMatch(index) {
            var nextSelectedValue = store.state.valuesRef.current[index];
            if (nextSelectedValue !== void 0) store.state.setSelectedValue(nextSelectedValue, createChangeEventDetails("none"));
        }
    }), triggerTypeaheadProps = ref2.reference;
    var ref3 = useClick(floatingRootContext, {
        enabled: !readOnly && !comboboxDisabled,
        event: "mousedown"
    }), triggerClickProps = ref3.reference;
    var ref4 = useButton({
        native: nativeButton,
        disabled: disabled
    }), buttonRef = ref4.buttonRef, getButtonProps = ref4.getButtonProps;
    var state = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, fieldState), {
        open: open,
        disabled: disabled,
        popupSide: popupSide,
        listEmpty: listEmpty,
        placeholder: selectionMode === "none" ? false : !hasSelectedValue
    });
    return useRenderElement("button", componentProps, {
        ref: [
            forwardedRef,
            buttonRef,
            useStableCallback(function(element) {
                store.set("triggerElement", element);
            })
        ],
        state: state,
        props: [
            triggerProps,
            triggerClickProps,
            triggerTypeaheadProps,
            {
                id: id,
                tabIndex: inputInsidePopup ? 0 : -1,
                role: inputInsidePopup ? "combobox" : void 0,
                "aria-expanded": open ? "true" : "false",
                "aria-haspopup": inputInsidePopup ? "dialog" : "listbox",
                "aria-controls": open ? listElement === null || listElement === void 0 ? void 0 : listElement.id : void 0,
                "aria-required": inputInsidePopup ? required || void 0 : void 0,
                "aria-labelledby": ariaLabelledBy,
                onPointerDown: trackPointerType,
                onPointerEnter: trackPointerType,
                onFocus: function onFocus() {
                    setFocused(true);
                    if (disabled || readOnly) return;
                    focusTimeout.start(0, store.state.forceMount);
                },
                onBlur: function onBlur(event) {
                    if (contains(positionerElement, event.relatedTarget)) return;
                    setTouched(true);
                    setFocused(false);
                    if (validationMode === "onBlur") {
                        var valueToValidate = selectionMode === "none" ? inputValue : selectedValue;
                        validation.commit(valueToValidate);
                    }
                },
                onMouseDown: function onMouseDown(event) {
                    var handleMouseUp = function handleMouseUp(mouseEvent) {
                        if (!triggerElement) return;
                        var mouseUpTarget = getTarget(mouseEvent);
                        var positioner = store.state.positionerElement;
                        var list = store.state.listElement;
                        if (contains(triggerElement, mouseUpTarget) || contains(positioner, mouseUpTarget) || contains(list, mouseUpTarget) || mouseUpTarget === triggerElement) return;
                        var bounds = getPseudoElementBounds(triggerElement);
                        var withinHorizontal = mouseEvent.clientX >= bounds.left - BOUNDARY_OFFSET && mouseEvent.clientX <= bounds.right + BOUNDARY_OFFSET;
                        var withinVertical = mouseEvent.clientY >= bounds.top - BOUNDARY_OFFSET && mouseEvent.clientY <= bounds.bottom + BOUNDARY_OFFSET;
                        if (withinHorizontal && withinVertical) return;
                        store.state.setOpen(false, createChangeEventDetails("cancel-open", mouseEvent));
                    };
                    if (disabled || readOnly) return;
                    if (!inputInsidePopup) floatingRootContext.set("domReferenceElement", event.currentTarget);
                    store.state.forceMount();
                    if (currentPointerTypeRef.current !== "touch") {
                        var ref;
                        (ref = store.state.inputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
                        if (!inputInsidePopup) event.preventDefault();
                    }
                    if (open) return;
                    var doc = ownerDocument(event.currentTarget);
                    if (inputInsidePopup) doc.addEventListener("mouseup", handleMouseUp, {
                        once: true
                    });
                },
                onKeyDown: function onKeyDown(event) {
                    if (disabled || readOnly) return;
                    if (event.key === "ArrowDown" || event.key === "ArrowUp") {
                        var ref;
                        stopEvent(event);
                        store.state.setOpen(true, createChangeEventDetails(listNavigation, event.nativeEvent));
                        (ref = store.state.inputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
                    }
                }
            },
            validation ? validation.getValidationProps(elementProps) : elementProps,
            getButtonProps
        ],
        stateAttributesMapping: triggerStateAttributesMapping
    });
});
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/combobox/collection/GroupCollectionContext.js
var GroupCollectionContext = /* @__PURE__ */ /*#__PURE__*/ react.createContext(null);
if (false) {}
function useGroupCollectionContext() {
    return react.useContext(GroupCollectionContext);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/combobox/collection/ComboboxCollection.js
/**
* Renders filtered list items.
* Doesn't render its own HTML element.
*
* If rendering a flat list, pass a function child to the `List` component instead, which implicitly wraps it.
*
* Documentation: [Base UI Combobox](https://base-ui.com/react/components/combobox)
*/ function ComboboxCollection(props) {
    var children = props.children;
    var filteredItems = useComboboxDerivedItemsContext().filteredItems;
    var groupContext = useGroupCollectionContext();
    var itemsToRender = groupContext ? groupContext.items : filteredItems;
    if (!itemsToRender) return null;
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(react.Fragment, {
        children: itemsToRender.map(children)
    });
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/composite/list/CompositeListContext.js
var CompositeListContext = /* @__PURE__ */ /*#__PURE__*/ react.createContext({
    register: function() {},
    unregister: function() {},
    subscribeMapChange: function() {
        return function() {};
    },
    elementsRef: {
        current: []
    },
    nextIndexRef: {
        current: 0
    }
});
if (false) {}
function useCompositeListContext() {
    return react.useContext(CompositeListContext);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/composite/list/CompositeList.js
/**
* Provides context for a list of items in a composite component.
* @internal
*/ function CompositeList(props) {
    var children = props.children, elementsRef = props.elementsRef, labelsRef = props.labelsRef, onMapChangeProp = props.onMapChange;
    var onMapChange = useStableCallback(onMapChangeProp);
    var nextIndexRef = react.useRef(0);
    var listeners = useRefWithInit(createListeners).current;
    var map = useRefWithInit(createMap).current;
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(0), 2), mapTick = ref[0], setMapTick = ref[1];
    var lastTickRef = react.useRef(mapTick);
    var _$register = useStableCallback(function(node, metadata) {
        map.set(node, metadata !== null && metadata !== void 0 ? metadata : null);
        lastTickRef.current += 1;
        setMapTick(lastTickRef.current);
    });
    var unregister = useStableCallback(function(node) {
        map.delete(node);
        lastTickRef.current += 1;
        setMapTick(lastTickRef.current);
    });
    var sortedMap = react.useMemo(function() {
        var newMap = /* @__PURE__ */ new Map();
        Array.from(map.keys()).filter(function(node) {
            return node.isConnected;
        }).sort(sortByDocumentPosition).forEach(function(node, index) {
            var ref;
            var metadata = (ref = map.get(node)) !== null && ref !== void 0 ? ref : {};
            newMap.set(node, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, metadata), {
                index: index
            }));
        });
        return newMap;
    }, [
        map,
        mapTick
    ]);
    useIsoLayoutEffect(function() {
        if (typeof MutationObserver !== "function" || sortedMap.size === 0) return;
        var mutationObserver = new MutationObserver(function(entries) {
            var diff = /* @__PURE__ */ new Set();
            var updateDiff = function(node) {
                return diff.has(node) ? diff.delete(node) : diff.add(node);
            };
            entries.forEach(function(entry) {
                entry.removedNodes.forEach(updateDiff);
                entry.addedNodes.forEach(updateDiff);
            });
            if (diff.size === 0) {
                lastTickRef.current += 1;
                setMapTick(lastTickRef.current);
            }
        });
        sortedMap.forEach(function(_, node) {
            if (node.parentElement) mutationObserver.observe(node.parentElement, {
                childList: true
            });
        });
        return function() {
            mutationObserver.disconnect();
        };
    }, [
        sortedMap
    ]);
    useIsoLayoutEffect(function() {
        if (lastTickRef.current === mapTick) {
            if (elementsRef.current.length !== sortedMap.size) elementsRef.current.length = sortedMap.size;
            if (labelsRef && labelsRef.current.length !== sortedMap.size) labelsRef.current.length = sortedMap.size;
            nextIndexRef.current = sortedMap.size;
        }
        onMapChange(sortedMap);
    }, [
        onMapChange,
        sortedMap,
        elementsRef,
        labelsRef,
        mapTick
    ]);
    useIsoLayoutEffect(function() {
        return function() {
            elementsRef.current = [];
        };
    }, [
        elementsRef
    ]);
    useIsoLayoutEffect(function() {
        return function() {
            if (labelsRef) labelsRef.current = [];
        };
    }, [
        labelsRef
    ]);
    var subscribeMapChange = useStableCallback(function(fn) {
        listeners.add(fn);
        return function() {
            listeners.delete(fn);
        };
    });
    useIsoLayoutEffect(function() {
        listeners.forEach(function(l) {
            return l(sortedMap);
        });
    }, [
        listeners,
        sortedMap
    ]);
    var contextValue = react.useMemo(function() {
        return {
            register: _$register,
            unregister: unregister,
            subscribeMapChange: subscribeMapChange,
            elementsRef: elementsRef,
            labelsRef: labelsRef,
            nextIndexRef: nextIndexRef
        };
    }, [
        _$register,
        unregister,
        subscribeMapChange,
        elementsRef,
        labelsRef,
        nextIndexRef
    ]);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(CompositeListContext.Provider, {
        value: contextValue,
        children: children
    });
}
function createMap() {
    return /* @__PURE__ */ new Map();
}
function createListeners() {
    return /* @__PURE__ */ new Set();
}
function sortByDocumentPosition(a, b) {
    var position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/combobox/list/ComboboxList.js
/**
* A list container for the items.
* Renders a `<div>` element.
*
* Documentation: [Base UI Combobox](https://base-ui.com/react/components/combobox)
*/ var ComboboxList = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function ComboboxList(componentProps, forwardedRef) {
    var _ComboboxCollection;
    var render = componentProps.render, className = componentProps.className, style = componentProps.style, children = componentProps.children, elementProps = (0,src_object_without_properties/* default */.Z)(componentProps, [
        "render",
        "className",
        "style",
        "children"
    ]);
    var store = useComboboxRootContext();
    var floatingRootContext = useComboboxFloatingContext();
    var hasPositionerContext = Boolean(useComboboxPositionerContext(true));
    var ref = useComboboxDerivedItemsContext(), filteredItems = ref.filteredItems, hasItems = ref.hasItems;
    var selectionMode = useStore(store, selectors$2.selectionMode);
    var grid = useStore(store, selectors$2.grid);
    var popupProps = useStore(store, selectors$2.popupProps);
    var virtualized = useStore(store, selectors$2.virtualized);
    var multiple = selectionMode === "multiple";
    var empty = filteredItems.length === 0;
    var setPositionerElement = useStableCallback(function(element) {
        store.set("positionerElement", element);
    });
    var setListElement = useStableCallback(function(element) {
        store.set("listElement", element);
    });
    var resolvedChildren = react.useMemo(function() {
        if (typeof children === "function") return _ComboboxCollection || (_ComboboxCollection = /* @__PURE__ */ (0,jsx_runtime.jsx)(ComboboxCollection, {
            children: children
        }));
        return children;
    }, [
        children
    ]);
    var state = {
        empty: empty
    };
    var floatingId = floatingRootContext.useState("floatingId");
    var element = useRenderElement("div", componentProps, {
        state: state,
        ref: [
            forwardedRef,
            setListElement,
            hasPositionerContext ? null : setPositionerElement
        ],
        props: [
            popupProps,
            {
                children: resolvedChildren,
                tabIndex: -1,
                id: floatingId,
                role: grid ? "grid" : "listbox",
                "aria-multiselectable": multiple ? "true" : void 0,
                onKeyDown: function onKeyDown(event) {
                    if (store.state.disabled || store.state.readOnly) return;
                    if (event.key === "Enter") {
                        var activeIndex = store.state.activeIndex;
                        if (activeIndex == null) return;
                        stopEvent(event);
                        var nativeEvent = event.nativeEvent;
                        var listItem = store.state.listRef.current[activeIndex];
                        if (listItem) {
                            store.state.selectionEventRef.current = nativeEvent;
                            listItem.click();
                            store.state.selectionEventRef.current = null;
                        }
                    }
                },
                onKeyDownCapture: function onKeyDownCapture() {
                    store.state.keyboardActiveRef.current = true;
                },
                onPointerMoveCapture: function onPointerMoveCapture() {
                    store.state.keyboardActiveRef.current = false;
                }
            },
            elementProps
        ]
    });
    if (virtualized) return element;
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(CompositeList, {
        elementsRef: store.state.listRef,
        labelsRef: hasItems ? void 0 : store.state.labelsRef,
        children: element
    });
});
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/combobox/utils/useInitialLiveRegionTextMutation.js
var LIVE_REGION_MARKER = "⁠";
function findLastTextNode(root) {
    var walker = root.ownerDocument.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var lastTextNode = null;
    while(walker.nextNode()){
        var textNode = walker.currentNode;
        if (textNode.nodeValue !== "") lastTextNode = textNode;
    }
    return lastTextNode;
}
function useInitialLiveRegionTextMutation() {
    var timeout = useTimeout();
    var rootRef = react.useRef(null);
    react.useEffect(function() {
        if (isIOS) return;
        var root = rootRef.current;
        if (root == null) return;
        var textNode = findLastTextNode(root);
        if (textNode == null) return;
        var _nodeValue;
        var originalValue = (_nodeValue = textNode.nodeValue) !== null && _nodeValue !== void 0 ? _nodeValue : "";
        var markedValue = "".concat(originalValue).concat(LIVE_REGION_MARKER);
        textNode.nodeValue = markedValue;
        timeout.start(200, function() {
            if (textNode.nodeValue === markedValue) textNode.nodeValue = originalValue;
        });
        return function() {
            timeout.clear();
            if (textNode.nodeValue === markedValue) textNode.nodeValue = originalValue;
        };
    }, [
        rootRef,
        timeout
    ]);
    return rootRef;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/combobox/portal/ComboboxPortalContext.js
var ComboboxPortalContext = /* @__PURE__ */ /*#__PURE__*/ react.createContext(void 0);
if (false) {}
function useComboboxPortalContext() {
    var context = react.useContext(ComboboxPortalContext);
    if (context === void 0) throw new Error( false ? 0 : formatErrorMessage(20));
    return context;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/combobox/portal/ComboboxPortal.js
/**
* A portal element that moves the popup to a different part of the DOM.
* By default, the portal element is appended to `<body>`.
* Renders a `<div>` element.
*
* Documentation: [Base UI Combobox](https://base-ui.com/react/components/combobox)
*/ var ComboboxPortal = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function ComboboxPortal(props, forwardedRef) {
    var _keepMounted = props.keepMounted, keepMounted = _keepMounted === void 0 ? false : _keepMounted, portalProps = (0,src_object_without_properties/* default */.Z)(props, [
        "keepMounted"
    ]);
    var store = useComboboxRootContext();
    var mounted = useStore(store, selectors$2.mounted);
    var forceMounted = useStore(store, selectors$2.forceMounted);
    if (!(mounted || keepMounted || forceMounted)) return null;
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(ComboboxPortalContext.Provider, {
        value: keepMounted,
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(FloatingPortal, (0,src_object_spread/* default */.Z)({
            ref: forwardedRef
        }, portalProps))
    });
});
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/inertValue.js
function inertValue(value) {
    if (isReactVersionAtLeast(19)) return value;
    return value ? "true" : void 0;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/floating-ui-react/middleware/arrow.js
/**
* Fork of the original `arrow` middleware from Floating UI that allows
* configuring the offset parent.
*/ var baseArrow = function(options) {
    return {
        name: "arrow",
        options: options,
        fn: function fn(state) {
            return (0,_async_to_generator/* default */.Z)(function() {
                var ref, ref1, x, y, placement, rects, platform, elements, middlewareData, ref2, element, _padding, padding, _offsetParent, offsetParent, paddingObject, coords, axis, length, arrowDimensions, isYAxis, minProp, maxProp, clientProp, endDiff, startDiff, arrowOffsetParent, _tmp, clientSize, _tmp1, centerToReference, largestPossiblePadding, minPadding, maxPadding, min, max, center, offset, shouldAddOffset, alignmentOffset, _obj, _obj1;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            x = state.x, y = state.y, placement = state.placement, rects = state.rects, platform = state.platform, elements = state.elements, middlewareData = state.middlewareData;
                            ref2 = evaluate(options, state) || {}, element = ref2.element, _padding = ref2.padding, padding = _padding === void 0 ? 0 : _padding, _offsetParent = ref2.offsetParent, offsetParent = _offsetParent === void 0 ? "real" : _offsetParent;
                            if (element == null) return [
                                2,
                                {}
                            ];
                            paddingObject = getPaddingObject(padding);
                            coords = {
                                x: x,
                                y: y
                            };
                            axis = getAlignmentAxis(placement);
                            length = getAxisLength(axis);
                            return [
                                4,
                                platform.getDimensions(element)
                            ];
                        case 1:
                            arrowDimensions = _state.sent();
                            isYAxis = axis === "y";
                            minProp = isYAxis ? "top" : "left";
                            maxProp = isYAxis ? "bottom" : "right";
                            clientProp = isYAxis ? "clientHeight" : "clientWidth";
                            endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
                            startDiff = coords[axis] - rects.reference[axis];
                            if (!(offsetParent === "real")) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                (ref = platform.getOffsetParent) === null || ref === void 0 ? void 0 : ref.call(platform, element)
                            ];
                        case 2:
                            _tmp = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            _tmp = elements.floating;
                            _state.label = 4;
                        case 4:
                            arrowOffsetParent = _tmp;
                            clientSize = elements.floating[clientProp] || rects.floating[length];
                            _tmp1 = !clientSize;
                            if (_tmp1) return [
                                3,
                                6
                            ];
                            return [
                                4,
                                (ref1 = platform.isElement) === null || ref1 === void 0 ? void 0 : ref1.call(platform, arrowOffsetParent)
                            ];
                        case 5:
                            _tmp1 = !_state.sent();
                            _state.label = 6;
                        case 6:
                            if (_tmp1) clientSize = elements.floating[clientProp] || rects.floating[length];
                            centerToReference = endDiff / 2 - startDiff / 2;
                            largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
                            minPadding = Math.min(paddingObject[minProp], largestPossiblePadding);
                            maxPadding = Math.min(paddingObject[maxProp], largestPossiblePadding);
                            min = minPadding;
                            max = clientSize - arrowDimensions[length] - maxPadding;
                            center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
                            offset = clamp$1(min, center, max);
                            shouldAddOffset = !middlewareData.arrow && getAlignment(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
                            alignmentOffset = shouldAddOffset ? center < min ? center - min : center - max : 0;
                            return [
                                2,
                                (_obj1 = {}, (0,src_define_property/* default */.Z)(_obj1, axis, coords[axis] + alignmentOffset), (0,src_define_property/* default */.Z)(_obj1, "data", (0,src_object_spread/* default */.Z)((_obj = {}, (0,src_define_property/* default */.Z)(_obj, axis, offset), (0,src_define_property/* default */.Z)(_obj, "centerOffset", center - offset - alignmentOffset), _obj), shouldAddOffset && {
                                    alignmentOffset: alignmentOffset
                                })), (0,src_define_property/* default */.Z)(_obj1, "reset", shouldAddOffset), _obj1)
                            ];
                    }
                });
            })();
        }
    };
};
/**
* Provides data to position an inner element of the floating element so that it
* appears centered to the reference element.
* This wraps the core `arrow` middleware to allow React refs as the element.
* @see https://floating-ui.com/docs/arrow
*/ var arrow = function(options, deps) {
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, baseArrow(options)), {
        options: [
            options,
            deps
        ]
    });
};
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/utils/hideMiddleware.js
var hide = {
    name: "hide",
    fn: function fn(state) {
        return (0,_async_to_generator/* default */.Z)(function() {
            var ref, _reference, width, height, x, y, anchorHidden, _tmp, _tmp1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _reference = state.rects.reference, width = _reference.width, height = _reference.height, x = _reference.x, y = _reference.y;
                        anchorHidden = width === 0 && height === 0 && x === 0 && y === 0;
                        _tmp = {};
                        _tmp1 = {};
                        return [
                            4,
                            hide$1().fn(state)
                        ];
                    case 1:
                        return [
                            2,
                            (_tmp.data = (_tmp1.referenceHidden = ((ref = _state.sent().data) === null || ref === void 0 ? void 0 : ref.referenceHidden) || anchorHidden, _tmp1), _tmp)
                        ];
                }
            });
        })();
    }
};
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/utils/adaptiveOriginMiddleware.js
var DEFAULT_SIDES = {
    sideX: "left",
    sideY: "top"
};
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/utils/useAnchorPositioning.js
function getLogicalSide(sideParam, renderedSide, isRtl) {
    var isLogicalSideParam = sideParam === "inline-start" || sideParam === "inline-end";
    return ({
        top: "top",
        right: isLogicalSideParam ? isRtl ? "inline-start" : "inline-end" : "right",
        bottom: "bottom",
        left: isLogicalSideParam ? isRtl ? "inline-end" : "inline-start" : "left"
    })[renderedSide];
}
function getOffsetData(state, sideParam, isRtl) {
    var rects = state.rects, placement = state.placement;
    return {
        side: getLogicalSide(sideParam, getSide(placement), isRtl),
        align: getAlignment(placement) || "center",
        anchor: {
            width: rects.reference.width,
            height: rects.reference.height
        },
        positioner: {
            width: rects.floating.width,
            height: rects.floating.height
        }
    };
}
/**
* Provides standardized anchor positioning behavior for floating elements. Wraps Floating UI's
* `useFloating` hook.
*/ function useAnchorPositioning(params) {
    var ref, ref1;
    var anchor = params.anchor, _positionMethod = params.positionMethod, positionMethod = _positionMethod === void 0 ? "absolute" : _positionMethod, tmp = params.side, sideParam = tmp === void 0 ? "bottom" : tmp, _sideOffset = params.sideOffset, sideOffset = _sideOffset === void 0 ? 0 : _sideOffset, _align = params.align, align = _align === void 0 ? "center" : _align, _alignOffset = params.alignOffset, alignOffset = _alignOffset === void 0 ? 0 : _alignOffset, collisionBoundary = params.collisionBoundary, tmp1 = params.collisionPadding, collisionPaddingParam = tmp1 === void 0 ? 5 : tmp1, _sticky = params.sticky, sticky = _sticky === void 0 ? false : _sticky, _arrowPadding = params.arrowPadding, arrowPadding = _arrowPadding === void 0 ? 5 : _arrowPadding, _disableAnchorTracking = params.disableAnchorTracking, disableAnchorTracking = _disableAnchorTracking === void 0 ? false : _disableAnchorTracking, _keepMounted = params.keepMounted, keepMounted = _keepMounted === void 0 ? false : _keepMounted, floatingRootContext = params.floatingRootContext, mounted = params.mounted, collisionAvoidance = params.collisionAvoidance, _shiftCrossAxis = params.shiftCrossAxis, shiftCrossAxis = _shiftCrossAxis === void 0 ? false : _shiftCrossAxis, nodeId = params.nodeId, adaptiveOrigin = params.adaptiveOrigin, _lazyFlip = params.lazyFlip, lazyFlip = _lazyFlip === void 0 ? false : _lazyFlip, externalTree = params.externalTree;
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), mountSide = ref2[0], setMountSide = ref2[1];
    if (!mounted && mountSide !== null) setMountSide(null);
    var collisionAvoidanceSide = collisionAvoidance.side || "flip";
    var collisionAvoidanceAlign = collisionAvoidance.align || "flip";
    var collisionAvoidanceFallbackAxisSide = collisionAvoidance.fallbackAxisSide || "end";
    var anchorFn = typeof anchor === "function" ? anchor : void 0;
    var anchorFnCallback = useStableCallback(anchorFn);
    var anchorDep = anchorFn ? anchorFnCallback : anchor;
    var anchorValueRef = useValueAsRef(anchor);
    var mountedRef = useValueAsRef(mounted);
    var isRtl = useDirection() === "rtl";
    var side = mountSide || ({
        top: "top",
        right: "right",
        bottom: "bottom",
        left: "left",
        "inline-end": isRtl ? "left" : "right",
        "inline-start": isRtl ? "right" : "left"
    })[sideParam];
    var placement = align === "center" ? side : "".concat(side, "-").concat(align);
    var collisionPadding = collisionPaddingParam;
    var bias = 1;
    var biasTop = sideParam === "bottom" ? bias : 0;
    var biasBottom = sideParam === "top" ? bias : 0;
    var biasLeft = sideParam === "right" ? bias : 0;
    var biasRight = sideParam === "left" ? bias : 0;
    if (typeof collisionPadding === "number") collisionPadding = {
        top: collisionPadding + biasTop,
        right: collisionPadding + biasRight,
        bottom: collisionPadding + biasBottom,
        left: collisionPadding + biasLeft
    };
    else if (collisionPadding) collisionPadding = {
        top: (collisionPadding.top || 0) + biasTop,
        right: (collisionPadding.right || 0) + biasRight,
        bottom: (collisionPadding.bottom || 0) + biasBottom,
        left: (collisionPadding.left || 0) + biasLeft
    };
    var commonCollisionProps = {
        boundary: collisionBoundary === "clipping-ancestors" ? "clippingAncestors" : collisionBoundary,
        padding: collisionPadding
    };
    var arrowRef = react.useRef(null);
    var sideOffsetRef = useValueAsRef(sideOffset);
    var alignOffsetRef = useValueAsRef(alignOffset);
    var middleware = [
        offset(function(state) {
            var data = getOffsetData(state, sideParam, isRtl);
            var sideAxis = typeof sideOffsetRef.current === "function" ? sideOffsetRef.current(data) : sideOffsetRef.current;
            var alignAxis = typeof alignOffsetRef.current === "function" ? alignOffsetRef.current(data) : alignOffsetRef.current;
            return {
                mainAxis: sideAxis,
                crossAxis: alignAxis,
                alignmentAxis: alignAxis
            };
        }, [
            typeof sideOffset !== "function" ? sideOffset : 0,
            typeof alignOffset !== "function" ? alignOffset : 0,
            isRtl,
            sideParam
        ])
    ];
    var shiftDisabled = collisionAvoidanceAlign === "none" && collisionAvoidanceSide !== "shift";
    var crossAxisShiftEnabled = !shiftDisabled && (sticky || shiftCrossAxis || collisionAvoidanceSide === "shift");
    var flipMiddleware = collisionAvoidanceSide === "none" ? null : flip((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, commonCollisionProps), {
        padding: {
            top: collisionPadding.top + bias,
            right: collisionPadding.right + bias,
            bottom: collisionPadding.bottom + bias,
            left: collisionPadding.left + bias
        },
        mainAxis: !shiftCrossAxis && collisionAvoidanceSide === "flip",
        crossAxis: collisionAvoidanceAlign === "flip" ? "alignment" : false,
        fallbackAxisSideDirection: collisionAvoidanceFallbackAxisSide
    }));
    var shiftMiddleware = shiftDisabled ? null : shift(function(data) {
        var html = ownerDocument(data.elements.floating).documentElement;
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, commonCollisionProps), {
            rootBoundary: shiftCrossAxis ? {
                x: 0,
                y: 0,
                width: html.clientWidth,
                height: html.clientHeight
            } : void 0,
            mainAxis: collisionAvoidanceAlign !== "none",
            crossAxis: crossAxisShiftEnabled,
            limiter: sticky || shiftCrossAxis ? void 0 : limitShift(function(limitData) {
                if (!arrowRef.current) return {};
                var ref = arrowRef.current.getBoundingClientRect(), width = ref.width, height = ref.height;
                var sideAxis = getSideAxis(getSide(limitData.placement));
                var arrowSize = sideAxis === "y" ? width : height;
                var offsetAmount = sideAxis === "y" ? collisionPadding.left + collisionPadding.right : collisionPadding.top + collisionPadding.bottom;
                return {
                    offset: arrowSize / 2 + offsetAmount / 2
                };
            })
        });
    }, [
        commonCollisionProps,
        sticky,
        shiftCrossAxis,
        collisionPadding,
        collisionAvoidanceAlign
    ]);
    if (collisionAvoidanceSide === "shift" || collisionAvoidanceAlign === "shift" || align === "center") middleware.push(shiftMiddleware, flipMiddleware);
    else middleware.push(flipMiddleware, shiftMiddleware);
    middleware.push(size((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, commonCollisionProps), {
        apply: function apply(param) {
            var floating = param.elements.floating, availableWidth = param.availableWidth, availableHeight = param.availableHeight, rects = param.rects;
            if (!mountedRef.current) return;
            var floatingStyle = floating.style;
            floatingStyle.setProperty("--available-width", "".concat(availableWidth, "px"));
            floatingStyle.setProperty("--available-height", "".concat(availableHeight, "px"));
            var dpr = getWindow(floating).devicePixelRatio || 1;
            var _reference = rects.reference, x = _reference.x, y = _reference.y, width = _reference.width, height = _reference.height;
            var anchorWidth = (Math.round((x + width) * dpr) - Math.round(x * dpr)) / dpr;
            var anchorHeight = (Math.round((y + height) * dpr) - Math.round(y * dpr)) / dpr;
            floatingStyle.setProperty("--anchor-width", "".concat(anchorWidth, "px"));
            floatingStyle.setProperty("--anchor-height", "".concat(anchorHeight, "px"));
        }
    })), arrow(function() {
        return {
            element: arrowRef.current || ownerDocument(arrowRef.current).createElement("div"),
            padding: arrowPadding,
            offsetParent: "floating"
        };
    }, [
        arrowPadding
    ]), {
        name: "transformOrigin",
        fn: function fn(state) {
            var ref, ref1, ref2;
            var elements = state.elements, middlewareData = state.middlewareData, renderedPlacement = state.placement, rects = state.rects, y = state.y;
            var currentRenderedSide = getSide(renderedPlacement);
            var currentRenderedAxis = getSideAxis(currentRenderedSide);
            var arrowEl = arrowRef.current;
            var arrowX = ((ref = middlewareData.arrow) === null || ref === void 0 ? void 0 : ref.x) || 0;
            var arrowY = ((ref1 = middlewareData.arrow) === null || ref1 === void 0 ? void 0 : ref1.y) || 0;
            var arrowWidth = (arrowEl === null || arrowEl === void 0 ? void 0 : arrowEl.clientWidth) || 0;
            var arrowHeight = (arrowEl === null || arrowEl === void 0 ? void 0 : arrowEl.clientHeight) || 0;
            var transformX = arrowX + arrowWidth / 2;
            var transformY = arrowY + arrowHeight / 2;
            var shiftY = Math.abs(((ref2 = middlewareData.shift) === null || ref2 === void 0 ? void 0 : ref2.y) || 0);
            var halfAnchorHeight = rects.reference.height / 2;
            var sideOffsetValue = typeof sideOffset === "function" ? sideOffset(getOffsetData(state, sideParam, isRtl)) : sideOffset;
            var isOverlappingAnchor = shiftY > sideOffsetValue;
            var adjacentTransformOrigin = {
                top: "".concat(transformX, "px calc(100% + ").concat(sideOffsetValue, "px)"),
                bottom: "".concat(transformX, "px ").concat(-sideOffsetValue, "px"),
                left: "calc(100% + ".concat(sideOffsetValue, "px) ").concat(transformY, "px"),
                right: "".concat(-sideOffsetValue, "px ").concat(transformY, "px")
            }[currentRenderedSide];
            var overlapTransformOrigin = "".concat(transformX, "px ").concat(rects.reference.y + halfAnchorHeight - y, "px");
            elements.floating.style.setProperty("--transform-origin", crossAxisShiftEnabled && currentRenderedAxis === "y" && isOverlappingAnchor ? overlapTransformOrigin : adjacentTransformOrigin);
            return {};
        }
    }, hide, adaptiveOrigin);
    useIsoLayoutEffect(function() {
        if (!mounted && floatingRootContext) floatingRootContext.update({
            referenceElement: null,
            floatingElement: null,
            domReferenceElement: null,
            positionReference: null
        });
    }, [
        mounted,
        floatingRootContext
    ]);
    var autoUpdateOptions = react.useMemo(function() {
        return {
            elementResize: !disableAnchorTracking && typeof ResizeObserver !== "undefined",
            layoutShift: !disableAnchorTracking && typeof IntersectionObserver !== "undefined"
        };
    }, [
        disableAnchorTracking
    ]);
    var ref3 = useFloating({
        rootContext: floatingRootContext,
        open: keepMounted ? mounted : void 0,
        placement: placement,
        middleware: middleware,
        strategy: positionMethod,
        whileElementsMounted: keepMounted ? void 0 : function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return autoUpdate.apply(void 0, (0,src_to_consumable_array/* default */.Z)(args).concat([
                autoUpdateOptions
            ]));
        },
        nodeId: nodeId,
        externalTree: externalTree
    }), refs = ref3.refs, elements = ref3.elements, x = ref3.x, y = ref3.y, middlewareData = ref3.middlewareData, update = ref3.update, renderedPlacement = ref3.placement, context = ref3.context, isPositioned = ref3.isPositioned, originalFloatingStyles = ref3.floatingStyles;
    var ref4 = middlewareData.adaptiveOrigin || DEFAULT_SIDES, sideX = ref4.sideX, sideY = ref4.sideY;
    var resolvedPosition = isPositioned ? positionMethod : "fixed";
    var floatingStyles = react.useMemo(function() {
        var _obj;
        var base = adaptiveOrigin ? (_obj = {
            position: resolvedPosition
        }, (0,src_define_property/* default */.Z)(_obj, sideX, x), (0,src_define_property/* default */.Z)(_obj, sideY, y), _obj) : (0,src_object_spread/* default */.Z)({
            position: resolvedPosition
        }, originalFloatingStyles);
        if (!isPositioned) base.opacity = 0;
        return base;
    }, [
        adaptiveOrigin,
        resolvedPosition,
        sideX,
        x,
        sideY,
        y,
        originalFloatingStyles,
        isPositioned
    ]);
    var registeredPositionReferenceRef = react.useRef(null);
    useIsoLayoutEffect(function() {
        if (!mounted) return;
        var anchorValue = anchorValueRef.current;
        var resolvedAnchor = typeof anchorValue === "function" ? anchorValue() : anchorValue;
        var finalAnchor = (isRef(resolvedAnchor) ? resolvedAnchor.current : resolvedAnchor) || null;
        if (finalAnchor !== registeredPositionReferenceRef.current) {
            refs.setPositionReference(finalAnchor);
            registeredPositionReferenceRef.current = finalAnchor;
        }
    }, [
        mounted,
        refs,
        anchorDep,
        anchorValueRef
    ]);
    react.useEffect(function() {
        if (!mounted) return;
        var anchorValue = anchorValueRef.current;
        if (typeof anchorValue === "function") return;
        if (isRef(anchorValue) && anchorValue.current !== registeredPositionReferenceRef.current) {
            refs.setPositionReference(anchorValue.current);
            registeredPositionReferenceRef.current = anchorValue.current;
        }
    }, [
        mounted,
        refs,
        anchorDep,
        anchorValueRef
    ]);
    react.useEffect(function() {
        if (keepMounted && mounted && elements.domReference && elements.floating) return autoUpdate(elements.domReference, elements.floating, update, autoUpdateOptions);
    }, [
        keepMounted,
        mounted,
        elements,
        update,
        autoUpdateOptions
    ]);
    var renderedSide = getSide(renderedPlacement);
    var logicalRenderedSide = getLogicalSide(sideParam, renderedSide, isRtl);
    var renderedAlign = getAlignment(renderedPlacement) || "center";
    var anchorHidden = Boolean((ref = middlewareData.hide) === null || ref === void 0 ? void 0 : ref.referenceHidden);
    /**
	* Locks the flip (makes it "sticky") so it doesn't prefer a given placement
	* and flips back lazily, not eagerly. Ideal for filtered lists that change
	* the size of the popup dynamically to avoid unwanted flipping when typing.
	*/ useIsoLayoutEffect(function() {
        if (lazyFlip && mounted && isPositioned) setMountSide(renderedSide);
    }, [
        lazyFlip,
        mounted,
        isPositioned,
        renderedSide
    ]);
    var arrowStyles = react.useMemo(function() {
        var ref, ref1;
        return {
            position: "absolute",
            top: (ref = middlewareData.arrow) === null || ref === void 0 ? void 0 : ref.y,
            left: (ref1 = middlewareData.arrow) === null || ref1 === void 0 ? void 0 : ref1.x
        };
    }, [
        middlewareData.arrow
    ]);
    var arrowUncentered = ((ref1 = middlewareData.arrow) === null || ref1 === void 0 ? void 0 : ref1.centerOffset) !== 0;
    return react.useMemo(function() {
        return {
            positionerStyles: floatingStyles,
            arrowStyles: arrowStyles,
            arrowRef: arrowRef,
            arrowUncentered: arrowUncentered,
            side: logicalRenderedSide,
            align: renderedAlign,
            physicalSide: renderedSide,
            anchorHidden: anchorHidden,
            refs: refs,
            context: context,
            isPositioned: isPositioned,
            update: update
        };
    }, [
        floatingStyles,
        arrowStyles,
        arrowRef,
        arrowUncentered,
        logicalRenderedSide,
        renderedAlign,
        renderedSide,
        anchorHidden,
        refs,
        context,
        isPositioned,
        update
    ]);
}
function isRef(param) {
    return param != null && "current" in param;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/utils/InternalBackdrop.js
/**
* @internal
*/ var InternalBackdrop = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function InternalBackdrop(props, ref) {
    var cutout = props.cutout, otherProps = (0,src_object_without_properties/* default */.Z)(props, [
        "cutout"
    ]);
    var clipPath;
    if (cutout) {
        var rect = cutout.getBoundingClientRect();
        clipPath = "polygon(0% 0%,100% 0%,100% 100%,0% 100%,0% 0%,".concat(rect.left, "px ").concat(rect.top, "px,").concat(rect.left, "px ").concat(rect.bottom, "px,").concat(rect.right, "px ").concat(rect.bottom, "px,").concat(rect.right, "px ").concat(rect.top, "px,").concat(rect.left, "px ").concat(rect.top, "px)");
    }
    return /* @__PURE__ */ (0,jsx_runtime.jsx)("div", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        ref: ref,
        role: "presentation",
        "data-base-ui-inert": ""
    }, otherProps), {
        style: {
            position: "fixed",
            inset: 0,
            userSelect: "none",
            WebkitUserSelect: "none",
            clipPath: clipPath
        }
    }));
});
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/utils/getDisabledMountTransitionStyles.js
function getDisabledMountTransitionStyles(transitionStatus) {
    return transitionStatus === "starting" ? DISABLED_TRANSITIONS_STYLE : EMPTY_OBJECT;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/utils/usePositioner.js
/**
* Renders the shared outer Positioner element used by popup components.
* Applies the common role, hidden state, transition styles, state attributes, and optional inert styling.
*/ function usePositioner(componentProps, state, param) {
    var styles = param.styles, transitionStatus = param.transitionStatus, props = param.props, refs = param.refs, hidden = param.hidden, _inert = param.inert, inert = _inert === void 0 ? false : _inert;
    var style = (0,src_object_spread/* default */.Z)({}, styles);
    if (inert) style.pointerEvents = "none";
    return useRenderElement("div", componentProps, {
        state: state,
        ref: refs,
        props: [
            {
                role: "presentation",
                hidden: hidden,
                style: style
            },
            getDisabledMountTransitionStyles(transitionStatus),
            props
        ],
        stateAttributesMapping: popupStateMapping
    });
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/useScrollLock.js
var originalHtmlStyles = {};
var originalBodyStyles = {};
var originalHtmlScrollBehavior = "";
function hasInsetScrollbars(referenceElement) {
    if (typeof document === "undefined") return false;
    var doc = ownerDocument(referenceElement);
    return getWindow(doc).innerWidth - doc.documentElement.clientWidth > 0;
}
function supportsStableScrollbarGutter(referenceElement) {
    if (!(typeof CSS !== "undefined" && CSS.supports && CSS.supports("scrollbar-gutter", "stable")) || typeof document === "undefined") return false;
    var doc = ownerDocument(referenceElement);
    var html = doc.documentElement;
    var body = doc.body;
    var scrollContainer = isOverflowElement(html) ? html : body;
    var originalScrollContainerOverflowY = scrollContainer.style.overflowY;
    var originalHtmlStyleGutter = html.style.scrollbarGutter;
    html.style.scrollbarGutter = "stable";
    scrollContainer.style.overflowY = "scroll";
    var before = scrollContainer.offsetWidth;
    scrollContainer.style.overflowY = "hidden";
    var after = scrollContainer.offsetWidth;
    scrollContainer.style.overflowY = originalScrollContainerOverflowY;
    html.style.scrollbarGutter = originalHtmlStyleGutter;
    return before === after;
}
function preventScrollOverlayScrollbars(referenceElement) {
    var doc = ownerDocument(referenceElement);
    var html = doc.documentElement;
    var body = doc.body;
    var elementToLock = isOverflowElement(html) ? html : body;
    var originalElementToLockStyles = {
        overflowY: elementToLock.style.overflowY,
        overflowX: elementToLock.style.overflowX
    };
    Object.assign(elementToLock.style, {
        overflowY: "hidden",
        overflowX: "hidden"
    });
    return function() {
        Object.assign(elementToLock.style, originalElementToLockStyles);
    };
}
function preventScrollInsetScrollbars(referenceElement) {
    var lockScroll = function lockScroll() {
        var htmlStyles = win.getComputedStyle(html);
        var bodyStyles = win.getComputedStyle(body);
        var scrollbarGutterValue = (htmlStyles.scrollbarGutter || "").includes("both-edges") ? "stable both-edges" : "stable";
        scrollTop = html.scrollTop;
        scrollLeft = html.scrollLeft;
        originalHtmlStyles = {
            scrollbarGutter: html.style.scrollbarGutter,
            overflowY: html.style.overflowY,
            overflowX: html.style.overflowX
        };
        originalHtmlScrollBehavior = html.style.scrollBehavior;
        originalBodyStyles = {
            position: body.style.position,
            height: body.style.height,
            width: body.style.width,
            boxSizing: body.style.boxSizing,
            overflowY: body.style.overflowY,
            overflowX: body.style.overflowX,
            scrollBehavior: body.style.scrollBehavior
        };
        var isScrollableY = html.scrollHeight > html.clientHeight;
        var isScrollableX = html.scrollWidth > html.clientWidth;
        var hasConstantOverflowY = htmlStyles.overflowY === "scroll" || bodyStyles.overflowY === "scroll";
        var hasConstantOverflowX = htmlStyles.overflowX === "scroll" || bodyStyles.overflowX === "scroll";
        var scrollbarWidth = Math.max(0, win.innerWidth - body.clientWidth);
        var scrollbarHeight = Math.max(0, win.innerHeight - body.clientHeight);
        var marginY = parseFloat(bodyStyles.marginTop) + parseFloat(bodyStyles.marginBottom);
        var marginX = parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight);
        var elementToLock = isOverflowElement(html) ? html : body;
        updateGutterOnly = supportsStableScrollbarGutter(referenceElement);
        if (updateGutterOnly) {
            html.style.scrollbarGutter = scrollbarGutterValue;
            elementToLock.style.overflowY = "hidden";
            elementToLock.style.overflowX = "hidden";
            return;
        }
        Object.assign(html.style, {
            scrollbarGutter: scrollbarGutterValue,
            overflowY: "hidden",
            overflowX: "hidden"
        });
        if (isScrollableY || hasConstantOverflowY) html.style.overflowY = "scroll";
        if (isScrollableX || hasConstantOverflowX) html.style.overflowX = "scroll";
        Object.assign(body.style, {
            position: "relative",
            height: marginY || scrollbarHeight ? "calc(100dvh - ".concat(marginY + scrollbarHeight, "px)") : "100dvh",
            width: marginX || scrollbarWidth ? "calc(100vw - ".concat(marginX + scrollbarWidth, "px)") : "100vw",
            boxSizing: "border-box",
            overflow: "hidden",
            scrollBehavior: "unset"
        });
        body.scrollTop = scrollTop;
        body.scrollLeft = scrollLeft;
        html.setAttribute("data-base-ui-scroll-locked", "");
        html.style.scrollBehavior = "unset";
    };
    var cleanup = function cleanup() {
        Object.assign(html.style, originalHtmlStyles);
        Object.assign(body.style, originalBodyStyles);
        if (!updateGutterOnly) {
            html.scrollTop = scrollTop;
            html.scrollLeft = scrollLeft;
            html.removeAttribute("data-base-ui-scroll-locked");
            html.style.scrollBehavior = originalHtmlScrollBehavior;
        }
    };
    var handleResize = function handleResize() {
        cleanup();
        resizeFrame.request(lockScroll);
    };
    var ref;
    var doc = ownerDocument(referenceElement);
    var html = doc.documentElement;
    var body = doc.body;
    var win = getWindow(html);
    var scrollTop = 0;
    var scrollLeft = 0;
    var updateGutterOnly = false;
    var resizeFrame = AnimationFrame.create();
    var ref1;
    if (isWebKit && ((ref1 = (ref = win.visualViewport) === null || ref === void 0 ? void 0 : ref.scale) !== null && ref1 !== void 0 ? ref1 : 1) !== 1) return function() {};
    lockScroll();
    var unsubscribeResize = addEventListener(win, "resize", handleResize);
    return function() {
        resizeFrame.cancel();
        cleanup();
        if (typeof win.removeEventListener === "function") unsubscribeResize();
    };
}
var ScrollLocker = /*#__PURE__*/ function() {
    "use strict";
    function ScrollLocker() {
        var _this = this;
        (0,src_class_call_check/* default */.Z)(this, ScrollLocker);
        (0,src_define_property/* default */.Z)(this, "lockCount", 0);
        (0,src_define_property/* default */.Z)(this, "restore", null);
        (0,src_define_property/* default */.Z)(this, "timeoutLock", Timeout.create());
        (0,src_define_property/* default */.Z)(this, "timeoutUnlock", Timeout.create());
        (0,src_define_property/* default */.Z)(this, "release", function() {
            _this.lockCount -= 1;
            if (_this.lockCount === 0 && _this.restore) _this.timeoutUnlock.start(0, _this.unlock);
        });
        (0,src_define_property/* default */.Z)(this, "unlock", function() {
            if (_this.lockCount === 0 && _this.restore) {
                var _obj, ref;
                (ref = (_obj = _this).restore) === null || ref === void 0 ? void 0 : ref.call(_obj);
                _this.restore = null;
            }
        });
    }
    (0,src_create_class/* default */.Z)(ScrollLocker, [
        {
            key: "acquire",
            value: function acquire(referenceElement) {
                var _this = this;
                this.lockCount += 1;
                if (this.lockCount === 1 && this.restore === null) this.timeoutLock.start(0, function() {
                    return _this.lock(referenceElement);
                });
                return this.release;
            }
        },
        {
            key: "lock",
            value: function lock(referenceElement) {
                if (this.lockCount === 0 || this.restore !== null) return;
                var html = ownerDocument(referenceElement).documentElement;
                var htmlOverflowY = getWindow(html).getComputedStyle(html).overflowY;
                if (htmlOverflowY === "hidden" || htmlOverflowY === "clip") {
                    this.restore = NOOP;
                    return;
                }
                var hasOverlayScrollbars = isIOS || !hasInsetScrollbars(referenceElement);
                this.restore = hasOverlayScrollbars ? preventScrollOverlayScrollbars(referenceElement) : preventScrollInsetScrollbars(referenceElement);
            }
        }
    ]);
    return ScrollLocker;
}();
var SCROLL_LOCKER = new ScrollLocker();
/**
* Locks the scroll of the document when enabled.
*
* @param enabled - Whether to enable the scroll lock.
* @param referenceElement - Element to use as a reference for lock calculations.
*/ function useScrollLock() {
    var enabled = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, referenceElement = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    useIsoLayoutEffect(function() {
        if (!enabled) return;
        return SCROLL_LOCKER.acquire(referenceElement);
    }, [
        enabled,
        referenceElement
    ]);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/utils/useAnchoredPopupScrollLock.js
var VIEWPORT_WIDTH_TOLERANCE_PX = 20;
/**
* Manages scroll lock for anchored popups. For non-touch opens, scroll lock is applied when
* enabled. For touch opens, scroll lock is applied only when the positioner width is effectively
* viewport-sized.
*/ function useAnchoredPopupScrollLock(enabled, touchOpen, positionerElement, referenceElement) {
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), touchOpenShouldLockScroll = ref[0], setTouchOpenShouldLockScroll = ref[1];
    useIsoLayoutEffect(function() {
        if (!enabled || !touchOpen || positionerElement == null) {
            setTouchOpenShouldLockScroll(false);
            return;
        }
        var viewportWidth = ownerDocument(positionerElement).documentElement.clientWidth;
        var popupWidth = positionerElement.offsetWidth;
        setTouchOpenShouldLockScroll(viewportWidth > 0 && popupWidth > 0 && popupWidth >= viewportWidth - VIEWPORT_WIDTH_TOLERANCE_PX);
    }, [
        enabled,
        touchOpen,
        positionerElement
    ]);
    useScrollLock(enabled && (!touchOpen || touchOpenShouldLockScroll), referenceElement);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/combobox/positioner/ComboboxPositioner.js
/**
* Positions the popup against the trigger.
* Renders a `<div>` element.
*
* Documentation: [Base UI Combobox](https://base-ui.com/react/components/combobox)
*/ var ComboboxPositioner = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function ComboboxPositioner(componentProps, forwardedRef) {
    var render = componentProps.render, className = componentProps.className, anchor = componentProps.anchor, _positionMethod = componentProps.positionMethod, positionMethod = _positionMethod === void 0 ? "absolute" : _positionMethod, _side = componentProps.side, side = _side === void 0 ? "bottom" : _side, _align = componentProps.align, align = _align === void 0 ? "center" : _align, _sideOffset = componentProps.sideOffset, sideOffset = _sideOffset === void 0 ? 0 : _sideOffset, _alignOffset = componentProps.alignOffset, alignOffset = _alignOffset === void 0 ? 0 : _alignOffset, _collisionBoundary = componentProps.collisionBoundary, collisionBoundary = _collisionBoundary === void 0 ? "clipping-ancestors" : _collisionBoundary, _collisionPadding = componentProps.collisionPadding, collisionPadding = _collisionPadding === void 0 ? 5 : _collisionPadding, _arrowPadding = componentProps.arrowPadding, arrowPadding = _arrowPadding === void 0 ? 5 : _arrowPadding, _sticky = componentProps.sticky, sticky = _sticky === void 0 ? false : _sticky, _disableAnchorTracking = componentProps.disableAnchorTracking, disableAnchorTracking = _disableAnchorTracking === void 0 ? false : _disableAnchorTracking, _collisionAvoidance = componentProps.collisionAvoidance, collisionAvoidance = _collisionAvoidance === void 0 ? DROPDOWN_COLLISION_AVOIDANCE : _collisionAvoidance, styleProp = componentProps.style, elementProps = (0,src_object_without_properties/* default */.Z)(componentProps, [
        "render",
        "className",
        "anchor",
        "positionMethod",
        "side",
        "align",
        "sideOffset",
        "alignOffset",
        "collisionBoundary",
        "collisionPadding",
        "arrowPadding",
        "sticky",
        "disableAnchorTracking",
        "collisionAvoidance",
        "style"
    ]);
    var store = useComboboxRootContext();
    var filteredItems = useComboboxDerivedItemsContext().filteredItems;
    var floatingRootContext = useComboboxFloatingContext();
    var keepMounted = useComboboxPortalContext();
    var modal = useStore(store, selectors$2.modal);
    var open = useStore(store, selectors$2.open);
    var mounted = useStore(store, selectors$2.mounted);
    var openMethod = useStore(store, selectors$2.openMethod);
    var positionerElement = useStore(store, selectors$2.positionerElement);
    var triggerElement = useStore(store, selectors$2.triggerElement);
    var inputElement = useStore(store, selectors$2.inputElement);
    var inputGroupElement = useStore(store, selectors$2.inputGroupElement);
    var inputInsidePopup = useStore(store, selectors$2.inputInsidePopup);
    var transitionStatus = useStore(store, selectors$2.transitionStatus);
    var empty = filteredItems.length === 0;
    var positioning = useAnchorPositioning({
        anchor: anchor !== null && anchor !== void 0 ? anchor : inputInsidePopup ? triggerElement : inputGroupElement !== null && inputGroupElement !== void 0 ? inputGroupElement : inputElement,
        floatingRootContext: floatingRootContext,
        positionMethod: positionMethod,
        mounted: mounted,
        side: side,
        sideOffset: sideOffset,
        align: align,
        alignOffset: alignOffset,
        arrowPadding: arrowPadding,
        collisionBoundary: collisionBoundary,
        collisionPadding: collisionPadding,
        sticky: sticky,
        disableAnchorTracking: disableAnchorTracking,
        keepMounted: keepMounted,
        collisionAvoidance: collisionAvoidance,
        lazyFlip: true
    });
    useAnchoredPopupScrollLock(open && modal, openMethod === "touch", positionerElement, triggerElement);
    var state = {
        open: open,
        side: positioning.side,
        align: positioning.align,
        anchorHidden: positioning.anchorHidden,
        empty: empty
    };
    useIsoLayoutEffect(function() {
        store.set("popupSide", positioning.side);
    }, [
        store,
        positioning.side
    ]);
    var setPositionerElement = useStableCallback(function(element) {
        store.set("positionerElement", element);
    });
    var element = usePositioner(componentProps, state, {
        styles: positioning.positionerStyles,
        transitionStatus: transitionStatus,
        props: elementProps,
        refs: [
            forwardedRef,
            setPositionerElement
        ],
        hidden: !mounted,
        inert: !open
    });
    var ref;
    return /* @__PURE__ */ (0,jsx_runtime.jsxs)(ComboboxPositionerContext.Provider, {
        value: positioning,
        children: [
            mounted && modal && /* @__PURE__ */ (0,jsx_runtime.jsx)(InternalBackdrop, {
                inert: inertValue(!open),
                cutout: (ref = inputGroupElement !== null && inputGroupElement !== void 0 ? inputGroupElement : inputElement) !== null && ref !== void 0 ? ref : triggerElement
            }),
            element
        ]
    });
});
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/combobox/popup/ComboboxPopup.js
var stateAttributesMapping$8 = (0,src_object_spread/* default */.Z)({}, popupStateMapping, transitionStatusMapping);
/**
* A container for the list.
* Renders a `<div>` element.
*
* Documentation: [Base UI Combobox](https://base-ui.com/react/components/combobox)
*/ var ComboboxPopup = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function ComboboxPopup(componentProps, forwardedRef) {
    var render = componentProps.render, className = componentProps.className, style = componentProps.style, initialFocus = componentProps.initialFocus, finalFocus = componentProps.finalFocus, elementProps = (0,src_object_without_properties/* default */.Z)(componentProps, [
        "render",
        "className",
        "style",
        "initialFocus",
        "finalFocus"
    ]);
    var store = useComboboxRootContext();
    var positioning = useComboboxPositionerContext();
    var floatingRootContext = useComboboxFloatingContext();
    var filteredItems = useComboboxDerivedItemsContext().filteredItems;
    var mounted = useStore(store, selectors$2.mounted);
    var open = useStore(store, selectors$2.open);
    var openMethod = useStore(store, selectors$2.openMethod);
    var transitionStatus = useStore(store, selectors$2.transitionStatus);
    var inputInsidePopup = useStore(store, selectors$2.inputInsidePopup);
    var inputElement = useStore(store, selectors$2.inputElement);
    var modal = useStore(store, selectors$2.modal);
    var empty = filteredItems.length === 0;
    useOpenChangeComplete({
        open: open,
        ref: store.state.popupRef,
        onComplete: function onComplete() {
            if (open) store.state.onOpenChangeComplete(true);
        }
    });
    var element = useRenderElement("div", componentProps, {
        state: {
            open: open,
            side: positioning.side,
            align: positioning.align,
            anchorHidden: positioning.anchorHidden,
            transitionStatus: transitionStatus,
            empty: empty
        },
        ref: [
            forwardedRef,
            store.state.popupRef
        ],
        props: [
            {
                role: inputInsidePopup ? "dialog" : "presentation",
                tabIndex: -1,
                onFocus: function onFocus(event) {
                    var ref;
                    var target = getTarget(event.nativeEvent);
                    if (openMethod !== "touch" && (contains(store.state.listElement, target) || target === event.currentTarget)) (ref = store.state.inputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
                }
            },
            getDisabledMountTransitionStyles(transitionStatus),
            elementProps
        ],
        stateAttributesMapping: stateAttributesMapping$8
    });
    var resolvedInitialFocus = initialFocus === void 0 ? inputInsidePopup ? function(interactionType) {
        return interactionType === "touch" ? store.state.popupRef.current : inputElement;
    } : false : initialFocus;
    var resolvedFinalFocus;
    if (finalFocus != null) resolvedFinalFocus = finalFocus;
    else resolvedFinalFocus = inputInsidePopup ? void 0 : false;
    var focusManagerModal = !inputInsidePopup || modal;
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(FloatingFocusManager, {
        context: floatingRootContext,
        disabled: !mounted,
        modal: focusManagerModal,
        openInteractionType: openMethod,
        initialFocus: resolvedInitialFocus,
        returnFocus: resolvedFinalFocus,
        getInsideElements: function() {
            return [
                store.state.startDismissRef.current,
                store.state.endDismissRef.current
            ];
        },
        children: /* @__PURE__ */ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                element,
                focusManagerModal && /* @__PURE__ */ (0,jsx_runtime.jsx)(ComboboxInternalDismissButton, {
                    ref: store.state.endDismissRef
                })
            ]
        })
    });
});
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/composite/list/useCompositeListItem.js
var IndexGuessBehavior = /* @__PURE__ */ function(IndexGuessBehavior) {
    IndexGuessBehavior[IndexGuessBehavior["None"] = 0] = "None";
    IndexGuessBehavior[IndexGuessBehavior["GuessFromOrder"] = 1] = "GuessFromOrder";
    return IndexGuessBehavior;
}({});
/**
* Used to register a list item and its index (DOM position) in the `CompositeList`.
*/ function useCompositeListItem() {
    var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var label = params.label, metadata = params.metadata, textRef = params.textRef, indexGuessBehavior = params.indexGuessBehavior, externalIndex = params.index;
    var ref = useCompositeListContext(), _$register = ref.register, unregister = ref.unregister, subscribeMapChange = ref.subscribeMapChange, elementsRef = ref.elementsRef, labelsRef = ref.labelsRef, nextIndexRef = ref.nextIndexRef;
    var indexRef = react.useRef(-1);
    var ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState(externalIndex !== null && externalIndex !== void 0 ? externalIndex : indexGuessBehavior === IndexGuessBehavior.GuessFromOrder ? function() {
        if (indexRef.current === -1) {
            var newIndex = nextIndexRef.current;
            nextIndexRef.current += 1;
            indexRef.current = newIndex;
        }
        return indexRef.current;
    } : -1), 2), index = ref1[0], setIndex = ref1[1];
    var componentRef = react.useRef(null);
    var ref2 = react.useCallback(function(node) {
        componentRef.current = node;
        if (index !== -1 && node !== null) {
            elementsRef.current[index] = node;
            if (labelsRef) {
                var ref;
                var isLabelDefined = label !== void 0;
                var ref1;
                labelsRef.current[index] = isLabelDefined ? label : (ref1 = textRef === null || textRef === void 0 ? void 0 : (ref = textRef.current) === null || ref === void 0 ? void 0 : ref.textContent) !== null && ref1 !== void 0 ? ref1 : node.textContent;
            }
        }
    }, [
        index,
        elementsRef,
        labelsRef,
        label,
        textRef
    ]);
    useIsoLayoutEffect(function() {
        if (externalIndex != null) return;
        var node = componentRef.current;
        if (node) {
            _$register(node, metadata);
            return function() {
                unregister(node);
            };
        }
    }, [
        externalIndex,
        _$register,
        unregister,
        metadata
    ]);
    useIsoLayoutEffect(function() {
        if (externalIndex != null) return;
        return subscribeMapChange(function(map) {
            var ref;
            var i = componentRef.current ? (ref = map.get(componentRef.current)) === null || ref === void 0 ? void 0 : ref.index : null;
            if (i != null) setIndex(i);
        });
    }, [
        externalIndex,
        subscribeMapChange,
        setIndex
    ]);
    return react.useMemo(function() {
        return {
            ref: ref2,
            index: index
        };
    }, [
        index,
        ref2
    ]);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/combobox/item/ComboboxItemContext.js
var ComboboxItemContext = /* @__PURE__ */ /*#__PURE__*/ react.createContext(void 0);
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/combobox/row/ComboboxRowContext.js
var ComboboxRowContext = /* @__PURE__ */ /*#__PURE__*/ react.createContext(false);
if (false) {}
function useComboboxRowContext() {
    return react.useContext(ComboboxRowContext);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/combobox/item/ComboboxItem.js
/**
* An individual item in the list.
* Renders a `<div>` element.
*
* Documentation: [Base UI Combobox](https://base-ui.com/react/components/combobox)
*/ var ComboboxItem = /* @__PURE__ */ /*#__PURE__*/ react.memo(/* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function ComboboxItem(componentProps, forwardedRef) {
    var commitSelection = function commitSelection(nativeEvent) {
        function selectItem() {
            store.state.handleSelection(nativeEvent, itemValue);
        }
        if (store.state.submitOnItemClick) {
            react_dom.flushSync(selectItem);
            store.state.requestSubmit();
        } else selectItem();
    };
    var render = componentProps.render, className = componentProps.className, tmp = componentProps.value, itemValue = tmp === void 0 ? null : tmp, indexProp = componentProps.index, _disabled = componentProps.disabled, disabled = _disabled === void 0 ? false : _disabled, _nativeButton = componentProps.nativeButton, nativeButton = _nativeButton === void 0 ? false : _nativeButton, style = componentProps.style, elementProps = (0,src_object_without_properties/* default */.Z)(componentProps, [
        "render",
        "className",
        "value",
        "index",
        "disabled",
        "nativeButton",
        "style"
    ]);
    var didPointerDownRef = react.useRef(false);
    var textRef = react.useRef(null);
    var listItem = useCompositeListItem({
        index: indexProp,
        textRef: textRef,
        indexGuessBehavior: IndexGuessBehavior.GuessFromOrder
    });
    var store = useComboboxRootContext();
    var isRow = useComboboxRowContext();
    var ref = useComboboxDerivedItemsContext(), flatFilteredItems = ref.flatFilteredItems, hasItems = ref.hasItems;
    var open = useStore(store, selectors$2.open);
    var selectionMode = useStore(store, selectors$2.selectionMode);
    var readOnly = useStore(store, selectors$2.readOnly);
    var virtualized = useStore(store, selectors$2.virtualized);
    var isItemEqualToValue = useStore(store, selectors$2.isItemEqualToValue);
    var selectable = selectionMode !== "none";
    var index = indexProp !== null && indexProp !== void 0 ? indexProp : virtualized ? findItemIndex(flatFilteredItems, itemValue, isItemEqualToValue) : listItem.index;
    var hasRegistered = listItem.index !== -1;
    var rootId = useStore(store, selectors$2.id);
    var highlighted = useStore(store, selectors$2.isActive, index);
    var matchesSelectedValue = useStore(store, selectors$2.isSelected, itemValue);
    var getItemProps = useStore(store, selectors$2.getItemProps);
    var itemRef = react.useRef(null);
    var id = rootId != null && hasRegistered ? "".concat(rootId, "-").concat(index) : void 0;
    var selected = matchesSelectedValue && selectable;
    useIsoLayoutEffect(function() {
        if (!(hasRegistered && (virtualized || indexProp != null))) return;
        var list = store.state.listRef.current;
        list[index] = itemRef.current;
        return function() {
            delete list[index];
        };
    }, [
        hasRegistered,
        virtualized,
        index,
        indexProp,
        store
    ]);
    useIsoLayoutEffect(function() {
        if (!hasRegistered || hasItems) return;
        var visibleMap = store.state.valuesRef.current;
        visibleMap[index] = itemValue;
        if (selectionMode !== "none") store.state.allValuesRef.current.push(itemValue);
        return function() {
            delete visibleMap[index];
        };
    }, [
        hasRegistered,
        hasItems,
        index,
        itemValue,
        store,
        selectionMode
    ]);
    useIsoLayoutEffect(function() {
        if (!open) {
            didPointerDownRef.current = false;
            return;
        }
        if (!hasRegistered || hasItems) return;
        var selectedValue = store.state.selectedValue;
        if (compareItemEquality(itemValue, Array.isArray(selectedValue) ? selectedValue[selectedValue.length - 1] : selectedValue, isItemEqualToValue)) store.set("selectedIndex", index);
    }, [
        hasRegistered,
        hasItems,
        open,
        store,
        index,
        itemValue,
        isItemEqualToValue
    ]);
    var state = {
        disabled: disabled,
        selected: selected,
        highlighted: highlighted
    };
    var rootProps = getItemProps({
        active: highlighted,
        selected: selected
    });
    rootProps.id = void 0;
    rootProps.onFocus = void 0;
    var ref1 = useButton({
        disabled: disabled,
        focusableWhenDisabled: true,
        native: nativeButton,
        composite: true
    }), getButtonProps = ref1.getButtonProps, buttonRef = ref1.buttonRef;
    var defaultProps = {
        id: id,
        role: isRow ? "gridcell" : "option",
        "aria-selected": selectable ? selected : void 0,
        tabIndex: void 0,
        onPointerDownCapture: function onPointerDownCapture(event) {
            didPointerDownRef.current = true;
            event.preventDefault();
        },
        onMouseDown: function onMouseDown(event) {
            event.preventDefault();
        },
        onClick: function onClick(event) {
            if (disabled || readOnly) return;
            commitSelection(event.nativeEvent);
        },
        onMouseUp: function onMouseUp(event) {
            var pointerStartedOnItem = didPointerDownRef.current;
            didPointerDownRef.current = false;
            if (disabled || readOnly || event.button !== 0 || pointerStartedOnItem || !highlighted) return;
            commitSelection(event.nativeEvent);
        }
    };
    var element = useRenderElement("div", componentProps, {
        ref: [
            buttonRef,
            forwardedRef,
            listItem.ref,
            itemRef
        ],
        state: state,
        props: [
            rootProps,
            defaultProps,
            elementProps,
            getButtonProps
        ]
    });
    var contextValue = react.useMemo(function() {
        return {
            selected: selected,
            textRef: textRef
        };
    }, [
        selected,
        textRef
    ]);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(ComboboxItemContext.Provider, {
        value: contextValue,
        children: element
    });
}));
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/combobox/empty/ComboboxEmpty.js
/**
* Renders its children only when the list is empty.
* Requires the `items` prop on the root component.
* Announces changes politely to screen readers.
* This component's root element must remain mounted in the DOM to announce
* changes consistently across screen readers. Avoid hiding or removing the
* component itself with `display: none`, `hidden`, `aria-hidden`, or conditional
* rendering. Prefer updating or conditionally rendering its children instead.
* Renders a `<div>` element.
*
* Documentation: [Base UI Combobox](https://base-ui.com/react/components/combobox)
*/ var ComboboxEmpty = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function ComboboxEmpty(componentProps, forwardedRef) {
    var render = componentProps.render, className = componentProps.className, style = componentProps.style, childrenProp = componentProps.children, elementProps = (0,src_object_without_properties/* default */.Z)(componentProps, [
        "render",
        "className",
        "style",
        "children"
    ]);
    var filteredItems = useComboboxDerivedItemsContext().filteredItems;
    var store = useComboboxRootContext();
    var emptyRef = useInitialLiveRegionTextMutation();
    var children = filteredItems.length === 0 ? childrenProp : null;
    return useRenderElement("div", componentProps, {
        ref: [
            forwardedRef,
            store.state.emptyRef,
            emptyRef
        ],
        props: [
            {
                children: children,
                role: "status",
                "aria-live": "polite",
                "aria-atomic": true
            },
            elementProps
        ]
    });
});
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/fieldset/root/FieldsetRootContext.js
var FieldsetRootContext = /* @__PURE__ */ /*#__PURE__*/ react.createContext({
    legendId: void 0,
    setLegendId: function() {},
    disabled: void 0
});
if (false) {}
function useFieldsetRootContext() {
    var optional = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var context = react.useContext(FieldsetRootContext);
    if (!context && !optional) throw new Error( false ? 0 : formatErrorMessage(86));
    return context;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/labelable-provider/LabelableProvider.js
/**
* @internal
*/ var LabelableProvider = function LabelableProvider(props) {
    var defaultId = useBaseUiId();
    var initialControlId = props.controlId === void 0 ? defaultId : props.controlId;
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(initialControlId), 2), controlId = ref[0], setControlIdState = ref[1];
    var ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState(props.labelId), 2), labelId = ref1[0], setLabelId = ref1[1];
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState([]), 2), messageIds = ref2[0], setMessageIds = ref2[1];
    var registrationsRef = useRefWithInit(function() {
        return /* @__PURE__ */ new Map();
    });
    var ref3 = useLabelableContext(), parentMessageIds = ref3.messageIds;
    var registerControlId = useStableCallback(function(source, nextId) {
        var registrations = registrationsRef.current;
        if (nextId === void 0) {
            registrations.delete(source);
            return;
        }
        registrations.set(source, nextId);
        setControlIdState(function(prev) {
            if (registrations.size === 0) return;
            var nextControlId;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = registrations.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var id = _step.value;
                    if (prev !== void 0 && id === prev) return prev;
                    if (nextControlId === void 0) nextControlId = id;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return nextControlId;
        });
    });
    var getDescriptionProps = react.useCallback(function(externalProps) {
        return mergeProps$1({
            "aria-describedby": parentMessageIds.concat(messageIds).join(" ") || void 0
        }, externalProps);
    }, [
        parentMessageIds,
        messageIds
    ]);
    var contextValue = react.useMemo(function() {
        return {
            controlId: controlId,
            registerControlId: registerControlId,
            labelId: labelId,
            setLabelId: setLabelId,
            messageIds: messageIds,
            setMessageIds: setMessageIds,
            getDescriptionProps: getDescriptionProps
        };
    }, [
        controlId,
        registerControlId,
        labelId,
        setLabelId,
        messageIds,
        setMessageIds,
        getDescriptionProps
    ]);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(LabelableContext.Provider, {
        value: contextValue,
        children: props.children
    });
};
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/field/utils/getCombinedFieldValidityData.js
/**
* Combines the field's client-side, stateful validity data with the external invalid state to
* determine the field's true validity.
*/ function getCombinedFieldValidityData(validityData, invalid) {
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validityData), {
        state: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validityData.state), {
            valid: !invalid && validityData.state.valid
        })
    });
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/field/root/useFieldValidation.js
var validityKeys = Object.keys(DEFAULT_VALIDITY_STATE);
function isOnlyValueMissing(state) {
    if (!state || state.valid || !state.valueMissing) return false;
    var onlyValueMissing = false;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = validityKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (key === "valid") continue;
            if (key === "valueMissing") onlyValueMissing = state[key];
            if (state[key]) onlyValueMissing = false;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return onlyValueMissing;
}
function useFieldValidation(params) {
    var ref = useFormContext(), formRef = ref.formRef, clearErrors = ref.clearErrors;
    var setValidityData = params.setValidityData, validate = params.validate, validityData = params.validityData, validationDebounceTime = params.validationDebounceTime, invalid = params.invalid, markedDirtyRef = params.markedDirtyRef, state = params.state, name = params.name, shouldValidateOnChange = params.shouldValidateOnChange;
    var ref1 = useLabelableContext(), controlId = ref1.controlId, getDescriptionProps = ref1.getDescriptionProps;
    var timeout = useTimeout();
    var inputRef = react.useRef(null);
    var commit = useStableCallback(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(value) {
            var revalidate, element, currentNativeValidity, nextValidityData, currentFieldData, currentNativeValidityObject, result, validationErrors, nextState, defaultValidationMessage, validateOnChange, resultOrPromise, nextValidityData1, currentFieldData1;
            var _arguments = arguments;
            function getState(el) {
                var computedState = validityKeys.reduce(function(acc, key) {
                    acc[key] = el.validity[key];
                    return acc;
                }, {});
                var hasOnlyValueMissingError = false;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = validityKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (key === "valid") continue;
                        if (key === "valueMissing" && computedState[key]) hasOnlyValueMissingError = true;
                        else if (computedState[key]) return computedState;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (hasOnlyValueMissingError && !markedDirtyRef.current) {
                    computedState.valid = true;
                    computedState.valueMissing = false;
                }
                return computedState;
            }
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        revalidate = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : false;
                        element = inputRef.current;
                        if (!element) return [
                            2
                        ];
                        if (revalidate) {
                            if (state.valid !== false) return [
                                2
                            ];
                            currentNativeValidity = element.validity;
                            if (!currentNativeValidity.valueMissing) {
                                nextValidityData = {
                                    value: value,
                                    state: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, DEFAULT_VALIDITY_STATE), {
                                        valid: true
                                    }),
                                    error: "",
                                    errors: [],
                                    initialValue: validityData.initialValue
                                };
                                element.setCustomValidity("");
                                if (controlId) {
                                    currentFieldData = formRef.current.fields.get(controlId);
                                    if (currentFieldData) formRef.current.fields.set(controlId, (0,src_object_spread/* default */.Z)({}, currentFieldData, getCombinedFieldValidityData(nextValidityData, false)));
                                }
                                setValidityData(nextValidityData);
                                return [
                                    2
                                ];
                            }
                            currentNativeValidityObject = validityKeys.reduce(function(acc, key) {
                                acc[key] = currentNativeValidity[key];
                                return acc;
                            }, {});
                            if (!currentNativeValidityObject.valid && !isOnlyValueMissing(currentNativeValidityObject)) return [
                                2
                            ];
                        }
                        timeout.clear();
                        result = null;
                        validationErrors = [];
                        nextState = getState(element);
                        validateOnChange = shouldValidateOnChange();
                        if (!(element.validationMessage && !validateOnChange)) return [
                            3,
                            1
                        ];
                        defaultValidationMessage = element.validationMessage;
                        validationErrors = [
                            element.validationMessage
                        ];
                        return [
                            3,
                            5
                        ];
                    case 1:
                        resultOrPromise = validate(value, Array.from(formRef.current.fields.values()).reduce(function(acc, field) {
                            if (field.name) acc[field.name] = field.getValue();
                            return acc;
                        }, {}));
                        if (!(typeof resultOrPromise === "object" && resultOrPromise !== null && "then" in resultOrPromise)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            resultOrPromise
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        result = resultOrPromise;
                        _state.label = 4;
                    case 4:
                        if (result !== null) {
                            nextState.valid = false;
                            nextState.customError = true;
                            if (Array.isArray(result)) {
                                validationErrors = result;
                                element.setCustomValidity(result.join("\n"));
                            } else if (result) {
                                validationErrors = [
                                    result
                                ];
                                element.setCustomValidity(result);
                            }
                        } else if (validateOnChange) {
                            element.setCustomValidity("");
                            nextState.customError = false;
                            if (element.validationMessage) {
                                defaultValidationMessage = element.validationMessage;
                                validationErrors = [
                                    element.validationMessage
                                ];
                            } else if (element.validity.valid && !nextState.valid) nextState.valid = true;
                        }
                        _state.label = 5;
                    case 5:
                        nextValidityData1 = {
                            value: value,
                            state: nextState,
                            error: defaultValidationMessage !== null && defaultValidationMessage !== void 0 ? defaultValidationMessage : Array.isArray(result) ? result[0] : result !== null && result !== void 0 ? result : "",
                            errors: validationErrors,
                            initialValue: validityData.initialValue
                        };
                        if (controlId) {
                            currentFieldData1 = formRef.current.fields.get(controlId);
                            if (currentFieldData1) formRef.current.fields.set(controlId, (0,src_object_spread/* default */.Z)({}, currentFieldData1, getCombinedFieldValidityData(nextValidityData1, invalid)));
                        }
                        setValidityData(nextValidityData1);
                        return [
                            2
                        ];
                }
            });
        });
        return function(value) {
            return _ref.apply(this, arguments);
        };
    }());
    var getValidationProps = react.useCallback(function() {
        var externalProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return mergeProps$1(getDescriptionProps, state.valid === false ? {
            "aria-invalid": true
        } : EMPTY_OBJECT, externalProps);
    }, [
        getDescriptionProps,
        state.valid
    ]);
    var getInputValidationProps = react.useCallback(function() {
        var externalProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return mergeProps$1({
            onChange: function onChange(event) {
                if (event.nativeEvent.defaultPrevented) return;
                clearErrors(name);
                if (!shouldValidateOnChange()) {
                    commit(event.currentTarget.value, true);
                    return;
                }
                var element = event.currentTarget;
                if (element.value === "") {
                    commit(element.value);
                    return;
                }
                timeout.clear();
                if (validationDebounceTime) timeout.start(validationDebounceTime, function() {
                    commit(element.value);
                });
                else commit(element.value);
            }
        }, getValidationProps(externalProps));
    }, [
        getValidationProps,
        clearErrors,
        name,
        timeout,
        commit,
        validationDebounceTime,
        shouldValidateOnChange
    ]);
    return react.useMemo(function() {
        return {
            getValidationProps: getValidationProps,
            getInputValidationProps: getInputValidationProps,
            inputRef: inputRef,
            commit: commit
        };
    }, [
        getValidationProps,
        getInputValidationProps,
        commit
    ]);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/field-register-control/useFieldControlRegistration.js
function useFieldControlRegistration(params) {
    var refreshRegistration = function refreshRegistration() {
        var registration = registrationRef.current;
        if (!registration || !registration.id) return;
        var _controlRef;
        formRef.current.fields.set(registration.id, {
            getValue: getValue,
            name: name,
            controlRef: (_controlRef = registration.controlRef) !== null && _controlRef !== void 0 ? _controlRef : fallbackControlRef,
            validityData: getCombinedFieldValidityData(validityData, invalid),
            validate: validate
        });
    };
    var deleteRegistration = function deleteRegistration() {
        var id = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : (ref = registrationRef.current) === null || ref === void 0 ? void 0 : ref.id;
        if (id) formRef.current.fields.delete(id);
    };
    var syncInitialValue = function syncInitialValue() {
        var registration = registrationRef.current;
        if (!registration) return;
        var initialValue = registration.value;
        if (initialValue === void 0) initialValue = getValue();
        if (validityData.initialValue === null && initialValue !== null) setValidityData(function(prev) {
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, prev), {
                initialValue: initialValue
            });
        });
    };
    var ref;
    var commit = params.commit, invalid = params.invalid, markedDirtyRef = params.markedDirtyRef, name = params.name, setValidityData = params.setValidityData, validityData = params.validityData;
    var formRef = useFormContext().formRef;
    var activeFieldControlSourceRef = react.useRef(null);
    var registrationRef = react.useRef(null);
    var fallbackControlRef = react.useRef(null);
    var getValue = useStableCallback(function() {
        var registration = registrationRef.current;
        if (!registration) return;
        if (registration.getValue) return registration.getValue();
        return registration.value;
    });
    var validate = useStableCallback(function() {
        var flushSync = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        var registration = registrationRef.current;
        if (!registration) return;
        var nextValue = registration.value;
        if (nextValue === void 0) nextValue = getValue();
        markedDirtyRef.current = true;
        if (!flushSync) commit(nextValue);
        else react_dom.flushSync(function() {
            return commit(nextValue);
        });
    });
    useIsoLayoutEffect(function() {
        var registration = registrationRef.current;
        if (!registration || !registration.id) return;
        var _controlRef;
        formRef.current.fields.set(registration.id, {
            getValue: getValue,
            name: name,
            controlRef: (_controlRef = registration.controlRef) !== null && _controlRef !== void 0 ? _controlRef : fallbackControlRef,
            validityData: getCombinedFieldValidityData(validityData, invalid),
            validate: validate
        });
    }, [
        formRef,
        getValue,
        invalid,
        name,
        validate,
        validityData
    ]);
    useIsoLayoutEffect(function() {
        var fields = formRef.current.fields;
        return function() {
            var ref;
            var id = (ref = registrationRef.current) === null || ref === void 0 ? void 0 : ref.id;
            if (id) fields.delete(id);
        };
    }, [
        formRef
    ]);
    return useStableCallback(function(source, registration) {
        var ref;
        if (!registration) {
            if (activeFieldControlSourceRef.current === source) {
                activeFieldControlSourceRef.current = null;
                deleteRegistration();
                registrationRef.current = null;
            }
            return;
        }
        var previousId = (ref = registrationRef.current) === null || ref === void 0 ? void 0 : ref.id;
        activeFieldControlSourceRef.current = source;
        registrationRef.current = registration;
        if (previousId && previousId !== registration.id) deleteRegistration(previousId);
        syncInitialValue();
        refreshRegistration();
    });
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/field/root/FieldRoot.js
/**
* @internal
*/ var FieldRootInner = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function FieldRootInner(componentProps, forwardedRef) {
    var ref = useFormContext(), errors = ref.errors, formValidationMode = ref.validationMode, submitAttemptedRef = ref.submitAttemptedRef;
    var render = componentProps.render, className = componentProps.className, validateProp = componentProps.validate, _validationDebounceTime = componentProps.validationDebounceTime, validationDebounceTime = _validationDebounceTime === void 0 ? 0 : _validationDebounceTime, _validationMode = componentProps.validationMode, validationMode = _validationMode === void 0 ? formValidationMode : _validationMode, name = componentProps.name, tmp = componentProps.disabled, disabledProp = tmp === void 0 ? false : tmp, invalidProp = componentProps.invalid, dirtyProp = componentProps.dirty, touchedProp = componentProps.touched, actionsRef = componentProps.actionsRef, style = componentProps.style, elementProps = (0,src_object_without_properties/* default */.Z)(componentProps, [
        "render",
        "className",
        "validate",
        "validationDebounceTime",
        "validationMode",
        "name",
        "disabled",
        "invalid",
        "dirty",
        "touched",
        "actionsRef",
        "style"
    ]);
    var ref1 = useFieldsetRootContext(), disabledFieldset = ref1.disabled;
    var validate = useStableCallback(validateProp || function() {
        return null;
    });
    var disabled = disabledFieldset || disabledProp;
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), touchedState = ref2[0], setTouchedUnwrapped = ref2[1];
    var ref3 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), dirtyState = ref3[0], setDirtyUnwrapped = ref3[1];
    var ref4 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), filled = ref4[0], setFilled = ref4[1];
    var ref5 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), focused = ref5[0], setFocused = ref5[1];
    var dirty = dirtyProp !== null && dirtyProp !== void 0 ? dirtyProp : dirtyState;
    var touched = touchedProp !== null && touchedProp !== void 0 ? touchedProp : touchedState;
    var markedDirtyRef = react.useRef(false);
    var setDirty = useStableCallback(function(value) {
        if (dirtyProp !== void 0) return;
        if (value) markedDirtyRef.current = true;
        setDirtyUnwrapped(value);
    });
    var setTouched = useStableCallback(function(value) {
        if (touchedProp !== void 0) return;
        setTouchedUnwrapped(value);
    });
    var shouldValidateOnChange = useStableCallback(function() {
        return validationMode === "onChange" || validationMode === "onSubmit" && submitAttemptedRef.current;
    });
    var hasFormError = !!name && Object.hasOwn(errors, name) && errors[name] !== void 0;
    var invalid = invalidProp === true || hasFormError;
    var ref6 = (0,src_sliced_to_array/* default */.Z)(react.useState({
        state: DEFAULT_VALIDITY_STATE,
        error: "",
        errors: [],
        value: null,
        initialValue: null
    }), 2), validityData = ref6[0], setValidityData = ref6[1];
    var valid = !invalid && validityData.state.valid;
    var state = react.useMemo(function() {
        return {
            disabled: disabled,
            touched: touched,
            dirty: dirty,
            valid: valid,
            filled: filled,
            focused: focused
        };
    }, [
        disabled,
        touched,
        dirty,
        valid,
        filled,
        focused
    ]);
    var validation = useFieldValidation({
        setValidityData: setValidityData,
        validate: validate,
        validityData: validityData,
        validationDebounceTime: validationDebounceTime,
        invalid: invalid,
        markedDirtyRef: markedDirtyRef,
        state: state,
        name: name,
        shouldValidateOnChange: shouldValidateOnChange
    });
    var handleImperativeValidate = react.useCallback(function() {
        markedDirtyRef.current = true;
        validation.commit(validityData.value);
    }, [
        validation,
        validityData
    ]);
    var registerFieldControl = useFieldControlRegistration({
        commit: validation.commit,
        invalid: invalid,
        markedDirtyRef: markedDirtyRef,
        name: name,
        setValidityData: setValidityData,
        validityData: validityData
    });
    react.useImperativeHandle(actionsRef, function() {
        return {
            validate: handleImperativeValidate
        };
    }, [
        handleImperativeValidate
    ]);
    var contextValue = react.useMemo(function() {
        return {
            invalid: invalid,
            name: name,
            validityData: validityData,
            setValidityData: setValidityData,
            disabled: disabled,
            touched: touched,
            setTouched: setTouched,
            dirty: dirty,
            setDirty: setDirty,
            filled: filled,
            setFilled: setFilled,
            focused: focused,
            setFocused: setFocused,
            validate: validate,
            validationMode: validationMode,
            validationDebounceTime: validationDebounceTime,
            shouldValidateOnChange: shouldValidateOnChange,
            state: state,
            markedDirtyRef: markedDirtyRef,
            registerFieldControl: registerFieldControl,
            validation: validation
        };
    }, [
        invalid,
        name,
        validityData,
        disabled,
        touched,
        setTouched,
        dirty,
        setDirty,
        filled,
        setFilled,
        focused,
        setFocused,
        validate,
        validationMode,
        validationDebounceTime,
        shouldValidateOnChange,
        state,
        registerFieldControl,
        validation
    ]);
    var element = useRenderElement("div", componentProps, {
        ref: forwardedRef,
        state: state,
        props: elementProps,
        stateAttributesMapping: fieldValidityMapping
    });
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(FieldRootContext.Provider, {
        value: contextValue,
        children: element
    });
});
/**
* Groups all parts of the field.
* Renders a `<div>` element.
*
* Documentation: [Base UI Field](https://base-ui.com/react/components/field)
*/ if (false) {}
var FieldRoot = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function FieldRoot(componentProps, forwardedRef) {
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(LabelableProvider, {
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(FieldRootInner, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, componentProps), {
            ref: forwardedRef
        }))
    });
});
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/field/label/FieldLabel.js
/**
* An accessible label that is automatically associated with the field control.
* Renders a `<label>` element.
*
* Documentation: [Base UI Field](https://base-ui.com/react/components/field)
*/ var FieldLabel = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function FieldLabel(componentProps, forwardedRef) {
    var render = componentProps.render, className = componentProps.className, style = componentProps.style, idProp = componentProps.id, _nativeLabel = componentProps.nativeLabel, nativeLabel = _nativeLabel === void 0 ? true : _nativeLabel, elementProps = (0,src_object_without_properties/* default */.Z)(componentProps, [
        "render",
        "className",
        "style",
        "id",
        "nativeLabel"
    ]);
    var fieldRootContext = useFieldRootContext(false);
    var labelId = useLabelableContext().labelId;
    var labelRef = react.useRef(null);
    var labelProps = useLabel({
        id: labelId !== null && labelId !== void 0 ? labelId : idProp,
        native: nativeLabel
    });
    if (false) {}
    return useRenderElement("label", componentProps, {
        ref: [
            forwardedRef,
            labelRef
        ],
        state: fieldRootContext.state,
        props: [
            labelProps,
            elementProps
        ],
        stateAttributesMapping: fieldValidityMapping
    });
});
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/field/error/FieldError.js
var stateAttributesMapping$7 = (0,src_object_spread/* default */.Z)({}, fieldValidityMapping, transitionStatusMapping);
/**
* An error message displayed if the field control fails validation.
* Renders a `<div>` element.
*
* Documentation: [Base UI Field](https://base-ui.com/react/components/field)
*/ var FieldError = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function FieldError(componentProps, forwardedRef) {
    var render = componentProps.render, idProp = componentProps.id, className = componentProps.className, match = componentProps.match, style = componentProps.style, elementProps = (0,src_object_without_properties/* default */.Z)(componentProps, [
        "render",
        "id",
        "className",
        "match",
        "style"
    ]);
    var id = useBaseUiId(idProp);
    var ref = useFieldRootContext(false), validityData = ref.validityData, fieldState = ref.state, name = ref.name;
    var setMessageIds = useLabelableContext().setMessageIds;
    var errors = useFormContext().errors;
    var formError = name ? errors[name] : null;
    var hasSpecificMatch = typeof match === "string";
    var rendered = false;
    if (match === true) rendered = true;
    else if (hasSpecificMatch) rendered = Boolean(validityData.state[match]);
    else rendered = Boolean(formError) || validityData.state.valid === false;
    var ref1 = useTransitionStatus(rendered), mounted = ref1.mounted, transitionStatus = ref1.transitionStatus, setMounted = ref1.setMounted;
    useIsoLayoutEffect(function() {
        if (!rendered || !id) return;
        setMessageIds(function(v) {
            return v.concat(id);
        });
        return function() {
            setMessageIds(function(v) {
                return v.filter(function(item) {
                    return item !== id;
                });
            });
        };
    }, [
        rendered,
        id,
        setMessageIds
    ]);
    var errorRef = react.useRef(null);
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), lastRenderedMessage = ref2[0], setLastRenderedMessage = ref2[1];
    var ref3 = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), lastRenderedMessageKey = ref3[0], setLastRenderedMessageKey = ref3[1];
    var clientErrorMessage = validityData.errors.length > 1 ? /* @__PURE__ */ (0,jsx_runtime.jsx)("ul", {
        children: validityData.errors.map(function(message) {
            return /* @__PURE__ */ (0,jsx_runtime.jsx)("li", {
                children: message
            }, message);
        })
    }) : validityData.error;
    var errorMessage = hasSpecificMatch ? clientErrorMessage : formError || clientErrorMessage;
    var errorKey = validityData.error;
    if (formError != null) errorKey = Array.isArray(formError) ? JSON.stringify(formError) : formError;
    else if (validityData.errors.length > 1) errorKey = JSON.stringify(validityData.errors);
    if (rendered && errorKey !== lastRenderedMessageKey) {
        setLastRenderedMessageKey(errorKey);
        setLastRenderedMessage(errorMessage);
    }
    useOpenChangeComplete({
        open: rendered,
        ref: errorRef,
        onComplete: function onComplete() {
            if (!rendered) setMounted(false);
        }
    });
    var state = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, fieldState), {
        transitionStatus: transitionStatus
    });
    var element = useRenderElement("div", componentProps, {
        ref: [
            forwardedRef,
            errorRef
        ],
        state: state,
        props: [
            {
                id: id,
                children: rendered ? errorMessage : lastRenderedMessage
            },
            elementProps
        ],
        stateAttributesMapping: stateAttributesMapping$7,
        enabled: mounted
    });
    if (!mounted) return null;
    return element;
});
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/field/description/FieldDescription.js
/**
* A paragraph with additional information about the field.
* Renders a `<p>` element.
*
* Documentation: [Base UI Field](https://base-ui.com/react/components/field)
*/ var FieldDescription = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function FieldDescription(componentProps, forwardedRef) {
    var render = componentProps.render, idProp = componentProps.id, className = componentProps.className, style = componentProps.style, elementProps = (0,src_object_without_properties/* default */.Z)(componentProps, [
        "render",
        "id",
        "className",
        "style"
    ]);
    var id = useBaseUiId(idProp);
    var fieldRootContext = useFieldRootContext(false);
    var setMessageIds = useLabelableContext().setMessageIds;
    useIsoLayoutEffect(function() {
        if (!id) return;
        setMessageIds(function(v) {
            return v.concat(id);
        });
        return function() {
            setMessageIds(function(v) {
                return v.filter(function(item) {
                    return item !== id;
                });
            });
        };
    }, [
        id,
        setMessageIds
    ]);
    return useRenderElement("p", componentProps, {
        ref: forwardedRef,
        state: fieldRootContext.state,
        props: [
            {
                id: id
            },
            elementProps
        ],
        stateAttributesMapping: fieldValidityMapping
    });
});
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/field/control/FieldControl.js
/**
* The form control to label and validate.
* Renders an `<input>` element.
*
* You can omit this part and use any Base UI input component instead. For example,
* [Input](https://base-ui.com/react/components/input), [Checkbox](https://base-ui.com/react/components/checkbox),
* or [Select](https://base-ui.com/react/components/select), among others, will work with Field out of the box.
*
* Documentation: [Base UI Field](https://base-ui.com/react/components/field)
*/ var FieldControl = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function FieldControl(componentProps, forwardedRef) {
    var render = componentProps.render, className = componentProps.className, idProp = componentProps.id, nameProp = componentProps.name, valueProp = componentProps.value, tmp = componentProps.disabled, disabledProp = tmp === void 0 ? false : tmp, onValueChange = componentProps.onValueChange, defaultValue = componentProps.defaultValue, _autoFocus = componentProps.autoFocus, autoFocus = _autoFocus === void 0 ? false : _autoFocus, style = componentProps.style, elementProps = (0,src_object_without_properties/* default */.Z)(componentProps, [
        "render",
        "className",
        "id",
        "name",
        "value",
        "disabled",
        "onValueChange",
        "defaultValue",
        "autoFocus",
        "style"
    ]);
    var ref = useFieldRootContext(), fieldState = ref.state, fieldName = ref.name, fieldDisabled = ref.disabled, setTouched = ref.setTouched, setDirty = ref.setDirty, validityData = ref.validityData, setFocused = ref.setFocused, setFilled = ref.setFilled, validationMode = ref.validationMode, validation = ref.validation;
    var disabled = fieldDisabled || disabledProp;
    var name = fieldName !== null && fieldName !== void 0 ? fieldName : nameProp;
    var state = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, fieldState), {
        disabled: disabled
    });
    var labelId = useLabelableContext().labelId;
    var id = useLabelableId({
        id: idProp
    });
    useIsoLayoutEffect(function() {
        var ref;
        var hasExternalValue = valueProp != null;
        if (((ref = validation.inputRef.current) === null || ref === void 0 ? void 0 : ref.value) || hasExternalValue && valueProp !== "") setFilled(true);
        else if (hasExternalValue && valueProp === "") setFilled(false);
    }, [
        validation.inputRef,
        setFilled,
        valueProp
    ]);
    var inputRef = react.useRef(null);
    useIsoLayoutEffect(function() {
        if (autoFocus && inputRef.current === activeElement(ownerDocument(inputRef.current))) setFocused(true);
    }, [
        autoFocus,
        setFocused
    ]);
    var ref1 = (0,src_sliced_to_array/* default */.Z)(useControlled({
        controlled: valueProp,
        default: defaultValue,
        name: "FieldControl",
        state: "value"
    }), 1), valueUnwrapped = ref1[0];
    var isControlled = valueProp !== void 0;
    var value = isControlled ? valueUnwrapped : void 0;
    var getFieldValue = useStableCallback(function() {
        var ref;
        return (ref = validation.inputRef.current) === null || ref === void 0 ? void 0 : ref.value;
    });
    useRegisterFieldControl(validation.inputRef, {
        id: id,
        value: value,
        getValue: getFieldValue
    });
    return useRenderElement("input", componentProps, {
        ref: [
            forwardedRef,
            inputRef
        ],
        state: state,
        props: [
            (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
                id: id,
                disabled: disabled,
                name: name,
                ref: validation.inputRef,
                "aria-labelledby": labelId,
                autoFocus: autoFocus
            }, isControlled ? {
                value: value
            } : {
                defaultValue: defaultValue
            }), {
                onChange: function onChange(event) {
                    var inputValue = event.currentTarget.value;
                    onValueChange === null || onValueChange === void 0 ? void 0 : onValueChange(inputValue, createChangeEventDetails(none, event.nativeEvent));
                    setDirty(inputValue !== validityData.initialValue);
                    setFilled(inputValue !== "");
                },
                onFocus: function onFocus() {
                    setFocused(true);
                },
                onBlur: function onBlur(event) {
                    setTouched(true);
                    setFocused(false);
                    if (validationMode === "onBlur") validation.commit(event.currentTarget.value);
                },
                onKeyDown: function onKeyDown(event) {
                    if (event.currentTarget.tagName === "INPUT" && event.key === "Enter") {
                        setTouched(true);
                        validation.commit(event.currentTarget.value);
                    }
                }
            }),
            validation.getInputValidationProps(),
            elementProps
        ],
        stateAttributesMapping: fieldValidityMapping
    });
});
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/input/Input.js
/**
* A native input element that automatically works with [Field](https://base-ui.com/react/components/field).
* Renders an `<input>` element.
*
* Documentation: [Base UI Input](https://base-ui.com/react/components/input)
*/ var Input = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function Input(props, forwardedRef) {
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(FieldControl, (0,src_object_spread/* default */.Z)({
        ref: forwardedRef
    }, props));
});
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/number-field/root/NumberFieldRootContext.js
var NumberFieldRootContext = /* @__PURE__ */ /*#__PURE__*/ react.createContext(void 0);
if (false) {}
function useNumberFieldRootContext() {
    var context = react.useContext(NumberFieldRootContext);
    if (context === void 0) throw new Error( false ? 0 : formatErrorMessage(43));
    return context;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/number-field/utils/stateAttributesMapping.js
var stateAttributesMapping$6 = (0,src_object_spread/* default */.Z)({
    inputValue: function() {
        return null;
    },
    value: function() {
        return null;
    }
}, fieldValidityMapping);
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/utils/formatNumber.js
var cache = /* @__PURE__ */ new Map();
function getFormatter(locale, options) {
    var optionsString = JSON.stringify({
        locale: locale,
        options: options
    });
    var cachedFormatter = cache.get(optionsString);
    if (cachedFormatter) return cachedFormatter;
    var formatter = new Intl.NumberFormat(locale, options);
    cache.set(optionsString, formatter);
    return formatter;
}
function formatNumber(value, locale, options) {
    if (value == null) return "";
    return getFormatter(locale, options).format(value);
}
function formatNumberMaxPrecision(value, locale, options) {
    return formatNumber(value, locale, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, options), {
        maximumFractionDigits: 20
    }));
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/number-field/utils/parse.js
var HAN_NUMERALS = [
    "零",
    "〇",
    "一",
    "二",
    "三",
    "四",
    "五",
    "六",
    "七",
    "八",
    "九"
];
var HAN_NUMERAL_TO_DIGIT = {
    零: "0",
    〇: "0",
    一: "1",
    二: "2",
    三: "3",
    四: "4",
    五: "5",
    六: "6",
    七: "7",
    八: "8",
    九: "9"
};
var ARABIC_NUMERALS = [
    "٠",
    "١",
    "٢",
    "٣",
    "٤",
    "٥",
    "٦",
    "٧",
    "٨",
    "٩"
];
var PERSIAN_NUMERALS = [
    "۰",
    "۱",
    "۲",
    "۳",
    "۴",
    "۵",
    "۶",
    "۷",
    "۸",
    "۹"
];
var FULLWIDTH_NUMERALS = [
    "０",
    "１",
    "２",
    "３",
    "４",
    "５",
    "６",
    "７",
    "８",
    "９"
];
var PERCENTAGES = [
    "%",
    "٪",
    "％",
    "﹪"
];
var PERMILLE = [
    "‰",
    "؉"
];
var UNICODE_MINUS_SIGNS = [
    "−",
    "－",
    "‒",
    "–",
    "—",
    "﹣"
];
var UNICODE_PLUS_SIGNS = [
    "＋",
    "﹢"
];
var ARABIC_RE = new RegExp("[".concat(ARABIC_NUMERALS.join(""), "]"), "g");
var PERSIAN_RE = new RegExp("[".concat(PERSIAN_NUMERALS.join(""), "]"), "g");
var FULLWIDTH_RE = new RegExp("[".concat(FULLWIDTH_NUMERALS.join(""), "]"), "g");
var HAN_RE = new RegExp("[".concat(HAN_NUMERALS.join(""), "]"), "g");
var PERCENT_RE = new RegExp("[".concat(PERCENTAGES.join(""), "]"));
var PERMILLE_RE = new RegExp("[".concat(PERMILLE.join(""), "]"));
var ARABIC_DETECT_RE = /[٠١٢٣٤٥٦٧٨٩]/;
var PERSIAN_DETECT_RE = /[۰۱۲۳۴۵۶۷۸۹]/;
var HAN_DETECT_RE = /[零〇一二三四五六七八九]/;
var FULLWIDTH_DETECT_RE = new RegExp("[".concat(FULLWIDTH_NUMERALS.join(""), "]"));
var BASE_NON_NUMERIC_SYMBOLS = [
    ".",
    ",",
    "．",
    "，",
    "٫",
    "٬"
];
var SPACE_SEPARATOR_RE = RegExp("\\p{Zs}", "u");
var PLUS_SIGNS_WITH_ASCII = [
    "+"
].concat((0,src_to_consumable_array/* default */.Z)(UNICODE_PLUS_SIGNS));
var MINUS_SIGNS_WITH_ASCII = [
    "-"
].concat((0,src_to_consumable_array/* default */.Z)(UNICODE_MINUS_SIGNS));
var escapeRegExp = function(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
};
var escapeClassChar = function(s) {
    return s.replace(/[-\\\]^]/g, function(m) {
        return "\\".concat(m);
    });
};
var charClassFrom = function(chars) {
    return "[".concat(chars.map(escapeClassChar).join(""), "]");
};
var ANY_MINUS_CLASS = charClassFrom([
    "-"
].concat(UNICODE_MINUS_SIGNS));
var ANY_PLUS_CLASS = charClassFrom([
    "+"
].concat(UNICODE_PLUS_SIGNS));
var ANY_MINUS_RE = new RegExp(ANY_MINUS_CLASS, "gu");
var ANY_PLUS_RE = new RegExp(ANY_PLUS_CLASS, "gu");
var ANY_MINUS_DETECT_RE = new RegExp(ANY_MINUS_CLASS);
var ANY_PLUS_DETECT_RE = new RegExp(ANY_PLUS_CLASS);
function getNumberLocaleDetails(locale, options) {
    var parts = getFormatter(locale, options).formatToParts(11111.1);
    var result = {};
    parts.forEach(function(part) {
        result[part.type] = part.value;
    });
    getFormatter(locale).formatToParts(.1).forEach(function(part) {
        if (part.type === "decimal") result[part.type] = part.value;
    });
    return result;
}
function parseNumber(formattedNumber, locale, options) {
    if (formattedNumber == null) return null;
    var input = String(formattedNumber).replace(RegExp("\\p{Cf}", "gu"), "").trim();
    input = input.replace(ANY_MINUS_RE, "-").replace(ANY_PLUS_RE, "+");
    var isNegative = false;
    var trailing = input.match(/([+-])\s*$/);
    if (trailing) {
        if (trailing[1] === "-") isNegative = true;
        input = input.replace(/([+-])\s*$/, "");
    }
    var leading = input.match(/^\s*([+-])/);
    if (leading) {
        if (leading[1] === "-") isNegative = true;
        input = input.replace(/^\s*[+-]/, "");
    }
    var computedLocale = locale;
    if (computedLocale === void 0) {
        if (ARABIC_DETECT_RE.test(input) || PERSIAN_DETECT_RE.test(input)) computedLocale = "ar";
        else if (HAN_DETECT_RE.test(input)) computedLocale = "zh";
    }
    var ref = getNumberLocaleDetails(computedLocale, options), group = ref.group, decimal = ref.decimal, currency = ref.currency;
    var unitParts = getFormatter(computedLocale, options).formatToParts(1).filter(function(p) {
        return p.type === "unit";
    }).map(function(p) {
        return escapeRegExp(p.value);
    });
    var unitRegex = unitParts.length ? new RegExp(unitParts.join("|"), "g") : null;
    var groupRegex = null;
    if (group) {
        var isSpaceGroup = RegExp("\\p{Zs}", "u").test(group);
        var isApostropheGroup = group === "'" || group === "’";
        if (isSpaceGroup) groupRegex = RegExp("\\p{Zs}", "gu");
        else if (isApostropheGroup) groupRegex = /['’]/g;
        else groupRegex = new RegExp(escapeRegExp(group), "g");
    }
    var unformatted = [
        {
            regex: group ? groupRegex : null,
            replacement: ""
        },
        {
            regex: decimal ? new RegExp(escapeRegExp(decimal), "g") : null,
            replacement: "."
        },
        {
            regex: /．/g,
            replacement: "."
        },
        {
            regex: /，/g,
            replacement: ""
        },
        {
            regex: /٫/g,
            replacement: "."
        },
        {
            regex: /٬/g,
            replacement: ""
        },
        {
            regex: currency ? new RegExp(escapeRegExp(currency), "g") : null,
            replacement: ""
        },
        {
            regex: unitRegex,
            replacement: ""
        },
        {
            regex: ARABIC_RE,
            replacement: function(ch) {
                return String(ARABIC_NUMERALS.indexOf(ch));
            }
        },
        {
            regex: PERSIAN_RE,
            replacement: function(ch) {
                return String(PERSIAN_NUMERALS.indexOf(ch));
            }
        },
        {
            regex: FULLWIDTH_RE,
            replacement: function(ch) {
                return String(FULLWIDTH_NUMERALS.indexOf(ch));
            }
        },
        {
            regex: HAN_RE,
            replacement: function(ch) {
                return HAN_NUMERAL_TO_DIGIT[ch];
            }
        }
    ].reduce(function(acc, param) {
        var regex = param.regex, replacement = param.replacement;
        return regex ? acc.replace(regex, replacement) : acc;
    }, input);
    var lastDot = unformatted.lastIndexOf(".");
    if (lastDot !== -1) unformatted = "".concat(unformatted.slice(0, lastDot).replace(/\./g, ""), ".").concat(unformatted.slice(lastDot + 1).replace(/\./g, ""));
    if (/^[-+]?Infinity$/i.test(input) || /[∞]/.test(input)) return null;
    var parseTarget = (isNegative ? "-" : "") + unformatted;
    var num = parseFloat(parseTarget);
    var style = options === null || options === void 0 ? void 0 : options.style;
    var isUnitPercent = style === "unit" && (options === null || options === void 0 ? void 0 : options.unit) === "percent";
    var hasPercentSymbol = PERCENT_RE.test(formattedNumber) || style === "percent";
    if (PERMILLE_RE.test(formattedNumber)) num /= 1e3;
    else if (!isUnitPercent && hasPercentSymbol) num /= 100;
    if (Number.isNaN(num)) return null;
    return num;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/clamp.js
function clamp(val) {
    var min = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Number.MIN_SAFE_INTEGER, max = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Number.MAX_SAFE_INTEGER;
    return Math.max(min, Math.min(val, max));
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/number-field/utils/validate.js
var STEP_EPSILON_FACTOR = 1e-10;
function getFractionDigits(format) {
    var defaultOptions = getFormatter("en-US").resolvedOptions();
    var ref, ref1;
    var minimumFractionDigits = (ref1 = (ref = format === null || format === void 0 ? void 0 : format.minimumFractionDigits) !== null && ref !== void 0 ? ref : defaultOptions.minimumFractionDigits) !== null && ref1 !== void 0 ? ref1 : 0;
    var ref2, ref3;
    return {
        maximumFractionDigits: Math.max((ref3 = (ref2 = format === null || format === void 0 ? void 0 : format.maximumFractionDigits) !== null && ref2 !== void 0 ? ref2 : defaultOptions.maximumFractionDigits) !== null && ref3 !== void 0 ? ref3 : 20, minimumFractionDigits),
        minimumFractionDigits: minimumFractionDigits
    };
}
function roundToFractionDigits(value, maximumFractionDigits) {
    if (!Number.isFinite(value)) return value;
    var digits = Math.min(Math.max(maximumFractionDigits, 0), 20);
    return Number(value.toFixed(digits));
}
function removeFloatingPointErrors(value, format) {
    var maximumFractionDigits = getFractionDigits(format).maximumFractionDigits;
    return roundToFractionDigits(value, maximumFractionDigits);
}
function snapToStep(clampedValue, base, step) {
    var mode = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "directional";
    if (step === 0) return clampedValue;
    var stepSize = Math.abs(step);
    var direction = Math.sign(step);
    var tolerance = stepSize * STEP_EPSILON_FACTOR * direction;
    var divisor = mode === "nearest" ? step : stepSize;
    var rawSteps = (clampedValue - base + tolerance) / divisor;
    var snappedSteps;
    if (mode === "nearest") snappedSteps = Math.round(rawSteps);
    else if (direction > 0) snappedSteps = Math.floor(rawSteps);
    else snappedSteps = Math.ceil(rawSteps);
    return base + snappedSteps * (mode === "nearest" ? step : stepSize);
}
function toValidatedNumber(value, param) {
    var step = param.step, minWithDefault = param.minWithDefault, maxWithDefault = param.maxWithDefault, minWithZeroDefault = param.minWithZeroDefault, format = param.format, snapOnStep = param.snapOnStep, small = param.small, shouldClamp = param.clamp;
    if (value === null) return value;
    var clampedValue = shouldClamp ? clamp(value, minWithDefault, maxWithDefault) : value;
    if (step != null && snapOnStep) {
        if (step === 0) return removeFloatingPointErrors(clampedValue, format);
        var base = minWithZeroDefault;
        if (!small && minWithDefault !== Number.MIN_SAFE_INTEGER) base = minWithDefault;
        return removeFloatingPointErrors(snapToStep(clampedValue, base, step, small ? "nearest" : "directional"), format);
    }
    return removeFloatingPointErrors(clampedValue, format);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/number-field/root/NumberFieldRoot.js
/**
* Groups all parts of the number field and manages its state.
* Renders a `<div>` element.
*
* Documentation: [Base UI Number Field](https://base-ui.com/react/components/number-field)
*/ var NumberFieldRoot = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function NumberFieldRoot(componentProps, forwardedRef) {
    var idProp = componentProps.id, min = componentProps.min, max = componentProps.max, _smallStep = componentProps.smallStep, smallStep = _smallStep === void 0 ? .1 : _smallStep, tmp = componentProps.step, stepProp = tmp === void 0 ? 1 : tmp, _largeStep = componentProps.largeStep, largeStep = _largeStep === void 0 ? 10 : _largeStep, _required = componentProps.required, required = _required === void 0 ? false : _required, tmp1 = componentProps.disabled, disabledProp = tmp1 === void 0 ? false : tmp1, _readOnly = componentProps.readOnly, readOnly = _readOnly === void 0 ? false : _readOnly, form = componentProps.form, nameProp = componentProps.name, defaultValue = componentProps.defaultValue, valueProp = componentProps.value, onValueChangeProp = componentProps.onValueChange, onValueCommittedProp = componentProps.onValueCommitted, _allowWheelScrub = componentProps.allowWheelScrub, allowWheelScrub = _allowWheelScrub === void 0 ? false : _allowWheelScrub, _snapOnStep = componentProps.snapOnStep, snapOnStep = _snapOnStep === void 0 ? false : _snapOnStep, _allowOutOfRange = componentProps.allowOutOfRange, allowOutOfRange = _allowOutOfRange === void 0 ? false : _allowOutOfRange, format = componentProps.format, locale = componentProps.locale, render = componentProps.render, className = componentProps.className, inputRefProp = componentProps.inputRef, style = componentProps.style, elementProps = (0,src_object_without_properties/* default */.Z)(componentProps, [
        "id",
        "min",
        "max",
        "smallStep",
        "step",
        "largeStep",
        "required",
        "disabled",
        "readOnly",
        "form",
        "name",
        "defaultValue",
        "value",
        "onValueChange",
        "onValueCommitted",
        "allowWheelScrub",
        "snapOnStep",
        "allowOutOfRange",
        "format",
        "locale",
        "render",
        "className",
        "inputRef",
        "style"
    ]);
    var ref = useFieldRootContext(), setDirty = ref.setDirty, validityData = ref.validityData, fieldDisabled = ref.disabled, setFilled = ref.setFilled, invalid = ref.invalid, fieldName = ref.name, fieldState = ref.state, validation = ref.validation, shouldValidateOnChange = ref.shouldValidateOnChange;
    var disabled = fieldDisabled || disabledProp;
    var name = fieldName !== null && fieldName !== void 0 ? fieldName : nameProp;
    var step = stepProp === "any" ? 1 : stepProp;
    var ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), isScrubbing = ref1[0], setIsScrubbing = ref1[1];
    var minWithDefault = min !== null && min !== void 0 ? min : Number.MIN_SAFE_INTEGER;
    var maxWithDefault = max !== null && max !== void 0 ? max : Number.MAX_SAFE_INTEGER;
    var minWithZeroDefault = min !== null && min !== void 0 ? min : 0;
    var formatStyle = format === null || format === void 0 ? void 0 : format.style;
    var inputRef = react.useRef(null);
    var hiddenInputRef = useMergedRefs(inputRefProp, validation.inputRef);
    var id = useLabelableId({
        id: idProp
    });
    var ref2 = (0,src_sliced_to_array/* default */.Z)(useControlled({
        controlled: valueProp,
        default: defaultValue,
        name: "NumberField",
        state: "value"
    }), 2), valueUnwrapped = ref2[0], setValueUnwrapped = ref2[1];
    var value = valueUnwrapped !== null && valueUnwrapped !== void 0 ? valueUnwrapped : null;
    var valueRef = useValueAsRef(value);
    useIsoLayoutEffect(function() {
        setFilled(value !== null);
    }, [
        setFilled,
        value
    ]);
    var forceRender = useForcedRerendering();
    var formatOptionsRef = useValueAsRef(format);
    var hasPendingCommitRef = react.useRef(false);
    var onValueCommitted = useStableCallback(function(nextValue, eventDetails) {
        hasPendingCommitRef.current = false;
        onValueCommittedProp === null || onValueCommittedProp === void 0 ? void 0 : onValueCommittedProp(nextValue, eventDetails);
    });
    var allowInputSyncRef = react.useRef(true);
    var lastChangedValueRef = react.useRef(null);
    var ref3 = (0,src_sliced_to_array/* default */.Z)(react.useState(function() {
        if (valueProp !== void 0) return getControlledInputValue(value, locale, format);
        return formatNumber(value, locale, format);
    }), 2), inputValue = ref3[0], setInputValue = ref3[1];
    var ref4 = (0,src_sliced_to_array/* default */.Z)(react.useState("numeric"), 2), inputMode = ref4[0], setInputMode = ref4[1];
    var getAllowedNonNumericKeys = useStableCallback(function() {
        var ref = getNumberLocaleDetails(locale, format), decimal = ref.decimal, group = ref.group, currency = ref.currency, literal = ref.literal;
        var keys = /* @__PURE__ */ new Set();
        BASE_NON_NUMERIC_SYMBOLS.forEach(function(symbol) {
            return keys.add(symbol);
        });
        if (decimal) keys.add(decimal);
        if (group) {
            keys.add(group);
            if (SPACE_SEPARATOR_RE.test(group)) keys.add(" ");
        }
        var allowPercentSymbols = formatStyle === "percent" || formatStyle === "unit" && (format === null || format === void 0 ? void 0 : format.unit) === "percent";
        var allowPermilleSymbols = formatStyle === "percent" || formatStyle === "unit" && (format === null || format === void 0 ? void 0 : format.unit) === "permille";
        if (allowPercentSymbols) PERCENTAGES.forEach(function(key) {
            return keys.add(key);
        });
        if (allowPermilleSymbols) PERMILLE.forEach(function(key) {
            return keys.add(key);
        });
        if (formatStyle === "currency" && currency) keys.add(currency);
        if (literal) {
            Array.from(literal).forEach(function(char) {
                return keys.add(char);
            });
            if (SPACE_SEPARATOR_RE.test(literal)) keys.add(" ");
        }
        PLUS_SIGNS_WITH_ASCII.forEach(function(key) {
            return keys.add(key);
        });
        if (minWithDefault < 0) MINUS_SIGNS_WITH_ASCII.forEach(function(key) {
            return keys.add(key);
        });
        return keys;
    });
    var getStepAmount = useStableCallback(function(event) {
        if (event === null || event === void 0 ? void 0 : event.altKey) return smallStep;
        if (event === null || event === void 0 ? void 0 : event.shiftKey) return largeStep;
        return step;
    });
    var setValue = useStableCallback(function(unvalidatedValue, details) {
        var eventWithOptionalKeyState = details.event;
        var dir = details.direction;
        var reason = details.reason;
        var shouldClampValue = !allowOutOfRange || !(reason === "input-change" || reason === "input-blur" || reason === "input-paste" || reason === "input-clear" || reason === "none");
        var ref;
        var validatedValue = toValidatedNumber(unvalidatedValue, {
            step: dir ? getStepAmount(eventWithOptionalKeyState) * dir : void 0,
            format: formatOptionsRef.current,
            minWithDefault: minWithDefault,
            maxWithDefault: maxWithDefault,
            minWithZeroDefault: minWithZeroDefault,
            snapOnStep: snapOnStep,
            small: (ref = eventWithOptionalKeyState === null || eventWithOptionalKeyState === void 0 ? void 0 : eventWithOptionalKeyState.altKey) !== null && ref !== void 0 ? ref : false,
            clamp: shouldClampValue
        });
        var isInputReason = details.reason === "input-change" || details.reason === "input-clear" || details.reason === "input-blur" || details.reason === "input-paste" || details.reason === "none";
        var shouldFireChange = validatedValue !== value || isInputReason && (unvalidatedValue !== value || allowInputSyncRef.current === false);
        if (shouldFireChange) {
            lastChangedValueRef.current = validatedValue;
            onValueChangeProp === null || onValueChangeProp === void 0 ? void 0 : onValueChangeProp(validatedValue, details);
            if (details.isCanceled) return shouldFireChange;
            setValueUnwrapped(validatedValue);
            setDirty(validatedValue !== validityData.initialValue);
            hasPendingCommitRef.current = true;
        }
        if (allowInputSyncRef.current) setInputValue(formatNumber(validatedValue, locale, format));
        forceRender();
        return shouldFireChange;
    });
    var incrementValue = useStableCallback(function(amount, param) {
        var direction = param.direction, currentValue = param.currentValue, event = param.event, reason = param.reason;
        var prevValue = currentValue == null ? valueRef.current : currentValue;
        return setValue(typeof prevValue === "number" ? prevValue + amount * direction : Math.max(0, min !== null && min !== void 0 ? min : 0), createChangeEventDetails(reason, event, void 0, {
            direction: direction
        }));
    });
    useIsoLayoutEffect(function syncFormattedInputValueOnValueChange() {
        if (!allowInputSyncRef.current) return;
        var nextInputValue = valueProp !== void 0 ? getControlledInputValue(value, locale, format) : formatNumber(value, locale, format);
        if (nextInputValue !== inputValue) setInputValue(nextInputValue);
    });
    useIsoLayoutEffect(function setDynamicInputModeForIOS() {
        if (!isIOS) return;
        var computedInputMode = "text";
        if (minWithDefault >= 0) computedInputMode = "decimal";
        setInputMode(computedInputMode);
    }, [
        minWithDefault,
        formatStyle
    ]);
    react.useEffect(function registerElementWheelListener() {
        var handleWheel = function handleWheel(event) {
            if (event.ctrlKey || activeElement(ownerDocument(inputRef.current)) !== inputRef.current) return;
            event.preventDefault();
            var ref;
            incrementValue((ref = getStepAmount(event)) !== null && ref !== void 0 ? ref : 1, {
                direction: event.deltaY > 0 ? -1 : 1,
                event: event,
                reason: "wheel"
            });
        };
        var element = inputRef.current;
        if (disabled || readOnly || !allowWheelScrub || !element) return;
        return addEventListener(element, "wheel", handleWheel);
    }, [
        allowWheelScrub,
        incrementValue,
        disabled,
        readOnly,
        largeStep,
        step,
        getStepAmount
    ]);
    var state = react.useMemo(function() {
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, fieldState), {
            disabled: disabled,
            readOnly: readOnly,
            required: required,
            value: value,
            inputValue: inputValue,
            scrubbing: isScrubbing
        });
    }, [
        fieldState,
        disabled,
        readOnly,
        required,
        value,
        inputValue,
        isScrubbing
    ]);
    var contextValue = react.useMemo(function() {
        return {
            inputRef: inputRef,
            inputValue: inputValue,
            value: value,
            minWithDefault: minWithDefault,
            maxWithDefault: maxWithDefault,
            disabled: disabled,
            readOnly: readOnly,
            id: id,
            setValue: setValue,
            incrementValue: incrementValue,
            getStepAmount: getStepAmount,
            allowInputSyncRef: allowInputSyncRef,
            formatOptionsRef: formatOptionsRef,
            valueRef: valueRef,
            lastChangedValueRef: lastChangedValueRef,
            hasPendingCommitRef: hasPendingCommitRef,
            name: name,
            required: required,
            invalid: invalid,
            inputMode: inputMode,
            getAllowedNonNumericKeys: getAllowedNonNumericKeys,
            min: min,
            max: max,
            setInputValue: setInputValue,
            locale: locale,
            isScrubbing: isScrubbing,
            setIsScrubbing: setIsScrubbing,
            state: state,
            onValueCommitted: onValueCommitted
        };
    }, [
        inputRef,
        inputValue,
        value,
        minWithDefault,
        maxWithDefault,
        disabled,
        readOnly,
        id,
        setValue,
        incrementValue,
        getStepAmount,
        formatOptionsRef,
        valueRef,
        name,
        required,
        invalid,
        inputMode,
        getAllowedNonNumericKeys,
        min,
        max,
        setInputValue,
        locale,
        isScrubbing,
        state,
        onValueCommitted
    ]);
    var element = useRenderElement("div", componentProps, {
        ref: forwardedRef,
        state: state,
        props: elementProps,
        stateAttributesMapping: stateAttributesMapping$6
    });
    return /* @__PURE__ */ (0,jsx_runtime.jsxs)(NumberFieldRootContext.Provider, {
        value: contextValue,
        children: [
            element,
            /* @__PURE__ */ (0,jsx_runtime.jsx)("input", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, validation.getInputValidationProps({
                onFocus: function onFocus() {
                    var ref;
                    (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
                },
                onChange: function onChange(event) {
                    if (event.nativeEvent.defaultPrevented) return;
                    var nextValue = event.currentTarget.valueAsNumber;
                    var parsedValue = Number.isNaN(nextValue) ? null : nextValue;
                    var details = createChangeEventDetails(none, event.nativeEvent);
                    setDirty(parsedValue !== validityData.initialValue);
                    setValue(parsedValue, details);
                    if (shouldValidateOnChange()) validation.commit(parsedValue);
                }
            })), {
                ref: hiddenInputRef,
                type: "number",
                form: form,
                name: name,
                value: value !== null && value !== void 0 ? value : "",
                min: min,
                max: max,
                step: stepProp,
                disabled: disabled,
                required: required,
                "aria-hidden": true,
                tabIndex: -1,
                style: name ? visuallyHiddenInput : visuallyHidden,
                suppressHydrationWarning: true
            }))
        ]
    });
});
if (false) {}
function getControlledInputValue(value, locale, format) {
    return (format === null || format === void 0 ? void 0 : format.maximumFractionDigits) != null || (format === null || format === void 0 ? void 0 : format.minimumFractionDigits) != null ? formatNumber(value, locale, format) : formatNumberMaxPrecision(value, locale, format);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/number-field/input/NumberFieldInput.js
var stateAttributesMapping$5 = (0,src_object_spread/* default */.Z)({}, fieldValidityMapping, stateAttributesMapping$6);
var NAVIGATE_KEYS = new Set([
    "Backspace",
    "Delete",
    "ArrowLeft",
    "ArrowRight",
    "Tab",
    "Enter",
    "Escape"
]);
/**
* The native input control in the number field.
* Renders an `<input>` element.
*
* Documentation: [Base UI Number Field](https://base-ui.com/react/components/number-field)
*/ var NumberFieldInput = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function NumberFieldInput(componentProps, forwardedRef) {
    var render = componentProps.render, className = componentProps.className, style = componentProps.style, elementProps = (0,src_object_without_properties/* default */.Z)(componentProps, [
        "render",
        "className",
        "style"
    ]);
    var ref = useNumberFieldRootContext(), allowInputSyncRef = ref.allowInputSyncRef, disabled = ref.disabled, formatOptionsRef = ref.formatOptionsRef, getAllowedNonNumericKeys = ref.getAllowedNonNumericKeys, getStepAmount = ref.getStepAmount, id = ref.id, incrementValue = ref.incrementValue, inputMode = ref.inputMode, inputValue = ref.inputValue, max = ref.max, min = ref.min, name = ref.name, readOnly = ref.readOnly, required = ref.required, setValue = ref.setValue, state = ref.state, setInputValue = ref.setInputValue, locale = ref.locale, inputRef = ref.inputRef, value = ref.value, onValueCommitted = ref.onValueCommitted, lastChangedValueRef = ref.lastChangedValueRef, hasPendingCommitRef = ref.hasPendingCommitRef, valueRef = ref.valueRef;
    var clearErrors = useFormContext().clearErrors;
    var ref1 = useFieldRootContext(), validationMode = ref1.validationMode, setTouched = ref1.setTouched, setFocused = ref1.setFocused, invalid = ref1.invalid, shouldValidateOnChange = ref1.shouldValidateOnChange, validation = ref1.validation;
    var labelId = useLabelableContext().labelId;
    var hasTouchedInputRef = react.useRef(false);
    var blockRevalidationRef = react.useRef(false);
    useRegisterFieldControl(inputRef, {
        id: id,
        value: value
    });
    useValueChanged(value, function(previousValue) {
        var validateOnChange = shouldValidateOnChange();
        clearErrors(name);
        if (validateOnChange) validation.commit(value);
        if (previousValue === value || validateOnChange) return;
        if (blockRevalidationRef.current) {
            blockRevalidationRef.current = false;
            return;
        }
        validation.commit(value, true);
    });
    return useRenderElement("input", componentProps, {
        ref: [
            forwardedRef,
            inputRef
        ],
        state: state,
        props: [
            {
                id: id,
                required: required,
                disabled: disabled,
                readOnly: readOnly,
                inputMode: inputMode,
                value: inputValue,
                type: "text",
                autoComplete: "off",
                autoCorrect: "off",
                spellCheck: "false",
                "aria-roledescription": "Number field",
                "aria-invalid": invalid || void 0,
                "aria-labelledby": labelId,
                suppressHydrationWarning: true,
                onFocus: function onFocus(event) {
                    if (event.defaultPrevented || readOnly || disabled) return;
                    setFocused(true);
                    if (hasTouchedInputRef.current) return;
                    hasTouchedInputRef.current = true;
                    var target = event.currentTarget;
                    var length = target.value.length;
                    target.setSelectionRange(length, length);
                },
                onBlur: function onBlur(event) {
                    if (event.defaultPrevented || readOnly || disabled) return;
                    setTouched(true);
                    setFocused(false);
                    var hadManualInput = !allowInputSyncRef.current;
                    var hadPendingProgrammaticChange = hasPendingCommitRef.current;
                    allowInputSyncRef.current = true;
                    if (inputValue.trim() === "") {
                        setValue(null, createChangeEventDetails(inputClear, event.nativeEvent));
                        if (validationMode === "onBlur") validation.commit(null);
                        onValueCommitted(null, createGenericEventDetails(inputClear, event.nativeEvent));
                        return;
                    }
                    var formatOptions = formatOptionsRef.current;
                    var parsedValue = parseNumber(inputValue, locale, formatOptions);
                    if (parsedValue === null) return;
                    var hasExplicitPrecision = (formatOptions === null || formatOptions === void 0 ? void 0 : formatOptions.maximumFractionDigits) != null || (formatOptions === null || formatOptions === void 0 ? void 0 : formatOptions.minimumFractionDigits) != null;
                    var maxFrac = formatOptions === null || formatOptions === void 0 ? void 0 : formatOptions.maximumFractionDigits;
                    var committed = hasExplicitPrecision && typeof maxFrac === "number" ? Number(parsedValue.toFixed(maxFrac)) : parsedValue;
                    var nextEventDetails = createGenericEventDetails(inputBlur, event.nativeEvent);
                    var shouldUpdateValue = value !== committed;
                    var shouldCommit = hadManualInput || shouldUpdateValue || hadPendingProgrammaticChange;
                    if (validationMode === "onBlur") validation.commit(committed);
                    if (shouldUpdateValue) {
                        blockRevalidationRef.current = true;
                        setValue(committed, createChangeEventDetails(inputBlur, event.nativeEvent));
                    }
                    if (shouldCommit) onValueCommitted(committed, nextEventDetails);
                    var canonicalText = formatNumber(committed, locale, formatOptions);
                    if (!(!hasExplicitPrecision && parsedValue === value && inputValue === formatNumberMaxPrecision(parsedValue, locale, formatOptions)) && inputValue !== canonicalText) setInputValue(canonicalText);
                },
                onChange: function onChange(event) {
                    if (event.nativeEvent.defaultPrevented) return;
                    allowInputSyncRef.current = false;
                    var targetValue = event.currentTarget.value;
                    if (targetValue.trim() === "") {
                        setInputValue(targetValue);
                        setValue(null, createChangeEventDetails(inputClear, event.nativeEvent));
                        return;
                    }
                    var allowedNonNumericKeys = getAllowedNonNumericKeys();
                    if (!Array.from(targetValue).every(function(ch) {
                        var isAsciiDigit = ch >= "0" && ch <= "9";
                        var isArabicNumeral = ARABIC_DETECT_RE.test(ch);
                        var isHanNumeral = HAN_DETECT_RE.test(ch);
                        var isPersianNumeral = PERSIAN_DETECT_RE.test(ch);
                        var isFullwidthNumeral = FULLWIDTH_DETECT_RE.test(ch);
                        var isMinus = ANY_MINUS_DETECT_RE.test(ch);
                        return isAsciiDigit || isArabicNumeral || isHanNumeral || isPersianNumeral || isFullwidthNumeral || isMinus || allowedNonNumericKeys.has(ch);
                    })) return;
                    var parsedValue = parseNumber(targetValue, locale, formatOptionsRef.current);
                    setInputValue(targetValue);
                    if (parsedValue !== null) setValue(parsedValue, createChangeEventDetails(inputChange, event.nativeEvent));
                },
                onKeyDown: function onKeyDown(event) {
                    if (event.defaultPrevented || readOnly || disabled) return;
                    var nativeEvent = event.nativeEvent;
                    allowInputSyncRef.current = true;
                    var allowedNonNumericKeys = getAllowedNonNumericKeys();
                    var isAllowedNonNumericKey = allowedNonNumericKeys.has(event.key);
                    var ref = getNumberLocaleDetails(locale, formatOptionsRef.current), decimal = ref.decimal, currency = ref.currency, percentSign = ref.percentSign;
                    var selectionStart = event.currentTarget.selectionStart;
                    var selectionEnd = event.currentTarget.selectionEnd;
                    var isAllSelected = selectionStart === 0 && selectionEnd === inputValue.length;
                    var selectionContainsIndex = function(index) {
                        return selectionStart != null && selectionEnd != null && index >= selectionStart && index < selectionEnd;
                    };
                    if (ANY_MINUS_DETECT_RE.test(event.key) && Array.from(allowedNonNumericKeys).some(function(k) {
                        return ANY_MINUS_DETECT_RE.test(k || "");
                    })) {
                        var existingIndex = inputValue.search(ANY_MINUS_RE);
                        var isReplacingExisting = existingIndex != null && existingIndex !== -1 && selectionContainsIndex(existingIndex);
                        isAllowedNonNumericKey = !(ANY_MINUS_DETECT_RE.test(inputValue) || ANY_PLUS_DETECT_RE.test(inputValue)) || isAllSelected || isReplacingExisting;
                    }
                    if (ANY_PLUS_DETECT_RE.test(event.key) && Array.from(allowedNonNumericKeys).some(function(k) {
                        return ANY_PLUS_DETECT_RE.test(k || "");
                    })) {
                        var existingIndex1 = inputValue.search(ANY_PLUS_RE);
                        var isReplacingExisting1 = existingIndex1 != null && existingIndex1 !== -1 && selectionContainsIndex(existingIndex1);
                        isAllowedNonNumericKey = !(ANY_MINUS_DETECT_RE.test(inputValue) || ANY_PLUS_DETECT_RE.test(inputValue)) || isAllSelected || isReplacingExisting1;
                    }
                    [
                        decimal,
                        currency,
                        percentSign
                    ].forEach(function(symbol) {
                        if (event.key === symbol) {
                            var isSymbolHighlighted = selectionContainsIndex(inputValue.indexOf(symbol));
                            isAllowedNonNumericKey = !inputValue.includes(symbol) || isAllSelected || isSymbolHighlighted;
                        }
                    });
                    var isAsciiDigit = event.key >= "0" && event.key <= "9";
                    var isArabicNumeral = ARABIC_DETECT_RE.test(event.key);
                    var isHanNumeral = HAN_DETECT_RE.test(event.key);
                    var isFullwidthNumeral = FULLWIDTH_DETECT_RE.test(event.key);
                    var isNavigateKey = NAVIGATE_KEYS.has(event.key);
                    if (event.which === 229 || event.altKey || event.ctrlKey || event.metaKey || isAllowedNonNumericKey || isAsciiDigit || isArabicNumeral || isFullwidthNumeral || isHanNumeral || isNavigateKey) return;
                    var parsedValue = parseNumber(inputValue, locale, formatOptionsRef.current);
                    var ref1;
                    var amount = (ref1 = getStepAmount(event)) !== null && ref1 !== void 0 ? ref1 : 1;
                    stopEvent(event);
                    var commitDetails = createGenericEventDetails(keyboard, nativeEvent);
                    if (event.key === "ArrowUp") {
                        incrementValue(amount, {
                            direction: 1,
                            currentValue: parsedValue,
                            event: nativeEvent,
                            reason: keyboard
                        });
                        var _current;
                        onValueCommitted((_current = lastChangedValueRef.current) !== null && _current !== void 0 ? _current : valueRef.current, commitDetails);
                    } else if (event.key === "ArrowDown") {
                        incrementValue(amount, {
                            direction: -1,
                            currentValue: parsedValue,
                            event: nativeEvent,
                            reason: keyboard
                        });
                        var _current1;
                        onValueCommitted((_current1 = lastChangedValueRef.current) !== null && _current1 !== void 0 ? _current1 : valueRef.current, commitDetails);
                    } else if (event.key === "Home" && min != null) {
                        setValue(min, createChangeEventDetails(keyboard, nativeEvent));
                        var _current2;
                        onValueCommitted((_current2 = lastChangedValueRef.current) !== null && _current2 !== void 0 ? _current2 : valueRef.current, commitDetails);
                    } else if (event.key === "End" && max != null) {
                        setValue(max, createChangeEventDetails(keyboard, nativeEvent));
                        var _current3;
                        onValueCommitted((_current3 = lastChangedValueRef.current) !== null && _current3 !== void 0 ? _current3 : valueRef.current, commitDetails);
                    }
                },
                onPaste: function onPaste(event) {
                    if (event.defaultPrevented || readOnly || disabled) return;
                    event.preventDefault();
                    var pastedData = (event.clipboardData || window.Clipboard).getData("text/plain");
                    var parsedValue = parseNumber(pastedData, locale, formatOptionsRef.current);
                    if (parsedValue !== null) {
                        allowInputSyncRef.current = false;
                        setValue(parsedValue, createChangeEventDetails(inputPaste, event.nativeEvent));
                        setInputValue(pastedData);
                    }
                }
            },
            validation.getValidationProps(),
            elementProps
        ],
        stateAttributesMapping: stateAttributesMapping$5
    });
});
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/dialog/root/useDialogRoot.js
function useDialogRoot(params) {
    var store = params.store, parentContext = params.parentContext, actionsRef = params.actionsRef, isDrawer = params.isDrawer;
    var open = store.useState("open");
    var disablePointerDismissal = store.useState("disablePointerDismissal");
    var modal = store.useState("modal");
    var popupElement = store.useState("popupElement");
    var ref = useOpenInteractionType(open), openMethod = ref.openMethod, triggerProps = ref.triggerProps;
    useImplicitActiveTrigger(store);
    var forceUnmount = useOpenStateTransitions(open, store).forceUnmount;
    var handleImperativeClose = React$1.useCallback(function() {
        store.setOpen(false, createChangeEventDetails(imperativeAction));
    }, [
        store
    ]);
    React$1.useImperativeHandle(actionsRef, function() {
        return {
            unmount: forceUnmount,
            close: handleImperativeClose
        };
    }, [
        forceUnmount,
        handleImperativeClose
    ]);
    var floatingRootContext = useSyncedFloatingRootContext({
        popupStore: store,
        onOpenChange: store.setOpen,
        treatPopupAsFloatingElement: true
    });
    var ref1 = _sliced_to_array(React$1.useState(0), 2), ownNestedOpenDialogs = ref1[0], setOwnNestedOpenDialogs = ref1[1];
    var ref2 = _sliced_to_array(React$1.useState(0), 2), ownNestedOpenDrawers = ref2[0], setOwnNestedOpenDrawers = ref2[1];
    var isTopmost = ownNestedOpenDialogs === 0;
    var role = useRole(floatingRootContext);
    var dismiss = useDismiss(floatingRootContext, {
        outsidePressEvent: function outsidePressEvent() {
            if (store.context.internalBackdropRef.current || store.context.backdropRef.current) return "intentional";
            return {
                mouse: modal === "trap-focus" ? "sloppy" : "intentional",
                touch: "sloppy"
            };
        },
        outsidePress: function outsidePress(event) {
            if (!store.context.outsidePressEnabledRef.current) return false;
            if ("button" in event && event.button !== 0) return false;
            if ("touches" in event && event.touches.length !== 1) return false;
            var target = getTarget(event);
            if (isTopmost && !disablePointerDismissal) {
                var eventTarget = target;
                if (modal) return store.context.internalBackdropRef.current || store.context.backdropRef.current ? store.context.internalBackdropRef.current === eventTarget || store.context.backdropRef.current === eventTarget || contains(eventTarget, popupElement) && !(eventTarget === null || eventTarget === void 0 ? void 0 : eventTarget.hasAttribute("data-base-ui-portal")) : true;
                return true;
            }
            return false;
        },
        escapeKey: isTopmost
    });
    useScrollLock(open && modal === true, popupElement);
    var ref3 = useInteractions([
        role,
        dismiss
    ]), getReferenceProps = ref3.getReferenceProps, getFloatingProps = ref3.getFloatingProps, getTriggerProps = ref3.getTriggerProps;
    store.useContextCallback("onNestedDialogOpen", function(dialogCount, drawerCount) {
        setOwnNestedOpenDialogs(dialogCount);
        setOwnNestedOpenDrawers(drawerCount);
    });
    store.useContextCallback("onNestedDialogClose", function() {
        setOwnNestedOpenDialogs(0);
        setOwnNestedOpenDrawers(0);
    });
    React$1.useEffect(function() {
        if ((parentContext === null || parentContext === void 0 ? void 0 : parentContext.onNestedDialogOpen) && open) parentContext.onNestedDialogOpen(ownNestedOpenDialogs + 1, ownNestedOpenDrawers + (isDrawer ? 1 : 0));
        if ((parentContext === null || parentContext === void 0 ? void 0 : parentContext.onNestedDialogClose) && !open) parentContext.onNestedDialogClose();
        return function() {
            if ((parentContext === null || parentContext === void 0 ? void 0 : parentContext.onNestedDialogClose) && open) parentContext.onNestedDialogClose();
        };
    }, [
        isDrawer,
        open,
        ownNestedOpenDialogs,
        ownNestedOpenDrawers,
        parentContext
    ]);
    var activeTriggerProps = React$1.useMemo(function() {
        return getReferenceProps(triggerProps);
    }, [
        getReferenceProps,
        triggerProps
    ]);
    var inactiveTriggerProps = React$1.useMemo(function() {
        return getTriggerProps(triggerProps);
    }, [
        getTriggerProps,
        triggerProps
    ]);
    var popupProps = React$1.useMemo(function() {
        return getFloatingProps();
    }, [
        getFloatingProps
    ]);
    store.useSyncedValues({
        openMethod: openMethod,
        activeTriggerProps: activeTriggerProps,
        inactiveTriggerProps: inactiveTriggerProps,
        popupProps: popupProps,
        floatingRootContext: floatingRootContext,
        nestedOpenDialogCount: ownNestedOpenDialogs,
        nestedOpenDrawerCount: ownNestedOpenDrawers
    });
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/dialog/root/DialogRootContext.js
var DialogRootContext = /* @__PURE__ */ /*#__PURE__*/ react.createContext(void 0);
if (false) {}
function useDialogRootContext(optional) {
    var dialogRootContext = React$1.useContext(DialogRootContext);
    if (optional === false && dialogRootContext === void 0) throw new Error( false ? 0 : formatErrorMessage(27));
    return dialogRootContext;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/dialog/store/DialogStore.js
var selectors$1 = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, popupStoreSelectors), {
    modal: createSelector$1(function(state) {
        return state.modal;
    }),
    nested: createSelector$1(function(state) {
        return state.nested;
    }),
    nestedOpenDialogCount: createSelector$1(function(state) {
        return state.nestedOpenDialogCount;
    }),
    nestedOpenDrawerCount: createSelector$1(function(state) {
        return state.nestedOpenDrawerCount;
    }),
    disablePointerDismissal: createSelector$1(function(state) {
        return state.disablePointerDismissal;
    }),
    openMethod: createSelector$1(function(state) {
        return state.openMethod;
    }),
    descriptionElementId: createSelector$1(function(state) {
        return state.descriptionElementId;
    }),
    titleElementId: createSelector$1(function(state) {
        return state.titleElementId;
    }),
    viewportElement: createSelector$1(function(state) {
        return state.viewportElement;
    }),
    role: createSelector$1(function(state) {
        return state.role;
    })
});
var DialogStore = /*#__PURE__*/ (/* unused pure expression or super */ null && (function(ReactStore) {
    "use strict";
    _inherits(DialogStore, ReactStore);
    var _super = _create_super(DialogStore);
    function DialogStore(initialState) {
        _class_call_check(this, DialogStore);
        var _this;
        _this = _super.call(this, createInitialState(initialState), {
            popupRef: /* @__PURE__ */ /*#__PURE__*/ React$1.createRef(),
            backdropRef: /* @__PURE__ */ /*#__PURE__*/ React$1.createRef(),
            internalBackdropRef: /* @__PURE__ */ /*#__PURE__*/ React$1.createRef(),
            outsidePressEnabledRef: {
                current: true
            },
            triggerElements: new PopupTriggerMap(),
            onOpenChange: void 0,
            onOpenChangeComplete: void 0
        }, selectors$1);
        _define_property(_assert_this_initialized(_this), "setOpen", function(nextOpen, eventDetails) {
            var _context, ref, ref1;
            eventDetails.preventUnmountOnClose = function() {
                _this.set("preventUnmountingOnClose", true);
            };
            var _activeTriggerElement;
            if (!nextOpen && eventDetails.trigger == null && _this.state.activeTriggerId != null) eventDetails.trigger = (_activeTriggerElement = _this.state.activeTriggerElement) !== null && _activeTriggerElement !== void 0 ? _activeTriggerElement : void 0;
            (ref = (_context = _this.context).onOpenChange) === null || ref === void 0 ? void 0 : ref.call(_context, nextOpen, eventDetails);
            if (eventDetails.isCanceled) return;
            _this.state.floatingRootContext.dispatchOpenChange(nextOpen, eventDetails);
            var updatedState = {
                open: nextOpen
            };
            var ref2;
            var newTriggerId = (ref2 = (ref1 = eventDetails.trigger) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref2 !== void 0 ? ref2 : null;
            if (newTriggerId || nextOpen) {
                updatedState.activeTriggerId = newTriggerId;
                var _trigger;
                updatedState.activeTriggerElement = (_trigger = eventDetails.trigger) !== null && _trigger !== void 0 ? _trigger : null;
            }
            _this.update(updatedState);
        });
        return _this;
    }
    _create_class(DialogStore, null, [
        {
            key: "useStore",
            value: function useStore(externalStore, initialState) {
                var internalStore = useRefWithInit(function() {
                    return new DialogStore(initialState);
                }).current;
                return externalStore !== null && externalStore !== void 0 ? externalStore : internalStore;
            }
        }
    ]);
    return DialogStore;
}(ReactStore)));
function createInitialState() {
    var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return _object_spread(_object_spread_props(_object_spread({}, createInitialPopupStoreState()), {
        modal: true,
        disablePointerDismissal: false,
        popupElement: null,
        viewportElement: null,
        descriptionElementId: void 0,
        titleElementId: void 0,
        openMethod: null,
        nested: false,
        nestedOpenDialogCount: 0,
        nestedOpenDrawerCount: 0,
        role: "dialog"
    }), initialState);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/dialog/root/DialogRoot.js
var IsDrawerContext = /* @__PURE__ */ /*#__PURE__*/ (/* unused pure expression or super */ null && (React$1.createContext(false)));
/**
* Groups all parts of the dialog.
* Doesn't render its own HTML element.
*
* Documentation: [Base UI Dialog](https://base-ui.com/react/components/dialog)
*/ if (false) {}
function DialogRoot(props) {
    var children = props.children, openProp = props.open, _defaultOpen = props.defaultOpen, defaultOpen = _defaultOpen === void 0 ? false : _defaultOpen, onOpenChange = props.onOpenChange, onOpenChangeComplete = props.onOpenChangeComplete, _disablePointerDismissal = props.disablePointerDismissal, disablePointerDismissal = _disablePointerDismissal === void 0 ? false : _disablePointerDismissal, _modal = props.modal, modal = _modal === void 0 ? true : _modal, actionsRef = props.actionsRef, handle = props.handle, triggerIdProp = props.triggerId, tmp = props.defaultTriggerId, defaultTriggerIdProp = tmp === void 0 ? null : tmp;
    var parentDialogRootContext = useDialogRootContext(true);
    var isDrawer = React$1.useContext(IsDrawerContext);
    var nested = Boolean(parentDialogRootContext);
    var store = DialogStore.useStore(handle === null || handle === void 0 ? void 0 : handle.store, {
        open: defaultOpen,
        openProp: openProp,
        activeTriggerId: defaultTriggerIdProp,
        triggerIdProp: triggerIdProp,
        modal: modal,
        disablePointerDismissal: disablePointerDismissal,
        nested: nested
    });
    useOnFirstRender(function() {
        if (openProp === void 0 && store.state.open === false && defaultOpen === true) store.update({
            open: true,
            activeTriggerId: defaultTriggerIdProp
        });
    });
    store.useControlledProp("openProp", openProp);
    store.useControlledProp("triggerIdProp", triggerIdProp);
    store.useSyncedValues({
        disablePointerDismissal: disablePointerDismissal,
        nested: nested,
        modal: modal
    });
    store.useContextCallback("onOpenChange", onOpenChange);
    store.useContextCallback("onOpenChangeComplete", onOpenChangeComplete);
    var payload = store.useState("payload");
    useDialogRoot({
        store: store,
        actionsRef: actionsRef,
        parentContext: parentDialogRootContext === null || parentDialogRootContext === void 0 ? void 0 : parentDialogRootContext.store.context,
        isDrawer: isDrawer,
        onOpenChange: onOpenChange,
        triggerIdProp: triggerIdProp
    });
    var contextValue = React$1.useMemo(function() {
        return {
            store: store
        };
    }, [
        store
    ]);
    return /* @__PURE__ */ jsx(IsDrawerContext.Provider, {
        value: false,
        children: /* @__PURE__ */ jsx(DialogRootContext.Provider, {
            value: contextValue,
            children: typeof children === "function" ? children({
                payload: payload
            }) : children
        })
    });
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/alert-dialog/root/AlertDialogRoot.js
/**
* Groups all parts of the alert dialog.
* Doesn't render its own HTML element.
*
* Documentation: [Base UI Alert Dialog](https://base-ui.com/react/components/alert-dialog)
*/ function AlertDialogRoot(props) {
    var children = props.children, openProp = props.open, _defaultOpen = props.defaultOpen, defaultOpen = _defaultOpen === void 0 ? false : _defaultOpen, onOpenChange = props.onOpenChange, onOpenChangeComplete = props.onOpenChangeComplete, actionsRef = props.actionsRef, handle = props.handle, triggerIdProp = props.triggerId, tmp = props.defaultTriggerId, defaultTriggerIdProp = tmp === void 0 ? null : tmp;
    var parentDialogRootContext = useDialogRootContext(true);
    var nested = Boolean(parentDialogRootContext);
    var store = DialogStore.useStore(handle === null || handle === void 0 ? void 0 : handle.store, {
        open: defaultOpen,
        openProp: openProp,
        activeTriggerId: defaultTriggerIdProp,
        triggerIdProp: triggerIdProp,
        modal: true,
        disablePointerDismissal: true,
        nested: nested,
        role: "alertdialog"
    });
    store.useControlledProp("openProp", openProp);
    store.useControlledProp("triggerIdProp", triggerIdProp);
    store.useSyncedValue("nested", nested);
    store.useContextCallback("onOpenChange", onOpenChange);
    store.useContextCallback("onOpenChangeComplete", onOpenChangeComplete);
    var payload = store.useState("payload");
    useDialogRoot({
        store: store,
        actionsRef: actionsRef,
        parentContext: parentDialogRootContext === null || parentDialogRootContext === void 0 ? void 0 : parentDialogRootContext.store.context,
        isDrawer: false,
        onOpenChange: onOpenChange,
        triggerIdProp: triggerIdProp
    });
    var contextValue = React$1.useMemo(function() {
        return {
            store: store
        };
    }, [
        store
    ]);
    return /* @__PURE__ */ jsx(IsDrawerContext.Provider, {
        value: false,
        children: /* @__PURE__ */ jsx(DialogRootContext.Provider, {
            value: contextValue,
            children: typeof children === "function" ? children({
                payload: payload
            }) : children
        })
    });
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/dialog/backdrop/DialogBackdrop.js
var stateAttributesMapping$4 = (0,src_object_spread/* default */.Z)({}, popupStateMapping, transitionStatusMapping);
/**
* An overlay displayed beneath the popup.
* Renders a `<div>` element.
*
* Documentation: [Base UI Dialog](https://base-ui.com/react/components/dialog)
*/ var DialogBackdrop = /* @__PURE__ */ /*#__PURE__*/ (/* unused pure expression or super */ null && (React$1.forwardRef(function DialogBackdrop(componentProps, forwardedRef) {
    var render = componentProps.render, className = componentProps.className, style = componentProps.style, _forceRender = componentProps.forceRender, forceRender = _forceRender === void 0 ? false : _forceRender, elementProps = _object_without_properties(componentProps, [
        "render",
        "className",
        "style",
        "forceRender"
    ]);
    var store = useDialogRootContext().store;
    var open = store.useState("open");
    var nested = store.useState("nested");
    var mounted = store.useState("mounted");
    return useRenderElement("div", componentProps, {
        state: {
            open: open,
            transitionStatus: store.useState("transitionStatus")
        },
        ref: [
            store.context.backdropRef,
            forwardedRef
        ],
        stateAttributesMapping: stateAttributesMapping$4,
        props: [
            {
                role: "presentation",
                hidden: !mounted,
                style: {
                    userSelect: "none",
                    WebkitUserSelect: "none"
                }
            },
            elementProps
        ],
        enabled: forceRender || !nested
    });
})));
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/dialog/close/DialogClose.js
/**
* A button that closes the dialog.
* Renders a `<button>` element.
*
* Documentation: [Base UI Dialog](https://base-ui.com/react/components/dialog)
*/ var DialogClose = /* @__PURE__ */ /*#__PURE__*/ (/* unused pure expression or super */ null && (React$1.forwardRef(function DialogClose(componentProps, forwardedRef) {
    var handleClick = function handleClick(event) {
        if (open) store.setOpen(false, createChangeEventDetails(closePress, event.nativeEvent));
    };
    var render = componentProps.render, className = componentProps.className, _disabled = componentProps.disabled, disabled = _disabled === void 0 ? false : _disabled, _nativeButton = componentProps.nativeButton, nativeButton = _nativeButton === void 0 ? true : _nativeButton, style = componentProps.style, elementProps = _object_without_properties(componentProps, [
        "render",
        "className",
        "disabled",
        "nativeButton",
        "style"
    ]);
    var store = useDialogRootContext().store;
    var open = store.useState("open");
    var ref = useButton({
        disabled: disabled,
        native: nativeButton
    }), getButtonProps = ref.getButtonProps, buttonRef = ref.buttonRef;
    return useRenderElement("button", componentProps, {
        state: {
            disabled: disabled
        },
        ref: [
            forwardedRef,
            buttonRef
        ],
        props: [
            {
                onClick: handleClick
            },
            elementProps,
            getButtonProps
        ]
    });
})));
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/dialog/description/DialogDescription.js
/**
* A paragraph with additional information about the dialog.
* Renders a `<p>` element.
*
* Documentation: [Base UI Dialog](https://base-ui.com/react/components/dialog)
*/ var DialogDescription = /* @__PURE__ */ /*#__PURE__*/ (/* unused pure expression or super */ null && (React$1.forwardRef(function DialogDescription(componentProps, forwardedRef) {
    var render = componentProps.render, className = componentProps.className, style = componentProps.style, idProp = componentProps.id, elementProps = _object_without_properties(componentProps, [
        "render",
        "className",
        "style",
        "id"
    ]);
    var store = useDialogRootContext().store;
    var id = useBaseUiId(idProp);
    store.useSyncedValueWithCleanup("descriptionElementId", id);
    return useRenderElement("p", componentProps, {
        ref: forwardedRef,
        props: [
            {
                id: id
            },
            elementProps
        ]
    });
})));
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/dialog/popup/DialogPopupCssVars.js
var DialogPopupCssVars = /* @__PURE__ */ function(DialogPopupCssVars) {
    /**
	* Indicates how many dialogs are nested within.
	* @type {number}
	*/ DialogPopupCssVars["nestedDialogs"] = "--nested-dialogs";
    return DialogPopupCssVars;
}({});
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/dialog/popup/DialogPopupDataAttributes.js
var DialogPopupDataAttributes = function(DialogPopupDataAttributes) {
    /**
	* Present when the dialog is open.
	*/ DialogPopupDataAttributes[DialogPopupDataAttributes["open"] = CommonPopupDataAttributes.open] = "open";
    /**
	* Present when the dialog is closed.
	*/ DialogPopupDataAttributes[DialogPopupDataAttributes["closed"] = CommonPopupDataAttributes.closed] = "closed";
    /**
	* Present when the dialog is animating in.
	*/ DialogPopupDataAttributes[DialogPopupDataAttributes["startingStyle"] = CommonPopupDataAttributes.startingStyle] = "startingStyle";
    /**
	* Present when the dialog is animating out.
	*/ DialogPopupDataAttributes[DialogPopupDataAttributes["endingStyle"] = CommonPopupDataAttributes.endingStyle] = "endingStyle";
    /**
	* Present when the dialog is nested within another dialog.
	*/ DialogPopupDataAttributes["nested"] = "data-nested";
    /**
	* Present when the dialog has other open dialogs nested within it.
	*/ DialogPopupDataAttributes["nestedDialogOpen"] = "data-nested-dialog-open";
    return DialogPopupDataAttributes;
}({});
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/dialog/portal/DialogPortalContext.js
var DialogPortalContext = /* @__PURE__ */ /*#__PURE__*/ react.createContext(void 0);
if (false) {}
function useDialogPortalContext() {
    var value = React$1.useContext(DialogPortalContext);
    if (value === void 0) throw new Error( false ? 0 : formatErrorMessage(26));
    return value;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/composite/composite.js
var ARROW_UP = "ArrowUp";
var ARROW_DOWN = "ArrowDown";
var ARROW_LEFT = "ArrowLeft";
var ARROW_RIGHT = "ArrowRight";
var HOME = "Home";
var HORIZONTAL_KEYS = new Set([
    ARROW_LEFT,
    ARROW_RIGHT
]);
var HORIZONTAL_KEYS_WITH_EXTRA_KEYS = new Set([
    ARROW_LEFT,
    ARROW_RIGHT,
    HOME,
    "End"
]);
var VERTICAL_KEYS = new Set([
    ARROW_UP,
    ARROW_DOWN
]);
var VERTICAL_KEYS_WITH_EXTRA_KEYS = new Set([
    ARROW_UP,
    ARROW_DOWN,
    HOME,
    "End"
]);
var ARROW_KEYS = new Set((0,src_to_consumable_array/* default */.Z)(HORIZONTAL_KEYS).concat((0,src_to_consumable_array/* default */.Z)(VERTICAL_KEYS)));
var ALL_KEYS = new Set((0,src_to_consumable_array/* default */.Z)(ARROW_KEYS).concat([
    HOME,
    "End"
]));
var COMPOSITE_KEYS = new Set([
    ARROW_UP,
    ARROW_DOWN,
    ARROW_LEFT,
    ARROW_RIGHT,
    HOME,
    "End"
]);
var SHIFT = "Shift";
var MODIFIER_KEYS$1 = new Set([
    SHIFT,
    "Control",
    "Alt",
    "Meta"
]);
function isInputElement(element) {
    return isHTMLElement(element) && element.tagName === "INPUT";
}
function isNativeInput(element) {
    if (isInputElement(element) && element.selectionStart != null) return true;
    if (isHTMLElement(element) && element.tagName === "TEXTAREA") return true;
    return false;
}
function scrollIntoViewIfNeeded(scrollContainer, element, direction, orientation) {
    if (!scrollContainer || !element || !element.scrollTo) return;
    var targetX = scrollContainer.scrollLeft;
    var targetY = scrollContainer.scrollTop;
    var isOverflowingX = scrollContainer.clientWidth < scrollContainer.scrollWidth;
    var isOverflowingY = scrollContainer.clientHeight < scrollContainer.scrollHeight;
    if (isOverflowingX && orientation !== "vertical") {
        var elementOffsetLeft = getOffset(scrollContainer, element, "left");
        var containerStyles = getStyles(scrollContainer);
        var elementStyles = getStyles(element);
        if (direction === "ltr") {
            if (elementOffsetLeft + element.offsetWidth + elementStyles.scrollMarginRight > scrollContainer.scrollLeft + scrollContainer.clientWidth - containerStyles.scrollPaddingRight) targetX = elementOffsetLeft + element.offsetWidth + elementStyles.scrollMarginRight - scrollContainer.clientWidth + containerStyles.scrollPaddingRight;
            else if (elementOffsetLeft - elementStyles.scrollMarginLeft < scrollContainer.scrollLeft + containerStyles.scrollPaddingLeft) targetX = elementOffsetLeft - elementStyles.scrollMarginLeft - containerStyles.scrollPaddingLeft;
        }
        if (direction === "rtl") {
            if (elementOffsetLeft - elementStyles.scrollMarginRight < scrollContainer.scrollLeft + containerStyles.scrollPaddingLeft) targetX = elementOffsetLeft - elementStyles.scrollMarginLeft - containerStyles.scrollPaddingLeft;
            else if (elementOffsetLeft + element.offsetWidth + elementStyles.scrollMarginRight > scrollContainer.scrollLeft + scrollContainer.clientWidth - containerStyles.scrollPaddingRight) targetX = elementOffsetLeft + element.offsetWidth + elementStyles.scrollMarginRight - scrollContainer.clientWidth + containerStyles.scrollPaddingRight;
        }
    }
    if (isOverflowingY && orientation !== "horizontal") {
        var elementOffsetTop = getOffset(scrollContainer, element, "top");
        var containerStyles1 = getStyles(scrollContainer);
        var elementStyles1 = getStyles(element);
        if (elementOffsetTop - elementStyles1.scrollMarginTop < scrollContainer.scrollTop + containerStyles1.scrollPaddingTop) targetY = elementOffsetTop - elementStyles1.scrollMarginTop - containerStyles1.scrollPaddingTop;
        else if (elementOffsetTop + element.offsetHeight + elementStyles1.scrollMarginBottom > scrollContainer.scrollTop + scrollContainer.clientHeight - containerStyles1.scrollPaddingBottom) targetY = elementOffsetTop + element.offsetHeight + elementStyles1.scrollMarginBottom - scrollContainer.clientHeight + containerStyles1.scrollPaddingBottom;
    }
    scrollContainer.scrollTo({
        left: targetX,
        top: targetY,
        behavior: "auto"
    });
}
function getOffset(ancestor, element, side) {
    var propName = side === "left" ? "offsetLeft" : "offsetTop";
    var result = 0;
    while(element.offsetParent){
        result += element[propName];
        if (element.offsetParent === ancestor) break;
        element = element.offsetParent;
    }
    return result;
}
function getStyles(element) {
    var styles = getComputedStyle(element);
    return {
        scrollMarginTop: parseFloat(styles.scrollMarginTop) || 0,
        scrollMarginRight: parseFloat(styles.scrollMarginRight) || 0,
        scrollMarginBottom: parseFloat(styles.scrollMarginBottom) || 0,
        scrollMarginLeft: parseFloat(styles.scrollMarginLeft) || 0,
        scrollPaddingTop: parseFloat(styles.scrollPaddingTop) || 0,
        scrollPaddingRight: parseFloat(styles.scrollPaddingRight) || 0,
        scrollPaddingBottom: parseFloat(styles.scrollPaddingBottom) || 0,
        scrollPaddingLeft: parseFloat(styles.scrollPaddingLeft) || 0
    };
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/dialog/popup/DialogPopup.js
var stateAttributesMapping$3 = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, popupStateMapping, transitionStatusMapping), {
    nestedDialogOpen: function nestedDialogOpen(value) {
        return value ? (0,src_define_property/* default */.Z)({}, DialogPopupDataAttributes.nestedDialogOpen, "") : null;
    }
});
/**
* A container for the dialog contents.
* Renders a `<div>` element.
*
* Documentation: [Base UI Dialog](https://base-ui.com/react/components/dialog)
*/ var DialogPopup = /* @__PURE__ */ /*#__PURE__*/ (/* unused pure expression or super */ null && (React$1.forwardRef(function DialogPopup(componentProps, forwardedRef) {
    var defaultInitialFocus = function defaultInitialFocus(interactionType) {
        if (interactionType === "touch") return store.context.popupRef.current;
        return true;
    };
    var className = componentProps.className, finalFocus = componentProps.finalFocus, initialFocus = componentProps.initialFocus, render = componentProps.render, style = componentProps.style, elementProps = _object_without_properties(componentProps, [
        "className",
        "finalFocus",
        "initialFocus",
        "render",
        "style"
    ]);
    var store = useDialogRootContext().store;
    var descriptionElementId = store.useState("descriptionElementId");
    var disablePointerDismissal = store.useState("disablePointerDismissal");
    var floatingRootContext = store.useState("floatingRootContext");
    var rootPopupProps = store.useState("popupProps");
    var modal = store.useState("modal");
    var mounted = store.useState("mounted");
    var nested = store.useState("nested");
    var nestedOpenDialogCount = store.useState("nestedOpenDialogCount");
    var open = store.useState("open");
    var openMethod = store.useState("openMethod");
    var titleElementId = store.useState("titleElementId");
    var transitionStatus = store.useState("transitionStatus");
    var role = store.useState("role");
    useDialogPortalContext();
    useOpenChangeComplete({
        open: open,
        ref: store.context.popupRef,
        onComplete: function onComplete() {
            var _context, ref;
            if (open) (ref = (_context = store.context).onOpenChangeComplete) === null || ref === void 0 ? void 0 : ref.call(_context, true);
        }
    });
    var resolvedInitialFocus = initialFocus === void 0 ? defaultInitialFocus : initialFocus;
    var element = useRenderElement("div", componentProps, {
        state: {
            open: open,
            nested: nested,
            transitionStatus: transitionStatus,
            nestedDialogOpen: nestedOpenDialogCount > 0
        },
        props: [
            rootPopupProps,
            {
                "aria-labelledby": titleElementId !== null && titleElementId !== void 0 ? titleElementId : void 0,
                "aria-describedby": descriptionElementId !== null && descriptionElementId !== void 0 ? descriptionElementId : void 0,
                role: role,
                tabIndex: -1,
                hidden: !mounted,
                onKeyDown: function onKeyDown(event) {
                    if (COMPOSITE_KEYS.has(event.key)) event.stopPropagation();
                },
                style: _define_property({}, DialogPopupCssVars.nestedDialogs, nestedOpenDialogCount)
            },
            elementProps
        ],
        ref: [
            forwardedRef,
            store.context.popupRef,
            store.useStateSetter("popupElement")
        ],
        stateAttributesMapping: stateAttributesMapping$3
    });
    return /* @__PURE__ */ jsx(FloatingFocusManager, {
        context: floatingRootContext,
        openInteractionType: openMethod,
        disabled: !mounted,
        closeOnFocusOut: !disablePointerDismissal,
        initialFocus: resolvedInitialFocus,
        returnFocus: finalFocus,
        modal: modal !== false,
        restoreFocus: "popup",
        children: element
    });
})));
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/dialog/portal/DialogPortal.js
/**
* A portal element that moves the popup to a different part of the DOM.
* By default, the portal element is appended to `<body>`.
* Renders a `<div>` element.
*
* Documentation: [Base UI Dialog](https://base-ui.com/react/components/dialog)
*/ var DialogPortal = /* @__PURE__ */ /*#__PURE__*/ (/* unused pure expression or super */ null && (React$1.forwardRef(function DialogPortal(props, forwardedRef) {
    var _keepMounted = props.keepMounted, keepMounted = _keepMounted === void 0 ? false : _keepMounted, portalProps = _object_without_properties(props, [
        "keepMounted"
    ]);
    var store = useDialogRootContext().store;
    var mounted = store.useState("mounted");
    var modal = store.useState("modal");
    var open = store.useState("open");
    if (!(mounted || keepMounted)) return null;
    return /* @__PURE__ */ jsx(DialogPortalContext.Provider, {
        value: keepMounted,
        children: /* @__PURE__ */ jsxs(FloatingPortal, _object_spread_props(_object_spread({
            ref: forwardedRef
        }, portalProps), {
            children: [
                mounted && modal === true && /* @__PURE__ */ jsx(InternalBackdrop, {
                    ref: store.context.internalBackdropRef,
                    inert: inertValue(!open)
                }),
                props.children
            ]
        }))
    });
})));
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/dialog/title/DialogTitle.js
/**
* A heading that labels the dialog.
* Renders an `<h2>` element.
*
* Documentation: [Base UI Dialog](https://base-ui.com/react/components/dialog)
*/ var DialogTitle = /* @__PURE__ */ /*#__PURE__*/ (/* unused pure expression or super */ null && (React$1.forwardRef(function DialogTitle(componentProps, forwardedRef) {
    var render = componentProps.render, className = componentProps.className, style = componentProps.style, idProp = componentProps.id, elementProps = _object_without_properties(componentProps, [
        "render",
        "className",
        "style",
        "id"
    ]);
    var store = useDialogRootContext().store;
    var id = useBaseUiId(idProp);
    store.useSyncedValueWithCleanup("titleElementId", id);
    return useRenderElement("h2", componentProps, {
        ref: forwardedRef,
        props: [
            {
                id: id
            },
            elementProps
        ]
    });
})));
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/dialog/trigger/DialogTrigger.js
/**
* A button that opens the dialog.
* Renders a `<button>` element.
*
* Documentation: [Base UI Dialog](https://base-ui.com/react/components/dialog)
*/ var DialogTrigger = /* @__PURE__ */ /*#__PURE__*/ (/* unused pure expression or super */ null && (React$1.forwardRef(function DialogTrigger(componentProps, forwardedRef) {
    var render = componentProps.render, className = componentProps.className, _disabled = componentProps.disabled, disabled = _disabled === void 0 ? false : _disabled, _nativeButton = componentProps.nativeButton, nativeButton = _nativeButton === void 0 ? true : _nativeButton, idProp = componentProps.id, payload = componentProps.payload, handle = componentProps.handle, style = componentProps.style, elementProps = _object_without_properties(componentProps, [
        "render",
        "className",
        "disabled",
        "nativeButton",
        "id",
        "payload",
        "handle",
        "style"
    ]);
    var dialogRootContext = useDialogRootContext(true);
    var ref;
    var store = (ref = handle === null || handle === void 0 ? void 0 : handle.store) !== null && ref !== void 0 ? ref : dialogRootContext === null || dialogRootContext === void 0 ? void 0 : dialogRootContext.store;
    if (!store) throw new Error( false ? 0 : formatErrorMessage(79));
    var thisTriggerId = useBaseUiId(idProp);
    var floatingContext = store.useState("floatingRootContext");
    var isOpenedByThisTrigger = store.useState("isOpenedByTrigger", thisTriggerId);
    var triggerElementRef = React$1.useRef(null);
    var ref1 = useTriggerDataForwarding(thisTriggerId, triggerElementRef, store, {
        payload: payload
    }), registerTrigger = ref1.registerTrigger, isMountedByThisTrigger = ref1.isMountedByThisTrigger;
    var ref2 = useButton({
        disabled: disabled,
        native: nativeButton
    }), getButtonProps = ref2.getButtonProps, buttonRef = ref2.buttonRef;
    var localInteractionProps = useInteractions([
        useClick(floatingContext, {
            enabled: floatingContext != null
        })
    ]);
    var state = {
        disabled: disabled,
        open: isOpenedByThisTrigger
    };
    var rootTriggerProps = store.useState("triggerProps", isMountedByThisTrigger);
    var _obj;
    return useRenderElement("button", componentProps, {
        state: state,
        ref: [
            buttonRef,
            forwardedRef,
            registerTrigger,
            triggerElementRef
        ],
        props: [
            localInteractionProps.getReferenceProps(),
            rootTriggerProps,
            (_obj = {}, _define_property(_obj, CLICK_TRIGGER_IDENTIFIER, ""), _define_property(_obj, "id", thisTriggerId), _obj),
            elementProps,
            getButtonProps
        ],
        stateAttributesMapping: triggerOpenStateMapping$1
    });
})));
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/collapsible/root/useCollapsibleRoot.js
function useCollapsibleRoot(parameters) {
    var openParam = parameters.open, defaultOpen = parameters.defaultOpen, onOpenChange = parameters.onOpenChange, disabled = parameters.disabled;
    var isControlled = openParam !== void 0;
    var ref = (0,src_sliced_to_array/* default */.Z)(useControlled({
        controlled: openParam,
        default: defaultOpen,
        name: "Collapsible",
        state: "open"
    }), 2), open = ref[0], setOpen = ref[1];
    var ref1 = useTransitionStatus(open, true, true), mounted = ref1.mounted, setMounted = ref1.setMounted, transitionStatus = ref1.transitionStatus;
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState(open), 2), visible = ref2[0], setVisible = ref2[1];
    var ref3 = (0,src_sliced_to_array/* default */.Z)(react.useState({
        height: void 0,
        width: void 0
    }), 2), ref4 = ref3[0], height = ref4.height, width = ref4.width, setDimensions = ref3[1];
    var defaultPanelId = useBaseUiId();
    var ref5 = (0,src_sliced_to_array/* default */.Z)(react.useState(), 2), panelIdState = ref5[0], setPanelIdState = ref5[1];
    var panelId = panelIdState !== null && panelIdState !== void 0 ? panelIdState : defaultPanelId;
    var ref6 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), hiddenUntilFound = ref6[0], setHiddenUntilFound = ref6[1];
    var ref7 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), keepMounted = ref7[0], setKeepMounted = ref7[1];
    var abortControllerRef = react.useRef(null);
    var animationTypeRef = react.useRef(null);
    var transitionDimensionRef = react.useRef(null);
    var panelRef = react.useRef(null);
    var runOnceAnimationsFinish = useAnimationsFinished(panelRef, false);
    var handleTrigger = useStableCallback(function(event) {
        var nextOpen = !open;
        var eventDetails = createChangeEventDetails(triggerPress, event.nativeEvent);
        onOpenChange(nextOpen, eventDetails);
        if (eventDetails.isCanceled) return;
        var panel = panelRef.current;
        if (animationTypeRef.current === "css-animation" && panel != null) panel.style.removeProperty("animation-name");
        if (!hiddenUntilFound && !keepMounted) {
            if (animationTypeRef.current != null && animationTypeRef.current !== "css-animation") {
                if (!mounted && nextOpen) setMounted(true);
            }
            if (animationTypeRef.current === "css-animation") {
                if (!visible && nextOpen) setVisible(true);
                if (!mounted && nextOpen) setMounted(true);
            }
        }
        setOpen(nextOpen);
        if (animationTypeRef.current === "none" && mounted && !nextOpen) setMounted(false);
    });
    useIsoLayoutEffect(function() {
        /**
		* Close immediately in controlled mode when no CSS animations or
		* transitions are applied. `keepMounted` only keeps the element in the
		* DOM; `mounted` must still become `false` so the panel regains `hidden`.
		*/ if (isControlled && animationTypeRef.current === "none" && !open) setMounted(false);
    }, [
        isControlled,
        open,
        openParam,
        setMounted
    ]);
    return react.useMemo(function() {
        return {
            abortControllerRef: abortControllerRef,
            animationTypeRef: animationTypeRef,
            disabled: disabled,
            handleTrigger: handleTrigger,
            height: height,
            mounted: mounted,
            open: open,
            panelId: panelId,
            panelRef: panelRef,
            runOnceAnimationsFinish: runOnceAnimationsFinish,
            setDimensions: setDimensions,
            setHiddenUntilFound: setHiddenUntilFound,
            setKeepMounted: setKeepMounted,
            setMounted: setMounted,
            setOpen: setOpen,
            setPanelIdState: setPanelIdState,
            setVisible: setVisible,
            transitionDimensionRef: transitionDimensionRef,
            transitionStatus: transitionStatus,
            visible: visible,
            width: width
        };
    }, [
        abortControllerRef,
        animationTypeRef,
        disabled,
        handleTrigger,
        height,
        mounted,
        open,
        panelId,
        panelRef,
        runOnceAnimationsFinish,
        setDimensions,
        setHiddenUntilFound,
        setKeepMounted,
        setMounted,
        setOpen,
        setVisible,
        transitionDimensionRef,
        transitionStatus,
        visible,
        width
    ]);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/collapsible/root/CollapsibleRootContext.js
var CollapsibleRootContext = /* @__PURE__ */ /*#__PURE__*/ react.createContext(void 0);
if (false) {}
function useCollapsibleRootContext() {
    var context = react.useContext(CollapsibleRootContext);
    if (context === void 0) throw new Error( false ? 0 : formatErrorMessage(15));
    return context;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/collapsible/panel/CollapsiblePanelDataAttributes.js
var CollapsiblePanelDataAttributes = function(CollapsiblePanelDataAttributes) {
    /**
	* Present when the collapsible panel is open.
	*/ CollapsiblePanelDataAttributes["open"] = "data-open";
    /**
	* Present when the collapsible panel is closed.
	*/ CollapsiblePanelDataAttributes["closed"] = "data-closed";
    /**
	* Present when the panel is animating in.
	*/ CollapsiblePanelDataAttributes[CollapsiblePanelDataAttributes["startingStyle"] = TransitionStatusDataAttributes.startingStyle] = "startingStyle";
    /**
	* Present when the panel is animating out.
	*/ CollapsiblePanelDataAttributes[CollapsiblePanelDataAttributes["endingStyle"] = TransitionStatusDataAttributes.endingStyle] = "endingStyle";
    return CollapsiblePanelDataAttributes;
}({});
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/collapsible/trigger/CollapsibleTriggerDataAttributes.js
var CollapsibleTriggerDataAttributes = /* @__PURE__ */ function(CollapsibleTriggerDataAttributes) {
    /**
	* Present when the collapsible panel is open.
	*/ CollapsibleTriggerDataAttributes["panelOpen"] = "data-panel-open";
    return CollapsibleTriggerDataAttributes;
}({});
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/utils/collapsibleOpenStateMapping.js
var PANEL_OPEN_HOOK = (0,src_define_property/* default */.Z)({}, CollapsiblePanelDataAttributes.open, "");
var PANEL_CLOSED_HOOK = (0,src_define_property/* default */.Z)({}, CollapsiblePanelDataAttributes.closed, "");
var triggerOpenStateMapping = {
    open: function open(value) {
        if (value) return (0,src_define_property/* default */.Z)({}, CollapsibleTriggerDataAttributes.panelOpen, "");
        return null;
    }
};
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/collapsible/root/stateAttributesMapping.js
var collapsibleStateAttributesMapping = (0,src_object_spread/* default */.Z)({
    open: function open(value) {
        if (value) return PANEL_OPEN_HOOK;
        return PANEL_CLOSED_HOOK;
    }
}, transitionStatusMapping);
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/collapsible/root/CollapsibleRoot.js
/**
* Groups all parts of the collapsible.
* Renders a `<div>` element.
*
* Documentation: [Base UI Collapsible](https://base-ui.com/react/components/collapsible)
*/ var CollapsibleRoot = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function CollapsibleRoot(componentProps, forwardedRef) {
    var render = componentProps.render, className = componentProps.className, _defaultOpen = componentProps.defaultOpen, defaultOpen = _defaultOpen === void 0 ? false : _defaultOpen, _disabled = componentProps.disabled, disabled = _disabled === void 0 ? false : _disabled, onOpenChangeProp = componentProps.onOpenChange, open = componentProps.open, style = componentProps.style, elementProps = (0,src_object_without_properties/* default */.Z)(componentProps, [
        "render",
        "className",
        "defaultOpen",
        "disabled",
        "onOpenChange",
        "open",
        "style"
    ]);
    var onOpenChange = useStableCallback(onOpenChangeProp);
    var collapsible = useCollapsibleRoot({
        open: open,
        defaultOpen: defaultOpen,
        onOpenChange: onOpenChange,
        disabled: disabled
    });
    var state = react.useMemo(function() {
        return {
            open: collapsible.open,
            disabled: collapsible.disabled,
            transitionStatus: collapsible.transitionStatus
        };
    }, [
        collapsible.open,
        collapsible.disabled,
        collapsible.transitionStatus
    ]);
    var contextValue = react.useMemo(function() {
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, collapsible), {
            onOpenChange: onOpenChange,
            state: state
        });
    }, [
        collapsible,
        onOpenChange,
        state
    ]);
    var element = useRenderElement("div", componentProps, {
        state: state,
        ref: forwardedRef,
        props: elementProps,
        stateAttributesMapping: collapsibleStateAttributesMapping
    });
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(CollapsibleRootContext.Provider, {
        value: contextValue,
        children: element
    });
});
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/collapsible/trigger/CollapsibleTrigger.js
var stateAttributesMapping$2 = (0,src_object_spread/* default */.Z)({}, triggerOpenStateMapping, transitionStatusMapping);
/**
* A button that opens and closes the collapsible panel.
* Renders a `<button>` element.
*
* Documentation: [Base UI Collapsible](https://base-ui.com/react/components/collapsible)
*/ var CollapsibleTrigger = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function CollapsibleTrigger(componentProps, forwardedRef) {
    var ref = useCollapsibleRootContext(), panelId = ref.panelId, open = ref.open, handleTrigger = ref.handleTrigger, state = ref.state, contextDisabled = ref.disabled;
    var className = componentProps.className, _disabled = componentProps.disabled, disabled = _disabled === void 0 ? contextDisabled : _disabled, id = componentProps.id, render = componentProps.render, _nativeButton = componentProps.nativeButton, nativeButton = _nativeButton === void 0 ? true : _nativeButton, style = componentProps.style, elementProps = (0,src_object_without_properties/* default */.Z)(componentProps, [
        "className",
        "disabled",
        "id",
        "render",
        "nativeButton",
        "style"
    ]);
    var ref1 = useButton({
        disabled: disabled,
        focusableWhenDisabled: true,
        native: nativeButton
    }), getButtonProps = ref1.getButtonProps, buttonRef = ref1.buttonRef;
    var props = react.useMemo(function() {
        return {
            "aria-controls": open ? panelId : void 0,
            "aria-expanded": open,
            onClick: handleTrigger
        };
    }, [
        panelId,
        open,
        handleTrigger
    ]);
    return useRenderElement("button", componentProps, {
        state: state,
        ref: [
            forwardedRef,
            buttonRef
        ],
        props: [
            props,
            elementProps,
            getButtonProps
        ],
        stateAttributesMapping: stateAttributesMapping$2
    });
});
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/accordion/root/AccordionRootDataAttributes.js
var AccordionRootDataAttributes = /* @__PURE__ */ function(AccordionRootDataAttributes) {
    /**
	* Present when the accordion is disabled.
	*/ AccordionRootDataAttributes["disabled"] = "data-disabled";
    /**
	* Indicates the orientation of the accordion.
	*/ AccordionRootDataAttributes["orientation"] = "data-orientation";
    return AccordionRootDataAttributes;
}({});
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/collapsible/panel/useCollapsiblePanel.js
function useCollapsiblePanel(parameters) {
    var abortControllerRef = parameters.abortControllerRef, animationTypeRef = parameters.animationTypeRef, externalRef = parameters.externalRef, height = parameters.height, hiddenUntilFound = parameters.hiddenUntilFound, keepMounted = parameters.keepMounted, idParam = parameters.id, mounted = parameters.mounted, onOpenChange = parameters.onOpenChange, open = parameters.open, panelRef = parameters.panelRef, runOnceAnimationsFinish = parameters.runOnceAnimationsFinish, setDimensions = parameters.setDimensions, setMounted = parameters.setMounted, setOpen = parameters.setOpen, setVisible = parameters.setVisible, transitionDimensionRef = parameters.transitionDimensionRef, visible = parameters.visible, width = parameters.width;
    var isBeforeMatchRef = react.useRef(false);
    var latestAnimationNameRef = react.useRef(null);
    var shouldCancelInitialOpenAnimationRef = react.useRef(open);
    var shouldCancelInitialOpenTransitionRef = react.useRef(open);
    var endingStyleFrame = useAnimationFrame();
    /**
	* When opening, the `hidden` attribute is removed immediately.
	* When closing, the `hidden` attribute is set after any exit animations runs.
	*/ var hidden = react.useMemo(function() {
        if (animationTypeRef.current === "css-animation") return !visible;
        return !open && !mounted;
    }, [
        open,
        mounted,
        visible,
        animationTypeRef
    ]);
    var mergedPanelRef = useMergedRefs(externalRef, panelRef, useStableCallback(function(element) {
        if (!element) return;
        if (animationTypeRef.current == null || transitionDimensionRef.current == null) {
            var panelStyles = getComputedStyle(element);
            var hasAnimation = panelStyles.animationName !== "none" && panelStyles.animationName !== "";
            var hasTransition = panelStyles.transitionDuration !== "0s" && panelStyles.transitionDuration !== "";
            /**
			* animationTypeRef is safe to read in render because it's only ever set
			* once here during the first render and never again.
			* https://react.dev/learn/referencing-values-with-refs#best-practices-for-refs
			*/ if (hasAnimation && hasTransition) {
                if (false) {}
            } else if (panelStyles.animationName === "none" && panelStyles.transitionDuration !== "0s") animationTypeRef.current = "css-transition";
            else if (panelStyles.animationName !== "none" && panelStyles.transitionDuration === "0s") animationTypeRef.current = "css-animation";
            else animationTypeRef.current = "none";
            /**
			* We need to know in advance which side is being collapsed when using CSS
			* transitions in order to set the value of width/height to `0px` momentarily.
			* Setting both to `0px` will break layout.
			*/ if (element.getAttribute(AccordionRootDataAttributes.orientation) === "horizontal" || panelStyles.transitionProperty.indexOf("width") > -1) transitionDimensionRef.current = "width";
            else transitionDimensionRef.current = "height";
        }
        if (animationTypeRef.current !== "css-transition") return;
        if (height === void 0 || width === void 0) {
            setDimensions({
                height: element.scrollHeight,
                width: element.scrollWidth
            });
            if (shouldCancelInitialOpenTransitionRef.current) element.style.setProperty("transition-duration", "0s");
        }
        var frame = -1;
        var nextFrame = -1;
        frame = AnimationFrame.request(function() {
            shouldCancelInitialOpenTransitionRef.current = false;
            nextFrame = AnimationFrame.request(function() {
                /**
				* This is slightly faster than another RAF and is the earliest
				* opportunity to remove the temporary `transition-duration: 0s` that
				* was applied to cancel opening transitions of initially open panels.
				* https://nolanlawson.com/2018/09/25/accurately-measuring-layout-on-the-web/
				*/ setTimeout(function() {
                    element.style.removeProperty("transition-duration");
                });
            });
        });
        return function() {
            AnimationFrame.cancel(frame);
            AnimationFrame.cancel(nextFrame);
        };
    }));
    useIsoLayoutEffect(function() {
        if (animationTypeRef.current !== "css-transition") return;
        var panel = panelRef.current;
        if (!panel) return;
        var resizeFrame = -1;
        if (abortControllerRef.current != null) {
            abortControllerRef.current.abort();
            abortControllerRef.current = null;
        }
        if (open) {
            var originalLayoutStyles = {
                "justify-content": panel.style.justifyContent,
                "align-items": panel.style.alignItems,
                "align-content": panel.style.alignContent,
                "justify-items": panel.style.justifyItems
            };
            Object.keys(originalLayoutStyles).forEach(function(key) {
                panel.style.setProperty(key, "initial", "important");
            });
            /**
			* When `keepMounted={false}` and the panel is initially closed, the very
			* first time it opens (not any subsequent opens) `data-starting-style` is
			* off or missing by a frame so we need to set it manually. Otherwise any
			* CSS properties expected to transition using [data-starting-style] may
			* be mis-timed and appear to be complete skipped.
			*/ if (!shouldCancelInitialOpenTransitionRef.current && !keepMounted) panel.setAttribute(CollapsiblePanelDataAttributes.startingStyle, "");
            setDimensions({
                height: panel.scrollHeight,
                width: panel.scrollWidth
            });
            resizeFrame = AnimationFrame.request(function() {
                Object.entries(originalLayoutStyles).forEach(function(param) {
                    var _param = (0,src_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
                    if (value === "") panel.style.removeProperty(key);
                    else panel.style.setProperty(key, value);
                });
            });
        } else {
            if (panel.scrollHeight === 0 && panel.scrollWidth === 0) return;
            setDimensions({
                height: panel.scrollHeight,
                width: panel.scrollWidth
            });
            var abortController = new AbortController();
            abortControllerRef.current = abortController;
            var signal = abortController.signal;
            var attributeObserver = null;
            var endingStyleAttribute = CollapsiblePanelDataAttributes.endingStyle;
            attributeObserver = new MutationObserver(function(mutationList) {
                if (mutationList.some(function(mutation) {
                    return mutation.type === "attributes" && mutation.attributeName === endingStyleAttribute;
                })) {
                    attributeObserver === null || attributeObserver === void 0 ? void 0 : attributeObserver.disconnect();
                    attributeObserver = null;
                    runOnceAnimationsFinish(function() {
                        setDimensions({
                            height: 0,
                            width: 0
                        });
                        panel.style.removeProperty("content-visibility");
                        setMounted(false);
                        if (abortControllerRef.current === abortController) abortControllerRef.current = null;
                    }, signal);
                }
            });
            attributeObserver.observe(panel, {
                attributes: true,
                attributeFilter: [
                    endingStyleAttribute
                ]
            });
            return function() {
                attributeObserver === null || attributeObserver === void 0 ? void 0 : attributeObserver.disconnect();
                endingStyleFrame.cancel();
                if (abortControllerRef.current === abortController) {
                    abortController.abort();
                    abortControllerRef.current = null;
                }
            };
        }
        return function() {
            AnimationFrame.cancel(resizeFrame);
        };
    }, [
        abortControllerRef,
        animationTypeRef,
        endingStyleFrame,
        hiddenUntilFound,
        keepMounted,
        mounted,
        open,
        panelRef,
        runOnceAnimationsFinish,
        setDimensions,
        setMounted
    ]);
    useIsoLayoutEffect(function() {
        if (animationTypeRef.current !== "css-animation") return;
        var panel = panelRef.current;
        if (!panel) return;
        latestAnimationNameRef.current = panel.style.animationName || latestAnimationNameRef.current;
        panel.style.setProperty("animation-name", "none");
        setDimensions({
            height: panel.scrollHeight,
            width: panel.scrollWidth
        });
        if (!shouldCancelInitialOpenAnimationRef.current && !isBeforeMatchRef.current) panel.style.removeProperty("animation-name");
        if (open) {
            if (abortControllerRef.current != null) {
                abortControllerRef.current.abort();
                abortControllerRef.current = null;
            }
            setMounted(true);
            setVisible(true);
        } else {
            abortControllerRef.current = new AbortController();
            runOnceAnimationsFinish(function() {
                setMounted(false);
                setVisible(false);
                abortControllerRef.current = null;
            }, abortControllerRef.current.signal);
        }
    }, [
        abortControllerRef,
        animationTypeRef,
        open,
        panelRef,
        runOnceAnimationsFinish,
        setDimensions,
        setMounted,
        setVisible,
        visible
    ]);
    useOnMount(function() {
        var frame = AnimationFrame.request(function() {
            shouldCancelInitialOpenAnimationRef.current = false;
        });
        return function() {
            return AnimationFrame.cancel(frame);
        };
    });
    useIsoLayoutEffect(function() {
        if (!hiddenUntilFound) return;
        var panel = panelRef.current;
        if (!panel) return;
        var frame = -1;
        var nextFrame = -1;
        if (open && isBeforeMatchRef.current) {
            panel.style.transitionDuration = "0s";
            setDimensions({
                height: panel.scrollHeight,
                width: panel.scrollWidth
            });
            frame = AnimationFrame.request(function() {
                isBeforeMatchRef.current = false;
                nextFrame = AnimationFrame.request(function() {
                    setTimeout(function() {
                        panel.style.removeProperty("transition-duration");
                    });
                });
            });
        }
        return function() {
            AnimationFrame.cancel(frame);
            AnimationFrame.cancel(nextFrame);
        };
    }, [
        hiddenUntilFound,
        open,
        panelRef,
        setDimensions
    ]);
    useIsoLayoutEffect(function() {
        var panel = panelRef.current;
        if (panel && hiddenUntilFound && hidden) {
            /**
			* React only supports a boolean for the `hidden` attribute and forces
			* legit string values to booleans so we have to force it back in the DOM
			* when necessary: https://github.com/facebook/react/issues/24740
			*/ panel.setAttribute("hidden", "until-found");
            /**
			* Set data-starting-style here to persist the closed styles, this is to
			* prevent transitions from starting when the `hidden` attribute changes
			* to `'until-found'` as they could have different `display` properties:
			* https://github.com/tailwindlabs/tailwindcss/pull/14625
			*/ if (animationTypeRef.current === "css-transition") panel.setAttribute(CollapsiblePanelDataAttributes.startingStyle, "");
        }
    }, [
        hiddenUntilFound,
        hidden,
        animationTypeRef,
        panelRef
    ]);
    react.useEffect(function registerBeforeMatchListener() {
        var handleBeforeMatch = function handleBeforeMatch(event) {
            isBeforeMatchRef.current = true;
            setOpen(true);
            onOpenChange(true, createChangeEventDetails(none, event));
        };
        var panel = panelRef.current;
        if (!panel) return;
        return addEventListener(panel, "beforematch", handleBeforeMatch);
    }, [
        onOpenChange,
        panelRef,
        setOpen
    ]);
    return react.useMemo(function() {
        return {
            props: {
                hidden: hidden,
                id: idParam,
                ref: mergedPanelRef
            }
        };
    }, [
        hidden,
        idParam,
        mergedPanelRef
    ]);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/collapsible/panel/CollapsiblePanelCssVars.js
var CollapsiblePanelCssVars = /* @__PURE__ */ function(CollapsiblePanelCssVars) {
    /**
	* The collapsible panel's height.
	* @type {number}
	*/ CollapsiblePanelCssVars["collapsiblePanelHeight"] = "--collapsible-panel-height";
    /**
	* The collapsible panel's width.
	* @type {number}
	*/ CollapsiblePanelCssVars["collapsiblePanelWidth"] = "--collapsible-panel-width";
    return CollapsiblePanelCssVars;
}({});
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/collapsible/panel/CollapsiblePanel.js
/**
* A panel with the collapsible contents.
* Renders a `<div>` element.
*
* Documentation: [Base UI Collapsible](https://base-ui.com/react/components/collapsible)
*/ var CollapsiblePanel = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function CollapsiblePanel(componentProps, forwardedRef) {
    var className = componentProps.className, hiddenUntilFoundProp = componentProps.hiddenUntilFound, keepMountedProp = componentProps.keepMounted, render = componentProps.render, idProp = componentProps.id, style = componentProps.style, elementProps = (0,src_object_without_properties/* default */.Z)(componentProps, [
        "className",
        "hiddenUntilFound",
        "keepMounted",
        "render",
        "id",
        "style"
    ]);
    if (false) {}
    var ref = useCollapsibleRootContext(), abortControllerRef = ref.abortControllerRef, animationTypeRef = ref.animationTypeRef, height = ref.height, mounted = ref.mounted, onOpenChange = ref.onOpenChange, open = ref.open, panelId = ref.panelId, panelRef = ref.panelRef, runOnceAnimationsFinish = ref.runOnceAnimationsFinish, setDimensions = ref.setDimensions, setHiddenUntilFound = ref.setHiddenUntilFound, setKeepMounted = ref.setKeepMounted, setMounted = ref.setMounted, setPanelIdState = ref.setPanelIdState, setOpen = ref.setOpen, setVisible = ref.setVisible, state = ref.state, transitionDimensionRef = ref.transitionDimensionRef, visible = ref.visible, width = ref.width, transitionStatus = ref.transitionStatus;
    var hiddenUntilFound = hiddenUntilFoundProp !== null && hiddenUntilFoundProp !== void 0 ? hiddenUntilFoundProp : false;
    var keepMounted = keepMountedProp !== null && keepMountedProp !== void 0 ? keepMountedProp : false;
    useIsoLayoutEffect(function() {
        if (idProp) {
            setPanelIdState(idProp);
            return function() {
                setPanelIdState(void 0);
            };
        }
    }, [
        idProp,
        setPanelIdState
    ]);
    useIsoLayoutEffect(function() {
        setHiddenUntilFound(hiddenUntilFound);
    }, [
        setHiddenUntilFound,
        hiddenUntilFound
    ]);
    useIsoLayoutEffect(function() {
        setKeepMounted(keepMounted);
    }, [
        setKeepMounted,
        keepMounted
    ]);
    var props = useCollapsiblePanel({
        abortControllerRef: abortControllerRef,
        animationTypeRef: animationTypeRef,
        externalRef: forwardedRef,
        height: height,
        hiddenUntilFound: hiddenUntilFound,
        id: panelId,
        keepMounted: keepMounted,
        mounted: mounted,
        onOpenChange: onOpenChange,
        open: open,
        panelRef: panelRef,
        runOnceAnimationsFinish: runOnceAnimationsFinish,
        setDimensions: setDimensions,
        setMounted: setMounted,
        setOpen: setOpen,
        setVisible: setVisible,
        transitionDimensionRef: transitionDimensionRef,
        visible: visible,
        width: width
    }).props;
    useOpenChangeComplete({
        open: open && transitionStatus === "idle",
        ref: panelRef,
        onComplete: function onComplete() {
            if (!open) return;
            setDimensions({
                height: void 0,
                width: void 0
            });
        }
    });
    var _obj;
    var element = useRenderElement("div", componentProps, {
        state: react.useMemo(function() {
            return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, state), {
                transitionStatus: transitionStatus
            });
        }, [
            state,
            transitionStatus
        ]),
        ref: [
            forwardedRef,
            panelRef
        ],
        props: [
            props,
            {
                style: (_obj = {}, (0,src_define_property/* default */.Z)(_obj, CollapsiblePanelCssVars.collapsiblePanelHeight, height === void 0 ? "auto" : "".concat(height, "px")), (0,src_define_property/* default */.Z)(_obj, CollapsiblePanelCssVars.collapsiblePanelWidth, width === void 0 ? "auto" : "".concat(width, "px")), _obj)
            },
            elementProps
        ],
        stateAttributesMapping: collapsibleStateAttributesMapping
    });
    if (!(keepMounted || hiddenUntilFound || mounted)) return null;
    return element;
});
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/isElementDisabled.js
function isElementDisabled(element) {
    return element == null || element.hasAttribute("disabled") || element.getAttribute("aria-disabled") === "true";
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/composite/item/useCompositeItem.js
function useCompositeItem() {
    var params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref = useCompositeRootContext(), highlightItemOnHover = ref.highlightItemOnHover, highlightedIndex = ref.highlightedIndex, onHighlightedIndexChange = ref.onHighlightedIndexChange;
    var ref1 = useCompositeListItem(params), ref2 = ref1.ref, index = ref1.index;
    var isHighlighted = highlightedIndex === index;
    var itemRef = react.useRef(null);
    var mergedRef = useMergedRefs(ref2, itemRef);
    return {
        compositeProps: react.useMemo(function() {
            return {
                tabIndex: isHighlighted ? 0 : -1,
                onFocus: function onFocus() {
                    onHighlightedIndexChange(index);
                },
                onMouseMove: function onMouseMove() {
                    var item = itemRef.current;
                    if (!highlightItemOnHover || !item) return;
                    var disabled = item.hasAttribute("disabled") || item.ariaDisabled === "true";
                    if (!isHighlighted && !disabled) item.focus();
                }
            };
        }, [
            isHighlighted,
            onHighlightedIndexChange,
            index,
            highlightItemOnHover
        ]),
        compositeRef: mergedRef,
        index: index
    };
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/composite/item/CompositeItem.js
/**
* @internal
*/ function CompositeItem(componentProps) {
    var render = componentProps.render, className = componentProps.className, style = componentProps.style, _state = componentProps.state, state = _state === void 0 ? EMPTY_OBJECT : _state, _props = componentProps.props, props = _props === void 0 ? EMPTY_ARRAY$1 : _props, _refs = componentProps.refs, refs = _refs === void 0 ? EMPTY_ARRAY$1 : _refs, metadata = componentProps.metadata, stateAttributesMapping = componentProps.stateAttributesMapping, _tag = componentProps.tag, tag = _tag === void 0 ? "div" : _tag, elementProps = (0,src_object_without_properties/* default */.Z)(componentProps, [
        "render",
        "className",
        "style",
        "state",
        "props",
        "refs",
        "metadata",
        "stateAttributesMapping",
        "tag"
    ]);
    var ref = useCompositeItem({
        metadata: metadata
    }), compositeProps = ref.compositeProps, compositeRef = ref.compositeRef;
    return useRenderElement(tag, componentProps, {
        state: state,
        ref: (0,src_to_consumable_array/* default */.Z)(refs).concat([
            compositeRef
        ]),
        props: [
            compositeProps
        ].concat((0,src_to_consumable_array/* default */.Z)(props), [
            elementProps
        ]),
        stateAttributesMapping: stateAttributesMapping
    });
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/composite/constants.js
var ACTIVE_COMPOSITE_ITEM = "data-composite-item-active";
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/composite/root/useCompositeRoot.js
var EMPTY_ARRAY = [];
function useCompositeRoot(params) {
    var itemSizes = params.itemSizes, _cols = params.cols, cols = _cols === void 0 ? 1 : _cols, _loopFocus = params.loopFocus, loopFocus = _loopFocus === void 0 ? true : _loopFocus, onLoop = params.onLoop, _dense = params.dense, dense = _dense === void 0 ? false : _dense, _orientation = params.orientation, orientation = _orientation === void 0 ? "both" : _orientation, direction = params.direction, externalHighlightedIndex = params.highlightedIndex, externalSetHighlightedIndex = params.onHighlightedIndexChange, externalRef = params.rootRef, _enableHomeAndEndKeys = params.enableHomeAndEndKeys, enableHomeAndEndKeys = _enableHomeAndEndKeys === void 0 ? false : _enableHomeAndEndKeys, _stopEventPropagation = params.stopEventPropagation, stopEventPropagation = _stopEventPropagation === void 0 ? false : _stopEventPropagation, disabledIndices = params.disabledIndices, _modifierKeys = params.modifierKeys, modifierKeys = _modifierKeys === void 0 ? EMPTY_ARRAY : _modifierKeys;
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(0), 2), internalHighlightedIndex = ref[0], internalSetHighlightedIndex = ref[1];
    var isGrid = cols > 1;
    var rootRef = react.useRef(null);
    var mergedRef = useMergedRefs(rootRef, externalRef);
    var elementsRef = react.useRef([]);
    var hasSetDefaultIndexRef = react.useRef(false);
    var highlightedIndex = externalHighlightedIndex !== null && externalHighlightedIndex !== void 0 ? externalHighlightedIndex : internalHighlightedIndex;
    var onHighlightedIndexChange = useStableCallback(function(index) {
        var shouldScrollIntoView = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        (externalSetHighlightedIndex !== null && externalSetHighlightedIndex !== void 0 ? externalSetHighlightedIndex : internalSetHighlightedIndex)(index);
        if (shouldScrollIntoView) {
            var newActiveItem = elementsRef.current[index];
            scrollIntoViewIfNeeded(rootRef.current, newActiveItem, direction, orientation);
        }
    });
    var onMapChange = useStableCallback(function(map) {
        if (map.size === 0 || hasSetDefaultIndexRef.current) return;
        hasSetDefaultIndexRef.current = true;
        var sortedElements = Array.from(map.keys());
        var ref;
        var activeItem = (ref = sortedElements.find(function(compositeElement) {
            return compositeElement === null || compositeElement === void 0 ? void 0 : compositeElement.hasAttribute("data-composite-item-active");
        })) !== null && ref !== void 0 ? ref : null;
        var activeIndex = activeItem ? sortedElements.indexOf(activeItem) : -1;
        if (activeIndex !== -1) onHighlightedIndexChange(activeIndex);
        scrollIntoViewIfNeeded(rootRef.current, activeItem, direction, orientation);
    });
    var wrappedOnLoop = useStableCallback(function(event, prevIndex, nextIndex) {
        if (!onLoop) return nextIndex;
        return onLoop === null || onLoop === void 0 ? void 0 : onLoop(event, prevIndex, nextIndex, elementsRef);
    });
    var props = react.useMemo(function() {
        return {
            "aria-orientation": orientation === "both" ? void 0 : orientation,
            ref: mergedRef,
            onFocus: function onFocus(event) {
                var element = rootRef.current;
                var target = getTarget(event.nativeEvent);
                if (!element || target == null || !isNativeInput(target)) return;
                var _length;
                target.setSelectionRange(0, (_length = target.value.length) !== null && _length !== void 0 ? _length : 0);
            },
            onKeyDown: function onKeyDown(event) {
                var RELEVANT_KEYS = enableHomeAndEndKeys ? ALL_KEYS : ARROW_KEYS;
                if (!RELEVANT_KEYS.has(event.key)) return;
                if (isModifierKeySet(event, modifierKeys)) return;
                if (!rootRef.current) return;
                var isRtl = direction === "rtl";
                var horizontalForwardKey = isRtl ? ARROW_LEFT : ARROW_RIGHT;
                var forwardKey = {
                    horizontal: horizontalForwardKey,
                    vertical: ARROW_DOWN,
                    both: horizontalForwardKey
                }[orientation];
                var horizontalBackwardKey = isRtl ? ARROW_RIGHT : ARROW_LEFT;
                var backwardKey = {
                    horizontal: horizontalBackwardKey,
                    vertical: ARROW_UP,
                    both: horizontalBackwardKey
                }[orientation];
                var target = getTarget(event.nativeEvent);
                if (target != null && isNativeInput(target) && !isElementDisabled(target)) {
                    var selectionStart = target.selectionStart;
                    var selectionEnd = target.selectionEnd;
                    var _value;
                    var textContent = (_value = target.value) !== null && _value !== void 0 ? _value : "";
                    if (selectionStart == null || event.shiftKey || selectionStart !== selectionEnd) return;
                    if (event.key !== backwardKey && selectionStart < textContent.length) return;
                    if (event.key !== forwardKey && selectionStart > 0) return;
                }
                var nextIndex = highlightedIndex;
                var minIndex = getMinListIndex(elementsRef, disabledIndices);
                var maxIndex = getMaxListIndex(elementsRef, disabledIndices);
                if (isGrid) {
                    var sizes = itemSizes || Array.from({
                        length: elementsRef.current.length
                    }, function() {
                        return {
                            width: 1,
                            height: 1
                        };
                    });
                    var cellMap = createGridCellMap(sizes, cols, dense);
                    var minGridIndex = cellMap.findIndex(function(index) {
                        return index != null && !isListIndexDisabled(elementsRef.current, index, disabledIndices);
                    });
                    var maxGridIndex = cellMap.reduce(function(foundIndex, index, cellIndex) {
                        return index != null && !isListIndexDisabled(elementsRef.current, index, disabledIndices) ? cellIndex : foundIndex;
                    }, -1);
                    nextIndex = cellMap[getGridNavigatedIndex(cellMap.map(function(itemIndex) {
                        return itemIndex != null ? elementsRef.current[itemIndex] : null;
                    }), {
                        event: event,
                        orientation: orientation,
                        loopFocus: loopFocus,
                        onLoop: wrappedOnLoop,
                        cols: cols,
                        disabledIndices: getGridCellIndices((0,src_to_consumable_array/* default */.Z)(disabledIndices || elementsRef.current.map(function(_, index) {
                            return isListIndexDisabled(elementsRef.current, index) ? index : void 0;
                        })).concat([
                            void 0
                        ]), cellMap),
                        minIndex: minGridIndex,
                        maxIndex: maxGridIndex,
                        prevIndex: getGridCellIndexOfCorner(highlightedIndex > maxIndex ? minIndex : highlightedIndex, sizes, cellMap, cols, event.key === "ArrowDown" ? "bl" : event.key === "ArrowRight" ? "tr" : "tl"),
                        rtl: isRtl
                    })];
                }
                var forwardKeys = {
                    horizontal: [
                        horizontalForwardKey
                    ],
                    vertical: [
                        ARROW_DOWN
                    ],
                    both: [
                        horizontalForwardKey,
                        ARROW_DOWN
                    ]
                }[orientation];
                var backwardKeys = {
                    horizontal: [
                        horizontalBackwardKey
                    ],
                    vertical: [
                        ARROW_UP
                    ],
                    both: [
                        horizontalBackwardKey,
                        ARROW_UP
                    ]
                }[orientation];
                var preventedKeys = isGrid ? RELEVANT_KEYS : ({
                    horizontal: enableHomeAndEndKeys ? HORIZONTAL_KEYS_WITH_EXTRA_KEYS : HORIZONTAL_KEYS,
                    vertical: enableHomeAndEndKeys ? VERTICAL_KEYS_WITH_EXTRA_KEYS : VERTICAL_KEYS,
                    both: RELEVANT_KEYS
                })[orientation];
                if (enableHomeAndEndKeys) {
                    if (event.key === "Home") nextIndex = minIndex;
                    else if (event.key === "End") nextIndex = maxIndex;
                }
                if (nextIndex === highlightedIndex && (forwardKeys.includes(event.key) || backwardKeys.includes(event.key))) if (loopFocus && nextIndex === maxIndex && forwardKeys.includes(event.key)) {
                    nextIndex = minIndex;
                    if (onLoop) nextIndex = onLoop(event, highlightedIndex, nextIndex, elementsRef);
                } else if (loopFocus && nextIndex === minIndex && backwardKeys.includes(event.key)) {
                    nextIndex = maxIndex;
                    if (onLoop) nextIndex = onLoop(event, highlightedIndex, nextIndex, elementsRef);
                } else nextIndex = findNonDisabledListIndex(elementsRef.current, {
                    startingIndex: nextIndex,
                    decrement: backwardKeys.includes(event.key),
                    disabledIndices: disabledIndices
                });
                if (nextIndex !== highlightedIndex && !isIndexOutOfListBounds(elementsRef.current, nextIndex)) {
                    if (stopEventPropagation) event.stopPropagation();
                    if (preventedKeys.has(event.key)) event.preventDefault();
                    onHighlightedIndexChange(nextIndex, true);
                    queueMicrotask(function() {
                        var ref;
                        (ref = elementsRef.current[nextIndex]) === null || ref === void 0 ? void 0 : ref.focus();
                    });
                }
            }
        };
    }, [
        cols,
        dense,
        direction,
        disabledIndices,
        elementsRef,
        enableHomeAndEndKeys,
        highlightedIndex,
        isGrid,
        itemSizes,
        loopFocus,
        onLoop,
        wrappedOnLoop,
        mergedRef,
        modifierKeys,
        onHighlightedIndexChange,
        orientation,
        stopEventPropagation
    ]);
    return react.useMemo(function() {
        return {
            props: props,
            highlightedIndex: highlightedIndex,
            onHighlightedIndexChange: onHighlightedIndexChange,
            elementsRef: elementsRef,
            disabledIndices: disabledIndices,
            onMapChange: onMapChange,
            relayKeyboardEvent: props.onKeyDown
        };
    }, [
        props,
        highlightedIndex,
        onHighlightedIndexChange,
        elementsRef,
        disabledIndices,
        onMapChange
    ]);
}
function isModifierKeySet(event, ignoredModifierKeys) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = MODIFIER_KEYS$1.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (ignoredModifierKeys.includes(key)) continue;
            if (event.getModifierState(key)) return true;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return false;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/internals/composite/root/CompositeRoot.js
/**
* @internal
*/ function CompositeRoot(componentProps) {
    var render = componentProps.render, className = componentProps.className, style = componentProps.style, _refs = componentProps.refs, refs = _refs === void 0 ? EMPTY_ARRAY$1 : _refs, _props = componentProps.props, props = _props === void 0 ? EMPTY_ARRAY$1 : _props, _state = componentProps.state, state = _state === void 0 ? EMPTY_OBJECT : _state, stateAttributesMapping = componentProps.stateAttributesMapping, highlightedIndexProp = componentProps.highlightedIndex, onHighlightedIndexChangeProp = componentProps.onHighlightedIndexChange, orientation = componentProps.orientation, dense = componentProps.dense, itemSizes = componentProps.itemSizes, loopFocus = componentProps.loopFocus, onLoop = componentProps.onLoop, cols = componentProps.cols, enableHomeAndEndKeys = componentProps.enableHomeAndEndKeys, onMapChangeProp = componentProps.onMapChange, _stopEventPropagation = componentProps.stopEventPropagation, stopEventPropagation = _stopEventPropagation === void 0 ? true : _stopEventPropagation, rootRef = componentProps.rootRef, disabledIndices = componentProps.disabledIndices, modifierKeys = componentProps.modifierKeys, _highlightItemOnHover = componentProps.highlightItemOnHover, highlightItemOnHover = _highlightItemOnHover === void 0 ? false : _highlightItemOnHover, _tag = componentProps.tag, tag = _tag === void 0 ? "div" : _tag, elementProps = (0,src_object_without_properties/* default */.Z)(componentProps, [
        "render",
        "className",
        "style",
        "refs",
        "props",
        "state",
        "stateAttributesMapping",
        "highlightedIndex",
        "onHighlightedIndexChange",
        "orientation",
        "dense",
        "itemSizes",
        "loopFocus",
        "onLoop",
        "cols",
        "enableHomeAndEndKeys",
        "onMapChange",
        "stopEventPropagation",
        "rootRef",
        "disabledIndices",
        "modifierKeys",
        "highlightItemOnHover",
        "tag"
    ]);
    var ref = useCompositeRoot({
        itemSizes: itemSizes,
        cols: cols,
        loopFocus: loopFocus,
        onLoop: onLoop,
        dense: dense,
        orientation: orientation,
        highlightedIndex: highlightedIndexProp,
        onHighlightedIndexChange: onHighlightedIndexChangeProp,
        rootRef: rootRef,
        stopEventPropagation: stopEventPropagation,
        enableHomeAndEndKeys: enableHomeAndEndKeys,
        direction: useDirection(),
        disabledIndices: disabledIndices,
        modifierKeys: modifierKeys
    }), defaultProps = ref.props, highlightedIndex = ref.highlightedIndex, onHighlightedIndexChange = ref.onHighlightedIndexChange, elementsRef = ref.elementsRef, onMapChangeUnwrapped = ref.onMapChange, relayKeyboardEvent = ref.relayKeyboardEvent;
    var element = useRenderElement(tag, componentProps, {
        state: state,
        ref: refs,
        props: [
            defaultProps
        ].concat((0,src_to_consumable_array/* default */.Z)(props), [
            elementProps
        ]),
        stateAttributesMapping: stateAttributesMapping
    });
    var contextValue = react.useMemo(function() {
        return {
            highlightedIndex: highlightedIndex,
            onHighlightedIndexChange: onHighlightedIndexChange,
            highlightItemOnHover: highlightItemOnHover,
            relayKeyboardEvent: relayKeyboardEvent
        };
    }, [
        highlightedIndex,
        onHighlightedIndexChange,
        highlightItemOnHover,
        relayKeyboardEvent
    ]);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(CompositeRootContext.Provider, {
        value: contextValue,
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(CompositeList, {
            elementsRef: elementsRef,
            onMapChange: function(newMap) {
                onMapChangeProp === null || onMapChangeProp === void 0 ? void 0 : onMapChangeProp(newMap);
                onMapChangeUnwrapped(newMap);
            },
            children: element
        })
    });
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/utils/FloatingPortalLite.js
/**
* `FloatingPortal` includes tabbable logic handling for focus management.
* For components that don't need tabbable logic, use `FloatingPortalLite`.
* @internal
*/ var FloatingPortalLite = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function FloatingPortalLite(componentProps, forwardedRef) {
    var children = componentProps.children, container = componentProps.container, className = componentProps.className, render = componentProps.render, style = componentProps.style, elementProps = (0,src_object_without_properties/* default */.Z)(componentProps, [
        "children",
        "container",
        "className",
        "render",
        "style"
    ]);
    var ref = useFloatingPortalNode({
        container: container,
        ref: forwardedRef,
        componentProps: componentProps,
        elementProps: elementProps
    }), portalNode = ref.portalNode, portalSubtree = ref.portalSubtree;
    if (!portalSubtree && !portalNode) return null;
    return /* @__PURE__ */ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            portalSubtree,
            portalNode && /* @__PURE__ */ /*#__PURE__*/ react_dom.createPortal(children, portalNode)
        ]
    });
});
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/radio/root/RadioRootDataAttributes.js
var RadioRootDataAttributes = /* @__PURE__ */ function(RadioRootDataAttributes) {
    /**
	* Present when the radio is checked.
	*/ RadioRootDataAttributes["checked"] = "data-checked";
    /**
	* Present when the radio is not checked.
	*/ RadioRootDataAttributes["unchecked"] = "data-unchecked";
    /**
	* Present when the radio is disabled.
	*/ RadioRootDataAttributes["disabled"] = "data-disabled";
    /**
	* Present when the radio is readonly.
	*/ RadioRootDataAttributes["readonly"] = "data-readonly";
    /**
	* Present when the radio is required.
	*/ RadioRootDataAttributes["required"] = "data-required";
    /**
	* Present when the radio is in a valid state (when wrapped in Field.Root).
	*/ RadioRootDataAttributes["valid"] = "data-valid";
    /**
	* Present when the radio is in an invalid state (when wrapped in Field.Root).
	*/ RadioRootDataAttributes["invalid"] = "data-invalid";
    /**
	* Present when the radio has been touched (when wrapped in Field.Root).
	*/ RadioRootDataAttributes["touched"] = "data-touched";
    /**
	* Present when the radio's value has changed (when wrapped in Field.Root).
	*/ RadioRootDataAttributes["dirty"] = "data-dirty";
    /**
	* Present when the radio is checked (when wrapped in Field.Root).
	*/ RadioRootDataAttributes["filled"] = "data-filled";
    /**
	* Present when the radio is focused (when wrapped in Field.Root).
	*/ RadioRootDataAttributes["focused"] = "data-focused";
    return RadioRootDataAttributes;
}({});
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/radio/utils/stateAttributesMapping.js
var stateAttributesMapping$1 = (0,src_object_spread/* default */.Z)({
    checked: function checked(value) {
        if (value) return (0,src_define_property/* default */.Z)({}, RadioRootDataAttributes.checked, "");
        return (0,src_define_property/* default */.Z)({}, RadioRootDataAttributes.unchecked, "");
    }
}, transitionStatusMapping, fieldValidityMapping);
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/radio-group/RadioGroupContext.js
var RadioGroupContext = /* @__PURE__ */ /*#__PURE__*/ react.createContext(void 0);
if (false) {}
function useRadioGroupContext() {
    return react.useContext(RadioGroupContext);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/radio/root/RadioRootContext.js
var RadioRootContext = /* @__PURE__ */ /*#__PURE__*/ react.createContext(void 0);
if (false) {}
function useRadioRootContext() {
    var value = react.useContext(RadioRootContext);
    if (value === void 0) throw new Error( false ? 0 : formatErrorMessage(52));
    return value;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/radio/root/RadioRoot.js
/**
* Represents the radio button itself.
* Renders a `<span>` element and a hidden `<input>` beside.
*
* Documentation: [Base UI Radio](https://base-ui.com/react/components/radio)
*/ var RadioRoot = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function RadioRoot(componentProps, forwardedRef) {
    var render = componentProps.render, className = componentProps.className, tmp = componentProps.disabled, disabledProp = tmp === void 0 ? false : tmp, tmp1 = componentProps.readOnly, readOnlyProp = tmp1 === void 0 ? false : tmp1, tmp2 = componentProps.required, requiredProp = tmp2 === void 0 ? false : tmp2, ariaLabelledByProp = componentProps["aria-labelledby"], value = componentProps.value, inputRefProp = componentProps.inputRef, _nativeButton = componentProps.nativeButton, nativeButton = _nativeButton === void 0 ? false : _nativeButton, idProp = componentProps.id, style = componentProps.style, elementProps = (0,src_object_without_properties/* default */.Z)(componentProps, [
        "render",
        "className",
        "disabled",
        "readOnly",
        "required",
        "aria-labelledby",
        "value",
        "inputRef",
        "nativeButton",
        "id",
        "style"
    ]);
    var groupContext = useRadioGroupContext();
    var ref = groupContext !== null && groupContext !== void 0 ? groupContext : {}, disabledGroup = ref.disabled, readOnlyGroup = ref.readOnly, requiredGroup = ref.required, formGroup = ref.form, checkedValue = ref.checkedValue, _touched = ref.touched, touched = _touched === void 0 ? false : _touched, validation = ref.validation, name = ref.name;
    var ref1;
    var setCheckedValue = (ref1 = groupContext === null || groupContext === void 0 ? void 0 : groupContext.setCheckedValue) !== null && ref1 !== void 0 ? ref1 : NOOP;
    var ref2;
    var setTouched = (ref2 = groupContext === null || groupContext === void 0 ? void 0 : groupContext.setTouched) !== null && ref2 !== void 0 ? ref2 : NOOP;
    var ref3;
    var registerControlRef = (ref3 = groupContext === null || groupContext === void 0 ? void 0 : groupContext.registerControlRef) !== null && ref3 !== void 0 ? ref3 : NOOP;
    var ref4;
    var registerInputRef = (ref4 = groupContext === null || groupContext === void 0 ? void 0 : groupContext.registerInputRef) !== null && ref4 !== void 0 ? ref4 : NOOP;
    var ref5 = useFieldRootContext(), setDirty = ref5.setDirty, validityData = ref5.validityData, setFieldTouched = ref5.setTouched, setFilled = ref5.setFilled, fieldState = ref5.state, fieldDisabled = ref5.disabled;
    var fieldItemContext = useFieldItemContext();
    var ref6 = useLabelableContext(), labelId = ref6.labelId, getDescriptionProps = ref6.getDescriptionProps;
    var disabled = fieldDisabled || fieldItemContext.disabled || disabledGroup || disabledProp;
    var readOnly = readOnlyGroup || readOnlyProp;
    var required = requiredGroup || requiredProp;
    var form = formGroup;
    var checked = groupContext ? checkedValue === value : value === "";
    var serializedValue = react.useMemo(function() {
        return serializeValue(value);
    }, [
        value
    ]);
    var radioRef = react.useRef(null);
    var inputRef = react.useRef(null);
    var handleControlRef = useStableCallback(function(element) {
        if (!element) return;
        registerControlRef(element, disabled);
    });
    var mergedInputRef = useMergedRefs(inputRefProp, inputRef, registerInputRef);
    useIsoLayoutEffect(function() {
        var ref;
        if ((ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.checked) setFilled(true);
    }, [
        setFilled
    ]);
    useIsoLayoutEffect(function() {
        if (!inputRef.current) return;
        if (disabled && checked) {
            registerInputRef(null);
            return;
        }
        if (radioRef.current) registerControlRef(radioRef.current, disabled);
        registerInputRef(inputRef.current);
    }, [
        checked,
        disabled,
        registerControlRef,
        registerInputRef
    ]);
    var id = useBaseUiId();
    var inputId = useLabelableId({
        id: idProp,
        implicit: false,
        controlRef: radioRef
    });
    var hiddenInputId = nativeButton ? void 0 : inputId;
    var ariaLabelledBy = useAriaLabelledBy(ariaLabelledByProp, labelId, inputRef, !nativeButton, hiddenInputId);
    var _obj;
    var rootProps = (_obj = {
        role: "radio",
        "aria-checked": checked,
        "aria-required": required || void 0,
        "aria-readonly": readOnly || void 0,
        "aria-labelledby": ariaLabelledBy
    }, (0,src_define_property/* default */.Z)(_obj, ACTIVE_COMPOSITE_ITEM, checked ? "" : void 0), (0,src_define_property/* default */.Z)(_obj, "id", nativeButton ? inputId : id), (0,src_define_property/* default */.Z)(_obj, "onKeyDown", function onKeyDown(event) {
        if (event.key === "Enter") event.preventDefault();
    }), (0,src_define_property/* default */.Z)(_obj, "onClick", function onClick(event) {
        var ref;
        if (event.defaultPrevented || disabled || readOnly) return;
        event.preventDefault();
        (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.dispatchEvent(new PointerEvent("click", {
            bubbles: true,
            shiftKey: event.shiftKey,
            ctrlKey: event.ctrlKey,
            altKey: event.altKey,
            metaKey: event.metaKey
        }));
    }), (0,src_define_property/* default */.Z)(_obj, "onFocus", function onFocus(event) {
        var ref;
        if (event.defaultPrevented || disabled || readOnly || !touched) return;
        (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.click();
        setTouched(false);
    }), _obj);
    var ref7 = useButton({
        disabled: disabled,
        native: nativeButton
    }), getButtonProps = ref7.getButtonProps, buttonRef = ref7.buttonRef;
    var inputProps = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        type: "radio",
        ref: mergedInputRef,
        form: form,
        id: hiddenInputId,
        name: name,
        tabIndex: -1,
        style: name ? visuallyHiddenInput : visuallyHidden,
        "aria-hidden": true
    }, value !== void 0 ? {
        value: serializedValue
    } : EMPTY_OBJECT), {
        disabled: disabled,
        checked: checked,
        required: required,
        readOnly: readOnly,
        onChange: function onChange(event) {
            if (event.nativeEvent.defaultPrevented) return;
            if (disabled || readOnly || value === void 0) return;
            var details = createChangeEventDetails(none, event.nativeEvent);
            if (details.isCanceled) return;
            setFieldTouched(true);
            setDirty(value !== validityData.initialValue);
            setFilled(true);
            setCheckedValue(value, details);
        },
        onFocus: function onFocus() {
            var ref;
            (ref = radioRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        }
    });
    var state = react.useMemo(function() {
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, fieldState), {
            required: required,
            disabled: disabled,
            readOnly: readOnly,
            checked: checked
        });
    }, [
        fieldState,
        disabled,
        readOnly,
        checked,
        required
    ]);
    var contextValue = state;
    var isRadioGroup = groupContext !== void 0;
    var refs = [
        forwardedRef,
        radioRef,
        buttonRef,
        handleControlRef
    ];
    var ref8;
    var props = [
        rootProps,
        getDescriptionProps,
        (ref8 = validation === null || validation === void 0 ? void 0 : validation.getValidationProps) !== null && ref8 !== void 0 ? ref8 : EMPTY_OBJECT,
        elementProps,
        getButtonProps
    ];
    var element = useRenderElement("span", componentProps, {
        enabled: !isRadioGroup,
        state: state,
        ref: refs,
        props: props,
        stateAttributesMapping: stateAttributesMapping$1
    });
    return /* @__PURE__ */ (0,jsx_runtime.jsxs)(RadioRootContext.Provider, {
        value: contextValue,
        children: [
            isRadioGroup ? /* @__PURE__ */ (0,jsx_runtime.jsx)(CompositeItem, {
                tag: "span",
                render: render,
                className: className,
                style: style,
                state: state,
                refs: refs,
                props: props,
                stateAttributesMapping: stateAttributesMapping$1
            }) : element,
            /* @__PURE__ */ (0,jsx_runtime.jsx)("input", (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, inputProps), {
                suppressHydrationWarning: true
            }))
        ]
    });
});
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/radio/indicator/RadioIndicator.js
/**
* Indicates whether the radio button is selected.
* Renders a `<span>` element.
*
* Documentation: [Base UI Radio](https://base-ui.com/react/components/radio)
*/ var RadioIndicator = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function RadioIndicator(componentProps, forwardedRef) {
    var render = componentProps.render, className = componentProps.className, style = componentProps.style, _keepMounted = componentProps.keepMounted, keepMounted = _keepMounted === void 0 ? false : _keepMounted, elementProps = (0,src_object_without_properties/* default */.Z)(componentProps, [
        "render",
        "className",
        "style",
        "keepMounted"
    ]);
    var rootState = useRadioRootContext();
    var rendered = rootState.checked;
    var ref = useTransitionStatus(rendered), mounted = ref.mounted, transitionStatus = ref.transitionStatus, setMounted = ref.setMounted;
    var state = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, rootState), {
        transitionStatus: transitionStatus
    });
    var indicatorRef = react.useRef(null);
    var shouldRender = keepMounted || mounted;
    var element = useRenderElement("span", componentProps, {
        ref: [
            forwardedRef,
            indicatorRef
        ],
        state: state,
        props: elementProps,
        stateAttributesMapping: stateAttributesMapping$1
    });
    useOpenChangeComplete({
        open: rendered,
        ref: indicatorRef,
        onComplete: function onComplete() {
            if (!rendered) setMounted(false);
        }
    });
    if (!shouldRender) return null;
    return element;
});
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/radio-group/RadioGroup.js
var MODIFIER_KEYS = [
    SHIFT
];
/**
* Provides a shared state to a series of radio buttons.
* Renders a `<div>` element.
*
* Documentation: [Base UI Radio Group](https://base-ui.com/react/components/radio)
*/ var RadioGroup = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function RadioGroup(componentProps, forwardedRef) {
    var setInputRef = function setInputRef(hiddenInput) {
        var cleanup = void 0;
        if (inputRefProp) if (typeof inputRefProp === "function") cleanup = inputRefProp(hiddenInput);
        else inputRefProp.current = hiddenInput;
        groupInputRef.current = hiddenInput;
        validation.inputRef.current = hiddenInput;
        return cleanup;
    };
    var render = componentProps.render, className = componentProps.className, disabledProp = componentProps.disabled, readOnly = componentProps.readOnly, required = componentProps.required, onValueChangeProp = componentProps.onValueChange, externalValue = componentProps.value, defaultValue = componentProps.defaultValue, form = componentProps.form, nameProp = componentProps.name, inputRefProp = componentProps.inputRef, idProp = componentProps.id, style = componentProps.style, elementProps = (0,src_object_without_properties/* default */.Z)(componentProps, [
        "render",
        "className",
        "disabled",
        "readOnly",
        "required",
        "onValueChange",
        "value",
        "defaultValue",
        "form",
        "name",
        "inputRef",
        "id",
        "style"
    ]);
    var ref = useFieldRootContext(), setFieldTouched = ref.setTouched, setFocused = ref.setFocused, shouldValidateOnChange = ref.shouldValidateOnChange, validationMode = ref.validationMode, fieldName = ref.name, fieldDisabled = ref.disabled, fieldState = ref.state, validation = ref.validation, setDirty = ref.setDirty, setFilled = ref.setFilled, validityData = ref.validityData;
    var labelId = useLabelableContext().labelId;
    var clearErrors = useFormContext().clearErrors;
    var fieldsetContext = useFieldsetRootContext(true);
    var disabled = fieldDisabled || disabledProp;
    var name = fieldName !== null && fieldName !== void 0 ? fieldName : nameProp;
    var id = useBaseUiId(idProp);
    var ref1 = (0,src_sliced_to_array/* default */.Z)(useControlled({
        controlled: externalValue,
        default: defaultValue,
        name: "RadioGroup",
        state: "value"
    }), 2), checkedValue = ref1[0], setCheckedValueUnwrapped = ref1[1];
    var onValueChange = useStableCallback(onValueChangeProp);
    var setCheckedValue = useStableCallback(function(value, eventDetails) {
        onValueChange(value, eventDetails);
        if (eventDetails.isCanceled) return;
        setCheckedValueUnwrapped(value);
    });
    var controlRef = react.useRef(null);
    var groupInputRef = react.useRef(null);
    var firstEnabledInputRef = react.useRef(null);
    var registerControlRef = useStableCallback(function(element) {
        var isDisabled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        if (!element) return;
        if (isDisabled) {
            if (controlRef.current === element) controlRef.current = null;
            return;
        }
        if (controlRef.current == null) controlRef.current = element;
    });
    var registerInputRef = useStableCallback(function(input) {
        if (!input || input.disabled) return;
        if (!firstEnabledInputRef.current) firstEnabledInputRef.current = input;
        var currentInput = groupInputRef.current;
        if (input.checked || currentInput == null || currentInput.disabled) return setInputRef(input);
    });
    useRegisterFieldControl(controlRef, {
        id: id,
        value: checkedValue,
        getValue: useStableCallback(function() {
            return checkedValue !== null && checkedValue !== void 0 ? checkedValue : null;
        })
    });
    useValueChanged(checkedValue, function() {
        clearErrors(name);
        setDirty(checkedValue !== validityData.initialValue);
        setFilled(checkedValue != null);
        if (shouldValidateOnChange()) validation.commit(checkedValue);
        else validation.commit(checkedValue, true);
        var fallbackInput = firstEnabledInputRef.current;
        if (checkedValue == null && fallbackInput && !fallbackInput.disabled) setInputRef(fallbackInput);
    });
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), touched = ref2[0], setTouched = ref2[1];
    var ref3, ref4;
    var ariaLabelledby = (ref4 = (ref3 = elementProps["aria-labelledby"]) !== null && ref3 !== void 0 ? ref3 : labelId) !== null && ref4 !== void 0 ? ref4 : fieldsetContext === null || fieldsetContext === void 0 ? void 0 : fieldsetContext.legendId;
    var state = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, fieldState), {
        disabled: disabled !== null && disabled !== void 0 ? disabled : false,
        required: required !== null && required !== void 0 ? required : false,
        readOnly: readOnly !== null && readOnly !== void 0 ? readOnly : false
    });
    var contextValue = react.useMemo(function() {
        return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, fieldState), {
            checkedValue: checkedValue,
            disabled: disabled,
            form: form,
            validation: validation,
            name: name,
            onValueChange: onValueChange,
            readOnly: readOnly,
            registerControlRef: registerControlRef,
            registerInputRef: registerInputRef,
            required: required,
            setCheckedValue: setCheckedValue,
            setTouched: setTouched,
            touched: touched
        });
    }, [
        checkedValue,
        disabled,
        form,
        validation,
        fieldState,
        name,
        onValueChange,
        readOnly,
        registerControlRef,
        registerInputRef,
        required,
        setCheckedValue,
        setTouched,
        touched
    ]);
    var defaultProps = {
        role: "radiogroup",
        "aria-required": required || void 0,
        "aria-disabled": disabled || void 0,
        "aria-readonly": readOnly || void 0,
        "aria-labelledby": ariaLabelledby,
        onFocus: function onFocus() {
            setFocused(true);
        },
        onBlur: function onBlur(event) {
            if (!contains(event.currentTarget, event.relatedTarget)) {
                setFieldTouched(true);
                setFocused(false);
                if (validationMode === "onBlur") validation.commit(checkedValue);
            }
        },
        onKeyDownCapture: function onKeyDownCapture(event) {
            if (event.key.startsWith("Arrow")) {
                setFieldTouched(true);
                setTouched(true);
                setFocused(true);
            }
        }
    };
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(RadioGroupContext.Provider, {
        value: contextValue,
        children: /* @__PURE__ */ (0,jsx_runtime.jsx)(CompositeRoot, {
            render: render,
            className: className,
            style: style,
            state: state,
            props: [
                defaultProps,
                validation.getValidationProps,
                elementProps
            ],
            refs: [
                forwardedRef
            ],
            stateAttributesMapping: fieldValidityMapping,
            enableHomeAndEndKeys: false,
            modifierKeys: MODIFIER_KEYS
        })
    });
});
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/toast/provider/ToastProviderContext.js
var ToastContext = /* @__PURE__ */ /*#__PURE__*/ react.createContext(void 0);
if (false) {}
function useToastProviderContext() {
    var context = react.useContext(ToastContext);
    if (!context) throw new Error( false ? 0 : formatErrorMessage(73));
    return context;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+utils@0.2.8_@types+react@18.3.28_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/@base-ui/utils/esm/generateId.js
var counter = 0;
function generateId(prefix) {
    counter += 1;
    return "".concat(prefix, "-").concat(Math.random().toString(36).slice(2, 6), "-").concat(counter);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/toast/utils/resolvePromiseOptions.js
function resolvePromiseOptions(options, result) {
    if (typeof options === "string") return {
        description: options
    };
    if (typeof options === "function") {
        var resolvedOptions = options(result);
        return typeof resolvedOptions === "string" ? {
            description: resolvedOptions
        } : resolvedOptions;
    }
    return options;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/toast/store.js
var toastMapSelector = createSelectorMemoized(function(state) {
    return state.toasts;
}, function(toasts) {
    var map = /* @__PURE__ */ new Map();
    var visibleIndex = 0;
    var offsetY = 0;
    toasts.forEach(function(toast, toastIndex) {
        var isEnding = toast.transitionStatus === "ending";
        map.set(toast.id, {
            value: toast,
            domIndex: toastIndex,
            visibleIndex: isEnding ? -1 : visibleIndex,
            offsetY: offsetY
        });
        offsetY += toast.height || 0;
        if (!isEnding) visibleIndex += 1;
    });
    return map;
});
var ref, ref1, ref2;
var selectors = {
    toasts: createSelector$1(function(state) {
        return state.toasts;
    }),
    isEmpty: createSelector$1(function(state) {
        return state.toasts.length === 0;
    }),
    toast: createSelector$1(toastMapSelector, function(toastMap, id) {
        var ref;
        return (ref = toastMap.get(id)) === null || ref === void 0 ? void 0 : ref.value;
    }),
    toastIndex: createSelector$1(toastMapSelector, function(toastMap, id) {
        var ref1;
        return (ref = (ref1 = toastMap.get(id)) === null || ref1 === void 0 ? void 0 : ref1.domIndex) !== null && ref !== void 0 ? ref : -1;
    }),
    toastOffsetY: createSelector$1(toastMapSelector, function(toastMap, id) {
        var ref;
        return (ref1 = (ref = toastMap.get(id)) === null || ref === void 0 ? void 0 : ref.offsetY) !== null && ref1 !== void 0 ? ref1 : 0;
    }),
    toastVisibleIndex: createSelector$1(toastMapSelector, function(toastMap, id) {
        var ref;
        return (ref2 = (ref = toastMap.get(id)) === null || ref === void 0 ? void 0 : ref.visibleIndex) !== null && ref2 !== void 0 ? ref2 : -1;
    }),
    hovering: createSelector$1(function(state) {
        return state.hovering;
    }),
    focused: createSelector$1(function(state) {
        return state.focused;
    }),
    expanded: createSelector$1(function(state) {
        return state.hovering || state.focused;
    }),
    expandedOrOutOfFocus: createSelector$1(function(state) {
        return state.hovering || state.focused || !state.isWindowFocused;
    }),
    prevFocusElement: createSelector$1(function(state) {
        return state.prevFocusElement;
    })
};
var ToastStore = /*#__PURE__*/ function(ReactStore) {
    "use strict";
    (0,src_inherits/* default */.Z)(ToastStore, ReactStore);
    var _super = (0,src_create_super/* default */.Z)(ToastStore);
    function ToastStore(initialState) {
        (0,src_class_call_check/* default */.Z)(this, ToastStore);
        var _this;
        _this = _super.call(this, initialState, {}, selectors);
        (0,src_define_property/* default */.Z)((0,src_assert_this_initialized/* default */.Z)(_this), "timers", /* @__PURE__ */ new Map());
        (0,src_define_property/* default */.Z)((0,src_assert_this_initialized/* default */.Z)(_this), "areTimersPaused", false);
        (0,src_define_property/* default */.Z)((0,src_assert_this_initialized/* default */.Z)(_this), "setViewport", function(viewport) {
            _this.set("viewport", viewport);
        });
        (0,src_define_property/* default */.Z)((0,src_assert_this_initialized/* default */.Z)(_this), "disposeEffect", function() {
            return function() {
                _this.timers.forEach(function(timer) {
                    var ref;
                    (ref = timer.timeout) === null || ref === void 0 ? void 0 : ref.clear();
                });
                _this.timers.clear();
            };
        });
        (0,src_define_property/* default */.Z)((0,src_assert_this_initialized/* default */.Z)(_this), "addToast", function(toast) {
            var _state = _this.state, timeout = _state.timeout, limit = _state.limit;
            var id = toast.id || generateId("toast");
            if (toast.id) {
                var existingToast = selectors.toast(_this.state, toast.id);
                if (existingToast) if (existingToast.transitionStatus === "ending") _this.removeToast(toast.id, {
                    skipOnRemove: true
                });
                else {
                    var ignoredId = toast.id, ignoredTransitionStatus = toast.transitionStatus, updates = (0,src_object_without_properties/* default */.Z)(toast, [
                        "id",
                        "transitionStatus"
                    ]);
                    _this.updateToastInternal(toast.id, updates, {
                        resetTimer: true,
                        markUpdated: true
                    });
                    return toast.id;
                }
            }
            var toastToAdd = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, toast), {
                id: id,
                updateKey: 0,
                transitionStatus: "starting"
            });
            var updatedToasts = [
                toastToAdd
            ].concat((0,src_to_consumable_array/* default */.Z)(_this.state.toasts));
            var activeToasts = updatedToasts.filter(function(t) {
                return t.transitionStatus !== "ending";
            });
            if (activeToasts.length > limit) {
                var excessCount = activeToasts.length - limit;
                var oldestActiveToasts = activeToasts.slice(-excessCount);
                var limitedIds = new Set(oldestActiveToasts.map(function(t) {
                    return t.id;
                }));
                _this.setToasts(updatedToasts.map(function(t) {
                    var limited = limitedIds.has(t.id);
                    if (t.limited !== limited) return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, t), {
                        limited: limited
                    });
                    return t;
                }));
            } else _this.setToasts(updatedToasts.map(function(t) {
                return t.limited ? (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, t), {
                    limited: false
                }) : t;
            }));
            var _timeout;
            var duration = (_timeout = toastToAdd.timeout) !== null && _timeout !== void 0 ? _timeout : timeout;
            if (toastToAdd.type !== "loading" && duration > 0) _this.scheduleTimer(id, duration, function() {
                return _this.closeToast(id);
            });
            if (selectors.expandedOrOutOfFocus(_this.state)) _this.pauseTimers();
            return id;
        });
        (0,src_define_property/* default */.Z)((0,src_assert_this_initialized/* default */.Z)(_this), "updateToast", function(id, updates) {
            _this.updateToastInternal(id, updates, {
                markUpdated: true
            });
        });
        (0,src_define_property/* default */.Z)((0,src_assert_this_initialized/* default */.Z)(_this), "updateToastInternal", function(id, updates) {
            var behavior = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            var _state = _this.state, timeout = _state.timeout, toasts = _state.toasts;
            var ref;
            var prevToast = (ref = selectors.toast(_this.state, id)) !== null && ref !== void 0 ? ref : null;
            if (!prevToast) return;
            if (prevToast.transitionStatus === "ending") return;
            var _updateKey;
            var nextToast = (0,src_object_spread/* default */.Z)({}, prevToast, updates, behavior.markUpdated && {
                updateKey: ((_updateKey = prevToast.updateKey) !== null && _updateKey !== void 0 ? _updateKey : 0) + 1
            });
            _this.setToasts(toasts.map(function(toast) {
                return toast.id === id ? nextToast : toast;
            }));
            var _timeout;
            var nextTimeout = (_timeout = nextToast.timeout) !== null && _timeout !== void 0 ? _timeout : timeout;
            var ref1;
            var prevTimeout = (ref1 = prevToast === null || prevToast === void 0 ? void 0 : prevToast.timeout) !== null && ref1 !== void 0 ? ref1 : timeout;
            var timeoutUpdated = Object.hasOwn(updates, "timeout");
            var shouldHaveTimer = nextToast.transitionStatus !== "ending" && nextToast.type !== "loading" && nextTimeout > 0;
            var hasTimer = _this.timers.has(id);
            var timeoutChanged = prevTimeout !== nextTimeout;
            var wasLoading = (prevToast === null || prevToast === void 0 ? void 0 : prevToast.type) === "loading";
            if (!shouldHaveTimer && hasTimer) {
                var ref2, ref3;
                (ref2 = _this.timers.get(id)) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.timeout) === null || ref3 === void 0 ? void 0 : ref3.clear();
                _this.timers.delete(id);
                return;
            }
            if (shouldHaveTimer && (!hasTimer || timeoutChanged || timeoutUpdated || wasLoading || behavior.resetTimer)) {
                var timer = _this.timers.get(id);
                if (timer) {
                    var ref4;
                    (ref4 = timer.timeout) === null || ref4 === void 0 ? void 0 : ref4.clear();
                    _this.timers.delete(id);
                }
                _this.scheduleTimer(id, nextTimeout, function() {
                    return _this.closeToast(id);
                });
                if (selectors.expandedOrOutOfFocus(_this.state)) _this.pauseTimers();
            }
        });
        (0,src_define_property/* default */.Z)((0,src_assert_this_initialized/* default */.Z)(_this), "closeToast", function(toastId) {
            var closeAll = toastId === void 0;
            var _state = _this.state, limit = _state.limit, toasts = _state.toasts;
            var toastsToClose;
            if (closeAll) {
                toastsToClose = toasts;
                _this.timers.forEach(function(timer) {
                    var ref;
                    (ref = timer.timeout) === null || ref === void 0 ? void 0 : ref.clear();
                });
                _this.timers.clear();
            } else {
                var toast = selectors.toast(_this.state, toastId);
                if (!toast) return;
                toastsToClose = [
                    toast
                ];
                var timer = _this.timers.get(toastId);
                if (timer === null || timer === void 0 ? void 0 : timer.timeout) {
                    timer.timeout.clear();
                    _this.timers.delete(toastId);
                }
            }
            var activeIndex = 0;
            var updates = {
                toasts: toasts.map(function(item) {
                    if (closeAll || item.id === toastId) return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item), {
                        transitionStatus: "ending",
                        height: 0
                    });
                    if (item.transitionStatus === "ending") return item;
                    var isLimited = activeIndex >= limit;
                    activeIndex += 1;
                    return item.limited !== isLimited ? (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, item), {
                        limited: isLimited
                    }) : item;
                })
            };
            if (closeAll || toasts.length === 1) {
                updates.hovering = false;
                updates.focused = false;
            }
            _this.update(updates);
            toastsToClose.forEach(function(toast) {
                var ref;
                if (toast.transitionStatus !== "ending") (ref = toast.onClose) === null || ref === void 0 ? void 0 : ref.call(toast);
            });
            _this.handleFocusManagement(toastId);
        });
        (0,src_define_property/* default */.Z)((0,src_assert_this_initialized/* default */.Z)(_this), "promiseToast", function(promiseValue, options) {
            var loadingOptions = resolvePromiseOptions(options.loading);
            var id = _this.addToast((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, loadingOptions), {
                type: "loading"
            }));
            var handledPromise = promiseValue.then(function(result) {
                var successOptions = resolvePromiseOptions(options.success, result);
                _this.updateToast(id, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, successOptions), {
                    type: "success",
                    timeout: successOptions.timeout
                }));
                return result;
            }).catch(function(error) {
                var errorOptions = resolvePromiseOptions(options.error, error);
                _this.updateToast(id, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, errorOptions), {
                    type: "error",
                    timeout: errorOptions.timeout
                }));
                return Promise.reject(error);
            });
            if (({}).hasOwnProperty.call(options, "setPromise")) options.setPromise(handledPromise);
            return handledPromise;
        });
        (0,src_define_property/* default */.Z)((0,src_assert_this_initialized/* default */.Z)(_this), "handleDocumentPointerDown", function(event) {
            if (event.pointerType !== "touch") return;
            var target = getTarget(event);
            if (contains(_this.state.viewport, target)) return;
            _this.resumeTimers();
            _this.update({
                hovering: false,
                focused: false
            });
        });
        return _this;
    }
    (0,src_create_class/* default */.Z)(ToastStore, [
        {
            key: "setFocused",
            value: function setFocused(focused) {
                this.set("focused", focused);
            }
        },
        {
            key: "setHovering",
            value: function setHovering(hovering) {
                this.set("hovering", hovering);
            }
        },
        {
            key: "setIsWindowFocused",
            value: function setIsWindowFocused(isWindowFocused) {
                this.set("isWindowFocused", isWindowFocused);
            }
        },
        {
            key: "setPrevFocusElement",
            value: function setPrevFocusElement(prevFocusElement) {
                this.set("prevFocusElement", prevFocusElement);
            }
        },
        {
            key: "removeToast",
            value: function removeToast(toastId) {
                var behavior = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var ref;
                var index = selectors.toastIndex(this.state, toastId);
                if (index === -1) return;
                var toast = this.state.toasts[index];
                if (!behavior.skipOnRemove) toast === null || toast === void 0 ? void 0 : (ref = toast.onRemove) === null || ref === void 0 ? void 0 : ref.call(toast);
                var newToasts = (0,src_to_consumable_array/* default */.Z)(this.state.toasts);
                newToasts.splice(index, 1);
                this.setToasts(newToasts);
            }
        },
        {
            key: "pauseTimers",
            value: function pauseTimers() {
                if (this.areTimersPaused) return;
                this.areTimersPaused = true;
                this.timers.forEach(function(timer) {
                    if (timer.timeout) {
                        timer.timeout.clear();
                        var elapsed = Date.now() - timer.start;
                        var remaining = timer.delay - elapsed;
                        timer.remaining = remaining > 0 ? remaining : 0;
                    }
                });
            }
        },
        {
            key: "resumeTimers",
            value: function resumeTimers() {
                var _this = this;
                if (!this.areTimersPaused) return;
                this.areTimersPaused = false;
                this.timers.forEach(function(timer, id) {
                    timer.remaining = timer.remaining > 0 ? timer.remaining : timer.delay;
                    var _timeout;
                    (_timeout = (_timer = timer).timeout) !== null && _timeout !== void 0 ? _timeout : _timer.timeout = Timeout.create();
                    timer.timeout.start(timer.remaining, function() {
                        _this.timers.delete(id);
                        timer.callback();
                    });
                    timer.start = Date.now();
                });
            }
        },
        {
            key: "restoreFocusToPrevElement",
            value: function restoreFocusToPrevElement() {
                var ref;
                (ref = this.state.prevFocusElement) === null || ref === void 0 ? void 0 : ref.focus({
                    preventScroll: true
                });
            }
        },
        {
            key: "scheduleTimer",
            value: function scheduleTimer(id, delay, callback) {
                var _this = this;
                var start = Date.now();
                var shouldStartActive = !selectors.expandedOrOutOfFocus(this.state);
                var currentTimeout = shouldStartActive ? Timeout.create() : void 0;
                currentTimeout === null || currentTimeout === void 0 ? void 0 : currentTimeout.start(delay, function() {
                    _this.timers.delete(id);
                    callback();
                });
                this.timers.set(id, {
                    timeout: currentTimeout,
                    start: shouldStartActive ? start : 0,
                    delay: delay,
                    remaining: delay,
                    callback: callback
                });
            }
        },
        {
            key: "setToasts",
            value: function setToasts(newToasts) {
                var updates = {
                    toasts: newToasts
                };
                if (newToasts.length === 0) {
                    updates.hovering = false;
                    updates.focused = false;
                }
                this.update(updates);
            }
        },
        {
            key: "handleFocusManagement",
            value: function handleFocusManagement(toastId) {
                var ref, ref1;
                var activeEl = activeElement(ownerDocument(this.state.viewport));
                if (!this.state.viewport || !contains(this.state.viewport, activeEl) || !matchesFocusVisible(activeEl)) return;
                if (toastId === void 0) {
                    this.restoreFocusToPrevElement();
                    return;
                }
                var toasts = selectors.toasts(this.state);
                var currentIndex = selectors.toastIndex(this.state, toastId);
                var nextToast = null;
                var index = currentIndex + 1;
                while(index < toasts.length){
                    if (toasts[index].transitionStatus !== "ending") {
                        nextToast = toasts[index];
                        break;
                    }
                    index += 1;
                }
                if (!nextToast) {
                    index = currentIndex - 1;
                    while(index >= 0){
                        if (toasts[index].transitionStatus !== "ending") {
                            nextToast = toasts[index];
                            break;
                        }
                        index -= 1;
                    }
                }
                if (nextToast) (ref = nextToast.ref) === null || ref === void 0 ? void 0 : (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.focus();
                else this.restoreFocusToPrevElement();
            }
        }
    ]);
    return ToastStore;
}(ReactStore);
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/toast/provider/ToastProvider.js
/**
* Provides a context for creating and managing toasts.
*
* Documentation: [Base UI Toast](https://base-ui.com/react/components/toast)
*/ var ToastProvider = function ToastProvider(props) {
    var children = props.children, _timeout = props.timeout, timeout = _timeout === void 0 ? 5e3 : _timeout, _limit = props.limit, limit = _limit === void 0 ? 3 : _limit, toastManager = props.toastManager;
    var store = useRefWithInit(function() {
        return new ToastStore({
            timeout: timeout,
            limit: limit,
            viewport: null,
            toasts: [],
            hovering: false,
            focused: false,
            isWindowFocused: true,
            prevFocusElement: null
        });
    }).current;
    useOnMount(store.disposeEffect);
    react.useEffect(function subscribeToToastManager() {
        if (!toastManager) return;
        return toastManager[" subscribe"](function(param) {
            var action = param.action, options = param.options;
            var id = options.id;
            if (action === "promise" && options.promise) store.promiseToast(options.promise, options);
            else if (action === "update" && id) store.updateToast(id, options);
            else if (action === "close") store.closeToast(id);
            else store.addToast(options);
        });
    }, [
        store,
        timeout,
        toastManager
    ]);
    store.useSyncedValues({
        timeout: timeout,
        limit: limit
    });
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(ToastContext.Provider, {
        value: store,
        children: children
    });
};
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/toast/viewport/ToastViewportCssVars.js
var ToastViewportCssVars = /* @__PURE__ */ function(ToastViewportCssVars) {
    /**
	* Indicates the height of the frontmost toast.
	* @type {number}
	*/ ToastViewportCssVars["frontmostHeight"] = "--toast-frontmost-height";
    return ToastViewportCssVars;
}({});
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/toast/viewport/ToastViewport.js
/**
* A container viewport for toasts.
* Renders a `<div>` element.
*
* Documentation: [Base UI Toast](https://base-ui.com/react/components/toast)
*/ var ToastViewport = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function ToastViewport(componentProps, forwardedRef) {
    var handleFocusGuard = function handleFocusGuard(event) {
        var ref, ref1, ref2;
        var viewport = store.state.viewport;
        if (!viewport) return;
        handlingFocusGuardRef.current = true;
        if (event.relatedTarget === viewport) (ref = toasts[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.ref) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.current) === null || ref2 === void 0 ? void 0 : ref2.focus();
        else store.restoreFocusToPrevElement();
    };
    var handleKeyDown = function handleKeyDown(event) {
        if (event.key === "Tab" && event.shiftKey && getTarget(event.nativeEvent) === store.state.viewport) {
            event.preventDefault();
            store.restoreFocusToPrevElement();
            store.resumeTimers();
        }
    };
    var flushMouseLeave = function flushMouseLeave() {
        var hasEndingToasts = store.state.toasts.some(function(toast) {
            return toast.transitionStatus === "ending";
        });
        if (!store.state.isWindowFocused || hasEndingToasts || touchActiveRef.current || !markedReadyForMouseLeaveRef.current) return;
        store.resumeTimers();
        store.setHovering(false);
        markedReadyForMouseLeaveRef.current = false;
    };
    var handleMouseEnter = function handleMouseEnter() {
        store.pauseTimers();
        store.setHovering(true);
        markedReadyForMouseLeaveRef.current = false;
    };
    var handleMouseLeave = function handleMouseLeave() {
        if (hasTransitioningToasts || touchActiveRef.current) markedReadyForMouseLeaveRef.current = true;
        else {
            store.resumeTimers();
            store.setHovering(false);
        }
    };
    var handlePointerDown = function handlePointerDown(event) {
        if (event.pointerType === "touch") touchActiveRef.current = true;
    };
    var handlePointerEnd = function handlePointerEnd(event) {
        if (event.pointerType !== "touch") return;
        touchActiveRef.current = false;
        flushMouseLeave();
    };
    var handleFocus = function handleFocus() {
        if (handlingFocusGuardRef.current) {
            handlingFocusGuardRef.current = false;
            return;
        }
        if (focused) return;
        if (matchesFocusVisible(activeElement(ownerDocument(store.state.viewport)))) {
            store.setFocused(true);
            store.pauseTimers();
        }
    };
    var handleBlur = function handleBlur(event) {
        if (!focused || contains(store.state.viewport, event.relatedTarget)) return;
        store.setFocused(false);
        store.resumeTimers();
    };
    var ref;
    var render = componentProps.render, className = componentProps.className, style = componentProps.style, children = componentProps.children, elementProps = (0,src_object_without_properties/* default */.Z)(componentProps, [
        "render",
        "className",
        "style",
        "children"
    ]);
    var store = useToastProviderContext();
    var windowFocusTimeout = useTimeout();
    var handlingFocusGuardRef = react.useRef(false);
    var markedReadyForMouseLeaveRef = react.useRef(false);
    var touchActiveRef = react.useRef(false);
    var isEmpty = store.useState("isEmpty");
    var toasts = store.useState("toasts");
    var focused = store.useState("focused");
    var expanded = store.useState("expanded");
    var prevFocusElement = store.useState("prevFocusElement");
    var ref1;
    var frontmostHeight = (ref1 = (ref = toasts[0]) === null || ref === void 0 ? void 0 : ref.height) !== null && ref1 !== void 0 ? ref1 : 0;
    var hasTransitioningToasts = react.useMemo(function() {
        return toasts.some(function(toast) {
            return toast.transitionStatus === "ending";
        });
    }, [
        toasts
    ]);
    react.useEffect(function() {
        var handleGlobalKeyDown = function handleGlobalKeyDown(event) {
            if (isEmpty) return;
            if (event.key === "F6" && getTarget(event) !== viewport) {
                event.preventDefault();
                store.setPrevFocusElement(activeElement(ownerDocument(viewport)));
                viewport === null || viewport === void 0 ? void 0 : viewport.focus({
                    preventScroll: true
                });
                store.pauseTimers();
                store.setFocused(true);
            }
        };
        var viewport = store.state.viewport;
        if (!viewport) return;
        return addEventListener(getWindow(viewport), "keydown", handleGlobalKeyDown);
    }, [
        store,
        isEmpty
    ]);
    react.useEffect(function() {
        var handleWindowBlur = function handleWindowBlur(event) {
            if (getTarget(event) !== win) return;
            store.setIsWindowFocused(false);
            store.pauseTimers();
        };
        var handleWindowFocus = function handleWindowFocus(event) {
            if (event.relatedTarget) return;
            var target = getTarget(event);
            var activeEl = activeElement(ownerDocument(viewport));
            if (target === win || !contains(viewport, target) || !matchesFocusVisible(activeEl)) store.resumeTimers();
            windowFocusTimeout.start(0, function() {
                return store.setIsWindowFocused(true);
            });
        };
        var viewport = store.state.viewport;
        if (!viewport || isEmpty) return;
        var win = getWindow(viewport);
        return mergeCleanups(addEventListener(win, "blur", handleWindowBlur, true), addEventListener(win, "focus", handleWindowFocus, true));
    }, [
        store,
        windowFocusTimeout,
        isEmpty
    ]);
    react.useEffect(function() {
        var viewport = store.state.viewport;
        if (!viewport || isEmpty) return;
        return addEventListener(ownerDocument(viewport), "pointerdown", store.handleDocumentPointerDown, true);
    }, [
        isEmpty,
        store
    ]);
    react.useEffect(flushMouseLeave, [
        hasTransitioningToasts,
        store
    ]);
    var defaultProps = {
        tabIndex: -1,
        role: "region",
        "aria-live": "polite",
        "aria-atomic": false,
        "aria-relevant": "additions text",
        "aria-label": "Notifications",
        onMouseEnter: handleMouseEnter,
        onMouseMove: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onKeyDown: handleKeyDown,
        onClick: handleFocus,
        onPointerDown: handlePointerDown,
        onPointerUp: handlePointerEnd,
        onPointerCancel: handlePointerEnd
    };
    var state = {
        expanded: expanded
    };
    var element = useRenderElement("div", componentProps, {
        ref: [
            forwardedRef,
            store.setViewport
        ],
        state: state,
        props: [
            defaultProps,
            {
                style: (0,src_define_property/* default */.Z)({}, ToastViewportCssVars.frontmostHeight, frontmostHeight ? "".concat(frontmostHeight, "px") : void 0)
            },
            elementProps,
            {
                children: /* @__PURE__ */ (0,jsx_runtime.jsxs)(react.Fragment, {
                    children: [
                        !isEmpty && prevFocusElement && /* @__PURE__ */ (0,jsx_runtime.jsx)(FocusGuard, {
                            onFocus: handleFocusGuard
                        }),
                        children,
                        !isEmpty && prevFocusElement && /* @__PURE__ */ (0,jsx_runtime.jsx)(FocusGuard, {
                            onFocus: handleFocusGuard
                        })
                    ]
                })
            }
        ]
    });
    var highPriorityToasts = react.useMemo(function() {
        return toasts.filter(function(toast) {
            return toast.priority === "high";
        });
    }, [
        toasts
    ]);
    return /* @__PURE__ */ (0,jsx_runtime.jsxs)(react.Fragment, {
        children: [
            !isEmpty && prevFocusElement && /* @__PURE__ */ (0,jsx_runtime.jsx)(FocusGuard, {
                onFocus: handleFocusGuard
            }),
            element,
            !focused && highPriorityToasts.length > 0 && /* @__PURE__ */ (0,jsx_runtime.jsx)("div", {
                style: visuallyHidden,
                children: highPriorityToasts.map(function(toast) {
                    return /* @__PURE__ */ (0,jsx_runtime.jsxs)("div", {
                        role: "alert",
                        "aria-atomic": true,
                        children: [
                            /* @__PURE__ */ (0,jsx_runtime.jsx)("div", {
                                children: toast.title
                            }),
                            /* @__PURE__ */ (0,jsx_runtime.jsx)("div", {
                                children: toast.description
                            })
                        ]
                    }, toast.id);
                })
            })
        ]
    });
});
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/toast/root/ToastRootContext.js
var ToastRootContext = /* @__PURE__ */ /*#__PURE__*/ react.createContext(void 0);
if (false) {}
function useToastRootContext() {
    var context = react.useContext(ToastRootContext);
    if (!context) throw new Error( false ? 0 : formatErrorMessage(66));
    return context;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/toast/root/ToastRootCssVars.js
var ToastRootCssVars = /* @__PURE__ */ function(ToastRootCssVars) {
    /**
	* Indicates the index of the toast in the list.
	* @type {number}
	*/ ToastRootCssVars["index"] = "--toast-index";
    /**
	* Indicates the vertical pixels offset of the toast in the list when expanded.
	* @type {number}
	*/ ToastRootCssVars["offsetY"] = "--toast-offset-y";
    /**
	* Indicates the measured natural height of the toast in pixels.
	* @type {number}
	*/ ToastRootCssVars["height"] = "--toast-height";
    /**
	* Indicates the horizontal swipe movement of the toast.
	* @type {number}
	*/ ToastRootCssVars["swipeMovementX"] = "--toast-swipe-movement-x";
    /**
	* Indicates the vertical swipe movement of the toast.
	* @type {number}
	*/ ToastRootCssVars["swipeMovementY"] = "--toast-swipe-movement-y";
    return ToastRootCssVars;
}({});
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/toast/root/ToastRoot.js
var stateAttributesMapping = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, transitionStatusMapping), {
    swipeDirection: function swipeDirection(value) {
        return value ? {
            "data-swipe-direction": value
        } : null;
    }
});
var SWIPE_THRESHOLD = 40;
var REVERSE_CANCEL_THRESHOLD = 10;
var OPPOSITE_DIRECTION_DAMPING_FACTOR = .5;
var MIN_DRAG_THRESHOLD = 1;
var TOAST_SWIPE_IGNORE_SELECTOR = "".concat(BASE_UI_SWIPE_IGNORE_SELECTOR, ",").concat(LEGACY_SWIPE_IGNORE_SELECTOR);
function getDisplacement(direction, deltaX, deltaY) {
    switch(direction){
        case "up":
            return -deltaY;
        case "down":
            return deltaY;
        case "left":
            return -deltaX;
        case "right":
            return deltaX;
        default:
            return 0;
    }
}
function getElementTransform(element) {
    var transform = getWindow(element).getComputedStyle(element).transform;
    var translateX = 0;
    var translateY = 0;
    var scale = 1;
    if (transform && transform !== "none") {
        var matrix = transform.match(/matrix(?:3d)?\(([^)]+)\)/);
        if (matrix) {
            var values = matrix[1].split(", ").map(parseFloat);
            if (values.length === 6) {
                translateX = values[4];
                translateY = values[5];
                scale = Math.sqrt(values[0] * values[0] + values[1] * values[1]);
            } else if (values.length === 16) {
                translateX = values[12];
                translateY = values[13];
                scale = values[0];
            }
        }
    }
    return {
        x: translateX,
        y: translateY,
        scale: scale
    };
}
/**
* Groups all parts of an individual toast.
* Renders a `<div>` element.
*
* Documentation: [Base UI Toast](https://base-ui.com/react/components/toast)
*/ var ToastRoot = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function ToastRoot(componentProps, forwardedRef) {
    var applyDirectionalDamping = function applyDirectionalDamping(deltaX, deltaY) {
        var newDeltaX = deltaX;
        var newDeltaY = deltaY;
        if (!swipeDirections.includes("left") && !swipeDirections.includes("right")) newDeltaX = deltaX > 0 ? Math.pow(deltaX, OPPOSITE_DIRECTION_DAMPING_FACTOR) : -Math.pow(Math.abs(deltaX), OPPOSITE_DIRECTION_DAMPING_FACTOR);
        else {
            if (!swipeDirections.includes("right") && deltaX > 0) newDeltaX = Math.pow(deltaX, OPPOSITE_DIRECTION_DAMPING_FACTOR);
            if (!swipeDirections.includes("left") && deltaX < 0) newDeltaX = -Math.pow(Math.abs(deltaX), OPPOSITE_DIRECTION_DAMPING_FACTOR);
        }
        if (!swipeDirections.includes("up") && !swipeDirections.includes("down")) newDeltaY = deltaY > 0 ? Math.pow(deltaY, OPPOSITE_DIRECTION_DAMPING_FACTOR) : -Math.pow(Math.abs(deltaY), OPPOSITE_DIRECTION_DAMPING_FACTOR);
        else {
            if (!swipeDirections.includes("down") && deltaY > 0) newDeltaY = Math.pow(deltaY, OPPOSITE_DIRECTION_DAMPING_FACTOR);
            if (!swipeDirections.includes("up") && deltaY < 0) newDeltaY = -Math.pow(Math.abs(deltaY), OPPOSITE_DIRECTION_DAMPING_FACTOR);
        }
        return {
            x: newDeltaX,
            y: newDeltaY
        };
    };
    var handlePointerDown = function handlePointerDown(event) {
        var ref;
        if (event.button !== 0) return;
        if (event.pointerType === "touch") store.pauseTimers();
        var target = getTarget(event.nativeEvent);
        if (target ? target.closest('button,a,input,textarea,[role="button"],'.concat(TOAST_SWIPE_IGNORE_SELECTOR)) : false) return;
        cancelledSwipeRef.current = false;
        intendedSwipeDirectionRef.current = void 0;
        maxSwipeDisplacementRef.current = 0;
        dragStartPosRef.current = {
            x: event.clientX,
            y: event.clientY
        };
        swipeCancelBaselineRef.current = dragStartPosRef.current;
        if (rootRef.current) {
            var transform = getElementTransform(rootRef.current);
            initialTransformRef.current = transform;
            setInitialTransform(transform);
            setDragOffset({
                x: transform.x,
                y: transform.y
            });
        }
        store.setHovering(true);
        setIsSwiping(true);
        setIsRealSwipe(false);
        setLockedDirection(null);
        isFirstPointerMoveRef.current = true;
        (ref = rootRef.current) === null || ref === void 0 ? void 0 : ref.setPointerCapture(event.pointerId);
    };
    var handlePointerMove = function handlePointerMove(event) {
        if (!isSwiping) return;
        event.preventDefault();
        if (isFirstPointerMoveRef.current) {
            dragStartPosRef.current = {
                x: event.clientX,
                y: event.clientY
            };
            isFirstPointerMoveRef.current = false;
        }
        var clientY = event.clientY, clientX = event.clientX, movementX = event.movementX, movementY = event.movementY;
        if (movementY < 0 && clientY > swipeCancelBaselineRef.current.y || movementY > 0 && clientY < swipeCancelBaselineRef.current.y) swipeCancelBaselineRef.current = {
            x: swipeCancelBaselineRef.current.x,
            y: clientY
        };
        if (movementX < 0 && clientX > swipeCancelBaselineRef.current.x || movementX > 0 && clientX < swipeCancelBaselineRef.current.x) swipeCancelBaselineRef.current = {
            x: clientX,
            y: swipeCancelBaselineRef.current.y
        };
        var deltaX = clientX - dragStartPosRef.current.x;
        var deltaY = clientY - dragStartPosRef.current.y;
        var cancelDeltaY = clientY - swipeCancelBaselineRef.current.y;
        var cancelDeltaX = clientX - swipeCancelBaselineRef.current.x;
        if (!isRealSwipe) {
            if (Math.sqrt(deltaX * deltaX + deltaY * deltaY) >= MIN_DRAG_THRESHOLD) {
                setIsRealSwipe(true);
                if (lockedDirection === null) {
                    var hasHorizontal = swipeDirections.includes("left") || swipeDirections.includes("right");
                    var hasVertical = swipeDirections.includes("up") || swipeDirections.includes("down");
                    if (hasHorizontal && hasVertical) setLockedDirection(Math.abs(deltaX) > Math.abs(deltaY) ? "horizontal" : "vertical");
                }
            }
        }
        var candidate;
        if (!intendedSwipeDirectionRef.current) {
            if (lockedDirection === "vertical") {
                if (deltaY > 0) candidate = "down";
                else if (deltaY < 0) candidate = "up";
            } else if (lockedDirection === "horizontal") {
                if (deltaX > 0) candidate = "right";
                else if (deltaX < 0) candidate = "left";
            } else if (Math.abs(deltaX) >= Math.abs(deltaY)) candidate = deltaX > 0 ? "right" : "left";
            else candidate = deltaY > 0 ? "down" : "up";
            if (candidate && swipeDirections.includes(candidate)) {
                intendedSwipeDirectionRef.current = candidate;
                maxSwipeDisplacementRef.current = getDisplacement(candidate, deltaX, deltaY);
                setCurrentSwipeDirection(candidate);
            }
        } else {
            var direction = intendedSwipeDirectionRef.current;
            var currentDisplacement = getDisplacement(direction, cancelDeltaX, cancelDeltaY);
            if (currentDisplacement > SWIPE_THRESHOLD) {
                cancelledSwipeRef.current = false;
                setCurrentSwipeDirection(direction);
            } else if (!(swipeDirections.includes("left") && swipeDirections.includes("right")) && !(swipeDirections.includes("up") && swipeDirections.includes("down")) && maxSwipeDisplacementRef.current - currentDisplacement >= REVERSE_CANCEL_THRESHOLD) cancelledSwipeRef.current = true;
        }
        var dampedDelta = applyDirectionalDamping(deltaX, deltaY);
        var newOffsetX = initialTransformRef.current.x;
        var newOffsetY = initialTransformRef.current.y;
        if (lockedDirection === "horizontal") {
            if (swipeDirections.includes("left") || swipeDirections.includes("right")) newOffsetX += dampedDelta.x;
        } else if (lockedDirection === "vertical") {
            if (swipeDirections.includes("up") || swipeDirections.includes("down")) newOffsetY += dampedDelta.y;
        } else {
            if (swipeDirections.includes("left") || swipeDirections.includes("right")) newOffsetX += dampedDelta.x;
            if (swipeDirections.includes("up") || swipeDirections.includes("down")) newOffsetY += dampedDelta.y;
        }
        setDragOffset({
            x: newOffsetX,
            y: newOffsetY
        });
    };
    var handlePointerUp = function handlePointerUp(event) {
        var ref;
        if (!isSwiping) return;
        setIsSwiping(false);
        setIsRealSwipe(false);
        setLockedDirection(null);
        (ref = rootRef.current) === null || ref === void 0 ? void 0 : ref.releasePointerCapture(event.pointerId);
        if (cancelledSwipeRef.current) {
            setDragOffset({
                x: initialTransform.x,
                y: initialTransform.y
            });
            setCurrentSwipeDirection(void 0);
            return;
        }
        var shouldClose = false;
        var deltaX = dragOffset.x - initialTransform.x;
        var deltaY = dragOffset.y - initialTransform.y;
        var dismissDirection;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = swipeDirections[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var direction = _step.value;
                switch(direction){
                    case "right":
                        if (deltaX > SWIPE_THRESHOLD) {
                            shouldClose = true;
                            dismissDirection = "right";
                        }
                        break;
                    case "left":
                        if (deltaX < -SWIPE_THRESHOLD) {
                            shouldClose = true;
                            dismissDirection = "left";
                        }
                        break;
                    case "down":
                        if (deltaY > SWIPE_THRESHOLD) {
                            shouldClose = true;
                            dismissDirection = "down";
                        }
                        break;
                    case "up":
                        if (deltaY < -SWIPE_THRESHOLD) {
                            shouldClose = true;
                            dismissDirection = "up";
                        }
                        break;
                    default:
                        break;
                }
                if (shouldClose) break;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (shouldClose) {
            setCurrentSwipeDirection(dismissDirection);
            setDragDismissed(true);
            store.closeToast(toast.id);
        } else {
            setDragOffset({
                x: initialTransform.x,
                y: initialTransform.y
            });
            setCurrentSwipeDirection(void 0);
        }
    };
    var handlePointerCancel = function handlePointerCancel() {
        if (!isSwiping) return;
        setIsSwiping(false);
        setIsRealSwipe(false);
        setLockedDirection(null);
        setDragOffset({
            x: initialTransform.x,
            y: initialTransform.y
        });
        setCurrentSwipeDirection(void 0);
    };
    var handleKeyDown = function handleKeyDown(event) {
        if (event.key === "Escape") {
            if (!rootRef.current || !contains(rootRef.current, activeElement(ownerDocument(rootRef.current)))) return;
            store.closeToast(toast.id);
        }
    };
    var getDragStyles = function getDragStyles() {
        var _obj;
        if (!isSwiping && dragOffset.x === initialTransform.x && dragOffset.y === initialTransform.y && !dragDismissed) return _obj = {}, (0,src_define_property/* default */.Z)(_obj, ToastRootCssVars.swipeMovementX, "0px"), (0,src_define_property/* default */.Z)(_obj, ToastRootCssVars.swipeMovementY, "0px"), _obj;
        var deltaX = dragOffset.x - initialTransform.x;
        var deltaY = dragOffset.y - initialTransform.y;
        var _obj1;
        return _obj1 = {
            transition: isSwiping ? "none" : void 0,
            transform: isSwiping ? "translateX(".concat(dragOffset.x, "px) translateY(").concat(dragOffset.y, "px) scale(").concat(initialTransform.scale, ")") : void 0
        }, (0,src_define_property/* default */.Z)(_obj1, ToastRootCssVars.swipeMovementX, "".concat(deltaX, "px")), (0,src_define_property/* default */.Z)(_obj1, ToastRootCssVars.swipeMovementY, "".concat(deltaY, "px")), _obj1;
    };
    var ref;
    var toast = componentProps.toast, render = componentProps.render, className = componentProps.className, _swipeDirection = componentProps.swipeDirection, swipeDirection = _swipeDirection === void 0 ? [
        "down",
        "right"
    ] : _swipeDirection, style = componentProps.style, elementProps = (0,src_object_without_properties/* default */.Z)(componentProps, [
        "toast",
        "render",
        "className",
        "swipeDirection",
        "style"
    ]);
    var isAnchored = ((ref = toast.positionerProps) === null || ref === void 0 ? void 0 : ref.anchor) !== void 0;
    var swipeDirections = [];
    if (!isAnchored) swipeDirections = Array.isArray(swipeDirection) ? swipeDirection : [
        swipeDirection
    ];
    var swipeEnabled = swipeDirections.length > 0;
    var store = useToastProviderContext();
    var ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState(void 0), 2), currentSwipeDirection = ref1[0], setCurrentSwipeDirection = ref1[1];
    var ref2 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), isSwiping = ref2[0], setIsSwiping = ref2[1];
    var ref3 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), isRealSwipe = ref3[0], setIsRealSwipe = ref3[1];
    var ref4 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), dragDismissed = ref4[0], setDragDismissed = ref4[1];
    var ref5 = (0,src_sliced_to_array/* default */.Z)(react.useState({
        x: 0,
        y: 0
    }), 2), dragOffset = ref5[0], setDragOffset = ref5[1];
    var ref6 = (0,src_sliced_to_array/* default */.Z)(react.useState({
        x: 0,
        y: 0,
        scale: 1
    }), 2), initialTransform = ref6[0], setInitialTransform = ref6[1];
    var ref7 = (0,src_sliced_to_array/* default */.Z)(react.useState(), 2), titleId = ref7[0], setTitleId = ref7[1];
    var ref8 = (0,src_sliced_to_array/* default */.Z)(react.useState(), 2), descriptionId = ref8[0], setDescriptionId = ref8[1];
    var ref9 = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), lockedDirection = ref9[0], setLockedDirection = ref9[1];
    var rootRef = react.useRef(null);
    var dragStartPosRef = react.useRef({
        x: 0,
        y: 0
    });
    var initialTransformRef = react.useRef({
        x: 0,
        y: 0,
        scale: 1
    });
    var intendedSwipeDirectionRef = react.useRef(void 0);
    var maxSwipeDisplacementRef = react.useRef(0);
    var cancelledSwipeRef = react.useRef(false);
    var swipeCancelBaselineRef = react.useRef({
        x: 0,
        y: 0
    });
    var isFirstPointerMoveRef = react.useRef(false);
    var domIndex = store.useState("toastIndex", toast.id);
    var visibleIndex = store.useState("toastVisibleIndex", toast.id);
    var offsetY = store.useState("toastOffsetY", toast.id);
    var focused = store.useState("focused");
    var expanded = store.useState("expanded");
    useOpenChangeComplete({
        open: toast.transitionStatus !== "ending",
        ref: rootRef,
        onComplete: function onComplete() {
            if (toast.transitionStatus === "ending") store.removeToast(toast.id);
        }
    });
    /**
	* Recalculates the natural height of the toast and updates it in the toast manager.
	* @param flushSync Whether to flush the update synchronously. Use in observer
	* callbacks to avoid visual flickers.
	*/ var recalculateHeight = useStableCallback(function() {
        var flushSync = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        var update = function update() {
            store.updateToastInternal(toast.id, (0,src_object_spread/* default */.Z)({
                ref: rootRef,
                height: height
            }, toast.transitionStatus === "starting" ? {
                transitionStatus: void 0
            } : {}));
        };
        var element = rootRef.current;
        if (!element) return;
        var previousHeight = element.style.height;
        element.style.height = "auto";
        var height = element.offsetHeight;
        element.style.height = previousHeight;
        if (flushSync) react_dom.flushSync(update);
        else update();
    });
    useIsoLayoutEffect(recalculateHeight, [
        recalculateHeight
    ]);
    react.useEffect(function() {
        var preventDefaultTouchStart = function preventDefaultTouchStart(event) {
            if (contains(element, getTarget(event))) event.preventDefault();
        };
        if (!swipeEnabled) return;
        var element = rootRef.current;
        if (!element) return;
        return addEventListener(element, "touchmove", preventDefaultTouchStart, {
            passive: false
        });
    }, [
        swipeEnabled
    ]);
    var isHighPriority = toast.priority === "high";
    var _obj;
    var defaultProps = {
        role: isHighPriority ? "alertdialog" : "dialog",
        tabIndex: 0,
        "aria-modal": false,
        "aria-labelledby": titleId,
        "aria-describedby": descriptionId,
        "aria-hidden": isHighPriority && !focused ? true : void 0,
        onPointerDown: swipeEnabled ? handlePointerDown : void 0,
        onPointerMove: swipeEnabled ? handlePointerMove : void 0,
        onPointerUp: swipeEnabled ? handlePointerUp : void 0,
        onPointerCancel: swipeEnabled ? handlePointerCancel : void 0,
        onKeyDown: handleKeyDown,
        inert: inertValue(toast.limited),
        style: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, getDragStyles()), (_obj = {}, (0,src_define_property/* default */.Z)(_obj, ToastRootCssVars.index, toast.transitionStatus === "ending" ? domIndex : visibleIndex), (0,src_define_property/* default */.Z)(_obj, ToastRootCssVars.offsetY, "".concat(offsetY, "px")), (0,src_define_property/* default */.Z)(_obj, ToastRootCssVars.height, toast.height ? "".concat(toast.height, "px") : void 0), _obj))
    };
    var toastRoot = react.useMemo(function() {
        return {
            rootRef: rootRef,
            toast: toast,
            titleId: titleId,
            setTitleId: setTitleId,
            descriptionId: descriptionId,
            setDescriptionId: setDescriptionId,
            swiping: isSwiping,
            swipeDirection: currentSwipeDirection,
            recalculateHeight: recalculateHeight,
            index: domIndex,
            visibleIndex: visibleIndex,
            expanded: expanded
        };
    }, [
        toast,
        titleId,
        descriptionId,
        isSwiping,
        currentSwipeDirection,
        recalculateHeight,
        domIndex,
        visibleIndex,
        expanded
    ]);
    var state = {
        transitionStatus: toast.transitionStatus,
        expanded: expanded,
        limited: toast.limited || false,
        type: toast.type,
        swiping: toastRoot.swiping,
        swipeDirection: toastRoot.swipeDirection
    };
    var element = useRenderElement("div", componentProps, {
        ref: [
            forwardedRef,
            toastRoot.rootRef
        ],
        state: state,
        stateAttributesMapping: stateAttributesMapping,
        props: [
            defaultProps,
            elementProps
        ]
    });
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(ToastRootContext.Provider, {
        value: toastRoot,
        children: element
    });
});
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/toast/content/ToastContent.js
/**
* A container for the contents of a toast.
* Renders a `<div>` element.
*
* Documentation: [Base UI Toast](https://base-ui.com/react/components/toast)
*/ var ToastContent = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function ToastContent(componentProps, forwardedRef) {
    var render = componentProps.render, className = componentProps.className, style = componentProps.style, elementProps = (0,src_object_without_properties/* default */.Z)(componentProps, [
        "render",
        "className",
        "style"
    ]);
    var ref = useToastRootContext(), visibleIndex = ref.visibleIndex, expanded = ref.expanded, recalculateHeight = ref.recalculateHeight;
    var contentRef = react.useRef(null);
    useIsoLayoutEffect(function() {
        var node = contentRef.current;
        if (!node) return;
        recalculateHeight();
        if (typeof ResizeObserver !== "function" || typeof MutationObserver !== "function") return;
        var resizeObserver = new ResizeObserver(function() {
            return recalculateHeight(true);
        });
        var mutationObserver = new MutationObserver(function() {
            return recalculateHeight(true);
        });
        resizeObserver.observe(node);
        mutationObserver.observe(node, {
            childList: true,
            subtree: true,
            characterData: true
        });
        return function() {
            resizeObserver.disconnect();
            mutationObserver.disconnect();
        };
    }, [
        recalculateHeight
    ]);
    return useRenderElement("div", componentProps, {
        ref: [
            forwardedRef,
            contentRef
        ],
        state: {
            expanded: expanded,
            behind: visibleIndex > 0
        },
        props: elementProps
    });
});
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/toast/description/ToastDescription.js
/**
* A description that describes the toast.
* Can be used as the default message for the toast when no title is provided.
* Renders a `<p>` element.
*
* Documentation: [Base UI Toast](https://base-ui.com/react/components/toast)
*/ var ToastDescription = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function ToastDescription(componentProps, forwardedRef) {
    var render = componentProps.render, className = componentProps.className, style = componentProps.style, idProp = componentProps.id, childrenProp = componentProps.children, elementProps = (0,src_object_without_properties/* default */.Z)(componentProps, [
        "render",
        "className",
        "style",
        "id",
        "children"
    ]);
    var ref = useToastRootContext(), toast = ref.toast, setDescriptionId = ref.setDescriptionId;
    var children = childrenProp !== null && childrenProp !== void 0 ? childrenProp : toast.description;
    var shouldRender = Boolean(children);
    var id = useId$1(idProp);
    useIsoLayoutEffect(function() {
        if (!shouldRender) return;
        setDescriptionId(id);
        return function() {
            setDescriptionId(void 0);
        };
    }, [
        shouldRender,
        id,
        setDescriptionId
    ]);
    var element = useRenderElement("p", componentProps, {
        ref: forwardedRef,
        state: {
            type: toast.type
        },
        props: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, elementProps), {
            id: id,
            children: children
        })
    });
    if (!shouldRender) return null;
    return element;
});
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/toast/title/ToastTitle.js
/**
* A title that labels the toast.
* Renders an `<h2>` element.
*
* Documentation: [Base UI Toast](https://base-ui.com/react/components/toast)
*/ var ToastTitle = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function ToastTitle(componentProps, forwardedRef) {
    var render = componentProps.render, className = componentProps.className, style = componentProps.style, idProp = componentProps.id, childrenProp = componentProps.children, elementProps = (0,src_object_without_properties/* default */.Z)(componentProps, [
        "render",
        "className",
        "style",
        "id",
        "children"
    ]);
    var ref = useToastRootContext(), toast = ref.toast, setTitleId = ref.setTitleId;
    var children = childrenProp !== null && childrenProp !== void 0 ? childrenProp : toast.title;
    var shouldRender = Boolean(children);
    var id = useId$1(idProp);
    useIsoLayoutEffect(function() {
        if (!shouldRender) return;
        setTitleId(id);
        return function() {
            setTitleId(void 0);
        };
    }, [
        shouldRender,
        id,
        setTitleId
    ]);
    var element = useRenderElement("h2", componentProps, {
        ref: forwardedRef,
        state: {
            type: toast.type
        },
        props: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, elementProps), {
            id: id,
            children: children
        })
    });
    if (!shouldRender) return null;
    return element;
});
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/toast/close/ToastClose.js
/**
* Closes the toast when clicked.
* Renders a `<button>` element.
*
* Documentation: [Base UI Toast](https://base-ui.com/react/components/toast)
*/ var ToastClose = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function ToastClose(componentProps, forwardedRef) {
    var render = componentProps.render, className = componentProps.className, style = componentProps.style, disabled = componentProps.disabled, _nativeButton = componentProps.nativeButton, nativeButton = _nativeButton === void 0 ? true : _nativeButton, elementProps = (0,src_object_without_properties/* default */.Z)(componentProps, [
        "render",
        "className",
        "style",
        "disabled",
        "nativeButton"
    ]);
    var store = useToastProviderContext();
    var toast = useToastRootContext().toast;
    var expanded = store.useState("expanded");
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), hasFocus = ref[0], setHasFocus = ref[1];
    var ref1 = useButton({
        disabled: disabled,
        native: nativeButton
    }), getButtonProps = ref1.getButtonProps, buttonRef = ref1.buttonRef;
    var state = {
        type: toast.type
    };
    return useRenderElement("button", componentProps, {
        ref: [
            forwardedRef,
            buttonRef
        ],
        state: state,
        props: [
            {
                "aria-hidden": !expanded && !hasFocus,
                onClick: function onClick() {
                    store.closeToast(toast.id);
                },
                onFocus: function onFocus() {
                    setHasFocus(true);
                },
                onBlur: function onBlur() {
                    setHasFocus(false);
                }
            },
            elementProps,
            getButtonProps
        ]
    });
});
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/toast/action/ToastAction.js
/**
* Performs an action when clicked.
* Renders a `<button>` element.
*
* Documentation: [Base UI Toast](https://base-ui.com/react/components/toast)
*/ var ToastAction = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function ToastAction(componentProps, forwardedRef) {
    var ref;
    var render = componentProps.render, className = componentProps.className, style = componentProps.style, disabled = componentProps.disabled, _nativeButton = componentProps.nativeButton, nativeButton = _nativeButton === void 0 ? true : _nativeButton, elementProps = (0,src_object_without_properties/* default */.Z)(componentProps, [
        "render",
        "className",
        "style",
        "disabled",
        "nativeButton"
    ]);
    var toast = useToastRootContext().toast;
    var ref1;
    var computedChildren = (ref1 = (ref = toast.actionProps) === null || ref === void 0 ? void 0 : ref.children) !== null && ref1 !== void 0 ? ref1 : elementProps.children;
    var shouldRender = Boolean(computedChildren);
    var ref2 = useButton({
        disabled: disabled,
        native: nativeButton
    }), getButtonProps = ref2.getButtonProps, buttonRef = ref2.buttonRef;
    var state = {
        type: toast.type
    };
    var element = useRenderElement("button", componentProps, {
        ref: [
            forwardedRef,
            buttonRef
        ],
        state: state,
        props: [
            elementProps,
            toast.actionProps,
            getButtonProps,
            {
                children: computedChildren
            }
        ]
    });
    if (!shouldRender) return null;
    return element;
});
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/toast/portal/ToastPortal.js
/**
* A portal element that moves the viewport to a different part of the DOM.
* By default, the portal element is appended to `<body>`.
* Renders a `<div>` element.
*
* Documentation: [Base UI Toast](https://base-ui.com/react/components/toast)
*/ var ToastPortal = FloatingPortalLite;
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/toast/positioner/ToastPositionerContext.js
var ToastPositionerContext = /* @__PURE__ */ /*#__PURE__*/ react.createContext(void 0);
if (false) {}
function useToastPositionerContext() {
    var context = react.useContext(ToastPositionerContext);
    if (context === void 0) throw new Error( false ? 0 : formatErrorMessage(84));
    return context;
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/toast/positioner/ToastPositioner.js
/**
* Positions the toast against the anchor.
* Renders a `<div>` element.
*
* Documentation: [Base UI Toast](https://base-ui.com/react/components/toast)
*/ var ToastPositioner = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function ToastPositioner(componentProps, forwardedRef) {
    var toast = componentProps.toast, props = (0,src_object_without_properties/* default */.Z)(componentProps, [
        "toast"
    ]);
    var store = useToastProviderContext();
    var _positionerProps;
    var positionerProps = (_positionerProps = toast.positionerProps) !== null && _positionerProps !== void 0 ? _positionerProps : EMPTY_OBJECT;
    var _positionMethod, _side, _align, _sideOffset, _alignOffset, _collisionBoundary, _collisionPadding, _arrowPadding, _sticky, _disableAnchorTracking, _collisionAvoidance;
    var render = props.render, className = props.className, tmp = props.anchor, anchorProp = tmp === void 0 ? positionerProps.anchor : tmp, _positionMethod1 = props.positionMethod, positionMethod = _positionMethod1 === void 0 ? (_positionMethod = positionerProps.positionMethod) !== null && _positionMethod !== void 0 ? _positionMethod : "absolute" : _positionMethod1, _side1 = props.side, side = _side1 === void 0 ? (_side = positionerProps.side) !== null && _side !== void 0 ? _side : "top" : _side1, _align1 = props.align, align = _align1 === void 0 ? (_align = positionerProps.align) !== null && _align !== void 0 ? _align : "center" : _align1, _sideOffset1 = props.sideOffset, sideOffset = _sideOffset1 === void 0 ? (_sideOffset = positionerProps.sideOffset) !== null && _sideOffset !== void 0 ? _sideOffset : 0 : _sideOffset1, _alignOffset1 = props.alignOffset, alignOffset = _alignOffset1 === void 0 ? (_alignOffset = positionerProps.alignOffset) !== null && _alignOffset !== void 0 ? _alignOffset : 0 : _alignOffset1, _collisionBoundary1 = props.collisionBoundary, collisionBoundary = _collisionBoundary1 === void 0 ? (_collisionBoundary = positionerProps.collisionBoundary) !== null && _collisionBoundary !== void 0 ? _collisionBoundary : "clipping-ancestors" : _collisionBoundary1, _collisionPadding1 = props.collisionPadding, collisionPadding = _collisionPadding1 === void 0 ? (_collisionPadding = positionerProps.collisionPadding) !== null && _collisionPadding !== void 0 ? _collisionPadding : 5 : _collisionPadding1, _arrowPadding1 = props.arrowPadding, arrowPadding = _arrowPadding1 === void 0 ? (_arrowPadding = positionerProps.arrowPadding) !== null && _arrowPadding !== void 0 ? _arrowPadding : 5 : _arrowPadding1, _sticky1 = props.sticky, sticky = _sticky1 === void 0 ? (_sticky = positionerProps.sticky) !== null && _sticky !== void 0 ? _sticky : false : _sticky1, _disableAnchorTracking1 = props.disableAnchorTracking, disableAnchorTracking = _disableAnchorTracking1 === void 0 ? (_disableAnchorTracking = positionerProps.disableAnchorTracking) !== null && _disableAnchorTracking !== void 0 ? _disableAnchorTracking : false : _disableAnchorTracking1, _collisionAvoidance1 = props.collisionAvoidance, collisionAvoidance = _collisionAvoidance1 === void 0 ? (_collisionAvoidance = positionerProps.collisionAvoidance) !== null && _collisionAvoidance !== void 0 ? _collisionAvoidance : POPUP_COLLISION_AVOIDANCE : _collisionAvoidance1, style = props.style, elementProps = (0,src_object_without_properties/* default */.Z)(props, [
        "render",
        "className",
        "anchor",
        "positionMethod",
        "side",
        "align",
        "sideOffset",
        "alignOffset",
        "collisionBoundary",
        "collisionPadding",
        "arrowPadding",
        "sticky",
        "disableAnchorTracking",
        "collisionAvoidance",
        "style"
    ]);
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(null), 2), positionerElement = ref[0], setPositionerElement = ref[1];
    var domIndex = store.useState("toastIndex", toast.id);
    var visibleIndex = store.useState("toastVisibleIndex", toast.id);
    var anchor = isElement(anchorProp) ? anchorProp : null;
    var positioning = useAnchorPositioning({
        anchor: anchor,
        positionMethod: positionMethod,
        floatingRootContext: useFloatingRootContext({
            open: true,
            onOpenChange: NOOP,
            elements: {
                floating: positionerElement,
                reference: anchor
            }
        }),
        mounted: true,
        side: side,
        sideOffset: sideOffset,
        align: align,
        alignOffset: alignOffset,
        collisionBoundary: collisionBoundary,
        collisionPadding: collisionPadding,
        sticky: sticky,
        arrowPadding: arrowPadding,
        disableAnchorTracking: disableAnchorTracking,
        keepMounted: true,
        collisionAvoidance: collisionAvoidance
    });
    var element = usePositioner(componentProps, react.useMemo(function() {
        return {
            side: positioning.side,
            align: positioning.align,
            anchorHidden: positioning.anchorHidden
        };
    }, [
        positioning.side,
        positioning.align,
        positioning.anchorHidden
    ]), {
        styles: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, positioning.positionerStyles), (0,src_define_property/* default */.Z)({}, ToastRootCssVars.index, toast.transitionStatus === "ending" ? domIndex : visibleIndex)),
        transitionStatus: toast.transitionStatus,
        props: elementProps,
        refs: [
            forwardedRef,
            setPositionerElement
        ]
    });
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(ToastPositionerContext.Provider, {
        value: positioning,
        children: element
    });
});
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/toast/arrow/ToastArrow.js
/**
* Displays an element positioned against the toast anchor.
* Renders a `<div>` element.
*
* Documentation: [Base UI Toast](https://base-ui.com/react/components/toast)
*/ var ToastArrow = /* @__PURE__ */ /*#__PURE__*/ react.forwardRef(function ToastArrow(componentProps, forwardedRef) {
    var className = componentProps.className, render = componentProps.render, style = componentProps.style, elementProps = (0,src_object_without_properties/* default */.Z)(componentProps, [
        "className",
        "render",
        "style"
    ]);
    var ref = useToastPositionerContext(), arrowRef = ref.arrowRef, side = ref.side, align = ref.align, arrowUncentered = ref.arrowUncentered, arrowStyles = ref.arrowStyles;
    return useRenderElement("div", componentProps, {
        state: {
            side: side,
            align: align,
            uncentered: arrowUncentered
        },
        ref: [
            forwardedRef,
            arrowRef
        ],
        props: [
            {
                style: arrowStyles,
                "aria-hidden": true
            },
            elementProps
        ]
    });
});
if (false) {}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/toast/useToastManager.js
/**
* Returns the array of toasts and methods to manage them.
*/ function useToastManager() {
    var store = react.useContext(ToastContext);
    if (!store) throw new Error( false ? 0 : formatErrorMessage(73));
    var toasts = store.useState("toasts");
    return react.useMemo(function() {
        return {
            toasts: toasts,
            add: store.addToast,
            close: store.closeToast,
            update: store.updateToast,
            promise: store.promiseToast
        };
    }, [
        toasts,
        store
    ]);
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/toast/createToastManager.js
/**
* Creates a new toast manager.
*/ function createToastManager() {
    var emit = function emit(data) {
        listeners.forEach(function(listener) {
            return listener(data);
        });
    };
    var listeners = /* @__PURE__ */ new Set();
    return {
        " subscribe": function subscribe(listener) {
            listeners.add(listener);
            return function() {
                listeners.delete(listener);
            };
        },
        add: function add(options) {
            var id = options.id || generateId("toast");
            emit({
                action: "add",
                options: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, options), {
                    id: id,
                    transitionStatus: "starting"
                })
            });
            return id;
        },
        close: function close(id) {
            emit({
                action: "close",
                options: {
                    id: id
                }
            });
        },
        update: function update(id, updates) {
            emit({
                action: "update",
                options: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, updates), {
                    id: id
                })
            });
        },
        promise: function promise(promiseValue, options) {
            var handledPromise = promiseValue;
            emit({
                action: "promise",
                options: (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, options), {
                    promise: promiseValue,
                    setPromise: function setPromise(promise) {
                        handledPromise = promise;
                    }
                })
            });
            return handledPromise;
        }
    };
}
//#endregion
//#region ../../node_modules/.pnpm/@base-ui+react@1.4.1_@date-fns+tz@1.4.1_@types+react-dom@18.3.7_@types+react@18.3.28__@_2307bb0c52932efabee959d063a8bf6d/node_modules/@base-ui/react/esm/toast/index.parts.js
var index_parts_exports = /* @__PURE__ */ __exportAll({
    Action: function() {
        return ToastAction;
    },
    Arrow: function() {
        return ToastArrow;
    },
    Close: function() {
        return ToastClose;
    },
    Content: function() {
        return ToastContent;
    },
    Description: function() {
        return ToastDescription;
    },
    Portal: function() {
        return ToastPortal;
    },
    Positioner: function() {
        return ToastPositioner;
    },
    Provider: function() {
        return ToastProvider;
    },
    Root: function() {
        return ToastRoot;
    },
    Title: function() {
        return ToastTitle;
    },
    Viewport: function() {
        return ToastViewport;
    },
    createToastManager: function() {
        return createToastManager;
    },
    useToastManager: function() {
        return useToastManager;
    }
});
//#endregion



/***/ }),

/***/ 57306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "zx": function() { return /* binding */ Button; }
/* harmony export */ });
/* unused harmony exports ATOMS_BUTTON_DEFAULT_VARIANTS, ATOMS_BUTTON_VARIANTS, buttonVariants */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59106);
/* harmony import */ var _chunks_vendor_base_ui_n0ony04mhklkmnfd_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47380);
/* harmony import */ var _chunks_use_impression_ref_k081rlv0dt8gci3d_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74637);
/* harmony import */ var _chunks_accessible_name_h2kn8kxv0zjyg24j_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35290);
/* harmony import */ var _chunks_cn_dk9nmc4mhy1765ud_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27739);
/* harmony import */ var _chunks_link_provider_erp27xeaxlv7jgvb_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(76366);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31549);
"use client";










//#region src/components/button/button.tsx
/** Button variant definitions mapping size and variant names to their Tailwind classes. */ var ATOMS_BUTTON_VARIANTS = {
    size: {
        sm: {
            classes: "h-8 gap-1 rounded-xl px-4 text-label-md",
            description: "Small button for secondary actions"
        },
        md: {
            classes: "h-11 gap-1 rounded-2xl px-5 text-label-md",
            description: "Medium button for compact contexts"
        },
        lg: {
            classes: "h-14 gap-1.5 rounded-2xl px-6 text-label-lg",
            description: "Large button (default)"
        }
    },
    variant: {
        primary: {
            classes: "border border-od-border-accent-brand bg-od-bg-accent-brand !text-od-content-inverse-primary not-disabled:hover:border-od-border-hover-accent-brand not-disabled:hover:bg-od-bg-hover-accent-brand not-disabled:active:border-od-border-pressed-accent-brand not-disabled:active:bg-od-bg-pressed-accent-brand disabled:not-aria-busy:border-transparent disabled:not-aria-busy:bg-od-bg-inverse-inactive-primary disabled:not-aria-busy:!text-od-content-tertiary focus-visible:outline-od-border-focused-accent-brand",
            description: "High-emphasis button for primary actions"
        },
        secondary: {
            classes: "border border-od-border-primary bg-od-bg-primary !text-od-content-primary not-disabled:hover:border-od-border-hover-secondary not-disabled:hover:bg-od-bg-hover-primary not-disabled:active:border-od-border-hover-primary not-disabled:active:bg-od-bg-hover-primary disabled:not-aria-busy:border-transparent disabled:not-aria-busy:bg-od-bg-inverse-inactive-primary disabled:not-aria-busy:!text-od-content-tertiary focus-visible:outline-od-border-focused-secondary data-[state=open]:bg-od-bg-primary",
            description: "Default button style for most actions"
        },
        secondaryInverse: {
            classes: "border border-transparent bg-od-bg-inverse-secondary !text-od-content-inverse-primary not-disabled:hover:border-od-border-inverse-hover-secondary not-disabled:hover:bg-od-bg-inverse-hover-secondary not-disabled:active:border-od-border-inverse-pressed-secondary not-disabled:active:bg-od-bg-inverse-pressed-secondary disabled:not-aria-busy:border-transparent disabled:not-aria-busy:bg-od-bg-inverse-inactive-primary disabled:not-aria-busy:!text-od-content-tertiary focus-visible:outline-od-border-focused-secondary",
            description: "Secondary button for use on inverted/dark surfaces"
        },
        destructive: {
            classes: "border border-od-border-error bg-od-bg-error !text-od-content-inverse-primary not-disabled:hover:border-od-border-hover-accent-error not-disabled:hover:bg-od-bg-hover-accent-error not-disabled:active:border-od-border-pressed-accent-error not-disabled:active:bg-od-bg-pressed-accent-error disabled:not-aria-busy:border-transparent disabled:not-aria-busy:bg-od-bg-inverse-inactive-primary disabled:not-aria-busy:!text-od-content-tertiary focus-visible:outline-od-border-focused-accent-error",
            description: "High-emphasis red button for destructive actions"
        }
    }
};
var ATOMS_BUTTON_DEFAULT_VARIANTS = {
    size: "lg",
    variant: "primary"
};
function buttonVariants() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _variant = ref.variant, variant = _variant === void 0 ? ATOMS_BUTTON_DEFAULT_VARIANTS.variant : _variant, _size = ref.size, size = _size === void 0 ? ATOMS_BUTTON_DEFAULT_VARIANTS.size : _size;
    return (0,_chunks_cn_dk9nmc4mhy1765ud_js__WEBPACK_IMPORTED_MODULE_2__.t)("group flex w-max shrink-0 items-center justify-center select-none", "transition-transform not-disabled:active:scale-95", "focus:outline-none focus-visible:outline-solid focus-visible:outline-1 focus-visible:outline-offset-2", "cursor-pointer", "disabled:cursor-not-allowed", ATOMS_BUTTON_VARIANTS.variant[variant].classes, ATOMS_BUTTON_VARIANTS.size[size].classes);
}
var BUTTON_LOADER_DOT_CLASS = {
    sm: "size-1.25",
    md: "size-1.5",
    lg: "size-1.75"
};
var BUTTON_LOADER_GAP_CLASS = {
    sm: "gap-1",
    md: "gap-1",
    lg: "gap-1"
};
var BUTTON_LOADER_MIN_CLASS = {
    primary: "[--atoms-button-loader-min:0.4]",
    secondary: "[--atoms-button-loader-min:0.3]",
    secondaryInverse: "[--atoms-button-loader-min:0.4]",
    destructive: "[--atoms-button-loader-min:0.4]"
};
var BUTTON_LOADER_DOT_ANIMATIONS = [
    "animate-[atoms-button-loader-1_1900ms_ease-in-out_infinite]",
    "animate-[atoms-button-loader-2_1900ms_ease-in-out_infinite]",
    "animate-[atoms-button-loader-3_1900ms_ease-in-out_infinite]",
    "animate-[atoms-button-loader-4_1900ms_ease-in-out_infinite]"
];
function ButtonLoadingDots(param) {
    var size = param.size, variant = param.variant;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
        role: "status",
        "aria-label": "Loading",
        className: (0,_chunks_cn_dk9nmc4mhy1765ud_js__WEBPACK_IMPORTED_MODULE_2__.t)("absolute inset-0 flex items-center justify-center", BUTTON_LOADER_GAP_CLASS[size], BUTTON_LOADER_MIN_CLASS[variant]),
        children: BUTTON_LOADER_DOT_ANIMATIONS.map(function(animClass) {
            return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                className: (0,_chunks_cn_dk9nmc4mhy1765ud_js__WEBPACK_IMPORTED_MODULE_2__.t)("rounded-full bg-current", BUTTON_LOADER_DOT_CLASS[size], animClass)
            }, animClass);
        })
    });
}
/**
* Button form — renders a native `<button>`. Selected by {@link Button} when no
* `href` is given. Owns the `loading` affordance (the only form that supports it).
*/ var ButtonAsButton = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function ButtonAsButton(props, ref) {
    var children = props.children, className = props.className, disabled = props.disabled, loading = props.loading, type = props.type, _size = props.size, size = _size === void 0 ? ATOMS_BUTTON_DEFAULT_VARIANTS.size : _size, _variant = props.variant, variant = _variant === void 0 ? ATOMS_BUTTON_DEFAULT_VARIANTS.variant : _variant, analyticsName = props.analyticsName, trackImpression = props.trackImpression, onClick = props.onClick, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, [
        "children",
        "className",
        "disabled",
        "loading",
        "type",
        "size",
        "variant",
        "analyticsName",
        "trackImpression",
        "onClick"
    ]);
    var trackJourneyEvent = (0,_chunks_use_impression_ref_k081rlv0dt8gci3d_js__WEBPACK_IMPORTED_MODULE_4__.n)().trackJourneyEvent;
    var viewRef = (0,_chunks_use_impression_ref_k081rlv0dt8gci3d_js__WEBPACK_IMPORTED_MODULE_4__.t)(Boolean(analyticsName && trackImpression), analyticsName, "buttonViewEvent", ref);
    (0,_chunks_accessible_name_h2kn8kxv0zjyg24j_js__WEBPACK_IMPORTED_MODULE_5__.r)("Button", Boolean(props["aria-label"]));
    var handleClick = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function(event) {
        if (analyticsName) trackJourneyEvent("platform", "buttonClickEvent", {
            targetName: analyticsName
        });
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    }, [
        analyticsName,
        onClick,
        trackJourneyEvent
    ]);
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("button", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        ref: viewRef,
        type: type !== null && type !== void 0 ? type : "button",
        disabled: disabled || loading,
        "aria-busy": loading || void 0,
        className: (0,_chunks_cn_dk9nmc4mhy1765ud_js__WEBPACK_IMPORTED_MODULE_2__.t)(buttonVariants({
            variant: variant,
            size: size
        }), "relative", className),
        onClick: handleClick
    }, rest), {
        children: [
            loading && /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ButtonLoadingDots, {
                size: size,
                variant: variant
            }),
            /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                "aria-hidden": loading || void 0,
                className: (0,_chunks_cn_dk9nmc4mhy1765ud_js__WEBPACK_IMPORTED_MODULE_2__.t)("contents", loading && "invisible"),
                children: children
            })
        ]
    }));
});
ButtonAsButton.displayName = "Button";
/**
* Link form — renders an anchor styled as a button, routed through
* `LinkProvider`. Selected by {@link Button} when `href` is given.
*/ var ButtonAsLink = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function ButtonAsLink(props, ref) {
    var children = props.children, className = props.className, external = props.external, href = props.href, disabled = props.disabled, _size = props.size, size = _size === void 0 ? ATOMS_BUTTON_DEFAULT_VARIANTS.size : _size, _variant = props.variant, variant = _variant === void 0 ? ATOMS_BUTTON_DEFAULT_VARIANTS.variant : _variant, analyticsName = props.analyticsName, trackImpression = props.trackImpression, onClick = props.onClick, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, [
        "children",
        "className",
        "external",
        "href",
        "disabled",
        "size",
        "variant",
        "analyticsName",
        "trackImpression",
        "onClick"
    ]);
    var renderLink = (0,_chunks_link_provider_erp27xeaxlv7jgvb_js__WEBPACK_IMPORTED_MODULE_8__.n)();
    var trackJourneyEvent = (0,_chunks_use_impression_ref_k081rlv0dt8gci3d_js__WEBPACK_IMPORTED_MODULE_4__.n)().trackJourneyEvent;
    (0,_chunks_accessible_name_h2kn8kxv0zjyg24j_js__WEBPACK_IMPORTED_MODULE_5__.r)("Button", Boolean(props["aria-label"]));
    var viewRef = (0,_chunks_use_impression_ref_k081rlv0dt8gci3d_js__WEBPACK_IMPORTED_MODULE_4__.t)(Boolean(analyticsName && trackImpression), analyticsName, "linkViewEvent", ref);
    var handleClick = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function(event) {
        if (analyticsName) trackJourneyEvent("platform", "linkClickEvent", {
            targetName: analyticsName
        });
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    }, [
        analyticsName,
        onClick,
        trackJourneyEvent
    ]);
    var linkDisabled = Boolean(disabled);
    return (0,_chunks_vendor_base_ui_n0ony04mhklkmnfd_js__WEBPACK_IMPORTED_MODULE_9__.K)({
        render: renderLink,
        defaultTagName: "a",
        ref: viewRef,
        props: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            className: (0,_chunks_cn_dk9nmc4mhy1765ud_js__WEBPACK_IMPORTED_MODULE_2__.t)(buttonVariants({
                variant: variant,
                size: size
            }), "flex items-center no-underline!", linkDisabled && "pointer-events-none", className),
            href: linkDisabled ? void 0 : href,
            to: linkDisabled || typeof href !== "string" ? void 0 : href,
            "aria-disabled": linkDisabled || void 0,
            onClick: handleClick
        }, rest, external ? {
            target: "_blank",
            rel: [
                rest.rel,
                "noopener",
                "noreferrer"
            ].filter(Boolean).join(" ")
        } : {}), {
            children: children
        })
    });
});
ButtonAsLink.displayName = "Button";
/**
* Primary action trigger. Renders a native `<button>` by default; pass `href` to
* render an anchor styled identically (routed through `LinkProvider`). Supports
* multiple variants and sizes, plus a `loading` state on the button form.
* Compose icons by placing them inside `children`.
*
* @example
* ```tsx
* <Button aria-label="Save">Save</Button>
* <Button aria-label="New listing" variant="secondary"><IconPlus />New listing</Button>
* <Button aria-label="Settings" href="/settings" variant="secondary">Settings</Button>
* <Button aria-label="Visit Site" href="https://example.com" external>Visit Site</Button>
* ```
*/ var Button = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Button(props, ref) {
    if (props.href != null) return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ButtonAsLink, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        ref: ref
    }, props));
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ButtonAsButton, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        ref: ref
    }, props));
});
Button.displayName = "Button";
//#endregion



/***/ }),

/***/ 3109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ Image; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59106);
/* harmony import */ var _chunks_cn_dk9nmc4mhy1765ud_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27739);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31549);
"use client";





//#region src/components/image/image.tsx
function formatSrcSet(entries) {
    if (entries == null) return void 0;
    if (typeof entries === "string") return entries;
    return entries.map(function(entry) {
        if (typeof entry === "string") return entry;
        if ("width" in entry) return "".concat(entry.src, " ").concat(entry.width, "w");
        return "".concat(entry.src, " ").concat(entry.density, "x");
    }).join(", ");
}
var PICTURE_KEY_SEPARATOR = "|";
var getPictureSrcId = function(picture) {
    return [
        formatSrcSet(picture.srcSet),
        picture.type,
        picture.media,
        picture.sizes
    ].map(function(value) {
        return value !== null && value !== void 0 ? value : "";
    }).join(PICTURE_KEY_SEPARATOR);
};
/**
* Defaults to `loading="lazy"` and `decoding="async"`.
*/ var Image = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function(_param, ref) {
    var alt = _param.alt, className = _param.className, srcSet = _param.srcSet, sources = _param.sources, fallbackSrc = _param.fallbackSrc, _loading = _param.loading, loading = _loading === void 0 ? "lazy" : _loading, _decoding = _param.decoding, decoding = _decoding === void 0 ? "async" : _decoding, onError = _param.onError, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "alt",
        "className",
        "srcSet",
        "sources",
        "fallbackSrc",
        "loading",
        "decoding",
        "onError"
    ]);
    var handleError = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function(event) {
        if (fallbackSrc && event.currentTarget.src !== fallbackSrc) {
            event.currentTarget.src = fallbackSrc;
            event.currentTarget.srcset = "";
        }
        onError === null || onError === void 0 ? void 0 : onError(event);
    }, [
        fallbackSrc,
        onError
    ]);
    var errorProps = fallbackSrc || onError ? {
        onError: handleError
    } : void 0;
    var img = /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        ref: ref,
        alt: alt,
        srcSet: formatSrcSet(srcSet),
        loading: loading,
        decoding: decoding,
        className: (0,_chunks_cn_dk9nmc4mhy1765ud_js__WEBPACK_IMPORTED_MODULE_4__.t)("block max-w-full", className)
    }, props, errorProps));
    if (!sources || sources.length === 0) return img;
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("picture", {
        children: [
            sources.map(function(source) {
                return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("source", {
                    srcSet: formatSrcSet(source.srcSet),
                    type: source.type,
                    media: source.media,
                    sizes: source.sizes,
                    width: source.width,
                    height: source.height
                }, getPictureSrcId(source));
            }),
            img
        ]
    });
});
Image.displayName = "Image";
//#endregion



/***/ })

}]);